
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6a55"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6a55"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ajr9Q", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $7820beb5f0013563$export$ffb0004e005737fa; }, function (v) { return $7820beb5f0013563$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $7820beb5f0013563$export$34b9dba7ce09269b; }, function (v) { return $7820beb5f0013563$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $7820beb5f0013563$export$25062201e9e25d76; }, function (v) { return $7820beb5f0013563$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7820beb5f0013563$export$ffb0004e005737fa;
var $7820beb5f0013563$export$34b9dba7ce09269b;
var $7820beb5f0013563$export$25062201e9e25d76;
"use strict";
var $7820beb5f0013563$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $7820beb5f0013563$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $7820beb5f0013563$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $7820beb5f0013563$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$7820beb5f0013563$export$ffb0004e005737fa = $7820beb5f0013563$var$REACT_FRAGMENT_TYPE;
$7820beb5f0013563$export$34b9dba7ce09269b = $7820beb5f0013563$var$jsxProd;
$7820beb5f0013563$export$25062201e9e25d76 = $7820beb5f0013563$var$jsxProd;

});

parcelRegister("ydj4E", function(module, exports) {

$parcel$export(module.exports, "Activity", function () { return $066d7f83535f715d$export$9c16c1426311996d; }, function (v) { return $066d7f83535f715d$export$9c16c1426311996d = v; });
$parcel$export(module.exports, "Children", function () { return $066d7f83535f715d$export$dca3b0875bd9a954; }, function (v) { return $066d7f83535f715d$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $066d7f83535f715d$export$16fa2f45be04daa8; }, function (v) { return $066d7f83535f715d$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $066d7f83535f715d$export$ffb0004e005737fa; }, function (v) { return $066d7f83535f715d$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $066d7f83535f715d$export$e2c29f18771995cb; }, function (v) { return $066d7f83535f715d$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $066d7f83535f715d$export$221d75b3f55bb0bd; }, function (v) { return $066d7f83535f715d$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $066d7f83535f715d$export$5f8d39834fd61797; }, function (v) { return $066d7f83535f715d$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $066d7f83535f715d$export$74bf444e3cd11ea5; }, function (v) { return $066d7f83535f715d$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $066d7f83535f715d$export$1ced07cd6b1985ce; }, function (v) { return $066d7f83535f715d$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "__COMPILER_RUNTIME", function () { return $066d7f83535f715d$export$abd8e32b826d7ea7; }, function (v) { return $066d7f83535f715d$export$abd8e32b826d7ea7 = v; });
$parcel$export(module.exports, "cache", function () { return $066d7f83535f715d$export$69a3209f1a06c04d; }, function (v) { return $066d7f83535f715d$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cacheSignal", function () { return $066d7f83535f715d$export$8c538325882c7eec; }, function (v) { return $066d7f83535f715d$export$8c538325882c7eec = v; });
$parcel$export(module.exports, "cloneElement", function () { return $066d7f83535f715d$export$e530037191fcd5d7; }, function (v) { return $066d7f83535f715d$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $066d7f83535f715d$export$fd42f52fd3ae1109; }, function (v) { return $066d7f83535f715d$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $066d7f83535f715d$export$c8a8987d4410bf2d; }, function (v) { return $066d7f83535f715d$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $066d7f83535f715d$export$7d1e3a5e95ceca43; }, function (v) { return $066d7f83535f715d$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $066d7f83535f715d$export$257a8862b851cb5b; }, function (v) { return $066d7f83535f715d$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $066d7f83535f715d$export$a8257692ac88316c; }, function (v) { return $066d7f83535f715d$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $066d7f83535f715d$export$488013bae63b21da; }, function (v) { return $066d7f83535f715d$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $066d7f83535f715d$export$7c73462e0d25e514; }, function (v) { return $066d7f83535f715d$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $066d7f83535f715d$export$7568632d0d33d16d; }, function (v) { return $066d7f83535f715d$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $066d7f83535f715d$export$f93f40ac0ca7e3a8; }, function (v) { return $066d7f83535f715d$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $066d7f83535f715d$export$1f96ae73734a86cc; }, function (v) { return $066d7f83535f715d$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $066d7f83535f715d$export$9a47ced3238df325; }, function (v) { return $066d7f83535f715d$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $066d7f83535f715d$export$35808ee640e87ca7; }, function (v) { return $066d7f83535f715d$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $066d7f83535f715d$export$fae74005e78b1a27; }, function (v) { return $066d7f83535f715d$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $066d7f83535f715d$export$dc8fbce3eb94dc1e; }, function (v) { return $066d7f83535f715d$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $066d7f83535f715d$export$6a7bc4e911dc01cf; }, function (v) { return $066d7f83535f715d$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $066d7f83535f715d$export$6d9c69b0de29b591; }, function (v) { return $066d7f83535f715d$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useEffectEvent", function () { return $066d7f83535f715d$export$7f54fc3180508a52; }, function (v) { return $066d7f83535f715d$export$7f54fc3180508a52 = v; });
$parcel$export(module.exports, "useId", function () { return $066d7f83535f715d$export$f680877a34711e37; }, function (v) { return $066d7f83535f715d$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $066d7f83535f715d$export$d5a552a76deda3c2; }, function (v) { return $066d7f83535f715d$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $066d7f83535f715d$export$aaabe4eda9ed9969; }, function (v) { return $066d7f83535f715d$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $066d7f83535f715d$export$e5c5a5f917a5871c; }, function (v) { return $066d7f83535f715d$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $066d7f83535f715d$export$1538c33de8887b59; }, function (v) { return $066d7f83535f715d$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $066d7f83535f715d$export$fca7f784ae7a249a; }, function (v) { return $066d7f83535f715d$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $066d7f83535f715d$export$13e3392192263954; }, function (v) { return $066d7f83535f715d$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $066d7f83535f715d$export$b8f5890fc79d6aca; }, function (v) { return $066d7f83535f715d$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $066d7f83535f715d$export$60241385465d0a34; }, function (v) { return $066d7f83535f715d$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $066d7f83535f715d$export$306c0aa65ff9ec16; }, function (v) { return $066d7f83535f715d$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $066d7f83535f715d$export$7b286972b8d8ccbf; }, function (v) { return $066d7f83535f715d$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $066d7f83535f715d$export$83d89fbfd8236492; }, function (v) { return $066d7f83535f715d$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $066d7f83535f715d$export$9c16c1426311996d;
var $066d7f83535f715d$export$dca3b0875bd9a954;
var $066d7f83535f715d$export$16fa2f45be04daa8;
var $066d7f83535f715d$export$ffb0004e005737fa;
var $066d7f83535f715d$export$e2c29f18771995cb;
var $066d7f83535f715d$export$221d75b3f55bb0bd;
var $066d7f83535f715d$export$5f8d39834fd61797;
var $066d7f83535f715d$export$74bf444e3cd11ea5;
var $066d7f83535f715d$export$1ced07cd6b1985ce;
var $066d7f83535f715d$export$abd8e32b826d7ea7;
var $066d7f83535f715d$export$69a3209f1a06c04d;
var $066d7f83535f715d$export$8c538325882c7eec;
var $066d7f83535f715d$export$e530037191fcd5d7;
var $066d7f83535f715d$export$fd42f52fd3ae1109;
var $066d7f83535f715d$export$c8a8987d4410bf2d;
var $066d7f83535f715d$export$7d1e3a5e95ceca43;
var $066d7f83535f715d$export$257a8862b851cb5b;
var $066d7f83535f715d$export$a8257692ac88316c;
var $066d7f83535f715d$export$488013bae63b21da;
var $066d7f83535f715d$export$7c73462e0d25e514;
var $066d7f83535f715d$export$7568632d0d33d16d;
var $066d7f83535f715d$export$f93f40ac0ca7e3a8;
var $066d7f83535f715d$export$1f96ae73734a86cc;
var $066d7f83535f715d$export$9a47ced3238df325;
var $066d7f83535f715d$export$35808ee640e87ca7;
var $066d7f83535f715d$export$fae74005e78b1a27;
var $066d7f83535f715d$export$dc8fbce3eb94dc1e;
var $066d7f83535f715d$export$6a7bc4e911dc01cf;
var $066d7f83535f715d$export$6d9c69b0de29b591;
var $066d7f83535f715d$export$7f54fc3180508a52;
var $066d7f83535f715d$export$f680877a34711e37;
var $066d7f83535f715d$export$d5a552a76deda3c2;
var $066d7f83535f715d$export$aaabe4eda9ed9969;
var $066d7f83535f715d$export$e5c5a5f917a5871c;
var $066d7f83535f715d$export$1538c33de8887b59;
var $066d7f83535f715d$export$fca7f784ae7a249a;
var $066d7f83535f715d$export$13e3392192263954;
var $066d7f83535f715d$export$b8f5890fc79d6aca;
var $066d7f83535f715d$export$60241385465d0a34;
var $066d7f83535f715d$export$306c0aa65ff9ec16;
var $066d7f83535f715d$export$7b286972b8d8ccbf;
var $066d7f83535f715d$export$83d89fbfd8236492;
"use strict";
var $066d7f83535f715d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $066d7f83535f715d$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $066d7f83535f715d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $066d7f83535f715d$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $066d7f83535f715d$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $066d7f83535f715d$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $066d7f83535f715d$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $066d7f83535f715d$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $066d7f83535f715d$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $066d7f83535f715d$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $066d7f83535f715d$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $066d7f83535f715d$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $066d7f83535f715d$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $066d7f83535f715d$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $066d7f83535f715d$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$066d7f83535f715d$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $066d7f83535f715d$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $066d7f83535f715d$var$assign = Object.assign, $066d7f83535f715d$var$emptyObject = {};
function $066d7f83535f715d$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $066d7f83535f715d$var$emptyObject;
    this.updater = updater || $066d7f83535f715d$var$ReactNoopUpdateQueue;
}
$066d7f83535f715d$var$Component.prototype.isReactComponent = {};
$066d7f83535f715d$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$066d7f83535f715d$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $066d7f83535f715d$var$ComponentDummy() {}
$066d7f83535f715d$var$ComponentDummy.prototype = $066d7f83535f715d$var$Component.prototype;
function $066d7f83535f715d$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $066d7f83535f715d$var$emptyObject;
    this.updater = updater || $066d7f83535f715d$var$ReactNoopUpdateQueue;
}
var $066d7f83535f715d$var$pureComponentPrototype = $066d7f83535f715d$var$PureComponent.prototype = new $066d7f83535f715d$var$ComponentDummy();
$066d7f83535f715d$var$pureComponentPrototype.constructor = $066d7f83535f715d$var$PureComponent;
$066d7f83535f715d$var$assign($066d7f83535f715d$var$pureComponentPrototype, $066d7f83535f715d$var$Component.prototype);
$066d7f83535f715d$var$pureComponentPrototype.isPureReactComponent = !0;
var $066d7f83535f715d$var$isArrayImpl = Array.isArray;
function $066d7f83535f715d$var$noop() {}
var $066d7f83535f715d$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $066d7f83535f715d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $066d7f83535f715d$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $066d7f83535f715d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $066d7f83535f715d$var$cloneAndReplaceKey(oldElement, newKey) {
    return $066d7f83535f715d$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $066d7f83535f715d$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $066d7f83535f715d$var$REACT_ELEMENT_TYPE;
}
function $066d7f83535f715d$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $066d7f83535f715d$var$userProvidedKeyEscapeRegex = /\/+/g;
function $066d7f83535f715d$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $066d7f83535f715d$var$escape("" + element.key) : index.toString(36);
}
function $066d7f83535f715d$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($066d7f83535f715d$var$noop, $066d7f83535f715d$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $066d7f83535f715d$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $066d7f83535f715d$var$REACT_ELEMENT_TYPE:
                case $066d7f83535f715d$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $066d7f83535f715d$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $066d7f83535f715d$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $066d7f83535f715d$var$getElementKey(children, 0) : nameSoFar, $066d7f83535f715d$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($066d7f83535f715d$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $066d7f83535f715d$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($066d7f83535f715d$var$isValidElement(callback) && (callback = $066d7f83535f715d$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($066d7f83535f715d$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($066d7f83535f715d$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $066d7f83535f715d$var$getElementKey(nameSoFar, i), invokeCallback += $066d7f83535f715d$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $066d7f83535f715d$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $066d7f83535f715d$var$getElementKey(nameSoFar, i++), invokeCallback += $066d7f83535f715d$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $066d7f83535f715d$var$mapIntoArray($066d7f83535f715d$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $066d7f83535f715d$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $066d7f83535f715d$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $066d7f83535f715d$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $066d7f83535f715d$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $066d7f83535f715d$var$Children = {
    map: $066d7f83535f715d$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $066d7f83535f715d$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $066d7f83535f715d$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $066d7f83535f715d$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$066d7f83535f715d$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$066d7f83535f715d$export$9c16c1426311996d = $066d7f83535f715d$var$REACT_ACTIVITY_TYPE;
$066d7f83535f715d$export$dca3b0875bd9a954 = $066d7f83535f715d$var$Children;
$066d7f83535f715d$export$16fa2f45be04daa8 = $066d7f83535f715d$var$Component;
$066d7f83535f715d$export$ffb0004e005737fa = $066d7f83535f715d$var$REACT_FRAGMENT_TYPE;
$066d7f83535f715d$export$e2c29f18771995cb = $066d7f83535f715d$var$REACT_PROFILER_TYPE;
$066d7f83535f715d$export$221d75b3f55bb0bd = $066d7f83535f715d$var$PureComponent;
$066d7f83535f715d$export$5f8d39834fd61797 = $066d7f83535f715d$var$REACT_STRICT_MODE_TYPE;
$066d7f83535f715d$export$74bf444e3cd11ea5 = $066d7f83535f715d$var$REACT_SUSPENSE_TYPE;
$066d7f83535f715d$export$1ced07cd6b1985ce = $066d7f83535f715d$var$ReactSharedInternals;
$066d7f83535f715d$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $066d7f83535f715d$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$066d7f83535f715d$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$066d7f83535f715d$export$8c538325882c7eec = function() {
    return null;
};
$066d7f83535f715d$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $066d7f83535f715d$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$066d7f83535f715d$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $066d7f83535f715d$var$ReactElement(element.type, key, props);
};
$066d7f83535f715d$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $066d7f83535f715d$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $066d7f83535f715d$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$066d7f83535f715d$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$066d7f83535f715d$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $066d7f83535f715d$var$ReactElement(type, key, props);
};
$066d7f83535f715d$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$066d7f83535f715d$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $066d7f83535f715d$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$066d7f83535f715d$export$a8257692ac88316c = $066d7f83535f715d$var$isValidElement;
$066d7f83535f715d$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $066d7f83535f715d$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $066d7f83535f715d$var$lazyInitializer
    };
};
$066d7f83535f715d$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $066d7f83535f715d$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$066d7f83535f715d$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $066d7f83535f715d$var$ReactSharedInternals.T, currentTransition = {};
    $066d7f83535f715d$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $066d7f83535f715d$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($066d7f83535f715d$var$noop, $066d7f83535f715d$var$reportGlobalError);
    } catch (error) {
        $066d7f83535f715d$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $066d7f83535f715d$var$ReactSharedInternals.T = prevTransition;
    }
};
$066d7f83535f715d$export$f93f40ac0ca7e3a8 = function() {
    return $066d7f83535f715d$var$ReactSharedInternals.H.useCacheRefresh();
};
$066d7f83535f715d$export$1f96ae73734a86cc = function(usable) {
    return $066d7f83535f715d$var$ReactSharedInternals.H.use(usable);
};
$066d7f83535f715d$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $066d7f83535f715d$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$066d7f83535f715d$export$35808ee640e87ca7 = function(callback, deps) {
    return $066d7f83535f715d$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$066d7f83535f715d$export$fae74005e78b1a27 = function(Context) {
    return $066d7f83535f715d$var$ReactSharedInternals.H.useContext(Context);
};
$066d7f83535f715d$export$dc8fbce3eb94dc1e = function() {};
$066d7f83535f715d$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $066d7f83535f715d$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$066d7f83535f715d$export$6d9c69b0de29b591 = function(create, deps) {
    return $066d7f83535f715d$var$ReactSharedInternals.H.useEffect(create, deps);
};
$066d7f83535f715d$export$7f54fc3180508a52 = function(callback) {
    return $066d7f83535f715d$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$066d7f83535f715d$export$f680877a34711e37 = function() {
    return $066d7f83535f715d$var$ReactSharedInternals.H.useId();
};
$066d7f83535f715d$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $066d7f83535f715d$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$066d7f83535f715d$export$aaabe4eda9ed9969 = function(create, deps) {
    return $066d7f83535f715d$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$066d7f83535f715d$export$e5c5a5f917a5871c = function(create, deps) {
    return $066d7f83535f715d$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$066d7f83535f715d$export$1538c33de8887b59 = function(create, deps) {
    return $066d7f83535f715d$var$ReactSharedInternals.H.useMemo(create, deps);
};
$066d7f83535f715d$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $066d7f83535f715d$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$066d7f83535f715d$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $066d7f83535f715d$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$066d7f83535f715d$export$b8f5890fc79d6aca = function(initialValue) {
    return $066d7f83535f715d$var$ReactSharedInternals.H.useRef(initialValue);
};
$066d7f83535f715d$export$60241385465d0a34 = function(initialState) {
    return $066d7f83535f715d$var$ReactSharedInternals.H.useState(initialState);
};
$066d7f83535f715d$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $066d7f83535f715d$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$066d7f83535f715d$export$7b286972b8d8ccbf = function() {
    return $066d7f83535f715d$var$ReactSharedInternals.H.useTransition();
};
$066d7f83535f715d$export$83d89fbfd8236492 = "19.2.7";

});

parcelRegister("lEmfK", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $fc2e98617fc942d3$export$882461b6382ed46c; }, function (v) { return $fc2e98617fc942d3$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $fc2e98617fc942d3$export$757ceba2d55c277e; }, function (v) { return $fc2e98617fc942d3$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $fc2e98617fc942d3$export$83d89fbfd8236492; }, function (v) { return $fc2e98617fc942d3$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $fc2e98617fc942d3$export$882461b6382ed46c;
var $fc2e98617fc942d3$export$757ceba2d55c277e;
var $fc2e98617fc942d3$export$83d89fbfd8236492;
"use strict";

var $3Txiq = parcelRequire("3Txiq");

var $lDJXT = parcelRequire("lDJXT");

var $6UFvd = parcelRequire("6UFvd");
function $fc2e98617fc942d3$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $fc2e98617fc942d3$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $fc2e98617fc942d3$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $fc2e98617fc942d3$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $fc2e98617fc942d3$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $fc2e98617fc942d3$var$assertIsMounted(fiber) {
    if ($fc2e98617fc942d3$var$getNearestMountedFiber(fiber) !== fiber) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(188));
}
function $fc2e98617fc942d3$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $fc2e98617fc942d3$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $fc2e98617fc942d3$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $fc2e98617fc942d3$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $fc2e98617fc942d3$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $fc2e98617fc942d3$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $fc2e98617fc942d3$var$assign = Object.assign, $fc2e98617fc942d3$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $fc2e98617fc942d3$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $fc2e98617fc942d3$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $fc2e98617fc942d3$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $fc2e98617fc942d3$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $fc2e98617fc942d3$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $fc2e98617fc942d3$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $fc2e98617fc942d3$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $fc2e98617fc942d3$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $fc2e98617fc942d3$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $fc2e98617fc942d3$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $fc2e98617fc942d3$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $fc2e98617fc942d3$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $fc2e98617fc942d3$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $fc2e98617fc942d3$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $fc2e98617fc942d3$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $fc2e98617fc942d3$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $fc2e98617fc942d3$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$fc2e98617fc942d3$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $fc2e98617fc942d3$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $fc2e98617fc942d3$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $fc2e98617fc942d3$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $fc2e98617fc942d3$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $fc2e98617fc942d3$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $fc2e98617fc942d3$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $fc2e98617fc942d3$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $fc2e98617fc942d3$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $fc2e98617fc942d3$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $fc2e98617fc942d3$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $fc2e98617fc942d3$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $fc2e98617fc942d3$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $fc2e98617fc942d3$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $fc2e98617fc942d3$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $fc2e98617fc942d3$var$getComponentNameFromType(type.type) || "Memo";
        case $fc2e98617fc942d3$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $fc2e98617fc942d3$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $fc2e98617fc942d3$var$isArrayImpl = Array.isArray, $fc2e98617fc942d3$var$ReactSharedInternals = $lDJXT.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $fc2e98617fc942d3$var$ReactDOMSharedInternals = $6UFvd.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $fc2e98617fc942d3$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $fc2e98617fc942d3$var$valueStack = [], $fc2e98617fc942d3$var$index = -1;
function $fc2e98617fc942d3$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $fc2e98617fc942d3$var$pop(cursor) {
    0 > $fc2e98617fc942d3$var$index || (cursor.current = $fc2e98617fc942d3$var$valueStack[$fc2e98617fc942d3$var$index], $fc2e98617fc942d3$var$valueStack[$fc2e98617fc942d3$var$index] = null, $fc2e98617fc942d3$var$index--);
}
function $fc2e98617fc942d3$var$push(cursor, value) {
    $fc2e98617fc942d3$var$index++;
    $fc2e98617fc942d3$var$valueStack[$fc2e98617fc942d3$var$index] = cursor.current;
    cursor.current = value;
}
var $fc2e98617fc942d3$var$contextStackCursor = $fc2e98617fc942d3$var$createCursor(null), $fc2e98617fc942d3$var$contextFiberStackCursor = $fc2e98617fc942d3$var$createCursor(null), $fc2e98617fc942d3$var$rootInstanceStackCursor = $fc2e98617fc942d3$var$createCursor(null), $fc2e98617fc942d3$var$hostTransitionProviderCursor = $fc2e98617fc942d3$var$createCursor(null);
function $fc2e98617fc942d3$var$pushHostContainer(fiber, nextRootInstance) {
    $fc2e98617fc942d3$var$push($fc2e98617fc942d3$var$rootInstanceStackCursor, nextRootInstance);
    $fc2e98617fc942d3$var$push($fc2e98617fc942d3$var$contextFiberStackCursor, fiber);
    $fc2e98617fc942d3$var$push($fc2e98617fc942d3$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $fc2e98617fc942d3$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $fc2e98617fc942d3$var$getOwnHostContext(nextRootInstance), fiber = $fc2e98617fc942d3$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $fc2e98617fc942d3$var$pop($fc2e98617fc942d3$var$contextStackCursor);
    $fc2e98617fc942d3$var$push($fc2e98617fc942d3$var$contextStackCursor, fiber);
}
function $fc2e98617fc942d3$var$popHostContainer() {
    $fc2e98617fc942d3$var$pop($fc2e98617fc942d3$var$contextStackCursor);
    $fc2e98617fc942d3$var$pop($fc2e98617fc942d3$var$contextFiberStackCursor);
    $fc2e98617fc942d3$var$pop($fc2e98617fc942d3$var$rootInstanceStackCursor);
}
function $fc2e98617fc942d3$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $fc2e98617fc942d3$var$push($fc2e98617fc942d3$var$hostTransitionProviderCursor, fiber);
    var context = $fc2e98617fc942d3$var$contextStackCursor.current;
    var JSCompiler_inline_result = $fc2e98617fc942d3$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($fc2e98617fc942d3$var$push($fc2e98617fc942d3$var$contextFiberStackCursor, fiber), $fc2e98617fc942d3$var$push($fc2e98617fc942d3$var$contextStackCursor, JSCompiler_inline_result));
}
function $fc2e98617fc942d3$var$popHostContext(fiber) {
    $fc2e98617fc942d3$var$contextFiberStackCursor.current === fiber && ($fc2e98617fc942d3$var$pop($fc2e98617fc942d3$var$contextStackCursor), $fc2e98617fc942d3$var$pop($fc2e98617fc942d3$var$contextFiberStackCursor));
    $fc2e98617fc942d3$var$hostTransitionProviderCursor.current === fiber && ($fc2e98617fc942d3$var$pop($fc2e98617fc942d3$var$hostTransitionProviderCursor), $fc2e98617fc942d3$var$HostTransitionContext._currentValue = $fc2e98617fc942d3$var$sharedNotPendingObject);
}
var $fc2e98617fc942d3$var$prefix, $fc2e98617fc942d3$var$suffix;
function $fc2e98617fc942d3$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $fc2e98617fc942d3$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $fc2e98617fc942d3$var$prefix = match && match[1] || "";
        $fc2e98617fc942d3$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $fc2e98617fc942d3$var$prefix + name + $fc2e98617fc942d3$var$suffix;
}
var $fc2e98617fc942d3$var$reentry = !1;
function $fc2e98617fc942d3$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $fc2e98617fc942d3$var$reentry) return "";
    $fc2e98617fc942d3$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $fc2e98617fc942d3$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $fc2e98617fc942d3$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $fc2e98617fc942d3$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $fc2e98617fc942d3$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $fc2e98617fc942d3$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $fc2e98617fc942d3$var$describeBuiltInComponentFrame("Suspense Fallback") : $fc2e98617fc942d3$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $fc2e98617fc942d3$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $fc2e98617fc942d3$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $fc2e98617fc942d3$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $fc2e98617fc942d3$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $fc2e98617fc942d3$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $fc2e98617fc942d3$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $fc2e98617fc942d3$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $fc2e98617fc942d3$var$hasOwnProperty = Object.prototype.hasOwnProperty, $fc2e98617fc942d3$var$scheduleCallback$3 = $3Txiq.unstable_scheduleCallback, $fc2e98617fc942d3$var$cancelCallback$1 = $3Txiq.unstable_cancelCallback, $fc2e98617fc942d3$var$shouldYield = $3Txiq.unstable_shouldYield, $fc2e98617fc942d3$var$requestPaint = $3Txiq.unstable_requestPaint, $fc2e98617fc942d3$var$now = $3Txiq.unstable_now, $fc2e98617fc942d3$var$getCurrentPriorityLevel = $3Txiq.unstable_getCurrentPriorityLevel, $fc2e98617fc942d3$var$ImmediatePriority = $3Txiq.unstable_ImmediatePriority, $fc2e98617fc942d3$var$UserBlockingPriority = $3Txiq.unstable_UserBlockingPriority, $fc2e98617fc942d3$var$NormalPriority$1 = $3Txiq.unstable_NormalPriority, $fc2e98617fc942d3$var$LowPriority = $3Txiq.unstable_LowPriority, $fc2e98617fc942d3$var$IdlePriority = $3Txiq.unstable_IdlePriority, $fc2e98617fc942d3$var$log$1 = $3Txiq.log, $fc2e98617fc942d3$var$unstable_setDisableYieldValue = $3Txiq.unstable_setDisableYieldValue, $fc2e98617fc942d3$var$rendererID = null, $fc2e98617fc942d3$var$injectedHook = null;
function $fc2e98617fc942d3$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $fc2e98617fc942d3$var$log$1 && $fc2e98617fc942d3$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($fc2e98617fc942d3$var$injectedHook && "function" === typeof $fc2e98617fc942d3$var$injectedHook.setStrictMode) try {
        $fc2e98617fc942d3$var$injectedHook.setStrictMode($fc2e98617fc942d3$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $fc2e98617fc942d3$var$clz32 = Math.clz32 ? Math.clz32 : $fc2e98617fc942d3$var$clz32Fallback, $fc2e98617fc942d3$var$log = Math.log, $fc2e98617fc942d3$var$LN2 = Math.LN2;
function $fc2e98617fc942d3$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($fc2e98617fc942d3$var$log(x) / $fc2e98617fc942d3$var$LN2 | 0) | 0;
}
var $fc2e98617fc942d3$var$nextTransitionUpdateLane = 256, $fc2e98617fc942d3$var$nextTransitionDeferredLane = 262144, $fc2e98617fc942d3$var$nextRetryLane = 4194304;
function $fc2e98617fc942d3$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $fc2e98617fc942d3$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $fc2e98617fc942d3$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $fc2e98617fc942d3$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $fc2e98617fc942d3$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $fc2e98617fc942d3$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $fc2e98617fc942d3$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $fc2e98617fc942d3$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $fc2e98617fc942d3$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $fc2e98617fc942d3$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $fc2e98617fc942d3$var$claimNextRetryLane() {
    var lane = $fc2e98617fc942d3$var$nextRetryLane;
    $fc2e98617fc942d3$var$nextRetryLane <<= 1;
    0 === ($fc2e98617fc942d3$var$nextRetryLane & 62914560) && ($fc2e98617fc942d3$var$nextRetryLane = 4194304);
    return lane;
}
function $fc2e98617fc942d3$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $fc2e98617fc942d3$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $fc2e98617fc942d3$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $fc2e98617fc942d3$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $fc2e98617fc942d3$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $fc2e98617fc942d3$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $fc2e98617fc942d3$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $fc2e98617fc942d3$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $fc2e98617fc942d3$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $fc2e98617fc942d3$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $fc2e98617fc942d3$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $fc2e98617fc942d3$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $fc2e98617fc942d3$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $fc2e98617fc942d3$var$resolveUpdatePriority() {
    var updatePriority = $fc2e98617fc942d3$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $fc2e98617fc942d3$var$getEventPriority(updatePriority.type);
}
function $fc2e98617fc942d3$var$runWithPriority(priority, fn) {
    var previousPriority = $fc2e98617fc942d3$var$ReactDOMSharedInternals.p;
    try {
        return $fc2e98617fc942d3$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $fc2e98617fc942d3$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $fc2e98617fc942d3$var$randomKey = Math.random().toString(36).slice(2), $fc2e98617fc942d3$var$internalInstanceKey = "__reactFiber$" + $fc2e98617fc942d3$var$randomKey, $fc2e98617fc942d3$var$internalPropsKey = "__reactProps$" + $fc2e98617fc942d3$var$randomKey, $fc2e98617fc942d3$var$internalContainerInstanceKey = "__reactContainer$" + $fc2e98617fc942d3$var$randomKey, $fc2e98617fc942d3$var$internalEventHandlersKey = "__reactEvents$" + $fc2e98617fc942d3$var$randomKey, $fc2e98617fc942d3$var$internalEventHandlerListenersKey = "__reactListeners$" + $fc2e98617fc942d3$var$randomKey, $fc2e98617fc942d3$var$internalEventHandlesSetKey = "__reactHandles$" + $fc2e98617fc942d3$var$randomKey, $fc2e98617fc942d3$var$internalRootNodeResourcesKey = "__reactResources$" + $fc2e98617fc942d3$var$randomKey, $fc2e98617fc942d3$var$internalHoistableMarker = "__reactMarker$" + $fc2e98617fc942d3$var$randomKey;
function $fc2e98617fc942d3$var$detachDeletedInstance(node) {
    delete node[$fc2e98617fc942d3$var$internalInstanceKey];
    delete node[$fc2e98617fc942d3$var$internalPropsKey];
    delete node[$fc2e98617fc942d3$var$internalEventHandlersKey];
    delete node[$fc2e98617fc942d3$var$internalEventHandlerListenersKey];
    delete node[$fc2e98617fc942d3$var$internalEventHandlesSetKey];
}
function $fc2e98617fc942d3$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$fc2e98617fc942d3$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$fc2e98617fc942d3$var$internalContainerInstanceKey] || parentNode[$fc2e98617fc942d3$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $fc2e98617fc942d3$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$fc2e98617fc942d3$var$internalInstanceKey]) return parentNode;
                targetNode = $fc2e98617fc942d3$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $fc2e98617fc942d3$var$getInstanceFromNode(node) {
    if (node = node[$fc2e98617fc942d3$var$internalInstanceKey] || node[$fc2e98617fc942d3$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $fc2e98617fc942d3$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(33));
}
function $fc2e98617fc942d3$var$getResourcesFromRoot(root) {
    var resources = root[$fc2e98617fc942d3$var$internalRootNodeResourcesKey];
    resources || (resources = root[$fc2e98617fc942d3$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $fc2e98617fc942d3$var$markNodeAsHoistable(node) {
    node[$fc2e98617fc942d3$var$internalHoistableMarker] = !0;
}
var $fc2e98617fc942d3$var$allNativeEvents = new Set(), $fc2e98617fc942d3$var$registrationNameDependencies = {};
function $fc2e98617fc942d3$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $fc2e98617fc942d3$var$registerDirectEvent(registrationName, dependencies);
    $fc2e98617fc942d3$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $fc2e98617fc942d3$var$registerDirectEvent(registrationName, dependencies) {
    $fc2e98617fc942d3$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$fc2e98617fc942d3$var$allNativeEvents.add(dependencies[registrationName]);
}
var $fc2e98617fc942d3$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $fc2e98617fc942d3$var$illegalAttributeNameCache = {}, $fc2e98617fc942d3$var$validatedAttributeNameCache = {};
function $fc2e98617fc942d3$var$isAttributeNameSafe(attributeName) {
    if ($fc2e98617fc942d3$var$hasOwnProperty.call($fc2e98617fc942d3$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($fc2e98617fc942d3$var$hasOwnProperty.call($fc2e98617fc942d3$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($fc2e98617fc942d3$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $fc2e98617fc942d3$var$validatedAttributeNameCache[attributeName] = !0;
    $fc2e98617fc942d3$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $fc2e98617fc942d3$var$setValueForAttribute(node, name, value) {
    if ($fc2e98617fc942d3$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $fc2e98617fc942d3$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $fc2e98617fc942d3$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $fc2e98617fc942d3$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $fc2e98617fc942d3$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $fc2e98617fc942d3$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $fc2e98617fc942d3$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $fc2e98617fc942d3$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $fc2e98617fc942d3$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $fc2e98617fc942d3$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $fc2e98617fc942d3$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $fc2e98617fc942d3$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $fc2e98617fc942d3$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $fc2e98617fc942d3$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($fc2e98617fc942d3$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $fc2e98617fc942d3$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $fc2e98617fc942d3$var$getToStringValue(value);
        } else element.value !== "" + $fc2e98617fc942d3$var$getToStringValue(value) && (element.value = "" + $fc2e98617fc942d3$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $fc2e98617fc942d3$var$setDefaultValue(element, type, $fc2e98617fc942d3$var$getToStringValue(value)) : null != defaultValue ? $fc2e98617fc942d3$var$setDefaultValue(element, type, $fc2e98617fc942d3$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $fc2e98617fc942d3$var$getToStringValue(name) : element.removeAttribute("name");
}
function $fc2e98617fc942d3$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $fc2e98617fc942d3$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $fc2e98617fc942d3$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $fc2e98617fc942d3$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $fc2e98617fc942d3$var$track(element);
}
function $fc2e98617fc942d3$var$setDefaultValue(node, type, value) {
    "number" === type && $fc2e98617fc942d3$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $fc2e98617fc942d3$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $fc2e98617fc942d3$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $fc2e98617fc942d3$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $fc2e98617fc942d3$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $fc2e98617fc942d3$var$getToStringValue(defaultValue) : "";
}
function $fc2e98617fc942d3$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(92));
            if ($fc2e98617fc942d3$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $fc2e98617fc942d3$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $fc2e98617fc942d3$var$track(element);
}
function $fc2e98617fc942d3$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $fc2e98617fc942d3$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $fc2e98617fc942d3$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $fc2e98617fc942d3$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $fc2e98617fc942d3$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $fc2e98617fc942d3$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $fc2e98617fc942d3$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $fc2e98617fc942d3$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $fc2e98617fc942d3$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $fc2e98617fc942d3$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $fc2e98617fc942d3$var$sanitizeURL(url) {
    return $fc2e98617fc942d3$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $fc2e98617fc942d3$var$noop$1() {}
var $fc2e98617fc942d3$var$currentReplayingEvent = null;
function $fc2e98617fc942d3$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $fc2e98617fc942d3$var$restoreTarget = null, $fc2e98617fc942d3$var$restoreQueue = null;
function $fc2e98617fc942d3$var$restoreStateOfTarget(target) {
    var internalInstance = $fc2e98617fc942d3$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$fc2e98617fc942d3$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $fc2e98617fc942d3$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $fc2e98617fc942d3$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$fc2e98617fc942d3$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(90));
                            $fc2e98617fc942d3$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $fc2e98617fc942d3$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $fc2e98617fc942d3$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $fc2e98617fc942d3$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $fc2e98617fc942d3$var$isInsideEventHandler = !1;
function $fc2e98617fc942d3$var$batchedUpdates$1(fn, a, b) {
    if ($fc2e98617fc942d3$var$isInsideEventHandler) return fn(a, b);
    $fc2e98617fc942d3$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($fc2e98617fc942d3$var$isInsideEventHandler = !1, null !== $fc2e98617fc942d3$var$restoreTarget || null !== $fc2e98617fc942d3$var$restoreQueue) {
            if ($fc2e98617fc942d3$var$flushSyncWork$1(), $fc2e98617fc942d3$var$restoreTarget && (a = $fc2e98617fc942d3$var$restoreTarget, fn = $fc2e98617fc942d3$var$restoreQueue, $fc2e98617fc942d3$var$restoreQueue = $fc2e98617fc942d3$var$restoreTarget = null, $fc2e98617fc942d3$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$fc2e98617fc942d3$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $fc2e98617fc942d3$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$fc2e98617fc942d3$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $fc2e98617fc942d3$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $fc2e98617fc942d3$var$passiveBrowserEventsSupported = !1;
if ($fc2e98617fc942d3$var$canUseDOM) try {
    var $fc2e98617fc942d3$var$options = {};
    Object.defineProperty($fc2e98617fc942d3$var$options, "passive", {
        get: function() {
            $fc2e98617fc942d3$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $fc2e98617fc942d3$var$options, $fc2e98617fc942d3$var$options);
    window.removeEventListener("test", $fc2e98617fc942d3$var$options, $fc2e98617fc942d3$var$options);
} catch (e) {
    $fc2e98617fc942d3$var$passiveBrowserEventsSupported = !1;
}
var $fc2e98617fc942d3$var$root = null, $fc2e98617fc942d3$var$startText = null, $fc2e98617fc942d3$var$fallbackText = null;
function $fc2e98617fc942d3$var$getData() {
    if ($fc2e98617fc942d3$var$fallbackText) return $fc2e98617fc942d3$var$fallbackText;
    var start, startValue = $fc2e98617fc942d3$var$startText, startLength = startValue.length, end, endValue = "value" in $fc2e98617fc942d3$var$root ? $fc2e98617fc942d3$var$root.value : $fc2e98617fc942d3$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $fc2e98617fc942d3$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $fc2e98617fc942d3$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $fc2e98617fc942d3$var$functionThatReturnsTrue() {
    return !0;
}
function $fc2e98617fc942d3$var$functionThatReturnsFalse() {
    return !1;
}
function $fc2e98617fc942d3$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $fc2e98617fc942d3$var$functionThatReturnsTrue : $fc2e98617fc942d3$var$functionThatReturnsFalse;
        this.isPropagationStopped = $fc2e98617fc942d3$var$functionThatReturnsFalse;
        return this;
    }
    $fc2e98617fc942d3$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $fc2e98617fc942d3$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $fc2e98617fc942d3$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $fc2e98617fc942d3$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $fc2e98617fc942d3$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $fc2e98617fc942d3$var$SyntheticEvent = $fc2e98617fc942d3$var$createSyntheticEvent($fc2e98617fc942d3$var$EventInterface), $fc2e98617fc942d3$var$UIEventInterface = $fc2e98617fc942d3$var$assign({}, $fc2e98617fc942d3$var$EventInterface, {
    view: 0,
    detail: 0
}), $fc2e98617fc942d3$var$SyntheticUIEvent = $fc2e98617fc942d3$var$createSyntheticEvent($fc2e98617fc942d3$var$UIEventInterface), $fc2e98617fc942d3$var$lastMovementX, $fc2e98617fc942d3$var$lastMovementY, $fc2e98617fc942d3$var$lastMouseEvent, $fc2e98617fc942d3$var$MouseEventInterface = $fc2e98617fc942d3$var$assign({}, $fc2e98617fc942d3$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $fc2e98617fc942d3$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $fc2e98617fc942d3$var$lastMouseEvent && ($fc2e98617fc942d3$var$lastMouseEvent && "mousemove" === event.type ? ($fc2e98617fc942d3$var$lastMovementX = event.screenX - $fc2e98617fc942d3$var$lastMouseEvent.screenX, $fc2e98617fc942d3$var$lastMovementY = event.screenY - $fc2e98617fc942d3$var$lastMouseEvent.screenY) : $fc2e98617fc942d3$var$lastMovementY = $fc2e98617fc942d3$var$lastMovementX = 0, $fc2e98617fc942d3$var$lastMouseEvent = event);
        return $fc2e98617fc942d3$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $fc2e98617fc942d3$var$lastMovementY;
    }
}), $fc2e98617fc942d3$var$SyntheticMouseEvent = $fc2e98617fc942d3$var$createSyntheticEvent($fc2e98617fc942d3$var$MouseEventInterface), $fc2e98617fc942d3$var$DragEventInterface = $fc2e98617fc942d3$var$assign({}, $fc2e98617fc942d3$var$MouseEventInterface, {
    dataTransfer: 0
}), $fc2e98617fc942d3$var$SyntheticDragEvent = $fc2e98617fc942d3$var$createSyntheticEvent($fc2e98617fc942d3$var$DragEventInterface), $fc2e98617fc942d3$var$FocusEventInterface = $fc2e98617fc942d3$var$assign({}, $fc2e98617fc942d3$var$UIEventInterface, {
    relatedTarget: 0
}), $fc2e98617fc942d3$var$SyntheticFocusEvent = $fc2e98617fc942d3$var$createSyntheticEvent($fc2e98617fc942d3$var$FocusEventInterface), $fc2e98617fc942d3$var$AnimationEventInterface = $fc2e98617fc942d3$var$assign({}, $fc2e98617fc942d3$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $fc2e98617fc942d3$var$SyntheticAnimationEvent = $fc2e98617fc942d3$var$createSyntheticEvent($fc2e98617fc942d3$var$AnimationEventInterface), $fc2e98617fc942d3$var$ClipboardEventInterface = $fc2e98617fc942d3$var$assign({}, $fc2e98617fc942d3$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $fc2e98617fc942d3$var$SyntheticClipboardEvent = $fc2e98617fc942d3$var$createSyntheticEvent($fc2e98617fc942d3$var$ClipboardEventInterface), $fc2e98617fc942d3$var$CompositionEventInterface = $fc2e98617fc942d3$var$assign({}, $fc2e98617fc942d3$var$EventInterface, {
    data: 0
}), $fc2e98617fc942d3$var$SyntheticCompositionEvent = $fc2e98617fc942d3$var$createSyntheticEvent($fc2e98617fc942d3$var$CompositionEventInterface), $fc2e98617fc942d3$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $fc2e98617fc942d3$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $fc2e98617fc942d3$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $fc2e98617fc942d3$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $fc2e98617fc942d3$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $fc2e98617fc942d3$var$getEventModifierState() {
    return $fc2e98617fc942d3$var$modifierStateGetter;
}
var $fc2e98617fc942d3$var$KeyboardEventInterface = $fc2e98617fc942d3$var$assign({}, $fc2e98617fc942d3$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $fc2e98617fc942d3$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $fc2e98617fc942d3$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $fc2e98617fc942d3$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $fc2e98617fc942d3$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $fc2e98617fc942d3$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $fc2e98617fc942d3$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $fc2e98617fc942d3$var$SyntheticKeyboardEvent = $fc2e98617fc942d3$var$createSyntheticEvent($fc2e98617fc942d3$var$KeyboardEventInterface), $fc2e98617fc942d3$var$PointerEventInterface = $fc2e98617fc942d3$var$assign({}, $fc2e98617fc942d3$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $fc2e98617fc942d3$var$SyntheticPointerEvent = $fc2e98617fc942d3$var$createSyntheticEvent($fc2e98617fc942d3$var$PointerEventInterface), $fc2e98617fc942d3$var$TouchEventInterface = $fc2e98617fc942d3$var$assign({}, $fc2e98617fc942d3$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $fc2e98617fc942d3$var$getEventModifierState
}), $fc2e98617fc942d3$var$SyntheticTouchEvent = $fc2e98617fc942d3$var$createSyntheticEvent($fc2e98617fc942d3$var$TouchEventInterface), $fc2e98617fc942d3$var$TransitionEventInterface = $fc2e98617fc942d3$var$assign({}, $fc2e98617fc942d3$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $fc2e98617fc942d3$var$SyntheticTransitionEvent = $fc2e98617fc942d3$var$createSyntheticEvent($fc2e98617fc942d3$var$TransitionEventInterface), $fc2e98617fc942d3$var$WheelEventInterface = $fc2e98617fc942d3$var$assign({}, $fc2e98617fc942d3$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $fc2e98617fc942d3$var$SyntheticWheelEvent = $fc2e98617fc942d3$var$createSyntheticEvent($fc2e98617fc942d3$var$WheelEventInterface), $fc2e98617fc942d3$var$ToggleEventInterface = $fc2e98617fc942d3$var$assign({}, $fc2e98617fc942d3$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $fc2e98617fc942d3$var$SyntheticToggleEvent = $fc2e98617fc942d3$var$createSyntheticEvent($fc2e98617fc942d3$var$ToggleEventInterface), $fc2e98617fc942d3$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $fc2e98617fc942d3$var$canUseCompositionEvent = $fc2e98617fc942d3$var$canUseDOM && "CompositionEvent" in window, $fc2e98617fc942d3$var$documentMode = null;
$fc2e98617fc942d3$var$canUseDOM && "documentMode" in document && ($fc2e98617fc942d3$var$documentMode = document.documentMode);
var $fc2e98617fc942d3$var$canUseTextInputEvent = $fc2e98617fc942d3$var$canUseDOM && "TextEvent" in window && !$fc2e98617fc942d3$var$documentMode, $fc2e98617fc942d3$var$useFallbackCompositionData = $fc2e98617fc942d3$var$canUseDOM && (!$fc2e98617fc942d3$var$canUseCompositionEvent || $fc2e98617fc942d3$var$documentMode && 8 < $fc2e98617fc942d3$var$documentMode && 11 >= $fc2e98617fc942d3$var$documentMode), $fc2e98617fc942d3$var$SPACEBAR_CHAR = String.fromCharCode(32), $fc2e98617fc942d3$var$hasSpaceKeypress = !1;
function $fc2e98617fc942d3$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $fc2e98617fc942d3$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $fc2e98617fc942d3$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $fc2e98617fc942d3$var$isComposing = !1;
function $fc2e98617fc942d3$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $fc2e98617fc942d3$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $fc2e98617fc942d3$var$hasSpaceKeypress = !0;
            return $fc2e98617fc942d3$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $fc2e98617fc942d3$var$SPACEBAR_CHAR && $fc2e98617fc942d3$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $fc2e98617fc942d3$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($fc2e98617fc942d3$var$isComposing) return "compositionend" === domEventName || !$fc2e98617fc942d3$var$canUseCompositionEvent && $fc2e98617fc942d3$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $fc2e98617fc942d3$var$getData(), $fc2e98617fc942d3$var$fallbackText = $fc2e98617fc942d3$var$startText = $fc2e98617fc942d3$var$root = null, $fc2e98617fc942d3$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $fc2e98617fc942d3$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $fc2e98617fc942d3$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $fc2e98617fc942d3$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$fc2e98617fc942d3$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $fc2e98617fc942d3$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $fc2e98617fc942d3$var$restoreTarget ? $fc2e98617fc942d3$var$restoreQueue ? $fc2e98617fc942d3$var$restoreQueue.push(target) : $fc2e98617fc942d3$var$restoreQueue = [
        target
    ] : $fc2e98617fc942d3$var$restoreTarget = target;
    inst = $fc2e98617fc942d3$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $fc2e98617fc942d3$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $fc2e98617fc942d3$var$activeElement$1 = null, $fc2e98617fc942d3$var$activeElementInst$1 = null;
function $fc2e98617fc942d3$var$runEventInBatch(dispatchQueue) {
    $fc2e98617fc942d3$var$processDispatchQueue(dispatchQueue, 0);
}
function $fc2e98617fc942d3$var$getInstIfValueChanged(targetInst) {
    var targetNode = $fc2e98617fc942d3$var$getNodeFromInstance(targetInst);
    if ($fc2e98617fc942d3$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $fc2e98617fc942d3$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $fc2e98617fc942d3$var$isInputEventSupported = !1;
if ($fc2e98617fc942d3$var$canUseDOM) {
    var $fc2e98617fc942d3$var$JSCompiler_inline_result$jscomp$286;
    if ($fc2e98617fc942d3$var$canUseDOM) {
        var $fc2e98617fc942d3$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$fc2e98617fc942d3$var$isSupported$jscomp$inline_427) {
            var $fc2e98617fc942d3$var$element$jscomp$inline_428 = document.createElement("div");
            $fc2e98617fc942d3$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $fc2e98617fc942d3$var$isSupported$jscomp$inline_427 = "function" === typeof $fc2e98617fc942d3$var$element$jscomp$inline_428.oninput;
        }
        $fc2e98617fc942d3$var$JSCompiler_inline_result$jscomp$286 = $fc2e98617fc942d3$var$isSupported$jscomp$inline_427;
    } else $fc2e98617fc942d3$var$JSCompiler_inline_result$jscomp$286 = !1;
    $fc2e98617fc942d3$var$isInputEventSupported = $fc2e98617fc942d3$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $fc2e98617fc942d3$var$stopWatchingForValueChange() {
    $fc2e98617fc942d3$var$activeElement$1 && ($fc2e98617fc942d3$var$activeElement$1.detachEvent("onpropertychange", $fc2e98617fc942d3$var$handlePropertyChange), $fc2e98617fc942d3$var$activeElementInst$1 = $fc2e98617fc942d3$var$activeElement$1 = null);
}
function $fc2e98617fc942d3$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $fc2e98617fc942d3$var$getInstIfValueChanged($fc2e98617fc942d3$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $fc2e98617fc942d3$var$createAndAccumulateChangeEvent(dispatchQueue, $fc2e98617fc942d3$var$activeElementInst$1, nativeEvent, $fc2e98617fc942d3$var$getEventTarget(nativeEvent));
        $fc2e98617fc942d3$var$batchedUpdates$1($fc2e98617fc942d3$var$runEventInBatch, dispatchQueue);
    }
}
function $fc2e98617fc942d3$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($fc2e98617fc942d3$var$stopWatchingForValueChange(), $fc2e98617fc942d3$var$activeElement$1 = target, $fc2e98617fc942d3$var$activeElementInst$1 = targetInst, $fc2e98617fc942d3$var$activeElement$1.attachEvent("onpropertychange", $fc2e98617fc942d3$var$handlePropertyChange)) : "focusout" === domEventName && $fc2e98617fc942d3$var$stopWatchingForValueChange();
}
function $fc2e98617fc942d3$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $fc2e98617fc942d3$var$getInstIfValueChanged($fc2e98617fc942d3$var$activeElementInst$1);
}
function $fc2e98617fc942d3$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $fc2e98617fc942d3$var$getInstIfValueChanged(targetInst);
}
function $fc2e98617fc942d3$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $fc2e98617fc942d3$var$getInstIfValueChanged(targetInst);
}
function $fc2e98617fc942d3$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $fc2e98617fc942d3$var$objectIs = "function" === typeof Object.is ? Object.is : $fc2e98617fc942d3$var$is;
function $fc2e98617fc942d3$var$shallowEqual(objA, objB) {
    if ($fc2e98617fc942d3$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$fc2e98617fc942d3$var$hasOwnProperty.call(objB, currentKey) || !$fc2e98617fc942d3$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $fc2e98617fc942d3$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $fc2e98617fc942d3$var$getNodeForCharacterOffset(root, offset) {
    var node = $fc2e98617fc942d3$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $fc2e98617fc942d3$var$getLeafNode(node);
    }
}
function $fc2e98617fc942d3$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $fc2e98617fc942d3$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $fc2e98617fc942d3$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $fc2e98617fc942d3$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $fc2e98617fc942d3$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $fc2e98617fc942d3$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $fc2e98617fc942d3$var$skipSelectionChangeEvent = $fc2e98617fc942d3$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $fc2e98617fc942d3$var$activeElement = null, $fc2e98617fc942d3$var$activeElementInst = null, $fc2e98617fc942d3$var$lastSelection = null, $fc2e98617fc942d3$var$mouseDown = !1;
function $fc2e98617fc942d3$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $fc2e98617fc942d3$var$mouseDown || null == $fc2e98617fc942d3$var$activeElement || $fc2e98617fc942d3$var$activeElement !== $fc2e98617fc942d3$var$getActiveElement(doc) || (doc = $fc2e98617fc942d3$var$activeElement, "selectionStart" in doc && $fc2e98617fc942d3$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $fc2e98617fc942d3$var$lastSelection && $fc2e98617fc942d3$var$shallowEqual($fc2e98617fc942d3$var$lastSelection, doc) || ($fc2e98617fc942d3$var$lastSelection = doc, doc = $fc2e98617fc942d3$var$accumulateTwoPhaseListeners($fc2e98617fc942d3$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $fc2e98617fc942d3$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $fc2e98617fc942d3$var$activeElement)));
}
function $fc2e98617fc942d3$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $fc2e98617fc942d3$var$vendorPrefixes = {
    animationend: $fc2e98617fc942d3$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $fc2e98617fc942d3$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $fc2e98617fc942d3$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $fc2e98617fc942d3$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $fc2e98617fc942d3$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $fc2e98617fc942d3$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $fc2e98617fc942d3$var$makePrefixMap("Transition", "TransitionEnd")
}, $fc2e98617fc942d3$var$prefixedEventNames = {}, $fc2e98617fc942d3$var$style = {};
$fc2e98617fc942d3$var$canUseDOM && ($fc2e98617fc942d3$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $fc2e98617fc942d3$var$vendorPrefixes.animationend.animation, delete $fc2e98617fc942d3$var$vendorPrefixes.animationiteration.animation, delete $fc2e98617fc942d3$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $fc2e98617fc942d3$var$vendorPrefixes.transitionend.transition);
function $fc2e98617fc942d3$var$getVendorPrefixedEventName(eventName) {
    if ($fc2e98617fc942d3$var$prefixedEventNames[eventName]) return $fc2e98617fc942d3$var$prefixedEventNames[eventName];
    if (!$fc2e98617fc942d3$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $fc2e98617fc942d3$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $fc2e98617fc942d3$var$style) return $fc2e98617fc942d3$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $fc2e98617fc942d3$var$ANIMATION_END = $fc2e98617fc942d3$var$getVendorPrefixedEventName("animationend"), $fc2e98617fc942d3$var$ANIMATION_ITERATION = $fc2e98617fc942d3$var$getVendorPrefixedEventName("animationiteration"), $fc2e98617fc942d3$var$ANIMATION_START = $fc2e98617fc942d3$var$getVendorPrefixedEventName("animationstart"), $fc2e98617fc942d3$var$TRANSITION_RUN = $fc2e98617fc942d3$var$getVendorPrefixedEventName("transitionrun"), $fc2e98617fc942d3$var$TRANSITION_START = $fc2e98617fc942d3$var$getVendorPrefixedEventName("transitionstart"), $fc2e98617fc942d3$var$TRANSITION_CANCEL = $fc2e98617fc942d3$var$getVendorPrefixedEventName("transitioncancel"), $fc2e98617fc942d3$var$TRANSITION_END = $fc2e98617fc942d3$var$getVendorPrefixedEventName("transitionend"), $fc2e98617fc942d3$var$topLevelEventsToReactNames = new Map(), $fc2e98617fc942d3$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$fc2e98617fc942d3$var$simpleEventPluginEvents.push("scrollEnd");
function $fc2e98617fc942d3$var$registerSimpleEvent(domEventName, reactName) {
    $fc2e98617fc942d3$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $fc2e98617fc942d3$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $fc2e98617fc942d3$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $fc2e98617fc942d3$var$concurrentQueues = [], $fc2e98617fc942d3$var$concurrentQueuesIndex = 0, $fc2e98617fc942d3$var$concurrentlyUpdatedLanes = 0;
function $fc2e98617fc942d3$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $fc2e98617fc942d3$var$concurrentQueuesIndex, i = $fc2e98617fc942d3$var$concurrentlyUpdatedLanes = $fc2e98617fc942d3$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $fc2e98617fc942d3$var$concurrentQueues[i];
        $fc2e98617fc942d3$var$concurrentQueues[i++] = null;
        var queue = $fc2e98617fc942d3$var$concurrentQueues[i];
        $fc2e98617fc942d3$var$concurrentQueues[i++] = null;
        var update = $fc2e98617fc942d3$var$concurrentQueues[i];
        $fc2e98617fc942d3$var$concurrentQueues[i++] = null;
        var lane = $fc2e98617fc942d3$var$concurrentQueues[i];
        $fc2e98617fc942d3$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $fc2e98617fc942d3$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $fc2e98617fc942d3$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $fc2e98617fc942d3$var$concurrentQueues[$fc2e98617fc942d3$var$concurrentQueuesIndex++] = fiber;
    $fc2e98617fc942d3$var$concurrentQueues[$fc2e98617fc942d3$var$concurrentQueuesIndex++] = queue;
    $fc2e98617fc942d3$var$concurrentQueues[$fc2e98617fc942d3$var$concurrentQueuesIndex++] = update;
    $fc2e98617fc942d3$var$concurrentQueues[$fc2e98617fc942d3$var$concurrentQueuesIndex++] = lane;
    $fc2e98617fc942d3$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $fc2e98617fc942d3$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $fc2e98617fc942d3$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $fc2e98617fc942d3$var$getRootForUpdatedFiber(fiber);
}
function $fc2e98617fc942d3$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $fc2e98617fc942d3$var$enqueueUpdate$1(fiber, null, null, lane);
    return $fc2e98617fc942d3$var$getRootForUpdatedFiber(fiber);
}
function $fc2e98617fc942d3$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $fc2e98617fc942d3$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $fc2e98617fc942d3$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $fc2e98617fc942d3$var$nestedUpdateCount) throw $fc2e98617fc942d3$var$nestedUpdateCount = 0, $fc2e98617fc942d3$var$rootWithNestedUpdates = null, Error($fc2e98617fc942d3$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $fc2e98617fc942d3$var$emptyContextObject = {};
function $fc2e98617fc942d3$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $fc2e98617fc942d3$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $fc2e98617fc942d3$var$FiberNode(tag, pendingProps, key, mode);
}
function $fc2e98617fc942d3$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $fc2e98617fc942d3$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $fc2e98617fc942d3$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $fc2e98617fc942d3$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $fc2e98617fc942d3$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $fc2e98617fc942d3$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $fc2e98617fc942d3$var$isHostHoistableType(type, pendingProps, $fc2e98617fc942d3$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $fc2e98617fc942d3$var$REACT_ACTIVITY_TYPE:
            return type = $fc2e98617fc942d3$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $fc2e98617fc942d3$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $fc2e98617fc942d3$var$REACT_FRAGMENT_TYPE:
            return $fc2e98617fc942d3$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $fc2e98617fc942d3$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $fc2e98617fc942d3$var$REACT_PROFILER_TYPE:
            return type = $fc2e98617fc942d3$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $fc2e98617fc942d3$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $fc2e98617fc942d3$var$REACT_SUSPENSE_TYPE:
            return type = $fc2e98617fc942d3$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $fc2e98617fc942d3$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $fc2e98617fc942d3$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $fc2e98617fc942d3$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $fc2e98617fc942d3$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $fc2e98617fc942d3$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $fc2e98617fc942d3$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $fc2e98617fc942d3$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $fc2e98617fc942d3$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $fc2e98617fc942d3$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($fc2e98617fc942d3$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $fc2e98617fc942d3$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $fc2e98617fc942d3$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $fc2e98617fc942d3$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $fc2e98617fc942d3$var$createFiberFromText(content, mode, lanes) {
    content = $fc2e98617fc942d3$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $fc2e98617fc942d3$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $fc2e98617fc942d3$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $fc2e98617fc942d3$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $fc2e98617fc942d3$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $fc2e98617fc942d3$var$CapturedStacks = new WeakMap();
function $fc2e98617fc942d3$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $fc2e98617fc942d3$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $fc2e98617fc942d3$var$getStackByFiberInDevAndProd(source)
        };
        $fc2e98617fc942d3$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $fc2e98617fc942d3$var$getStackByFiberInDevAndProd(source)
    };
}
var $fc2e98617fc942d3$var$forkStack = [], $fc2e98617fc942d3$var$forkStackIndex = 0, $fc2e98617fc942d3$var$treeForkProvider = null, $fc2e98617fc942d3$var$treeForkCount = 0, $fc2e98617fc942d3$var$idStack = [], $fc2e98617fc942d3$var$idStackIndex = 0, $fc2e98617fc942d3$var$treeContextProvider = null, $fc2e98617fc942d3$var$treeContextId = 1, $fc2e98617fc942d3$var$treeContextOverflow = "";
function $fc2e98617fc942d3$var$pushTreeFork(workInProgress, totalChildren) {
    $fc2e98617fc942d3$var$forkStack[$fc2e98617fc942d3$var$forkStackIndex++] = $fc2e98617fc942d3$var$treeForkCount;
    $fc2e98617fc942d3$var$forkStack[$fc2e98617fc942d3$var$forkStackIndex++] = $fc2e98617fc942d3$var$treeForkProvider;
    $fc2e98617fc942d3$var$treeForkProvider = workInProgress;
    $fc2e98617fc942d3$var$treeForkCount = totalChildren;
}
function $fc2e98617fc942d3$var$pushTreeId(workInProgress, totalChildren, index) {
    $fc2e98617fc942d3$var$idStack[$fc2e98617fc942d3$var$idStackIndex++] = $fc2e98617fc942d3$var$treeContextId;
    $fc2e98617fc942d3$var$idStack[$fc2e98617fc942d3$var$idStackIndex++] = $fc2e98617fc942d3$var$treeContextOverflow;
    $fc2e98617fc942d3$var$idStack[$fc2e98617fc942d3$var$idStackIndex++] = $fc2e98617fc942d3$var$treeContextProvider;
    $fc2e98617fc942d3$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $fc2e98617fc942d3$var$treeContextId;
    workInProgress = $fc2e98617fc942d3$var$treeContextOverflow;
    var baseLength = 32 - $fc2e98617fc942d3$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $fc2e98617fc942d3$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $fc2e98617fc942d3$var$treeContextId = 1 << 32 - $fc2e98617fc942d3$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $fc2e98617fc942d3$var$treeContextOverflow = length + workInProgress;
    } else $fc2e98617fc942d3$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $fc2e98617fc942d3$var$treeContextOverflow = workInProgress;
}
function $fc2e98617fc942d3$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($fc2e98617fc942d3$var$pushTreeFork(workInProgress, 1), $fc2e98617fc942d3$var$pushTreeId(workInProgress, 1, 0));
}
function $fc2e98617fc942d3$var$popTreeContext(workInProgress) {
    for(; workInProgress === $fc2e98617fc942d3$var$treeForkProvider;)$fc2e98617fc942d3$var$treeForkProvider = $fc2e98617fc942d3$var$forkStack[--$fc2e98617fc942d3$var$forkStackIndex], $fc2e98617fc942d3$var$forkStack[$fc2e98617fc942d3$var$forkStackIndex] = null, $fc2e98617fc942d3$var$treeForkCount = $fc2e98617fc942d3$var$forkStack[--$fc2e98617fc942d3$var$forkStackIndex], $fc2e98617fc942d3$var$forkStack[$fc2e98617fc942d3$var$forkStackIndex] = null;
    for(; workInProgress === $fc2e98617fc942d3$var$treeContextProvider;)$fc2e98617fc942d3$var$treeContextProvider = $fc2e98617fc942d3$var$idStack[--$fc2e98617fc942d3$var$idStackIndex], $fc2e98617fc942d3$var$idStack[$fc2e98617fc942d3$var$idStackIndex] = null, $fc2e98617fc942d3$var$treeContextOverflow = $fc2e98617fc942d3$var$idStack[--$fc2e98617fc942d3$var$idStackIndex], $fc2e98617fc942d3$var$idStack[$fc2e98617fc942d3$var$idStackIndex] = null, $fc2e98617fc942d3$var$treeContextId = $fc2e98617fc942d3$var$idStack[--$fc2e98617fc942d3$var$idStackIndex], $fc2e98617fc942d3$var$idStack[$fc2e98617fc942d3$var$idStackIndex] = null;
}
function $fc2e98617fc942d3$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $fc2e98617fc942d3$var$idStack[$fc2e98617fc942d3$var$idStackIndex++] = $fc2e98617fc942d3$var$treeContextId;
    $fc2e98617fc942d3$var$idStack[$fc2e98617fc942d3$var$idStackIndex++] = $fc2e98617fc942d3$var$treeContextOverflow;
    $fc2e98617fc942d3$var$idStack[$fc2e98617fc942d3$var$idStackIndex++] = $fc2e98617fc942d3$var$treeContextProvider;
    $fc2e98617fc942d3$var$treeContextId = suspendedContext.id;
    $fc2e98617fc942d3$var$treeContextOverflow = suspendedContext.overflow;
    $fc2e98617fc942d3$var$treeContextProvider = workInProgress;
}
var $fc2e98617fc942d3$var$hydrationParentFiber = null, $fc2e98617fc942d3$var$nextHydratableInstance = null, $fc2e98617fc942d3$var$isHydrating = !1, $fc2e98617fc942d3$var$hydrationErrors = null, $fc2e98617fc942d3$var$rootOrSingletonContext = !1, $fc2e98617fc942d3$var$HydrationMismatchException = Error($fc2e98617fc942d3$var$formatProdErrorMessage(519));
function $fc2e98617fc942d3$var$throwOnHydrationMismatch(fiber) {
    var error = Error($fc2e98617fc942d3$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $fc2e98617fc942d3$var$queueHydrationError($fc2e98617fc942d3$var$createCapturedValueAtFiber(error, fiber));
    throw $fc2e98617fc942d3$var$HydrationMismatchException;
}
function $fc2e98617fc942d3$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$fc2e98617fc942d3$var$internalInstanceKey] = fiber;
    instance[$fc2e98617fc942d3$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $fc2e98617fc942d3$var$listenToNonDelegatedEvent("cancel", instance);
            $fc2e98617fc942d3$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $fc2e98617fc942d3$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $fc2e98617fc942d3$var$mediaEventTypes.length; type++)$fc2e98617fc942d3$var$listenToNonDelegatedEvent($fc2e98617fc942d3$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $fc2e98617fc942d3$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $fc2e98617fc942d3$var$listenToNonDelegatedEvent("error", instance);
            $fc2e98617fc942d3$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $fc2e98617fc942d3$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $fc2e98617fc942d3$var$listenToNonDelegatedEvent("invalid", instance);
            $fc2e98617fc942d3$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $fc2e98617fc942d3$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $fc2e98617fc942d3$var$listenToNonDelegatedEvent("invalid", instance), $fc2e98617fc942d3$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $fc2e98617fc942d3$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($fc2e98617fc942d3$var$listenToNonDelegatedEvent("beforetoggle", instance), $fc2e98617fc942d3$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $fc2e98617fc942d3$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $fc2e98617fc942d3$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $fc2e98617fc942d3$var$noop$1), instance = !0) : instance = !1;
    instance || $fc2e98617fc942d3$var$throwOnHydrationMismatch(fiber, !0);
}
function $fc2e98617fc942d3$var$popToNextHostParent(fiber) {
    for($fc2e98617fc942d3$var$hydrationParentFiber = fiber.return; $fc2e98617fc942d3$var$hydrationParentFiber;)switch($fc2e98617fc942d3$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $fc2e98617fc942d3$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $fc2e98617fc942d3$var$rootOrSingletonContext = !0;
            return;
        default:
            $fc2e98617fc942d3$var$hydrationParentFiber = $fc2e98617fc942d3$var$hydrationParentFiber.return;
    }
}
function $fc2e98617fc942d3$var$popHydrationState(fiber) {
    if (fiber !== $fc2e98617fc942d3$var$hydrationParentFiber) return !1;
    if (!$fc2e98617fc942d3$var$isHydrating) return $fc2e98617fc942d3$var$popToNextHostParent(fiber), $fc2e98617fc942d3$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $fc2e98617fc942d3$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $fc2e98617fc942d3$var$nextHydratableInstance && $fc2e98617fc942d3$var$throwOnHydrationMismatch(fiber);
    $fc2e98617fc942d3$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(317));
        $fc2e98617fc942d3$var$nextHydratableInstance = $fc2e98617fc942d3$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(317));
        $fc2e98617fc942d3$var$nextHydratableInstance = $fc2e98617fc942d3$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $fc2e98617fc942d3$var$nextHydratableInstance, $fc2e98617fc942d3$var$isSingletonScope(fiber.type) ? (fiber = $fc2e98617fc942d3$var$previousHydratableOnEnteringScopedSingleton, $fc2e98617fc942d3$var$previousHydratableOnEnteringScopedSingleton = null, $fc2e98617fc942d3$var$nextHydratableInstance = fiber) : $fc2e98617fc942d3$var$nextHydratableInstance = tag) : $fc2e98617fc942d3$var$nextHydratableInstance = $fc2e98617fc942d3$var$hydrationParentFiber ? $fc2e98617fc942d3$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $fc2e98617fc942d3$var$resetHydrationState() {
    $fc2e98617fc942d3$var$nextHydratableInstance = $fc2e98617fc942d3$var$hydrationParentFiber = null;
    $fc2e98617fc942d3$var$isHydrating = !1;
}
function $fc2e98617fc942d3$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $fc2e98617fc942d3$var$hydrationErrors;
    null !== queuedErrors && (null === $fc2e98617fc942d3$var$workInProgressRootRecoverableErrors ? $fc2e98617fc942d3$var$workInProgressRootRecoverableErrors = queuedErrors : $fc2e98617fc942d3$var$workInProgressRootRecoverableErrors.push.apply($fc2e98617fc942d3$var$workInProgressRootRecoverableErrors, queuedErrors), $fc2e98617fc942d3$var$hydrationErrors = null);
    return queuedErrors;
}
function $fc2e98617fc942d3$var$queueHydrationError(error) {
    null === $fc2e98617fc942d3$var$hydrationErrors ? $fc2e98617fc942d3$var$hydrationErrors = [
        error
    ] : $fc2e98617fc942d3$var$hydrationErrors.push(error);
}
var $fc2e98617fc942d3$var$valueCursor = $fc2e98617fc942d3$var$createCursor(null), $fc2e98617fc942d3$var$currentlyRenderingFiber$1 = null, $fc2e98617fc942d3$var$lastContextDependency = null;
function $fc2e98617fc942d3$var$pushProvider(providerFiber, context, nextValue) {
    $fc2e98617fc942d3$var$push($fc2e98617fc942d3$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $fc2e98617fc942d3$var$popProvider(context) {
    context._currentValue = $fc2e98617fc942d3$var$valueCursor.current;
    $fc2e98617fc942d3$var$pop($fc2e98617fc942d3$var$valueCursor);
}
function $fc2e98617fc942d3$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $fc2e98617fc942d3$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $fc2e98617fc942d3$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $fc2e98617fc942d3$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $fc2e98617fc942d3$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $fc2e98617fc942d3$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $fc2e98617fc942d3$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($fc2e98617fc942d3$var$HostTransitionContext) : current = [
                $fc2e98617fc942d3$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $fc2e98617fc942d3$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $fc2e98617fc942d3$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$fc2e98617fc942d3$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $fc2e98617fc942d3$var$prepareToReadContext(workInProgress) {
    $fc2e98617fc942d3$var$currentlyRenderingFiber$1 = workInProgress;
    $fc2e98617fc942d3$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $fc2e98617fc942d3$var$readContext(context) {
    return $fc2e98617fc942d3$var$readContextForConsumer($fc2e98617fc942d3$var$currentlyRenderingFiber$1, context);
}
function $fc2e98617fc942d3$var$readContextDuringReconciliation(consumer, context) {
    null === $fc2e98617fc942d3$var$currentlyRenderingFiber$1 && $fc2e98617fc942d3$var$prepareToReadContext(consumer);
    return $fc2e98617fc942d3$var$readContextForConsumer(consumer, context);
}
function $fc2e98617fc942d3$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $fc2e98617fc942d3$var$lastContextDependency) {
        if (null === consumer) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(308));
        $fc2e98617fc942d3$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $fc2e98617fc942d3$var$lastContextDependency = $fc2e98617fc942d3$var$lastContextDependency.next = context;
    return value;
}
var $fc2e98617fc942d3$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $fc2e98617fc942d3$var$scheduleCallback$2 = $3Txiq.unstable_scheduleCallback, $fc2e98617fc942d3$var$NormalPriority = $3Txiq.unstable_NormalPriority, $fc2e98617fc942d3$var$CacheContext = {
    $$typeof: $fc2e98617fc942d3$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $fc2e98617fc942d3$var$createCache() {
    return {
        controller: new $fc2e98617fc942d3$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $fc2e98617fc942d3$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $fc2e98617fc942d3$var$scheduleCallback$2($fc2e98617fc942d3$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $fc2e98617fc942d3$var$currentEntangledListeners = null, $fc2e98617fc942d3$var$currentEntangledPendingCount = 0, $fc2e98617fc942d3$var$currentEntangledLane = 0, $fc2e98617fc942d3$var$currentEntangledActionThenable = null;
function $fc2e98617fc942d3$var$entangleAsyncAction(transition, thenable) {
    if (null === $fc2e98617fc942d3$var$currentEntangledListeners) {
        var entangledListeners = $fc2e98617fc942d3$var$currentEntangledListeners = [];
        $fc2e98617fc942d3$var$currentEntangledPendingCount = 0;
        $fc2e98617fc942d3$var$currentEntangledLane = $fc2e98617fc942d3$var$requestTransitionLane();
        $fc2e98617fc942d3$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $fc2e98617fc942d3$var$currentEntangledPendingCount++;
    thenable.then($fc2e98617fc942d3$var$pingEngtangledActionScope, $fc2e98617fc942d3$var$pingEngtangledActionScope);
    return thenable;
}
function $fc2e98617fc942d3$var$pingEngtangledActionScope() {
    if (0 === --$fc2e98617fc942d3$var$currentEntangledPendingCount && null !== $fc2e98617fc942d3$var$currentEntangledListeners) {
        null !== $fc2e98617fc942d3$var$currentEntangledActionThenable && ($fc2e98617fc942d3$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $fc2e98617fc942d3$var$currentEntangledListeners;
        $fc2e98617fc942d3$var$currentEntangledListeners = null;
        $fc2e98617fc942d3$var$currentEntangledLane = 0;
        $fc2e98617fc942d3$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $fc2e98617fc942d3$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $fc2e98617fc942d3$var$prevOnStartTransitionFinish = $fc2e98617fc942d3$var$ReactSharedInternals.S;
$fc2e98617fc942d3$var$ReactSharedInternals.S = function(transition, returnValue) {
    $fc2e98617fc942d3$var$globalMostRecentTransitionTime = $fc2e98617fc942d3$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $fc2e98617fc942d3$var$entangleAsyncAction(transition, returnValue);
    null !== $fc2e98617fc942d3$var$prevOnStartTransitionFinish && $fc2e98617fc942d3$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $fc2e98617fc942d3$var$resumedCache = $fc2e98617fc942d3$var$createCursor(null);
function $fc2e98617fc942d3$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $fc2e98617fc942d3$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $fc2e98617fc942d3$var$workInProgressRoot.pooledCache;
}
function $fc2e98617fc942d3$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $fc2e98617fc942d3$var$push($fc2e98617fc942d3$var$resumedCache, $fc2e98617fc942d3$var$resumedCache.current) : $fc2e98617fc942d3$var$push($fc2e98617fc942d3$var$resumedCache, prevCachePool.pool);
}
function $fc2e98617fc942d3$var$getSuspendedCache() {
    var cacheFromPool = $fc2e98617fc942d3$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $fc2e98617fc942d3$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $fc2e98617fc942d3$var$SuspenseException = Error($fc2e98617fc942d3$var$formatProdErrorMessage(460)), $fc2e98617fc942d3$var$SuspenseyCommitException = Error($fc2e98617fc942d3$var$formatProdErrorMessage(474)), $fc2e98617fc942d3$var$SuspenseActionException = Error($fc2e98617fc942d3$var$formatProdErrorMessage(542)), $fc2e98617fc942d3$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $fc2e98617fc942d3$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $fc2e98617fc942d3$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($fc2e98617fc942d3$var$noop$1, $fc2e98617fc942d3$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $fc2e98617fc942d3$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($fc2e98617fc942d3$var$noop$1, $fc2e98617fc942d3$var$noop$1);
            else {
                thenableState = $fc2e98617fc942d3$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $fc2e98617fc942d3$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $fc2e98617fc942d3$var$suspendedThenable = thenable;
            throw $fc2e98617fc942d3$var$SuspenseException;
    }
}
function $fc2e98617fc942d3$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $fc2e98617fc942d3$var$suspendedThenable = x, $fc2e98617fc942d3$var$SuspenseException;
        throw x;
    }
}
var $fc2e98617fc942d3$var$suspendedThenable = null;
function $fc2e98617fc942d3$var$getSuspendedThenable() {
    if (null === $fc2e98617fc942d3$var$suspendedThenable) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(459));
    var thenable = $fc2e98617fc942d3$var$suspendedThenable;
    $fc2e98617fc942d3$var$suspendedThenable = null;
    return thenable;
}
function $fc2e98617fc942d3$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $fc2e98617fc942d3$var$SuspenseException || rejectedReason === $fc2e98617fc942d3$var$SuspenseActionException) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(483));
}
var $fc2e98617fc942d3$var$thenableState$1 = null, $fc2e98617fc942d3$var$thenableIndexCounter$1 = 0;
function $fc2e98617fc942d3$var$unwrapThenable(thenable) {
    var index = $fc2e98617fc942d3$var$thenableIndexCounter$1;
    $fc2e98617fc942d3$var$thenableIndexCounter$1 += 1;
    null === $fc2e98617fc942d3$var$thenableState$1 && ($fc2e98617fc942d3$var$thenableState$1 = []);
    return $fc2e98617fc942d3$var$trackUsedThenable($fc2e98617fc942d3$var$thenableState$1, thenable, index);
}
function $fc2e98617fc942d3$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $fc2e98617fc942d3$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $fc2e98617fc942d3$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $fc2e98617fc942d3$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $fc2e98617fc942d3$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $fc2e98617fc942d3$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $fc2e98617fc942d3$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $fc2e98617fc942d3$var$REACT_LAZY_TYPE && $fc2e98617fc942d3$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $fc2e98617fc942d3$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $fc2e98617fc942d3$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $fc2e98617fc942d3$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $fc2e98617fc942d3$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $fc2e98617fc942d3$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $fc2e98617fc942d3$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $fc2e98617fc942d3$var$REACT_ELEMENT_TYPE:
                    return lanes = $fc2e98617fc942d3$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $fc2e98617fc942d3$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $fc2e98617fc942d3$var$REACT_PORTAL_TYPE:
                    return newChild = $fc2e98617fc942d3$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $fc2e98617fc942d3$var$REACT_LAZY_TYPE:
                    return newChild = $fc2e98617fc942d3$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($fc2e98617fc942d3$var$isArrayImpl(newChild) || $fc2e98617fc942d3$var$getIteratorFn(newChild)) return newChild = $fc2e98617fc942d3$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $fc2e98617fc942d3$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $fc2e98617fc942d3$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $fc2e98617fc942d3$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $fc2e98617fc942d3$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $fc2e98617fc942d3$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $fc2e98617fc942d3$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $fc2e98617fc942d3$var$REACT_LAZY_TYPE:
                    return newChild = $fc2e98617fc942d3$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($fc2e98617fc942d3$var$isArrayImpl(newChild) || $fc2e98617fc942d3$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $fc2e98617fc942d3$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $fc2e98617fc942d3$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $fc2e98617fc942d3$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $fc2e98617fc942d3$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $fc2e98617fc942d3$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $fc2e98617fc942d3$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $fc2e98617fc942d3$var$REACT_LAZY_TYPE:
                    return newChild = $fc2e98617fc942d3$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($fc2e98617fc942d3$var$isArrayImpl(newChild) || $fc2e98617fc942d3$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $fc2e98617fc942d3$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $fc2e98617fc942d3$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $fc2e98617fc942d3$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $fc2e98617fc942d3$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $fc2e98617fc942d3$var$isHydrating && $fc2e98617fc942d3$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $fc2e98617fc942d3$var$isHydrating && $fc2e98617fc942d3$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $fc2e98617fc942d3$var$isHydrating && $fc2e98617fc942d3$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $fc2e98617fc942d3$var$isHydrating && $fc2e98617fc942d3$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $fc2e98617fc942d3$var$isHydrating && $fc2e98617fc942d3$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $fc2e98617fc942d3$var$isHydrating && $fc2e98617fc942d3$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $fc2e98617fc942d3$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $fc2e98617fc942d3$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $fc2e98617fc942d3$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $fc2e98617fc942d3$var$REACT_LAZY_TYPE && $fc2e98617fc942d3$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $fc2e98617fc942d3$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $fc2e98617fc942d3$var$REACT_FRAGMENT_TYPE ? (lanes = $fc2e98617fc942d3$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $fc2e98617fc942d3$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $fc2e98617fc942d3$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $fc2e98617fc942d3$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $fc2e98617fc942d3$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $fc2e98617fc942d3$var$REACT_LAZY_TYPE:
                    return newChild = $fc2e98617fc942d3$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($fc2e98617fc942d3$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($fc2e98617fc942d3$var$getIteratorFn(newChild)) {
                key = $fc2e98617fc942d3$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $fc2e98617fc942d3$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $fc2e98617fc942d3$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $fc2e98617fc942d3$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $fc2e98617fc942d3$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $fc2e98617fc942d3$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $fc2e98617fc942d3$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $fc2e98617fc942d3$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $fc2e98617fc942d3$var$SuspenseException || x === $fc2e98617fc942d3$var$SuspenseActionException) throw x;
            var fiber = $fc2e98617fc942d3$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $fc2e98617fc942d3$var$reconcileChildFibers = $fc2e98617fc942d3$var$createChildReconciler(!0), $fc2e98617fc942d3$var$mountChildFibers = $fc2e98617fc942d3$var$createChildReconciler(!1), $fc2e98617fc942d3$var$hasForceUpdate = !1;
function $fc2e98617fc942d3$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $fc2e98617fc942d3$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $fc2e98617fc942d3$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $fc2e98617fc942d3$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($fc2e98617fc942d3$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $fc2e98617fc942d3$var$getRootForUpdatedFiber(fiber);
        $fc2e98617fc942d3$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $fc2e98617fc942d3$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $fc2e98617fc942d3$var$getRootForUpdatedFiber(fiber);
}
function $fc2e98617fc942d3$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $fc2e98617fc942d3$var$markRootEntangled(root, lane);
    }
}
function $fc2e98617fc942d3$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $fc2e98617fc942d3$var$didReadFromEntangledAsyncAction = !1;
function $fc2e98617fc942d3$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($fc2e98617fc942d3$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $fc2e98617fc942d3$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $fc2e98617fc942d3$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $fc2e98617fc942d3$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $fc2e98617fc942d3$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($fc2e98617fc942d3$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $fc2e98617fc942d3$var$currentEntangledLane && ($fc2e98617fc942d3$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $fc2e98617fc942d3$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $fc2e98617fc942d3$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $fc2e98617fc942d3$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $fc2e98617fc942d3$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $fc2e98617fc942d3$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$fc2e98617fc942d3$var$callCallback(callbacks[updateQueue], context);
}
var $fc2e98617fc942d3$var$currentTreeHiddenStackCursor = $fc2e98617fc942d3$var$createCursor(null), $fc2e98617fc942d3$var$prevEntangledRenderLanesCursor = $fc2e98617fc942d3$var$createCursor(0);
function $fc2e98617fc942d3$var$pushHiddenContext(fiber, context) {
    fiber = $fc2e98617fc942d3$var$entangledRenderLanes;
    $fc2e98617fc942d3$var$push($fc2e98617fc942d3$var$prevEntangledRenderLanesCursor, fiber);
    $fc2e98617fc942d3$var$push($fc2e98617fc942d3$var$currentTreeHiddenStackCursor, context);
    $fc2e98617fc942d3$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $fc2e98617fc942d3$var$reuseHiddenContextOnStack() {
    $fc2e98617fc942d3$var$push($fc2e98617fc942d3$var$prevEntangledRenderLanesCursor, $fc2e98617fc942d3$var$entangledRenderLanes);
    $fc2e98617fc942d3$var$push($fc2e98617fc942d3$var$currentTreeHiddenStackCursor, $fc2e98617fc942d3$var$currentTreeHiddenStackCursor.current);
}
function $fc2e98617fc942d3$var$popHiddenContext() {
    $fc2e98617fc942d3$var$entangledRenderLanes = $fc2e98617fc942d3$var$prevEntangledRenderLanesCursor.current;
    $fc2e98617fc942d3$var$pop($fc2e98617fc942d3$var$currentTreeHiddenStackCursor);
    $fc2e98617fc942d3$var$pop($fc2e98617fc942d3$var$prevEntangledRenderLanesCursor);
}
var $fc2e98617fc942d3$var$suspenseHandlerStackCursor = $fc2e98617fc942d3$var$createCursor(null), $fc2e98617fc942d3$var$shellBoundary = null;
function $fc2e98617fc942d3$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $fc2e98617fc942d3$var$push($fc2e98617fc942d3$var$suspenseStackCursor, $fc2e98617fc942d3$var$suspenseStackCursor.current & 1);
    $fc2e98617fc942d3$var$push($fc2e98617fc942d3$var$suspenseHandlerStackCursor, handler);
    null === $fc2e98617fc942d3$var$shellBoundary && (null === current || null !== $fc2e98617fc942d3$var$currentTreeHiddenStackCursor.current ? $fc2e98617fc942d3$var$shellBoundary = handler : null !== current.memoizedState && ($fc2e98617fc942d3$var$shellBoundary = handler));
}
function $fc2e98617fc942d3$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $fc2e98617fc942d3$var$push($fc2e98617fc942d3$var$suspenseStackCursor, $fc2e98617fc942d3$var$suspenseStackCursor.current);
    $fc2e98617fc942d3$var$push($fc2e98617fc942d3$var$suspenseHandlerStackCursor, fiber);
    null === $fc2e98617fc942d3$var$shellBoundary && ($fc2e98617fc942d3$var$shellBoundary = fiber);
}
function $fc2e98617fc942d3$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($fc2e98617fc942d3$var$push($fc2e98617fc942d3$var$suspenseStackCursor, $fc2e98617fc942d3$var$suspenseStackCursor.current), $fc2e98617fc942d3$var$push($fc2e98617fc942d3$var$suspenseHandlerStackCursor, fiber), null === $fc2e98617fc942d3$var$shellBoundary && ($fc2e98617fc942d3$var$shellBoundary = fiber)) : $fc2e98617fc942d3$var$reuseSuspenseHandlerOnStack(fiber);
}
function $fc2e98617fc942d3$var$reuseSuspenseHandlerOnStack() {
    $fc2e98617fc942d3$var$push($fc2e98617fc942d3$var$suspenseStackCursor, $fc2e98617fc942d3$var$suspenseStackCursor.current);
    $fc2e98617fc942d3$var$push($fc2e98617fc942d3$var$suspenseHandlerStackCursor, $fc2e98617fc942d3$var$suspenseHandlerStackCursor.current);
}
function $fc2e98617fc942d3$var$popSuspenseHandler(fiber) {
    $fc2e98617fc942d3$var$pop($fc2e98617fc942d3$var$suspenseHandlerStackCursor);
    $fc2e98617fc942d3$var$shellBoundary === fiber && ($fc2e98617fc942d3$var$shellBoundary = null);
    $fc2e98617fc942d3$var$pop($fc2e98617fc942d3$var$suspenseStackCursor);
}
var $fc2e98617fc942d3$var$suspenseStackCursor = $fc2e98617fc942d3$var$createCursor(0);
function $fc2e98617fc942d3$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $fc2e98617fc942d3$var$isSuspenseInstancePending(state) || $fc2e98617fc942d3$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $fc2e98617fc942d3$var$renderLanes = 0, $fc2e98617fc942d3$var$currentlyRenderingFiber = null, $fc2e98617fc942d3$var$currentHook = null, $fc2e98617fc942d3$var$workInProgressHook = null, $fc2e98617fc942d3$var$didScheduleRenderPhaseUpdate = !1, $fc2e98617fc942d3$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $fc2e98617fc942d3$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $fc2e98617fc942d3$var$localIdCounter = 0, $fc2e98617fc942d3$var$thenableIndexCounter = 0, $fc2e98617fc942d3$var$thenableState = null, $fc2e98617fc942d3$var$globalClientIdCounter = 0;
function $fc2e98617fc942d3$var$throwInvalidHookError() {
    throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(321));
}
function $fc2e98617fc942d3$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$fc2e98617fc942d3$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $fc2e98617fc942d3$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $fc2e98617fc942d3$var$renderLanes = nextRenderLanes;
    $fc2e98617fc942d3$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $fc2e98617fc942d3$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $fc2e98617fc942d3$var$HooksDispatcherOnMount : $fc2e98617fc942d3$var$HooksDispatcherOnUpdate;
    $fc2e98617fc942d3$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $fc2e98617fc942d3$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $fc2e98617fc942d3$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $fc2e98617fc942d3$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $fc2e98617fc942d3$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $fc2e98617fc942d3$var$finishRenderingHooks(current) {
    $fc2e98617fc942d3$var$ReactSharedInternals.H = $fc2e98617fc942d3$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $fc2e98617fc942d3$var$currentHook && null !== $fc2e98617fc942d3$var$currentHook.next;
    $fc2e98617fc942d3$var$renderLanes = 0;
    $fc2e98617fc942d3$var$workInProgressHook = $fc2e98617fc942d3$var$currentHook = $fc2e98617fc942d3$var$currentlyRenderingFiber = null;
    $fc2e98617fc942d3$var$didScheduleRenderPhaseUpdate = !1;
    $fc2e98617fc942d3$var$thenableIndexCounter = 0;
    $fc2e98617fc942d3$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(300));
    null === current || $fc2e98617fc942d3$var$didReceiveUpdate || (current = current.dependencies, null !== current && $fc2e98617fc942d3$var$checkIfContextChanged(current) && ($fc2e98617fc942d3$var$didReceiveUpdate = !0));
}
function $fc2e98617fc942d3$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $fc2e98617fc942d3$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $fc2e98617fc942d3$var$didScheduleRenderPhaseUpdateDuringThisPass && ($fc2e98617fc942d3$var$thenableState = null);
        $fc2e98617fc942d3$var$thenableIndexCounter = 0;
        $fc2e98617fc942d3$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $fc2e98617fc942d3$var$workInProgressHook = $fc2e98617fc942d3$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $fc2e98617fc942d3$var$ReactSharedInternals.H = $fc2e98617fc942d3$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($fc2e98617fc942d3$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $fc2e98617fc942d3$var$TransitionAwareHostComponent() {
    var dispatcher = $fc2e98617fc942d3$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $fc2e98617fc942d3$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $fc2e98617fc942d3$var$currentHook ? $fc2e98617fc942d3$var$currentHook.memoizedState : null) !== dispatcher && ($fc2e98617fc942d3$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $fc2e98617fc942d3$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $fc2e98617fc942d3$var$localIdCounter;
    $fc2e98617fc942d3$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $fc2e98617fc942d3$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $fc2e98617fc942d3$var$resetHooksOnUnwind(workInProgress) {
    if ($fc2e98617fc942d3$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $fc2e98617fc942d3$var$didScheduleRenderPhaseUpdate = !1;
    }
    $fc2e98617fc942d3$var$renderLanes = 0;
    $fc2e98617fc942d3$var$workInProgressHook = $fc2e98617fc942d3$var$currentHook = $fc2e98617fc942d3$var$currentlyRenderingFiber = null;
    $fc2e98617fc942d3$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $fc2e98617fc942d3$var$thenableIndexCounter = $fc2e98617fc942d3$var$localIdCounter = 0;
    $fc2e98617fc942d3$var$thenableState = null;
}
function $fc2e98617fc942d3$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $fc2e98617fc942d3$var$workInProgressHook ? $fc2e98617fc942d3$var$currentlyRenderingFiber.memoizedState = $fc2e98617fc942d3$var$workInProgressHook = hook : $fc2e98617fc942d3$var$workInProgressHook = $fc2e98617fc942d3$var$workInProgressHook.next = hook;
    return $fc2e98617fc942d3$var$workInProgressHook;
}
function $fc2e98617fc942d3$var$updateWorkInProgressHook() {
    if (null === $fc2e98617fc942d3$var$currentHook) {
        var nextCurrentHook = $fc2e98617fc942d3$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $fc2e98617fc942d3$var$currentHook.next;
    var nextWorkInProgressHook = null === $fc2e98617fc942d3$var$workInProgressHook ? $fc2e98617fc942d3$var$currentlyRenderingFiber.memoizedState : $fc2e98617fc942d3$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $fc2e98617fc942d3$var$workInProgressHook = nextWorkInProgressHook, $fc2e98617fc942d3$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $fc2e98617fc942d3$var$currentlyRenderingFiber.alternate) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(467));
            throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(310));
        }
        $fc2e98617fc942d3$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $fc2e98617fc942d3$var$currentHook.memoizedState,
            baseState: $fc2e98617fc942d3$var$currentHook.baseState,
            baseQueue: $fc2e98617fc942d3$var$currentHook.baseQueue,
            queue: $fc2e98617fc942d3$var$currentHook.queue,
            next: null
        };
        null === $fc2e98617fc942d3$var$workInProgressHook ? $fc2e98617fc942d3$var$currentlyRenderingFiber.memoizedState = $fc2e98617fc942d3$var$workInProgressHook = nextCurrentHook : $fc2e98617fc942d3$var$workInProgressHook = $fc2e98617fc942d3$var$workInProgressHook.next = nextCurrentHook;
    }
    return $fc2e98617fc942d3$var$workInProgressHook;
}
function $fc2e98617fc942d3$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $fc2e98617fc942d3$var$useThenable(thenable) {
    var index = $fc2e98617fc942d3$var$thenableIndexCounter;
    $fc2e98617fc942d3$var$thenableIndexCounter += 1;
    null === $fc2e98617fc942d3$var$thenableState && ($fc2e98617fc942d3$var$thenableState = []);
    thenable = $fc2e98617fc942d3$var$trackUsedThenable($fc2e98617fc942d3$var$thenableState, thenable, index);
    index = $fc2e98617fc942d3$var$currentlyRenderingFiber;
    null === (null === $fc2e98617fc942d3$var$workInProgressHook ? index.memoizedState : $fc2e98617fc942d3$var$workInProgressHook.next) && (index = index.alternate, $fc2e98617fc942d3$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $fc2e98617fc942d3$var$HooksDispatcherOnMount : $fc2e98617fc942d3$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $fc2e98617fc942d3$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $fc2e98617fc942d3$var$useThenable(usable);
        if (usable.$$typeof === $fc2e98617fc942d3$var$REACT_CONTEXT_TYPE) return $fc2e98617fc942d3$var$readContext(usable);
    }
    throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(438, String(usable)));
}
function $fc2e98617fc942d3$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $fc2e98617fc942d3$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $fc2e98617fc942d3$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $fc2e98617fc942d3$var$createFunctionComponentUpdateQueue(), $fc2e98617fc942d3$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $fc2e98617fc942d3$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $fc2e98617fc942d3$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $fc2e98617fc942d3$var$updateReducer(reducer) {
    var hook = $fc2e98617fc942d3$var$updateWorkInProgressHook();
    return $fc2e98617fc942d3$var$updateReducerImpl(hook, $fc2e98617fc942d3$var$currentHook, reducer);
}
function $fc2e98617fc942d3$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($fc2e98617fc942d3$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($fc2e98617fc942d3$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $fc2e98617fc942d3$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($fc2e98617fc942d3$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $fc2e98617fc942d3$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $fc2e98617fc942d3$var$currentlyRenderingFiber.lanes |= revertLane, $fc2e98617fc942d3$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $fc2e98617fc942d3$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $fc2e98617fc942d3$var$currentlyRenderingFiber.lanes |= updateLane, $fc2e98617fc942d3$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$fc2e98617fc942d3$var$objectIs(pendingQueue, hook.memoizedState) && ($fc2e98617fc942d3$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $fc2e98617fc942d3$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $fc2e98617fc942d3$var$rerenderReducer(reducer) {
    var hook = $fc2e98617fc942d3$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $fc2e98617fc942d3$var$objectIs(newState, hook.memoizedState) || ($fc2e98617fc942d3$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $fc2e98617fc942d3$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $fc2e98617fc942d3$var$currentlyRenderingFiber, hook = $fc2e98617fc942d3$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $fc2e98617fc942d3$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$fc2e98617fc942d3$var$objectIs(($fc2e98617fc942d3$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $fc2e98617fc942d3$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $fc2e98617fc942d3$var$updateEffect($fc2e98617fc942d3$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $fc2e98617fc942d3$var$workInProgressHook && $fc2e98617fc942d3$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $fc2e98617fc942d3$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $fc2e98617fc942d3$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $fc2e98617fc942d3$var$workInProgressRoot) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($fc2e98617fc942d3$var$renderLanes & 127) || $fc2e98617fc942d3$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $fc2e98617fc942d3$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $fc2e98617fc942d3$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $fc2e98617fc942d3$var$createFunctionComponentUpdateQueue(), $fc2e98617fc942d3$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $fc2e98617fc942d3$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $fc2e98617fc942d3$var$checkIfSnapshotChanged(inst) && $fc2e98617fc942d3$var$forceStoreRerender(fiber);
}
function $fc2e98617fc942d3$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $fc2e98617fc942d3$var$checkIfSnapshotChanged(inst) && $fc2e98617fc942d3$var$forceStoreRerender(fiber);
    });
}
function $fc2e98617fc942d3$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$fc2e98617fc942d3$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $fc2e98617fc942d3$var$forceStoreRerender(fiber) {
    var root = $fc2e98617fc942d3$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $fc2e98617fc942d3$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $fc2e98617fc942d3$var$mountStateImpl(initialState) {
    var hook = $fc2e98617fc942d3$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($fc2e98617fc942d3$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $fc2e98617fc942d3$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $fc2e98617fc942d3$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $fc2e98617fc942d3$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $fc2e98617fc942d3$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $fc2e98617fc942d3$var$updateReducerImpl(hook, $fc2e98617fc942d3$var$currentHook, "function" === typeof reducer ? reducer : $fc2e98617fc942d3$var$basicStateReducer);
}
function $fc2e98617fc942d3$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($fc2e98617fc942d3$var$isRenderPhaseUpdate(fiber)) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $fc2e98617fc942d3$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $fc2e98617fc942d3$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $fc2e98617fc942d3$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $fc2e98617fc942d3$var$ReactSharedInternals.T, currentTransition = {};
        $fc2e98617fc942d3$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $fc2e98617fc942d3$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $fc2e98617fc942d3$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $fc2e98617fc942d3$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $fc2e98617fc942d3$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $fc2e98617fc942d3$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $fc2e98617fc942d3$var$onActionError(actionQueue, node, error$66);
    }
}
function $fc2e98617fc942d3$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $fc2e98617fc942d3$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $fc2e98617fc942d3$var$onActionError(actionQueue, node, error);
    }) : $fc2e98617fc942d3$var$onActionSuccess(actionQueue, node, returnValue);
}
function $fc2e98617fc942d3$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $fc2e98617fc942d3$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $fc2e98617fc942d3$var$runActionStateAction(actionQueue, nextState)));
}
function $fc2e98617fc942d3$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $fc2e98617fc942d3$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $fc2e98617fc942d3$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $fc2e98617fc942d3$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $fc2e98617fc942d3$var$mountActionState(action, initialStateProp) {
    if ($fc2e98617fc942d3$var$isHydrating) {
        var ssrFormState = $fc2e98617fc942d3$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $fc2e98617fc942d3$var$currentlyRenderingFiber;
                if ($fc2e98617fc942d3$var$isHydrating) {
                    if ($fc2e98617fc942d3$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $fc2e98617fc942d3$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $fc2e98617fc942d3$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $fc2e98617fc942d3$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $fc2e98617fc942d3$var$nextHydratableInstance = $fc2e98617fc942d3$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $fc2e98617fc942d3$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $fc2e98617fc942d3$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $fc2e98617fc942d3$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $fc2e98617fc942d3$var$dispatchSetState.bind(null, $fc2e98617fc942d3$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $fc2e98617fc942d3$var$mountStateImpl(!1);
    inRootOrSingleton = $fc2e98617fc942d3$var$dispatchOptimisticSetState.bind(null, $fc2e98617fc942d3$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $fc2e98617fc942d3$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $fc2e98617fc942d3$var$dispatchActionState.bind(null, $fc2e98617fc942d3$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $fc2e98617fc942d3$var$updateActionState(action) {
    var stateHook = $fc2e98617fc942d3$var$updateWorkInProgressHook();
    return $fc2e98617fc942d3$var$updateActionStateImpl(stateHook, $fc2e98617fc942d3$var$currentHook, action);
}
function $fc2e98617fc942d3$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $fc2e98617fc942d3$var$updateReducerImpl(stateHook, currentStateHook, $fc2e98617fc942d3$var$actionStateReducer)[0];
    stateHook = $fc2e98617fc942d3$var$updateReducer($fc2e98617fc942d3$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $fc2e98617fc942d3$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $fc2e98617fc942d3$var$SuspenseException) throw $fc2e98617fc942d3$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $fc2e98617fc942d3$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($fc2e98617fc942d3$var$currentlyRenderingFiber.flags |= 2048, $fc2e98617fc942d3$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $fc2e98617fc942d3$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $fc2e98617fc942d3$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $fc2e98617fc942d3$var$rerenderActionState(action) {
    var stateHook = $fc2e98617fc942d3$var$updateWorkInProgressHook(), currentStateHook = $fc2e98617fc942d3$var$currentHook;
    if (null !== currentStateHook) return $fc2e98617fc942d3$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $fc2e98617fc942d3$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $fc2e98617fc942d3$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $fc2e98617fc942d3$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $fc2e98617fc942d3$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $fc2e98617fc942d3$var$createFunctionComponentUpdateQueue(), $fc2e98617fc942d3$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $fc2e98617fc942d3$var$updateRef() {
    return $fc2e98617fc942d3$var$updateWorkInProgressHook().memoizedState;
}
function $fc2e98617fc942d3$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $fc2e98617fc942d3$var$mountWorkInProgressHook();
    $fc2e98617fc942d3$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $fc2e98617fc942d3$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $fc2e98617fc942d3$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $fc2e98617fc942d3$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $fc2e98617fc942d3$var$currentHook && null !== deps && $fc2e98617fc942d3$var$areHookInputsEqual(deps, $fc2e98617fc942d3$var$currentHook.memoizedState.deps) ? hook.memoizedState = $fc2e98617fc942d3$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($fc2e98617fc942d3$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $fc2e98617fc942d3$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $fc2e98617fc942d3$var$mountEffect(create, deps) {
    $fc2e98617fc942d3$var$mountEffectImpl(8390656, 8, create, deps);
}
function $fc2e98617fc942d3$var$updateEffect(create, deps) {
    $fc2e98617fc942d3$var$updateEffectImpl(2048, 8, create, deps);
}
function $fc2e98617fc942d3$var$useEffectEventImpl(payload) {
    $fc2e98617fc942d3$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $fc2e98617fc942d3$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $fc2e98617fc942d3$var$createFunctionComponentUpdateQueue(), $fc2e98617fc942d3$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $fc2e98617fc942d3$var$updateEvent(callback) {
    var ref = $fc2e98617fc942d3$var$updateWorkInProgressHook().memoizedState;
    $fc2e98617fc942d3$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($fc2e98617fc942d3$var$executionContext & 2)) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $fc2e98617fc942d3$var$updateInsertionEffect(create, deps) {
    return $fc2e98617fc942d3$var$updateEffectImpl(4, 2, create, deps);
}
function $fc2e98617fc942d3$var$updateLayoutEffect(create, deps) {
    return $fc2e98617fc942d3$var$updateEffectImpl(4, 4, create, deps);
}
function $fc2e98617fc942d3$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $fc2e98617fc942d3$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $fc2e98617fc942d3$var$updateEffectImpl(4, 4, $fc2e98617fc942d3$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $fc2e98617fc942d3$var$mountDebugValue() {}
function $fc2e98617fc942d3$var$updateCallback(callback, deps) {
    var hook = $fc2e98617fc942d3$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $fc2e98617fc942d3$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $fc2e98617fc942d3$var$updateMemo(nextCreate, deps) {
    var hook = $fc2e98617fc942d3$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $fc2e98617fc942d3$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($fc2e98617fc942d3$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $fc2e98617fc942d3$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $fc2e98617fc942d3$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $fc2e98617fc942d3$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($fc2e98617fc942d3$var$renderLanes & 1073741824) && 0 === ($fc2e98617fc942d3$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $fc2e98617fc942d3$var$requestDeferredLane();
    $fc2e98617fc942d3$var$currentlyRenderingFiber.lanes |= hook;
    $fc2e98617fc942d3$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $fc2e98617fc942d3$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($fc2e98617fc942d3$var$objectIs(value, prevValue)) return value;
    if (null !== $fc2e98617fc942d3$var$currentTreeHiddenStackCursor.current) return hook = $fc2e98617fc942d3$var$mountDeferredValueImpl(hook, value, initialValue), $fc2e98617fc942d3$var$objectIs(hook, prevValue) || ($fc2e98617fc942d3$var$didReceiveUpdate = !0), hook;
    if (0 === ($fc2e98617fc942d3$var$renderLanes & 42) || 0 !== ($fc2e98617fc942d3$var$renderLanes & 1073741824) && 0 === ($fc2e98617fc942d3$var$workInProgressRootRenderLanes & 261930)) return $fc2e98617fc942d3$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $fc2e98617fc942d3$var$requestDeferredLane();
    $fc2e98617fc942d3$var$currentlyRenderingFiber.lanes |= hook;
    $fc2e98617fc942d3$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $fc2e98617fc942d3$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $fc2e98617fc942d3$var$ReactDOMSharedInternals.p;
    $fc2e98617fc942d3$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $fc2e98617fc942d3$var$ReactSharedInternals.T, currentTransition = {};
    $fc2e98617fc942d3$var$ReactSharedInternals.T = currentTransition;
    $fc2e98617fc942d3$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $fc2e98617fc942d3$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $fc2e98617fc942d3$var$chainThenableValue(returnValue, finishedState);
            $fc2e98617fc942d3$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $fc2e98617fc942d3$var$requestUpdateLane(fiber));
        } else $fc2e98617fc942d3$var$dispatchSetStateInternal(fiber, queue, finishedState, $fc2e98617fc942d3$var$requestUpdateLane(fiber));
    } catch (error) {
        $fc2e98617fc942d3$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $fc2e98617fc942d3$var$requestUpdateLane());
    } finally{
        $fc2e98617fc942d3$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $fc2e98617fc942d3$var$ReactSharedInternals.T = prevTransition;
    }
}
function $fc2e98617fc942d3$var$noop() {}
function $fc2e98617fc942d3$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(476));
    var queue = $fc2e98617fc942d3$var$ensureFormComponentIsStateful(formFiber).queue;
    $fc2e98617fc942d3$var$startTransition(formFiber, queue, pendingState, $fc2e98617fc942d3$var$sharedNotPendingObject, null === action ? $fc2e98617fc942d3$var$noop : function() {
        $fc2e98617fc942d3$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $fc2e98617fc942d3$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $fc2e98617fc942d3$var$sharedNotPendingObject,
        baseState: $fc2e98617fc942d3$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $fc2e98617fc942d3$var$basicStateReducer,
            lastRenderedState: $fc2e98617fc942d3$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $fc2e98617fc942d3$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $fc2e98617fc942d3$var$requestFormReset$1(formFiber) {
    var stateHook = $fc2e98617fc942d3$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $fc2e98617fc942d3$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $fc2e98617fc942d3$var$requestUpdateLane());
}
function $fc2e98617fc942d3$var$useHostTransitionStatus() {
    return $fc2e98617fc942d3$var$readContext($fc2e98617fc942d3$var$HostTransitionContext);
}
function $fc2e98617fc942d3$var$updateId() {
    return $fc2e98617fc942d3$var$updateWorkInProgressHook().memoizedState;
}
function $fc2e98617fc942d3$var$updateRefresh() {
    return $fc2e98617fc942d3$var$updateWorkInProgressHook().memoizedState;
}
function $fc2e98617fc942d3$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $fc2e98617fc942d3$var$requestUpdateLane();
                fiber = $fc2e98617fc942d3$var$createUpdate(lane);
                var root$69 = $fc2e98617fc942d3$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($fc2e98617fc942d3$var$scheduleUpdateOnFiber(root$69, provider, lane), $fc2e98617fc942d3$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $fc2e98617fc942d3$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $fc2e98617fc942d3$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $fc2e98617fc942d3$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $fc2e98617fc942d3$var$isRenderPhaseUpdate(fiber) ? $fc2e98617fc942d3$var$enqueueRenderPhaseUpdate(queue, action) : (action = $fc2e98617fc942d3$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($fc2e98617fc942d3$var$scheduleUpdateOnFiber(action, fiber, lane), $fc2e98617fc942d3$var$entangleTransitionUpdate(action, queue, lane)));
}
function $fc2e98617fc942d3$var$dispatchSetState(fiber, queue, action) {
    var lane = $fc2e98617fc942d3$var$requestUpdateLane();
    $fc2e98617fc942d3$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $fc2e98617fc942d3$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($fc2e98617fc942d3$var$isRenderPhaseUpdate(fiber)) $fc2e98617fc942d3$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($fc2e98617fc942d3$var$objectIs(eagerState, currentState)) return $fc2e98617fc942d3$var$enqueueUpdate$1(fiber, queue, update, 0), null === $fc2e98617fc942d3$var$workInProgressRoot && $fc2e98617fc942d3$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $fc2e98617fc942d3$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $fc2e98617fc942d3$var$scheduleUpdateOnFiber(action, fiber, lane), $fc2e98617fc942d3$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $fc2e98617fc942d3$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $fc2e98617fc942d3$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($fc2e98617fc942d3$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $fc2e98617fc942d3$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $fc2e98617fc942d3$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $fc2e98617fc942d3$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $fc2e98617fc942d3$var$currentlyRenderingFiber || null !== alternate && alternate === $fc2e98617fc942d3$var$currentlyRenderingFiber;
}
function $fc2e98617fc942d3$var$enqueueRenderPhaseUpdate(queue, update) {
    $fc2e98617fc942d3$var$didScheduleRenderPhaseUpdateDuringThisPass = $fc2e98617fc942d3$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $fc2e98617fc942d3$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $fc2e98617fc942d3$var$markRootEntangled(root, lane);
    }
}
var $fc2e98617fc942d3$var$ContextOnlyDispatcher = {
    readContext: $fc2e98617fc942d3$var$readContext,
    use: $fc2e98617fc942d3$var$use,
    useCallback: $fc2e98617fc942d3$var$throwInvalidHookError,
    useContext: $fc2e98617fc942d3$var$throwInvalidHookError,
    useEffect: $fc2e98617fc942d3$var$throwInvalidHookError,
    useImperativeHandle: $fc2e98617fc942d3$var$throwInvalidHookError,
    useLayoutEffect: $fc2e98617fc942d3$var$throwInvalidHookError,
    useInsertionEffect: $fc2e98617fc942d3$var$throwInvalidHookError,
    useMemo: $fc2e98617fc942d3$var$throwInvalidHookError,
    useReducer: $fc2e98617fc942d3$var$throwInvalidHookError,
    useRef: $fc2e98617fc942d3$var$throwInvalidHookError,
    useState: $fc2e98617fc942d3$var$throwInvalidHookError,
    useDebugValue: $fc2e98617fc942d3$var$throwInvalidHookError,
    useDeferredValue: $fc2e98617fc942d3$var$throwInvalidHookError,
    useTransition: $fc2e98617fc942d3$var$throwInvalidHookError,
    useSyncExternalStore: $fc2e98617fc942d3$var$throwInvalidHookError,
    useId: $fc2e98617fc942d3$var$throwInvalidHookError,
    useHostTransitionStatus: $fc2e98617fc942d3$var$throwInvalidHookError,
    useFormState: $fc2e98617fc942d3$var$throwInvalidHookError,
    useActionState: $fc2e98617fc942d3$var$throwInvalidHookError,
    useOptimistic: $fc2e98617fc942d3$var$throwInvalidHookError,
    useMemoCache: $fc2e98617fc942d3$var$throwInvalidHookError,
    useCacheRefresh: $fc2e98617fc942d3$var$throwInvalidHookError
};
$fc2e98617fc942d3$var$ContextOnlyDispatcher.useEffectEvent = $fc2e98617fc942d3$var$throwInvalidHookError;
var $fc2e98617fc942d3$var$HooksDispatcherOnMount = {
    readContext: $fc2e98617fc942d3$var$readContext,
    use: $fc2e98617fc942d3$var$use,
    useCallback: function(callback, deps) {
        $fc2e98617fc942d3$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $fc2e98617fc942d3$var$readContext,
    useEffect: $fc2e98617fc942d3$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $fc2e98617fc942d3$var$mountEffectImpl(4194308, 4, $fc2e98617fc942d3$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $fc2e98617fc942d3$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $fc2e98617fc942d3$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $fc2e98617fc942d3$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($fc2e98617fc942d3$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $fc2e98617fc942d3$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $fc2e98617fc942d3$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $fc2e98617fc942d3$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($fc2e98617fc942d3$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $fc2e98617fc942d3$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $fc2e98617fc942d3$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $fc2e98617fc942d3$var$dispatchReducerAction.bind(null, $fc2e98617fc942d3$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $fc2e98617fc942d3$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $fc2e98617fc942d3$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $fc2e98617fc942d3$var$dispatchSetState.bind(null, $fc2e98617fc942d3$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $fc2e98617fc942d3$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $fc2e98617fc942d3$var$mountWorkInProgressHook();
        return $fc2e98617fc942d3$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $fc2e98617fc942d3$var$mountStateImpl(!1);
        stateHook = $fc2e98617fc942d3$var$startTransition.bind(null, $fc2e98617fc942d3$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $fc2e98617fc942d3$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $fc2e98617fc942d3$var$currentlyRenderingFiber, hook = $fc2e98617fc942d3$var$mountWorkInProgressHook();
        if ($fc2e98617fc942d3$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $fc2e98617fc942d3$var$workInProgressRoot) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(349));
            0 !== ($fc2e98617fc942d3$var$workInProgressRootRenderLanes & 127) || $fc2e98617fc942d3$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $fc2e98617fc942d3$var$mountEffect($fc2e98617fc942d3$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $fc2e98617fc942d3$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $fc2e98617fc942d3$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $fc2e98617fc942d3$var$mountWorkInProgressHook(), identifierPrefix = $fc2e98617fc942d3$var$workInProgressRoot.identifierPrefix;
        if ($fc2e98617fc942d3$var$isHydrating) {
            var JSCompiler_inline_result = $fc2e98617fc942d3$var$treeContextOverflow;
            var idWithLeadingBit = $fc2e98617fc942d3$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $fc2e98617fc942d3$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $fc2e98617fc942d3$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $fc2e98617fc942d3$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $fc2e98617fc942d3$var$useHostTransitionStatus,
    useFormState: $fc2e98617fc942d3$var$mountActionState,
    useActionState: $fc2e98617fc942d3$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $fc2e98617fc942d3$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $fc2e98617fc942d3$var$dispatchOptimisticSetState.bind(null, $fc2e98617fc942d3$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $fc2e98617fc942d3$var$useMemoCache,
    useCacheRefresh: function() {
        return $fc2e98617fc942d3$var$mountWorkInProgressHook().memoizedState = $fc2e98617fc942d3$var$refreshCache.bind(null, $fc2e98617fc942d3$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $fc2e98617fc942d3$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($fc2e98617fc942d3$var$executionContext & 2)) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $fc2e98617fc942d3$var$HooksDispatcherOnUpdate = {
    readContext: $fc2e98617fc942d3$var$readContext,
    use: $fc2e98617fc942d3$var$use,
    useCallback: $fc2e98617fc942d3$var$updateCallback,
    useContext: $fc2e98617fc942d3$var$readContext,
    useEffect: $fc2e98617fc942d3$var$updateEffect,
    useImperativeHandle: $fc2e98617fc942d3$var$updateImperativeHandle,
    useInsertionEffect: $fc2e98617fc942d3$var$updateInsertionEffect,
    useLayoutEffect: $fc2e98617fc942d3$var$updateLayoutEffect,
    useMemo: $fc2e98617fc942d3$var$updateMemo,
    useReducer: $fc2e98617fc942d3$var$updateReducer,
    useRef: $fc2e98617fc942d3$var$updateRef,
    useState: function() {
        return $fc2e98617fc942d3$var$updateReducer($fc2e98617fc942d3$var$basicStateReducer);
    },
    useDebugValue: $fc2e98617fc942d3$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $fc2e98617fc942d3$var$updateWorkInProgressHook();
        return $fc2e98617fc942d3$var$updateDeferredValueImpl(hook, $fc2e98617fc942d3$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $fc2e98617fc942d3$var$updateReducer($fc2e98617fc942d3$var$basicStateReducer)[0], start = $fc2e98617fc942d3$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $fc2e98617fc942d3$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $fc2e98617fc942d3$var$updateSyncExternalStore,
    useId: $fc2e98617fc942d3$var$updateId,
    useHostTransitionStatus: $fc2e98617fc942d3$var$useHostTransitionStatus,
    useFormState: $fc2e98617fc942d3$var$updateActionState,
    useActionState: $fc2e98617fc942d3$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $fc2e98617fc942d3$var$updateWorkInProgressHook();
        return $fc2e98617fc942d3$var$updateOptimisticImpl(hook, $fc2e98617fc942d3$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $fc2e98617fc942d3$var$useMemoCache,
    useCacheRefresh: $fc2e98617fc942d3$var$updateRefresh
};
$fc2e98617fc942d3$var$HooksDispatcherOnUpdate.useEffectEvent = $fc2e98617fc942d3$var$updateEvent;
var $fc2e98617fc942d3$var$HooksDispatcherOnRerender = {
    readContext: $fc2e98617fc942d3$var$readContext,
    use: $fc2e98617fc942d3$var$use,
    useCallback: $fc2e98617fc942d3$var$updateCallback,
    useContext: $fc2e98617fc942d3$var$readContext,
    useEffect: $fc2e98617fc942d3$var$updateEffect,
    useImperativeHandle: $fc2e98617fc942d3$var$updateImperativeHandle,
    useInsertionEffect: $fc2e98617fc942d3$var$updateInsertionEffect,
    useLayoutEffect: $fc2e98617fc942d3$var$updateLayoutEffect,
    useMemo: $fc2e98617fc942d3$var$updateMemo,
    useReducer: $fc2e98617fc942d3$var$rerenderReducer,
    useRef: $fc2e98617fc942d3$var$updateRef,
    useState: function() {
        return $fc2e98617fc942d3$var$rerenderReducer($fc2e98617fc942d3$var$basicStateReducer);
    },
    useDebugValue: $fc2e98617fc942d3$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $fc2e98617fc942d3$var$updateWorkInProgressHook();
        return null === $fc2e98617fc942d3$var$currentHook ? $fc2e98617fc942d3$var$mountDeferredValueImpl(hook, value, initialValue) : $fc2e98617fc942d3$var$updateDeferredValueImpl(hook, $fc2e98617fc942d3$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $fc2e98617fc942d3$var$rerenderReducer($fc2e98617fc942d3$var$basicStateReducer)[0], start = $fc2e98617fc942d3$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $fc2e98617fc942d3$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $fc2e98617fc942d3$var$updateSyncExternalStore,
    useId: $fc2e98617fc942d3$var$updateId,
    useHostTransitionStatus: $fc2e98617fc942d3$var$useHostTransitionStatus,
    useFormState: $fc2e98617fc942d3$var$rerenderActionState,
    useActionState: $fc2e98617fc942d3$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $fc2e98617fc942d3$var$updateWorkInProgressHook();
        if (null !== $fc2e98617fc942d3$var$currentHook) return $fc2e98617fc942d3$var$updateOptimisticImpl(hook, $fc2e98617fc942d3$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $fc2e98617fc942d3$var$useMemoCache,
    useCacheRefresh: $fc2e98617fc942d3$var$updateRefresh
};
$fc2e98617fc942d3$var$HooksDispatcherOnRerender.useEffectEvent = $fc2e98617fc942d3$var$updateEvent;
function $fc2e98617fc942d3$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $fc2e98617fc942d3$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $fc2e98617fc942d3$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $fc2e98617fc942d3$var$requestUpdateLane(), update = $fc2e98617fc942d3$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $fc2e98617fc942d3$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($fc2e98617fc942d3$var$scheduleUpdateOnFiber(payload, inst, lane), $fc2e98617fc942d3$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $fc2e98617fc942d3$var$requestUpdateLane(), update = $fc2e98617fc942d3$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $fc2e98617fc942d3$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($fc2e98617fc942d3$var$scheduleUpdateOnFiber(payload, inst, lane), $fc2e98617fc942d3$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $fc2e98617fc942d3$var$requestUpdateLane(), update = $fc2e98617fc942d3$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $fc2e98617fc942d3$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($fc2e98617fc942d3$var$scheduleUpdateOnFiber(callback, inst, lane), $fc2e98617fc942d3$var$entangleTransitions(callback, inst, lane));
    }
};
function $fc2e98617fc942d3$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$fc2e98617fc942d3$var$shallowEqual(oldProps, newProps) || !$fc2e98617fc942d3$var$shallowEqual(oldState, newState) : !0;
}
function $fc2e98617fc942d3$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $fc2e98617fc942d3$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $fc2e98617fc942d3$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $fc2e98617fc942d3$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $fc2e98617fc942d3$var$defaultOnUncaughtError(error) {
    $fc2e98617fc942d3$var$reportGlobalError(error);
}
function $fc2e98617fc942d3$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $fc2e98617fc942d3$var$defaultOnRecoverableError(error) {
    $fc2e98617fc942d3$var$reportGlobalError(error);
}
function $fc2e98617fc942d3$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $fc2e98617fc942d3$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $fc2e98617fc942d3$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $fc2e98617fc942d3$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $fc2e98617fc942d3$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $fc2e98617fc942d3$var$createClassErrorUpdate(lane) {
    lane = $fc2e98617fc942d3$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $fc2e98617fc942d3$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $fc2e98617fc942d3$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $fc2e98617fc942d3$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $fc2e98617fc942d3$var$legacyErrorBoundariesThatAlreadyFailed ? $fc2e98617fc942d3$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $fc2e98617fc942d3$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $fc2e98617fc942d3$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $fc2e98617fc942d3$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $fc2e98617fc942d3$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $fc2e98617fc942d3$var$shellBoundary ? $fc2e98617fc942d3$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $fc2e98617fc942d3$var$workInProgressRootExitStatus && ($fc2e98617fc942d3$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $fc2e98617fc942d3$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $fc2e98617fc942d3$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $fc2e98617fc942d3$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $fc2e98617fc942d3$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $fc2e98617fc942d3$var$attachPingListener(root, value, rootRenderLanes);
        $fc2e98617fc942d3$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($fc2e98617fc942d3$var$isHydrating) return returnFiber = $fc2e98617fc942d3$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $fc2e98617fc942d3$var$HydrationMismatchException && (root = Error($fc2e98617fc942d3$var$formatProdErrorMessage(422), {
        cause: value
    }), $fc2e98617fc942d3$var$queueHydrationError($fc2e98617fc942d3$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $fc2e98617fc942d3$var$HydrationMismatchException && (returnFiber = Error($fc2e98617fc942d3$var$formatProdErrorMessage(423), {
        cause: value
    }), $fc2e98617fc942d3$var$queueHydrationError($fc2e98617fc942d3$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $fc2e98617fc942d3$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $fc2e98617fc942d3$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $fc2e98617fc942d3$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $fc2e98617fc942d3$var$workInProgressRootExitStatus && ($fc2e98617fc942d3$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($fc2e98617fc942d3$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $fc2e98617fc942d3$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $fc2e98617fc942d3$var$workInProgressRootConcurrentErrors ? $fc2e98617fc942d3$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $fc2e98617fc942d3$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $fc2e98617fc942d3$var$workInProgressRootExitStatus && ($fc2e98617fc942d3$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $fc2e98617fc942d3$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $fc2e98617fc942d3$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $fc2e98617fc942d3$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $fc2e98617fc942d3$var$legacyErrorBoundariesThatAlreadyFailed || !$fc2e98617fc942d3$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $fc2e98617fc942d3$var$createClassErrorUpdate(rootRenderLanes), $fc2e98617fc942d3$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $fc2e98617fc942d3$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $fc2e98617fc942d3$var$SelectiveHydrationException = Error($fc2e98617fc942d3$var$formatProdErrorMessage(461)), $fc2e98617fc942d3$var$didReceiveUpdate = !1;
function $fc2e98617fc942d3$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $fc2e98617fc942d3$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $fc2e98617fc942d3$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $fc2e98617fc942d3$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $fc2e98617fc942d3$var$prepareToReadContext(workInProgress);
    nextProps = $fc2e98617fc942d3$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $fc2e98617fc942d3$var$checkDidRenderIdHook();
    if (null !== current && !$fc2e98617fc942d3$var$didReceiveUpdate) return $fc2e98617fc942d3$var$bailoutHooks(current, workInProgress, renderLanes), $fc2e98617fc942d3$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $fc2e98617fc942d3$var$isHydrating && key && $fc2e98617fc942d3$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $fc2e98617fc942d3$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $fc2e98617fc942d3$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$fc2e98617fc942d3$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $fc2e98617fc942d3$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $fc2e98617fc942d3$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$fc2e98617fc942d3$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $fc2e98617fc942d3$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $fc2e98617fc942d3$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $fc2e98617fc942d3$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $fc2e98617fc942d3$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($fc2e98617fc942d3$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($fc2e98617fc942d3$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $fc2e98617fc942d3$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($fc2e98617fc942d3$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $fc2e98617fc942d3$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $fc2e98617fc942d3$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $fc2e98617fc942d3$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $fc2e98617fc942d3$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $fc2e98617fc942d3$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $fc2e98617fc942d3$var$pushHiddenContext(workInProgress, prevState) : $fc2e98617fc942d3$var$reuseHiddenContextOnStack(), $fc2e98617fc942d3$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $fc2e98617fc942d3$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($fc2e98617fc942d3$var$pushTransition(workInProgress, prevState.cachePool), $fc2e98617fc942d3$var$pushHiddenContext(workInProgress, prevState), $fc2e98617fc942d3$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $fc2e98617fc942d3$var$pushTransition(workInProgress, null), $fc2e98617fc942d3$var$reuseHiddenContextOnStack(), $fc2e98617fc942d3$var$reuseSuspenseHandlerOnStack(workInProgress));
    $fc2e98617fc942d3$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $fc2e98617fc942d3$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $fc2e98617fc942d3$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $fc2e98617fc942d3$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $fc2e98617fc942d3$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $fc2e98617fc942d3$var$pushTransition(workInProgress, null);
    $fc2e98617fc942d3$var$reuseHiddenContextOnStack();
    $fc2e98617fc942d3$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $fc2e98617fc942d3$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $fc2e98617fc942d3$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $fc2e98617fc942d3$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $fc2e98617fc942d3$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $fc2e98617fc942d3$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $fc2e98617fc942d3$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $fc2e98617fc942d3$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $fc2e98617fc942d3$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($fc2e98617fc942d3$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $fc2e98617fc942d3$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $fc2e98617fc942d3$var$bailoutOffscreenComponent(null, current);
            $fc2e98617fc942d3$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $fc2e98617fc942d3$var$nextHydratableInstance) ? (current = $fc2e98617fc942d3$var$canHydrateHydrationBoundary(current, $fc2e98617fc942d3$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $fc2e98617fc942d3$var$treeContextProvider ? {
                    id: $fc2e98617fc942d3$var$treeContextId,
                    overflow: $fc2e98617fc942d3$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $fc2e98617fc942d3$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $fc2e98617fc942d3$var$hydrationParentFiber = workInProgress, $fc2e98617fc942d3$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $fc2e98617fc942d3$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $fc2e98617fc942d3$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $fc2e98617fc942d3$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $fc2e98617fc942d3$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(558));
        } else if ($fc2e98617fc942d3$var$didReceiveUpdate || $fc2e98617fc942d3$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $fc2e98617fc942d3$var$didReceiveUpdate || didSuspend) {
            nextProps = $fc2e98617fc942d3$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $fc2e98617fc942d3$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $fc2e98617fc942d3$var$enqueueConcurrentRenderForLane(current, dehydrated), $fc2e98617fc942d3$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $fc2e98617fc942d3$var$SelectiveHydrationException;
            $fc2e98617fc942d3$var$renderDidSuspendDelayIfPossible();
            workInProgress = $fc2e98617fc942d3$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $fc2e98617fc942d3$var$nextHydratableInstance = $fc2e98617fc942d3$var$getNextHydratable(dehydrated.nextSibling), $fc2e98617fc942d3$var$hydrationParentFiber = workInProgress, $fc2e98617fc942d3$var$isHydrating = !0, $fc2e98617fc942d3$var$hydrationErrors = null, $fc2e98617fc942d3$var$rootOrSingletonContext = !1, null !== current && $fc2e98617fc942d3$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $fc2e98617fc942d3$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $fc2e98617fc942d3$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $fc2e98617fc942d3$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $fc2e98617fc942d3$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $fc2e98617fc942d3$var$prepareToReadContext(workInProgress);
    Component = $fc2e98617fc942d3$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $fc2e98617fc942d3$var$checkDidRenderIdHook();
    if (null !== current && !$fc2e98617fc942d3$var$didReceiveUpdate) return $fc2e98617fc942d3$var$bailoutHooks(current, workInProgress, renderLanes), $fc2e98617fc942d3$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $fc2e98617fc942d3$var$isHydrating && nextProps && $fc2e98617fc942d3$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $fc2e98617fc942d3$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $fc2e98617fc942d3$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $fc2e98617fc942d3$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $fc2e98617fc942d3$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $fc2e98617fc942d3$var$finishRenderingHooks(current);
    Component = $fc2e98617fc942d3$var$checkDidRenderIdHook();
    if (null !== current && !$fc2e98617fc942d3$var$didReceiveUpdate) return $fc2e98617fc942d3$var$bailoutHooks(current, workInProgress, renderLanes), $fc2e98617fc942d3$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $fc2e98617fc942d3$var$isHydrating && Component && $fc2e98617fc942d3$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $fc2e98617fc942d3$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $fc2e98617fc942d3$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $fc2e98617fc942d3$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $fc2e98617fc942d3$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $fc2e98617fc942d3$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $fc2e98617fc942d3$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $fc2e98617fc942d3$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $fc2e98617fc942d3$var$readContext(contextType) : $fc2e98617fc942d3$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($fc2e98617fc942d3$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $fc2e98617fc942d3$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $fc2e98617fc942d3$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $fc2e98617fc942d3$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $fc2e98617fc942d3$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $fc2e98617fc942d3$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $fc2e98617fc942d3$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $fc2e98617fc942d3$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $fc2e98617fc942d3$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $fc2e98617fc942d3$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $fc2e98617fc942d3$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $fc2e98617fc942d3$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($fc2e98617fc942d3$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $fc2e98617fc942d3$var$hasForceUpdate || $fc2e98617fc942d3$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $fc2e98617fc942d3$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $fc2e98617fc942d3$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $fc2e98617fc942d3$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $fc2e98617fc942d3$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $fc2e98617fc942d3$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $fc2e98617fc942d3$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $fc2e98617fc942d3$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $fc2e98617fc942d3$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $fc2e98617fc942d3$var$hasForceUpdate || null !== current && null !== current.dependencies && $fc2e98617fc942d3$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($fc2e98617fc942d3$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $fc2e98617fc942d3$var$hasForceUpdate || $fc2e98617fc942d3$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $fc2e98617fc942d3$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $fc2e98617fc942d3$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $fc2e98617fc942d3$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $fc2e98617fc942d3$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $fc2e98617fc942d3$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $fc2e98617fc942d3$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $fc2e98617fc942d3$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $fc2e98617fc942d3$var$resetHydrationState();
    workInProgress.flags |= 256;
    $fc2e98617fc942d3$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $fc2e98617fc942d3$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $fc2e98617fc942d3$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $fc2e98617fc942d3$var$getSuspendedCache()
    };
}
function $fc2e98617fc942d3$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $fc2e98617fc942d3$var$workInProgressDeferredLane);
    return current;
}
function $fc2e98617fc942d3$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($fc2e98617fc942d3$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($fc2e98617fc942d3$var$isHydrating) {
            showFallback ? $fc2e98617fc942d3$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $fc2e98617fc942d3$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $fc2e98617fc942d3$var$nextHydratableInstance) ? (current = $fc2e98617fc942d3$var$canHydrateHydrationBoundary(current, $fc2e98617fc942d3$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $fc2e98617fc942d3$var$treeContextProvider ? {
                    id: $fc2e98617fc942d3$var$treeContextId,
                    overflow: $fc2e98617fc942d3$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $fc2e98617fc942d3$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $fc2e98617fc942d3$var$hydrationParentFiber = workInProgress, $fc2e98617fc942d3$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $fc2e98617fc942d3$var$throwOnHydrationMismatch(workInProgress);
            $fc2e98617fc942d3$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $fc2e98617fc942d3$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $fc2e98617fc942d3$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $fc2e98617fc942d3$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $fc2e98617fc942d3$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $fc2e98617fc942d3$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $fc2e98617fc942d3$var$SUSPENDED_MARKER, $fc2e98617fc942d3$var$bailoutOffscreenComponent(null, nextProps);
        $fc2e98617fc942d3$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $fc2e98617fc942d3$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($fc2e98617fc942d3$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $fc2e98617fc942d3$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($fc2e98617fc942d3$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($fc2e98617fc942d3$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $fc2e98617fc942d3$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $fc2e98617fc942d3$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $fc2e98617fc942d3$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $fc2e98617fc942d3$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $fc2e98617fc942d3$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $fc2e98617fc942d3$var$SUSPENDED_MARKER, workInProgress = $fc2e98617fc942d3$var$bailoutOffscreenComponent(null, nextProps));
        else if ($fc2e98617fc942d3$var$pushPrimaryTreeSuspenseHandler(workInProgress), $fc2e98617fc942d3$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($fc2e98617fc942d3$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $fc2e98617fc942d3$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $fc2e98617fc942d3$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($fc2e98617fc942d3$var$didReceiveUpdate || $fc2e98617fc942d3$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $fc2e98617fc942d3$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $fc2e98617fc942d3$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $fc2e98617fc942d3$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $fc2e98617fc942d3$var$enqueueConcurrentRenderForLane(current, nextProps), $fc2e98617fc942d3$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $fc2e98617fc942d3$var$SelectiveHydrationException;
            $fc2e98617fc942d3$var$isSuspenseInstancePending(nextPrimaryChildren) || $fc2e98617fc942d3$var$renderDidSuspendDelayIfPossible();
            workInProgress = $fc2e98617fc942d3$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $fc2e98617fc942d3$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $fc2e98617fc942d3$var$nextHydratableInstance = $fc2e98617fc942d3$var$getNextHydratable(nextPrimaryChildren.nextSibling), $fc2e98617fc942d3$var$hydrationParentFiber = workInProgress, $fc2e98617fc942d3$var$isHydrating = !0, $fc2e98617fc942d3$var$hydrationErrors = null, $fc2e98617fc942d3$var$rootOrSingletonContext = !1, null !== current && $fc2e98617fc942d3$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $fc2e98617fc942d3$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $fc2e98617fc942d3$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $fc2e98617fc942d3$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $fc2e98617fc942d3$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $fc2e98617fc942d3$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $fc2e98617fc942d3$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $fc2e98617fc942d3$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $fc2e98617fc942d3$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $fc2e98617fc942d3$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $fc2e98617fc942d3$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $fc2e98617fc942d3$var$SUSPENDED_MARKER, $fc2e98617fc942d3$var$bailoutOffscreenComponent(current.child, nextProps);
    $fc2e98617fc942d3$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $fc2e98617fc942d3$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $fc2e98617fc942d3$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $fc2e98617fc942d3$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $fc2e98617fc942d3$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $fc2e98617fc942d3$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $fc2e98617fc942d3$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $fc2e98617fc942d3$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $fc2e98617fc942d3$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $fc2e98617fc942d3$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $fc2e98617fc942d3$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $fc2e98617fc942d3$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $fc2e98617fc942d3$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $fc2e98617fc942d3$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $fc2e98617fc942d3$var$push($fc2e98617fc942d3$var$suspenseStackCursor, suspenseContext);
    $fc2e98617fc942d3$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $fc2e98617fc942d3$var$isHydrating ? $fc2e98617fc942d3$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $fc2e98617fc942d3$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $fc2e98617fc942d3$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $fc2e98617fc942d3$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $fc2e98617fc942d3$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $fc2e98617fc942d3$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $fc2e98617fc942d3$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $fc2e98617fc942d3$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $fc2e98617fc942d3$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $fc2e98617fc942d3$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($fc2e98617fc942d3$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $fc2e98617fc942d3$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $fc2e98617fc942d3$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $fc2e98617fc942d3$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $fc2e98617fc942d3$var$checkIfContextChanged(current) ? !0 : !1;
}
function $fc2e98617fc942d3$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $fc2e98617fc942d3$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $fc2e98617fc942d3$var$pushProvider(workInProgress, $fc2e98617fc942d3$var$CacheContext, current.memoizedState.cache);
            $fc2e98617fc942d3$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $fc2e98617fc942d3$var$pushHostContext(workInProgress);
            break;
        case 4:
            $fc2e98617fc942d3$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $fc2e98617fc942d3$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $fc2e98617fc942d3$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $fc2e98617fc942d3$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $fc2e98617fc942d3$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $fc2e98617fc942d3$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $fc2e98617fc942d3$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $fc2e98617fc942d3$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($fc2e98617fc942d3$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $fc2e98617fc942d3$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $fc2e98617fc942d3$var$push($fc2e98617fc942d3$var$suspenseStackCursor, $fc2e98617fc942d3$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $fc2e98617fc942d3$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $fc2e98617fc942d3$var$pushProvider(workInProgress, $fc2e98617fc942d3$var$CacheContext, current.memoizedState.cache);
    }
    return $fc2e98617fc942d3$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $fc2e98617fc942d3$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $fc2e98617fc942d3$var$didReceiveUpdate = !0;
        else {
            if (!$fc2e98617fc942d3$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $fc2e98617fc942d3$var$didReceiveUpdate = !1, $fc2e98617fc942d3$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $fc2e98617fc942d3$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $fc2e98617fc942d3$var$didReceiveUpdate = !1, $fc2e98617fc942d3$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $fc2e98617fc942d3$var$pushTreeId(workInProgress, $fc2e98617fc942d3$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $fc2e98617fc942d3$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $fc2e98617fc942d3$var$shouldConstruct(current) ? (props = $fc2e98617fc942d3$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $fc2e98617fc942d3$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $fc2e98617fc942d3$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $fc2e98617fc942d3$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $fc2e98617fc942d3$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $fc2e98617fc942d3$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $fc2e98617fc942d3$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $fc2e98617fc942d3$var$getComponentNameFromType(current) || current;
                    throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $fc2e98617fc942d3$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $fc2e98617fc942d3$var$resolveClassComponentProps(props, workInProgress.pendingProps), $fc2e98617fc942d3$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $fc2e98617fc942d3$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $fc2e98617fc942d3$var$cloneUpdateQueue(current, workInProgress);
                $fc2e98617fc942d3$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $fc2e98617fc942d3$var$pushProvider(workInProgress, $fc2e98617fc942d3$var$CacheContext, props);
                props !== prevState.cache && $fc2e98617fc942d3$var$propagateContextChanges(workInProgress, [
                    $fc2e98617fc942d3$var$CacheContext
                ], renderLanes, !0);
                $fc2e98617fc942d3$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $fc2e98617fc942d3$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $fc2e98617fc942d3$var$createCapturedValueAtFiber(Error($fc2e98617fc942d3$var$formatProdErrorMessage(424)), workInProgress);
                        $fc2e98617fc942d3$var$queueHydrationError($$typeof);
                        workInProgress = $fc2e98617fc942d3$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $fc2e98617fc942d3$var$nextHydratableInstance = $fc2e98617fc942d3$var$getNextHydratable(current.firstChild);
                        $fc2e98617fc942d3$var$hydrationParentFiber = workInProgress;
                        $fc2e98617fc942d3$var$isHydrating = !0;
                        $fc2e98617fc942d3$var$hydrationErrors = null;
                        $fc2e98617fc942d3$var$rootOrSingletonContext = !0;
                        renderLanes = $fc2e98617fc942d3$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $fc2e98617fc942d3$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $fc2e98617fc942d3$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $fc2e98617fc942d3$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $fc2e98617fc942d3$var$markRef(current, workInProgress), null === current ? (renderLanes = $fc2e98617fc942d3$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $fc2e98617fc942d3$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $fc2e98617fc942d3$var$getOwnerDocumentFromRootContainer($fc2e98617fc942d3$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$fc2e98617fc942d3$var$internalInstanceKey] = workInProgress, props[$fc2e98617fc942d3$var$internalPropsKey] = current, $fc2e98617fc942d3$var$setInitialProperties(props, renderLanes, current), $fc2e98617fc942d3$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $fc2e98617fc942d3$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $fc2e98617fc942d3$var$pushHostContext(workInProgress), null === current && $fc2e98617fc942d3$var$isHydrating && (props = workInProgress.stateNode = $fc2e98617fc942d3$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $fc2e98617fc942d3$var$rootInstanceStackCursor.current), $fc2e98617fc942d3$var$hydrationParentFiber = workInProgress, $fc2e98617fc942d3$var$rootOrSingletonContext = !0, $$typeof = $fc2e98617fc942d3$var$nextHydratableInstance, $fc2e98617fc942d3$var$isSingletonScope(workInProgress.type) ? ($fc2e98617fc942d3$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $fc2e98617fc942d3$var$nextHydratableInstance = $fc2e98617fc942d3$var$getNextHydratable(props.firstChild)) : $fc2e98617fc942d3$var$nextHydratableInstance = $$typeof), $fc2e98617fc942d3$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $fc2e98617fc942d3$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $fc2e98617fc942d3$var$isHydrating) {
                if ($$typeof = props = $fc2e98617fc942d3$var$nextHydratableInstance) props = $fc2e98617fc942d3$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $fc2e98617fc942d3$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $fc2e98617fc942d3$var$hydrationParentFiber = workInProgress, $fc2e98617fc942d3$var$nextHydratableInstance = $fc2e98617fc942d3$var$getNextHydratable(props.firstChild), $fc2e98617fc942d3$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $fc2e98617fc942d3$var$throwOnHydrationMismatch(workInProgress);
            }
            $fc2e98617fc942d3$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $fc2e98617fc942d3$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $fc2e98617fc942d3$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $fc2e98617fc942d3$var$renderWithHooks(current, workInProgress, $fc2e98617fc942d3$var$TransitionAwareHostComponent, null, null, renderLanes), $fc2e98617fc942d3$var$HostTransitionContext._currentValue = $$typeof);
            $fc2e98617fc942d3$var$markRef(current, workInProgress);
            $fc2e98617fc942d3$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $fc2e98617fc942d3$var$isHydrating) {
                if (current = renderLanes = $fc2e98617fc942d3$var$nextHydratableInstance) renderLanes = $fc2e98617fc942d3$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $fc2e98617fc942d3$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $fc2e98617fc942d3$var$hydrationParentFiber = workInProgress, $fc2e98617fc942d3$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $fc2e98617fc942d3$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $fc2e98617fc942d3$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $fc2e98617fc942d3$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $fc2e98617fc942d3$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $fc2e98617fc942d3$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $fc2e98617fc942d3$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $fc2e98617fc942d3$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $fc2e98617fc942d3$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $fc2e98617fc942d3$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $fc2e98617fc942d3$var$pushProvider(workInProgress, workInProgress.type, props.value), $fc2e98617fc942d3$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $fc2e98617fc942d3$var$prepareToReadContext(workInProgress), $$typeof = $fc2e98617fc942d3$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $fc2e98617fc942d3$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $fc2e98617fc942d3$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $fc2e98617fc942d3$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $fc2e98617fc942d3$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $fc2e98617fc942d3$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $fc2e98617fc942d3$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $fc2e98617fc942d3$var$prepareToReadContext(workInProgress), props = $fc2e98617fc942d3$var$readContext($fc2e98617fc942d3$var$CacheContext), null === current ? ($$typeof = $fc2e98617fc942d3$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $fc2e98617fc942d3$var$workInProgressRoot, prevState = $fc2e98617fc942d3$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $fc2e98617fc942d3$var$initializeUpdateQueue(workInProgress), $fc2e98617fc942d3$var$pushProvider(workInProgress, $fc2e98617fc942d3$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($fc2e98617fc942d3$var$cloneUpdateQueue(current, workInProgress), $fc2e98617fc942d3$var$processUpdateQueue(workInProgress, null, null, renderLanes), $fc2e98617fc942d3$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $fc2e98617fc942d3$var$pushProvider(workInProgress, $fc2e98617fc942d3$var$CacheContext, props)) : (props = prevState.cache, $fc2e98617fc942d3$var$pushProvider(workInProgress, $fc2e98617fc942d3$var$CacheContext, props), props !== $$typeof.cache && $fc2e98617fc942d3$var$propagateContextChanges(workInProgress, [
                $fc2e98617fc942d3$var$CacheContext
            ], renderLanes, !0))), $fc2e98617fc942d3$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $fc2e98617fc942d3$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $fc2e98617fc942d3$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($fc2e98617fc942d3$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $fc2e98617fc942d3$var$suspendedThenable = $fc2e98617fc942d3$var$noopSuspenseyCommitThenable, $fc2e98617fc942d3$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $fc2e98617fc942d3$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$fc2e98617fc942d3$var$preloadResource(resource)) {
        if ($fc2e98617fc942d3$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $fc2e98617fc942d3$var$suspendedThenable = $fc2e98617fc942d3$var$noopSuspenseyCommitThenable, $fc2e98617fc942d3$var$SuspenseyCommitException;
    }
}
function $fc2e98617fc942d3$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $fc2e98617fc942d3$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $fc2e98617fc942d3$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $fc2e98617fc942d3$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$fc2e98617fc942d3$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $fc2e98617fc942d3$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $fc2e98617fc942d3$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $fc2e98617fc942d3$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $fc2e98617fc942d3$var$bubbleProperties(workInProgress), null;
        case 1:
            return $fc2e98617fc942d3$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $fc2e98617fc942d3$var$popProvider($fc2e98617fc942d3$var$CacheContext);
            $fc2e98617fc942d3$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $fc2e98617fc942d3$var$popHydrationState(workInProgress) ? $fc2e98617fc942d3$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $fc2e98617fc942d3$var$upgradeHydrationErrorsToRecoverable());
            $fc2e98617fc942d3$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($fc2e98617fc942d3$var$markUpdate(workInProgress), null !== nextResource ? ($fc2e98617fc942d3$var$bubbleProperties(workInProgress), $fc2e98617fc942d3$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($fc2e98617fc942d3$var$bubbleProperties(workInProgress), $fc2e98617fc942d3$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($fc2e98617fc942d3$var$markUpdate(workInProgress), $fc2e98617fc942d3$var$bubbleProperties(workInProgress), $fc2e98617fc942d3$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($fc2e98617fc942d3$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $fc2e98617fc942d3$var$markUpdate(workInProgress), $fc2e98617fc942d3$var$bubbleProperties(workInProgress), $fc2e98617fc942d3$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $fc2e98617fc942d3$var$popHostContext(workInProgress);
            renderLanes = $fc2e98617fc942d3$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $fc2e98617fc942d3$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(166));
                    $fc2e98617fc942d3$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $fc2e98617fc942d3$var$contextStackCursor.current;
                $fc2e98617fc942d3$var$popHydrationState(workInProgress) ? $fc2e98617fc942d3$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $fc2e98617fc942d3$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $fc2e98617fc942d3$var$markUpdate(workInProgress));
            }
            $fc2e98617fc942d3$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $fc2e98617fc942d3$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $fc2e98617fc942d3$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(166));
                    $fc2e98617fc942d3$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $fc2e98617fc942d3$var$contextStackCursor.current;
                if ($fc2e98617fc942d3$var$popHydrationState(workInProgress)) $fc2e98617fc942d3$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $fc2e98617fc942d3$var$getOwnerDocumentFromRootContainer($fc2e98617fc942d3$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$fc2e98617fc942d3$var$internalInstanceKey] = workInProgress;
                    nextResource[$fc2e98617fc942d3$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($fc2e98617fc942d3$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $fc2e98617fc942d3$var$markUpdate(workInProgress);
                }
            }
            $fc2e98617fc942d3$var$bubbleProperties(workInProgress);
            $fc2e98617fc942d3$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $fc2e98617fc942d3$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(166));
                current = $fc2e98617fc942d3$var$rootInstanceStackCursor.current;
                if ($fc2e98617fc942d3$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $fc2e98617fc942d3$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$fc2e98617fc942d3$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $fc2e98617fc942d3$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $fc2e98617fc942d3$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $fc2e98617fc942d3$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$fc2e98617fc942d3$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $fc2e98617fc942d3$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $fc2e98617fc942d3$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(557));
                        current[$fc2e98617fc942d3$var$internalInstanceKey] = workInProgress;
                    } else $fc2e98617fc942d3$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $fc2e98617fc942d3$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $fc2e98617fc942d3$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $fc2e98617fc942d3$var$popSuspenseHandler(workInProgress), workInProgress;
                    $fc2e98617fc942d3$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(558));
            }
            $fc2e98617fc942d3$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $fc2e98617fc942d3$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(317));
                        type[$fc2e98617fc942d3$var$internalInstanceKey] = workInProgress;
                    } else $fc2e98617fc942d3$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $fc2e98617fc942d3$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $fc2e98617fc942d3$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $fc2e98617fc942d3$var$popSuspenseHandler(workInProgress), workInProgress;
                    $fc2e98617fc942d3$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $fc2e98617fc942d3$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $fc2e98617fc942d3$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $fc2e98617fc942d3$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $fc2e98617fc942d3$var$popHostContainer(), null === current && $fc2e98617fc942d3$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $fc2e98617fc942d3$var$bubbleProperties(workInProgress), null;
        case 10:
            return $fc2e98617fc942d3$var$popProvider(workInProgress.type), $fc2e98617fc942d3$var$bubbleProperties(workInProgress), null;
        case 19:
            $fc2e98617fc942d3$var$pop($fc2e98617fc942d3$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $fc2e98617fc942d3$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $fc2e98617fc942d3$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $fc2e98617fc942d3$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $fc2e98617fc942d3$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $fc2e98617fc942d3$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $fc2e98617fc942d3$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$fc2e98617fc942d3$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $fc2e98617fc942d3$var$push($fc2e98617fc942d3$var$suspenseStackCursor, $fc2e98617fc942d3$var$suspenseStackCursor.current & 1 | 2);
                            $fc2e98617fc942d3$var$isHydrating && $fc2e98617fc942d3$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $fc2e98617fc942d3$var$now() > $fc2e98617fc942d3$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $fc2e98617fc942d3$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $fc2e98617fc942d3$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $fc2e98617fc942d3$var$scheduleRetryEffect(workInProgress, current), $fc2e98617fc942d3$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$fc2e98617fc942d3$var$isHydrating) return $fc2e98617fc942d3$var$bubbleProperties(workInProgress), null;
                    } else 2 * $fc2e98617fc942d3$var$now() - newProps.renderingStartTime > $fc2e98617fc942d3$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $fc2e98617fc942d3$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $fc2e98617fc942d3$var$now(), current.sibling = null, renderLanes = $fc2e98617fc942d3$var$suspenseStackCursor.current, $fc2e98617fc942d3$var$push($fc2e98617fc942d3$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $fc2e98617fc942d3$var$isHydrating && $fc2e98617fc942d3$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $fc2e98617fc942d3$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $fc2e98617fc942d3$var$popSuspenseHandler(workInProgress), $fc2e98617fc942d3$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($fc2e98617fc942d3$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $fc2e98617fc942d3$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $fc2e98617fc942d3$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $fc2e98617fc942d3$var$pop($fc2e98617fc942d3$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $fc2e98617fc942d3$var$popProvider($fc2e98617fc942d3$var$CacheContext), $fc2e98617fc942d3$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $fc2e98617fc942d3$var$unwindWork(current, workInProgress) {
    $fc2e98617fc942d3$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $fc2e98617fc942d3$var$popProvider($fc2e98617fc942d3$var$CacheContext), $fc2e98617fc942d3$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $fc2e98617fc942d3$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $fc2e98617fc942d3$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(340));
                $fc2e98617fc942d3$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $fc2e98617fc942d3$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(340));
                $fc2e98617fc942d3$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $fc2e98617fc942d3$var$pop($fc2e98617fc942d3$var$suspenseStackCursor), null;
        case 4:
            return $fc2e98617fc942d3$var$popHostContainer(), null;
        case 10:
            return $fc2e98617fc942d3$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $fc2e98617fc942d3$var$popSuspenseHandler(workInProgress), $fc2e98617fc942d3$var$popHiddenContext(), null !== current && $fc2e98617fc942d3$var$pop($fc2e98617fc942d3$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $fc2e98617fc942d3$var$popProvider($fc2e98617fc942d3$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $fc2e98617fc942d3$var$unwindInterruptedWork(current, interruptedWork) {
    $fc2e98617fc942d3$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $fc2e98617fc942d3$var$popProvider($fc2e98617fc942d3$var$CacheContext);
            $fc2e98617fc942d3$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $fc2e98617fc942d3$var$popHostContext(interruptedWork);
            break;
        case 4:
            $fc2e98617fc942d3$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $fc2e98617fc942d3$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $fc2e98617fc942d3$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $fc2e98617fc942d3$var$pop($fc2e98617fc942d3$var$suspenseStackCursor);
            break;
        case 10:
            $fc2e98617fc942d3$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $fc2e98617fc942d3$var$popSuspenseHandler(interruptedWork);
            $fc2e98617fc942d3$var$popHiddenContext();
            null !== current && $fc2e98617fc942d3$var$pop($fc2e98617fc942d3$var$resumedCache);
            break;
        case 24:
            $fc2e98617fc942d3$var$popProvider($fc2e98617fc942d3$var$CacheContext);
    }
}
function $fc2e98617fc942d3$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $fc2e98617fc942d3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $fc2e98617fc942d3$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $fc2e98617fc942d3$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $fc2e98617fc942d3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $fc2e98617fc942d3$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $fc2e98617fc942d3$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $fc2e98617fc942d3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $fc2e98617fc942d3$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $fc2e98617fc942d3$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $fc2e98617fc942d3$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $fc2e98617fc942d3$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $fc2e98617fc942d3$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $fc2e98617fc942d3$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $fc2e98617fc942d3$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $fc2e98617fc942d3$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $fc2e98617fc942d3$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $fc2e98617fc942d3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $fc2e98617fc942d3$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $fc2e98617fc942d3$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$fc2e98617fc942d3$var$internalPropsKey] = newProps;
    } catch (error) {
        $fc2e98617fc942d3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $fc2e98617fc942d3$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $fc2e98617fc942d3$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $fc2e98617fc942d3$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $fc2e98617fc942d3$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $fc2e98617fc942d3$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $fc2e98617fc942d3$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $fc2e98617fc942d3$var$noop$1));
    else if (4 !== tag && (27 === tag && $fc2e98617fc942d3$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($fc2e98617fc942d3$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$fc2e98617fc942d3$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $fc2e98617fc942d3$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $fc2e98617fc942d3$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($fc2e98617fc942d3$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$fc2e98617fc942d3$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $fc2e98617fc942d3$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $fc2e98617fc942d3$var$setInitialProperties(singleton, type, props);
        singleton[$fc2e98617fc942d3$var$internalInstanceKey] = finishedWork;
        singleton[$fc2e98617fc942d3$var$internalPropsKey] = props;
    } catch (error) {
        $fc2e98617fc942d3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $fc2e98617fc942d3$var$offscreenSubtreeIsHidden = !1, $fc2e98617fc942d3$var$offscreenSubtreeWasHidden = !1, $fc2e98617fc942d3$var$needsFormReset = !1, $fc2e98617fc942d3$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $fc2e98617fc942d3$var$nextEffect = null;
function $fc2e98617fc942d3$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $fc2e98617fc942d3$var$eventsEnabled = $fc2e98617fc942d3$var$_enabled;
    root = $fc2e98617fc942d3$var$getActiveElementDeep(root);
    if ($fc2e98617fc942d3$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $fc2e98617fc942d3$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $fc2e98617fc942d3$var$_enabled = !1;
    for($fc2e98617fc942d3$var$nextEffect = firstChild; null !== $fc2e98617fc942d3$var$nextEffect;)if (firstChild = $fc2e98617fc942d3$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $fc2e98617fc942d3$var$nextEffect = root;
    else for(; null !== $fc2e98617fc942d3$var$nextEffect;){
        firstChild = $fc2e98617fc942d3$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $fc2e98617fc942d3$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $fc2e98617fc942d3$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $fc2e98617fc942d3$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $fc2e98617fc942d3$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $fc2e98617fc942d3$var$nextEffect = root;
            break;
        }
        $fc2e98617fc942d3$var$nextEffect = firstChild.return;
    }
}
function $fc2e98617fc942d3$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $fc2e98617fc942d3$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $fc2e98617fc942d3$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $fc2e98617fc942d3$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $fc2e98617fc942d3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $fc2e98617fc942d3$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $fc2e98617fc942d3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $fc2e98617fc942d3$var$commitClassCallbacks(finishedWork);
            flags & 512 && $fc2e98617fc942d3$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $fc2e98617fc942d3$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $fc2e98617fc942d3$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $fc2e98617fc942d3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $fc2e98617fc942d3$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $fc2e98617fc942d3$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $fc2e98617fc942d3$var$commitHostMount(finishedWork);
            flags & 512 && $fc2e98617fc942d3$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $fc2e98617fc942d3$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $fc2e98617fc942d3$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $fc2e98617fc942d3$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $fc2e98617fc942d3$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $fc2e98617fc942d3$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $fc2e98617fc942d3$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $fc2e98617fc942d3$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $fc2e98617fc942d3$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $fc2e98617fc942d3$var$offscreenSubtreeWasHidden;
                prevProps = $fc2e98617fc942d3$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $fc2e98617fc942d3$var$offscreenSubtreeWasHidden;
                $fc2e98617fc942d3$var$offscreenSubtreeIsHidden = flags;
                ($fc2e98617fc942d3$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $fc2e98617fc942d3$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $fc2e98617fc942d3$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $fc2e98617fc942d3$var$offscreenSubtreeIsHidden = prevProps;
                $fc2e98617fc942d3$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $fc2e98617fc942d3$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $fc2e98617fc942d3$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $fc2e98617fc942d3$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $fc2e98617fc942d3$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $fc2e98617fc942d3$var$hostParent = null, $fc2e98617fc942d3$var$hostParentIsContainer = !1;
function $fc2e98617fc942d3$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$fc2e98617fc942d3$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $fc2e98617fc942d3$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($fc2e98617fc942d3$var$injectedHook && "function" === typeof $fc2e98617fc942d3$var$injectedHook.onCommitFiberUnmount) try {
        $fc2e98617fc942d3$var$injectedHook.onCommitFiberUnmount($fc2e98617fc942d3$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $fc2e98617fc942d3$var$offscreenSubtreeWasHidden || $fc2e98617fc942d3$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $fc2e98617fc942d3$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $fc2e98617fc942d3$var$offscreenSubtreeWasHidden || $fc2e98617fc942d3$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $fc2e98617fc942d3$var$hostParent, prevHostParentIsContainer = $fc2e98617fc942d3$var$hostParentIsContainer;
            $fc2e98617fc942d3$var$isSingletonScope(deletedFiber.type) && ($fc2e98617fc942d3$var$hostParent = deletedFiber.stateNode, $fc2e98617fc942d3$var$hostParentIsContainer = !1);
            $fc2e98617fc942d3$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $fc2e98617fc942d3$var$releaseSingletonInstance(deletedFiber.stateNode);
            $fc2e98617fc942d3$var$hostParent = prevHostParent;
            $fc2e98617fc942d3$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $fc2e98617fc942d3$var$offscreenSubtreeWasHidden || $fc2e98617fc942d3$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $fc2e98617fc942d3$var$hostParent;
            prevHostParentIsContainer = $fc2e98617fc942d3$var$hostParentIsContainer;
            $fc2e98617fc942d3$var$hostParent = null;
            $fc2e98617fc942d3$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $fc2e98617fc942d3$var$hostParent = prevHostParent;
            $fc2e98617fc942d3$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $fc2e98617fc942d3$var$hostParent) {
                if ($fc2e98617fc942d3$var$hostParentIsContainer) try {
                    (9 === $fc2e98617fc942d3$var$hostParent.nodeType ? $fc2e98617fc942d3$var$hostParent.body : "HTML" === $fc2e98617fc942d3$var$hostParent.nodeName ? $fc2e98617fc942d3$var$hostParent.ownerDocument.body : $fc2e98617fc942d3$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $fc2e98617fc942d3$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $fc2e98617fc942d3$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $fc2e98617fc942d3$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $fc2e98617fc942d3$var$hostParent && ($fc2e98617fc942d3$var$hostParentIsContainer ? (finishedRoot = $fc2e98617fc942d3$var$hostParent, $fc2e98617fc942d3$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $fc2e98617fc942d3$var$retryIfBlockedOn(finishedRoot)) : $fc2e98617fc942d3$var$clearHydrationBoundary($fc2e98617fc942d3$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $fc2e98617fc942d3$var$hostParent;
            prevHostParentIsContainer = $fc2e98617fc942d3$var$hostParentIsContainer;
            $fc2e98617fc942d3$var$hostParent = deletedFiber.stateNode.containerInfo;
            $fc2e98617fc942d3$var$hostParentIsContainer = !0;
            $fc2e98617fc942d3$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $fc2e98617fc942d3$var$hostParent = prevHostParent;
            $fc2e98617fc942d3$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $fc2e98617fc942d3$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $fc2e98617fc942d3$var$offscreenSubtreeWasHidden || $fc2e98617fc942d3$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $fc2e98617fc942d3$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $fc2e98617fc942d3$var$offscreenSubtreeWasHidden || ($fc2e98617fc942d3$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $fc2e98617fc942d3$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $fc2e98617fc942d3$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $fc2e98617fc942d3$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $fc2e98617fc942d3$var$offscreenSubtreeWasHidden = (prevHostParent = $fc2e98617fc942d3$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $fc2e98617fc942d3$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $fc2e98617fc942d3$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $fc2e98617fc942d3$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $fc2e98617fc942d3$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $fc2e98617fc942d3$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $fc2e98617fc942d3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $fc2e98617fc942d3$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $fc2e98617fc942d3$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $fc2e98617fc942d3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $fc2e98617fc942d3$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $fc2e98617fc942d3$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $fc2e98617fc942d3$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $fc2e98617fc942d3$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $fc2e98617fc942d3$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $fc2e98617fc942d3$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $fc2e98617fc942d3$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($fc2e98617fc942d3$var$isSingletonScope(parent.type)) {
                        $fc2e98617fc942d3$var$hostParent = parent.stateNode;
                        $fc2e98617fc942d3$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $fc2e98617fc942d3$var$hostParent = parent.stateNode;
                    $fc2e98617fc942d3$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $fc2e98617fc942d3$var$hostParent = parent.stateNode.containerInfo;
                    $fc2e98617fc942d3$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $fc2e98617fc942d3$var$hostParent) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(160));
        $fc2e98617fc942d3$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $fc2e98617fc942d3$var$hostParent = null;
        $fc2e98617fc942d3$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$fc2e98617fc942d3$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $fc2e98617fc942d3$var$currentHoistableRoot = null;
function $fc2e98617fc942d3$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $fc2e98617fc942d3$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $fc2e98617fc942d3$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($fc2e98617fc942d3$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $fc2e98617fc942d3$var$commitHookEffectListMount(3, finishedWork), $fc2e98617fc942d3$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $fc2e98617fc942d3$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $fc2e98617fc942d3$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($fc2e98617fc942d3$var$offscreenSubtreeWasHidden || null === current || $fc2e98617fc942d3$var$safelyDetachRef(current, current.return));
            flags & 64 && $fc2e98617fc942d3$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $fc2e98617fc942d3$var$currentHoistableRoot;
            $fc2e98617fc942d3$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $fc2e98617fc942d3$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($fc2e98617fc942d3$var$offscreenSubtreeWasHidden || null === current || $fc2e98617fc942d3$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$fc2e98617fc942d3$var$internalHoistableMarker] || currentResource[$fc2e98617fc942d3$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $fc2e98617fc942d3$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$fc2e98617fc942d3$var$internalInstanceKey] = finishedWork;
                                        $fc2e98617fc942d3$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $fc2e98617fc942d3$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $fc2e98617fc942d3$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $fc2e98617fc942d3$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $fc2e98617fc942d3$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$fc2e98617fc942d3$var$internalInstanceKey] = finishedWork;
                                $fc2e98617fc942d3$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $fc2e98617fc942d3$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $fc2e98617fc942d3$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $fc2e98617fc942d3$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $fc2e98617fc942d3$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $fc2e98617fc942d3$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $fc2e98617fc942d3$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $fc2e98617fc942d3$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($fc2e98617fc942d3$var$offscreenSubtreeWasHidden || null === current || $fc2e98617fc942d3$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $fc2e98617fc942d3$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $fc2e98617fc942d3$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $fc2e98617fc942d3$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($fc2e98617fc942d3$var$offscreenSubtreeWasHidden || null === current || $fc2e98617fc942d3$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $fc2e98617fc942d3$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $fc2e98617fc942d3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $fc2e98617fc942d3$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($fc2e98617fc942d3$var$needsFormReset = !0);
            break;
        case 6:
            $fc2e98617fc942d3$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $fc2e98617fc942d3$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $fc2e98617fc942d3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $fc2e98617fc942d3$var$tagCaches = null;
            hoistableRoot = $fc2e98617fc942d3$var$currentHoistableRoot;
            $fc2e98617fc942d3$var$currentHoistableRoot = $fc2e98617fc942d3$var$getHoistableRoot(root.containerInfo);
            $fc2e98617fc942d3$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $fc2e98617fc942d3$var$currentHoistableRoot = hoistableRoot;
            $fc2e98617fc942d3$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $fc2e98617fc942d3$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $fc2e98617fc942d3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $fc2e98617fc942d3$var$needsFormReset && ($fc2e98617fc942d3$var$needsFormReset = !1, $fc2e98617fc942d3$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $fc2e98617fc942d3$var$currentHoistableRoot;
            $fc2e98617fc942d3$var$currentHoistableRoot = $fc2e98617fc942d3$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $fc2e98617fc942d3$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $fc2e98617fc942d3$var$commitReconciliationEffects(finishedWork);
            $fc2e98617fc942d3$var$currentHoistableRoot = flags;
            break;
        case 12:
            $fc2e98617fc942d3$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $fc2e98617fc942d3$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $fc2e98617fc942d3$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $fc2e98617fc942d3$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $fc2e98617fc942d3$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $fc2e98617fc942d3$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $fc2e98617fc942d3$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($fc2e98617fc942d3$var$globalMostRecentFallbackTime = $fc2e98617fc942d3$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $fc2e98617fc942d3$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $fc2e98617fc942d3$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $fc2e98617fc942d3$var$offscreenSubtreeWasHidden;
            $fc2e98617fc942d3$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $fc2e98617fc942d3$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $fc2e98617fc942d3$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $fc2e98617fc942d3$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $fc2e98617fc942d3$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $fc2e98617fc942d3$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $fc2e98617fc942d3$var$offscreenSubtreeIsHidden || $fc2e98617fc942d3$var$offscreenSubtreeWasHidden || $fc2e98617fc942d3$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $fc2e98617fc942d3$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $fc2e98617fc942d3$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $fc2e98617fc942d3$var$hideOrUnhideDehydratedBoundary(instance, !0) : $fc2e98617fc942d3$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $fc2e98617fc942d3$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $fc2e98617fc942d3$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $fc2e98617fc942d3$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $fc2e98617fc942d3$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $fc2e98617fc942d3$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $fc2e98617fc942d3$var$recursivelyTraverseMutationEffects(root, finishedWork), $fc2e98617fc942d3$var$commitReconciliationEffects(finishedWork);
    }
}
function $fc2e98617fc942d3$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($fc2e98617fc942d3$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $fc2e98617fc942d3$var$getHostSibling(finishedWork);
                    $fc2e98617fc942d3$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($fc2e98617fc942d3$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $fc2e98617fc942d3$var$getHostSibling(finishedWork);
                    $fc2e98617fc942d3$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $fc2e98617fc942d3$var$getHostSibling(finishedWork);
                    $fc2e98617fc942d3$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $fc2e98617fc942d3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $fc2e98617fc942d3$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $fc2e98617fc942d3$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $fc2e98617fc942d3$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$fc2e98617fc942d3$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $fc2e98617fc942d3$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $fc2e98617fc942d3$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $fc2e98617fc942d3$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $fc2e98617fc942d3$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $fc2e98617fc942d3$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $fc2e98617fc942d3$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $fc2e98617fc942d3$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $fc2e98617fc942d3$var$safelyDetachRef(finishedWork, finishedWork.return);
                $fc2e98617fc942d3$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $fc2e98617fc942d3$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $fc2e98617fc942d3$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $fc2e98617fc942d3$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $fc2e98617fc942d3$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $fc2e98617fc942d3$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $fc2e98617fc942d3$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $fc2e98617fc942d3$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $fc2e98617fc942d3$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$fc2e98617fc942d3$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $fc2e98617fc942d3$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $fc2e98617fc942d3$var$commitClassCallbacks(finishedWork);
                $fc2e98617fc942d3$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $fc2e98617fc942d3$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $fc2e98617fc942d3$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $fc2e98617fc942d3$var$commitHostMount(finishedWork);
                $fc2e98617fc942d3$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $fc2e98617fc942d3$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $fc2e98617fc942d3$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $fc2e98617fc942d3$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $fc2e98617fc942d3$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $fc2e98617fc942d3$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $fc2e98617fc942d3$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $fc2e98617fc942d3$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $fc2e98617fc942d3$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $fc2e98617fc942d3$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $fc2e98617fc942d3$var$releaseCache(previousCache));
}
function $fc2e98617fc942d3$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $fc2e98617fc942d3$var$releaseCache(current));
}
function $fc2e98617fc942d3$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$fc2e98617fc942d3$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $fc2e98617fc942d3$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $fc2e98617fc942d3$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $fc2e98617fc942d3$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $fc2e98617fc942d3$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $fc2e98617fc942d3$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $fc2e98617fc942d3$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $fc2e98617fc942d3$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $fc2e98617fc942d3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $fc2e98617fc942d3$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $fc2e98617fc942d3$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $fc2e98617fc942d3$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $fc2e98617fc942d3$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $fc2e98617fc942d3$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $fc2e98617fc942d3$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $fc2e98617fc942d3$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $fc2e98617fc942d3$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $fc2e98617fc942d3$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $fc2e98617fc942d3$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $fc2e98617fc942d3$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $fc2e98617fc942d3$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $fc2e98617fc942d3$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $fc2e98617fc942d3$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $fc2e98617fc942d3$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $fc2e98617fc942d3$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $fc2e98617fc942d3$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $fc2e98617fc942d3$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $fc2e98617fc942d3$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $fc2e98617fc942d3$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $fc2e98617fc942d3$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $fc2e98617fc942d3$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $fc2e98617fc942d3$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $fc2e98617fc942d3$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $fc2e98617fc942d3$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $fc2e98617fc942d3$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $fc2e98617fc942d3$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $fc2e98617fc942d3$var$suspenseyCommitFlag = 8192;
function $fc2e98617fc942d3$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $fc2e98617fc942d3$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$fc2e98617fc942d3$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $fc2e98617fc942d3$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $fc2e98617fc942d3$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $fc2e98617fc942d3$var$suspenseyCommitFlag && null !== fiber.memoizedState && $fc2e98617fc942d3$var$suspendResource(suspendedState, $fc2e98617fc942d3$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $fc2e98617fc942d3$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $fc2e98617fc942d3$var$currentHoistableRoot;
            $fc2e98617fc942d3$var$currentHoistableRoot = $fc2e98617fc942d3$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $fc2e98617fc942d3$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $fc2e98617fc942d3$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $fc2e98617fc942d3$var$suspenseyCommitFlag, $fc2e98617fc942d3$var$suspenseyCommitFlag = 16777216, $fc2e98617fc942d3$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $fc2e98617fc942d3$var$suspenseyCommitFlag = previousHoistableRoot) : $fc2e98617fc942d3$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $fc2e98617fc942d3$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $fc2e98617fc942d3$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $fc2e98617fc942d3$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $fc2e98617fc942d3$var$nextEffect = childToDelete;
            $fc2e98617fc942d3$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $fc2e98617fc942d3$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$fc2e98617fc942d3$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $fc2e98617fc942d3$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $fc2e98617fc942d3$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $fc2e98617fc942d3$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $fc2e98617fc942d3$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $fc2e98617fc942d3$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $fc2e98617fc942d3$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $fc2e98617fc942d3$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $fc2e98617fc942d3$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $fc2e98617fc942d3$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $fc2e98617fc942d3$var$nextEffect = childToDelete;
            $fc2e98617fc942d3$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $fc2e98617fc942d3$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $fc2e98617fc942d3$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $fc2e98617fc942d3$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $fc2e98617fc942d3$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $fc2e98617fc942d3$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $fc2e98617fc942d3$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $fc2e98617fc942d3$var$nextEffect;){
        var fiber = $fc2e98617fc942d3$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $fc2e98617fc942d3$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $fc2e98617fc942d3$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $fc2e98617fc942d3$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $fc2e98617fc942d3$var$nextEffect;){
            cache = $fc2e98617fc942d3$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $fc2e98617fc942d3$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $fc2e98617fc942d3$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $fc2e98617fc942d3$var$nextEffect = sibling;
                break a;
            }
            $fc2e98617fc942d3$var$nextEffect = returnFiber;
        }
    }
}
var $fc2e98617fc942d3$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $fc2e98617fc942d3$var$readContext($fc2e98617fc942d3$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $fc2e98617fc942d3$var$readContext($fc2e98617fc942d3$var$CacheContext).controller.signal;
    }
}, $fc2e98617fc942d3$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $fc2e98617fc942d3$var$executionContext = 0, $fc2e98617fc942d3$var$workInProgressRoot = null, $fc2e98617fc942d3$var$workInProgress = null, $fc2e98617fc942d3$var$workInProgressRootRenderLanes = 0, $fc2e98617fc942d3$var$workInProgressSuspendedReason = 0, $fc2e98617fc942d3$var$workInProgressThrownValue = null, $fc2e98617fc942d3$var$workInProgressRootDidSkipSuspendedSiblings = !1, $fc2e98617fc942d3$var$workInProgressRootIsPrerendering = !1, $fc2e98617fc942d3$var$workInProgressRootDidAttachPingListener = !1, $fc2e98617fc942d3$var$entangledRenderLanes = 0, $fc2e98617fc942d3$var$workInProgressRootExitStatus = 0, $fc2e98617fc942d3$var$workInProgressRootSkippedLanes = 0, $fc2e98617fc942d3$var$workInProgressRootInterleavedUpdatedLanes = 0, $fc2e98617fc942d3$var$workInProgressRootPingedLanes = 0, $fc2e98617fc942d3$var$workInProgressDeferredLane = 0, $fc2e98617fc942d3$var$workInProgressSuspendedRetryLanes = 0, $fc2e98617fc942d3$var$workInProgressRootConcurrentErrors = null, $fc2e98617fc942d3$var$workInProgressRootRecoverableErrors = null, $fc2e98617fc942d3$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $fc2e98617fc942d3$var$globalMostRecentFallbackTime = 0, $fc2e98617fc942d3$var$globalMostRecentTransitionTime = 0, $fc2e98617fc942d3$var$workInProgressRootRenderTargetTime = Infinity, $fc2e98617fc942d3$var$workInProgressTransitions = null, $fc2e98617fc942d3$var$legacyErrorBoundariesThatAlreadyFailed = null, $fc2e98617fc942d3$var$pendingEffectsStatus = 0, $fc2e98617fc942d3$var$pendingEffectsRoot = null, $fc2e98617fc942d3$var$pendingFinishedWork = null, $fc2e98617fc942d3$var$pendingEffectsLanes = 0, $fc2e98617fc942d3$var$pendingEffectsRemainingLanes = 0, $fc2e98617fc942d3$var$pendingPassiveTransitions = null, $fc2e98617fc942d3$var$pendingRecoverableErrors = null, $fc2e98617fc942d3$var$nestedUpdateCount = 0, $fc2e98617fc942d3$var$rootWithNestedUpdates = null;
function $fc2e98617fc942d3$var$requestUpdateLane() {
    return 0 !== ($fc2e98617fc942d3$var$executionContext & 2) && 0 !== $fc2e98617fc942d3$var$workInProgressRootRenderLanes ? $fc2e98617fc942d3$var$workInProgressRootRenderLanes & -$fc2e98617fc942d3$var$workInProgressRootRenderLanes : null !== $fc2e98617fc942d3$var$ReactSharedInternals.T ? $fc2e98617fc942d3$var$requestTransitionLane() : $fc2e98617fc942d3$var$resolveUpdatePriority();
}
function $fc2e98617fc942d3$var$requestDeferredLane() {
    if (0 === $fc2e98617fc942d3$var$workInProgressDeferredLane) {
        if (0 === ($fc2e98617fc942d3$var$workInProgressRootRenderLanes & 536870912) || $fc2e98617fc942d3$var$isHydrating) {
            var lane = $fc2e98617fc942d3$var$nextTransitionDeferredLane;
            $fc2e98617fc942d3$var$nextTransitionDeferredLane <<= 1;
            0 === ($fc2e98617fc942d3$var$nextTransitionDeferredLane & 3932160) && ($fc2e98617fc942d3$var$nextTransitionDeferredLane = 262144);
            $fc2e98617fc942d3$var$workInProgressDeferredLane = lane;
        } else $fc2e98617fc942d3$var$workInProgressDeferredLane = 536870912;
    }
    lane = $fc2e98617fc942d3$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $fc2e98617fc942d3$var$workInProgressDeferredLane;
}
function $fc2e98617fc942d3$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $fc2e98617fc942d3$var$workInProgressRoot && (2 === $fc2e98617fc942d3$var$workInProgressSuspendedReason || 9 === $fc2e98617fc942d3$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $fc2e98617fc942d3$var$prepareFreshStack(root, 0), $fc2e98617fc942d3$var$markRootSuspended(root, $fc2e98617fc942d3$var$workInProgressRootRenderLanes, $fc2e98617fc942d3$var$workInProgressDeferredLane, !1);
    $fc2e98617fc942d3$var$markRootUpdated$1(root, lane);
    if (0 === ($fc2e98617fc942d3$var$executionContext & 2) || root !== $fc2e98617fc942d3$var$workInProgressRoot) root === $fc2e98617fc942d3$var$workInProgressRoot && (0 === ($fc2e98617fc942d3$var$executionContext & 2) && ($fc2e98617fc942d3$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $fc2e98617fc942d3$var$workInProgressRootExitStatus && $fc2e98617fc942d3$var$markRootSuspended(root, $fc2e98617fc942d3$var$workInProgressRootRenderLanes, $fc2e98617fc942d3$var$workInProgressDeferredLane, !1)), $fc2e98617fc942d3$var$ensureRootIsScheduled(root);
}
function $fc2e98617fc942d3$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($fc2e98617fc942d3$var$executionContext & 6)) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $fc2e98617fc942d3$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $fc2e98617fc942d3$var$renderRootConcurrent(root$jscomp$0, lanes) : $fc2e98617fc942d3$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $fc2e98617fc942d3$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $fc2e98617fc942d3$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$fc2e98617fc942d3$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $fc2e98617fc942d3$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $fc2e98617fc942d3$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($fc2e98617fc942d3$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $fc2e98617fc942d3$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($fc2e98617fc942d3$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $fc2e98617fc942d3$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $fc2e98617fc942d3$var$workInProgressRootRecoverableErrors;
                            $fc2e98617fc942d3$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $fc2e98617fc942d3$var$workInProgressRootRecoverableErrors ? $fc2e98617fc942d3$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $fc2e98617fc942d3$var$workInProgressRootRecoverableErrors.push.apply($fc2e98617fc942d3$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $fc2e98617fc942d3$var$prepareFreshStack(root$jscomp$0, 0);
                $fc2e98617fc942d3$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $fc2e98617fc942d3$var$markRootSuspended(shouldTimeSlice, lanes, $fc2e98617fc942d3$var$workInProgressDeferredLane, !$fc2e98617fc942d3$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $fc2e98617fc942d3$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $fc2e98617fc942d3$var$globalMostRecentFallbackTime + 300 - $fc2e98617fc942d3$var$now(), 10 < exitStatus)) {
                    $fc2e98617fc942d3$var$markRootSuspended(shouldTimeSlice, lanes, $fc2e98617fc942d3$var$workInProgressDeferredLane, !$fc2e98617fc942d3$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $fc2e98617fc942d3$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $fc2e98617fc942d3$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $fc2e98617fc942d3$var$scheduleTimeout($fc2e98617fc942d3$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $fc2e98617fc942d3$var$workInProgressRootRecoverableErrors, $fc2e98617fc942d3$var$workInProgressTransitions, $fc2e98617fc942d3$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $fc2e98617fc942d3$var$workInProgressDeferredLane, $fc2e98617fc942d3$var$workInProgressRootInterleavedUpdatedLanes, $fc2e98617fc942d3$var$workInProgressSuspendedRetryLanes, $fc2e98617fc942d3$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $fc2e98617fc942d3$var$commitRootWhenReady(shouldTimeSlice, forceSync, $fc2e98617fc942d3$var$workInProgressRootRecoverableErrors, $fc2e98617fc942d3$var$workInProgressTransitions, $fc2e98617fc942d3$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $fc2e98617fc942d3$var$workInProgressDeferredLane, $fc2e98617fc942d3$var$workInProgressRootInterleavedUpdatedLanes, $fc2e98617fc942d3$var$workInProgressSuspendedRetryLanes, $fc2e98617fc942d3$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $fc2e98617fc942d3$var$ensureRootIsScheduled(root$jscomp$0);
}
function $fc2e98617fc942d3$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $fc2e98617fc942d3$var$noop$1
        };
        $fc2e98617fc942d3$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $fc2e98617fc942d3$var$globalMostRecentFallbackTime - $fc2e98617fc942d3$var$now() : (lanes & 4194048) === lanes ? $fc2e98617fc942d3$var$globalMostRecentTransitionTime - $fc2e98617fc942d3$var$now() : 0;
        timeoutOffset = $fc2e98617fc942d3$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $fc2e98617fc942d3$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($fc2e98617fc942d3$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $fc2e98617fc942d3$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $fc2e98617fc942d3$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $fc2e98617fc942d3$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$fc2e98617fc942d3$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $fc2e98617fc942d3$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$fc2e98617fc942d3$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$fc2e98617fc942d3$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $fc2e98617fc942d3$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $fc2e98617fc942d3$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $fc2e98617fc942d3$var$flushSyncWork$1() {
    return 0 === ($fc2e98617fc942d3$var$executionContext & 6) ? ($fc2e98617fc942d3$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $fc2e98617fc942d3$var$resetWorkInProgressStack() {
    if (null !== $fc2e98617fc942d3$var$workInProgress) {
        if (0 === $fc2e98617fc942d3$var$workInProgressSuspendedReason) var interruptedWork = $fc2e98617fc942d3$var$workInProgress.return;
        else interruptedWork = $fc2e98617fc942d3$var$workInProgress, $fc2e98617fc942d3$var$lastContextDependency = $fc2e98617fc942d3$var$currentlyRenderingFiber$1 = null, $fc2e98617fc942d3$var$resetHooksOnUnwind(interruptedWork), $fc2e98617fc942d3$var$thenableState$1 = null, $fc2e98617fc942d3$var$thenableIndexCounter$1 = 0, interruptedWork = $fc2e98617fc942d3$var$workInProgress;
        for(; null !== interruptedWork;)$fc2e98617fc942d3$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $fc2e98617fc942d3$var$workInProgress = null;
    }
}
function $fc2e98617fc942d3$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $fc2e98617fc942d3$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $fc2e98617fc942d3$var$pendingEffectsLanes = 0;
    $fc2e98617fc942d3$var$resetWorkInProgressStack();
    $fc2e98617fc942d3$var$workInProgressRoot = root;
    $fc2e98617fc942d3$var$workInProgress = timeoutHandle = $fc2e98617fc942d3$var$createWorkInProgress(root.current, null);
    $fc2e98617fc942d3$var$workInProgressRootRenderLanes = lanes;
    $fc2e98617fc942d3$var$workInProgressSuspendedReason = 0;
    $fc2e98617fc942d3$var$workInProgressThrownValue = null;
    $fc2e98617fc942d3$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $fc2e98617fc942d3$var$workInProgressRootIsPrerendering = $fc2e98617fc942d3$var$checkIfRootIsPrerendering(root, lanes);
    $fc2e98617fc942d3$var$workInProgressRootDidAttachPingListener = !1;
    $fc2e98617fc942d3$var$workInProgressSuspendedRetryLanes = $fc2e98617fc942d3$var$workInProgressDeferredLane = $fc2e98617fc942d3$var$workInProgressRootPingedLanes = $fc2e98617fc942d3$var$workInProgressRootInterleavedUpdatedLanes = $fc2e98617fc942d3$var$workInProgressRootSkippedLanes = $fc2e98617fc942d3$var$workInProgressRootExitStatus = 0;
    $fc2e98617fc942d3$var$workInProgressRootRecoverableErrors = $fc2e98617fc942d3$var$workInProgressRootConcurrentErrors = null;
    $fc2e98617fc942d3$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $fc2e98617fc942d3$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $fc2e98617fc942d3$var$entangledRenderLanes = lanes;
    $fc2e98617fc942d3$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $fc2e98617fc942d3$var$handleThrow(root, thrownValue) {
    $fc2e98617fc942d3$var$currentlyRenderingFiber = null;
    $fc2e98617fc942d3$var$ReactSharedInternals.H = $fc2e98617fc942d3$var$ContextOnlyDispatcher;
    thrownValue === $fc2e98617fc942d3$var$SuspenseException || thrownValue === $fc2e98617fc942d3$var$SuspenseActionException ? (thrownValue = $fc2e98617fc942d3$var$getSuspendedThenable(), $fc2e98617fc942d3$var$workInProgressSuspendedReason = 3) : thrownValue === $fc2e98617fc942d3$var$SuspenseyCommitException ? (thrownValue = $fc2e98617fc942d3$var$getSuspendedThenable(), $fc2e98617fc942d3$var$workInProgressSuspendedReason = 4) : $fc2e98617fc942d3$var$workInProgressSuspendedReason = thrownValue === $fc2e98617fc942d3$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $fc2e98617fc942d3$var$workInProgressThrownValue = thrownValue;
    null === $fc2e98617fc942d3$var$workInProgress && ($fc2e98617fc942d3$var$workInProgressRootExitStatus = 1, $fc2e98617fc942d3$var$logUncaughtError(root, $fc2e98617fc942d3$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $fc2e98617fc942d3$var$shouldRemainOnPreviousScreen() {
    var handler = $fc2e98617fc942d3$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($fc2e98617fc942d3$var$workInProgressRootRenderLanes & 4194048) === $fc2e98617fc942d3$var$workInProgressRootRenderLanes ? null === $fc2e98617fc942d3$var$shellBoundary ? !0 : !1 : ($fc2e98617fc942d3$var$workInProgressRootRenderLanes & 62914560) === $fc2e98617fc942d3$var$workInProgressRootRenderLanes || 0 !== ($fc2e98617fc942d3$var$workInProgressRootRenderLanes & 536870912) ? handler === $fc2e98617fc942d3$var$shellBoundary : !1;
}
function $fc2e98617fc942d3$var$pushDispatcher() {
    var prevDispatcher = $fc2e98617fc942d3$var$ReactSharedInternals.H;
    $fc2e98617fc942d3$var$ReactSharedInternals.H = $fc2e98617fc942d3$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $fc2e98617fc942d3$var$ContextOnlyDispatcher : prevDispatcher;
}
function $fc2e98617fc942d3$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $fc2e98617fc942d3$var$ReactSharedInternals.A;
    $fc2e98617fc942d3$var$ReactSharedInternals.A = $fc2e98617fc942d3$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $fc2e98617fc942d3$var$renderDidSuspendDelayIfPossible() {
    $fc2e98617fc942d3$var$workInProgressRootExitStatus = 4;
    $fc2e98617fc942d3$var$workInProgressRootDidSkipSuspendedSiblings || ($fc2e98617fc942d3$var$workInProgressRootRenderLanes & 4194048) !== $fc2e98617fc942d3$var$workInProgressRootRenderLanes && null !== $fc2e98617fc942d3$var$suspenseHandlerStackCursor.current || ($fc2e98617fc942d3$var$workInProgressRootIsPrerendering = !0);
    0 === ($fc2e98617fc942d3$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($fc2e98617fc942d3$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $fc2e98617fc942d3$var$workInProgressRoot || $fc2e98617fc942d3$var$markRootSuspended($fc2e98617fc942d3$var$workInProgressRoot, $fc2e98617fc942d3$var$workInProgressRootRenderLanes, $fc2e98617fc942d3$var$workInProgressDeferredLane, !1);
}
function $fc2e98617fc942d3$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $fc2e98617fc942d3$var$executionContext;
    $fc2e98617fc942d3$var$executionContext |= 2;
    var prevDispatcher = $fc2e98617fc942d3$var$pushDispatcher(), prevAsyncDispatcher = $fc2e98617fc942d3$var$pushAsyncDispatcher();
    if ($fc2e98617fc942d3$var$workInProgressRoot !== root || $fc2e98617fc942d3$var$workInProgressRootRenderLanes !== lanes) $fc2e98617fc942d3$var$workInProgressTransitions = null, $fc2e98617fc942d3$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $fc2e98617fc942d3$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $fc2e98617fc942d3$var$workInProgressSuspendedReason && null !== $fc2e98617fc942d3$var$workInProgress) {
            var unitOfWork = $fc2e98617fc942d3$var$workInProgress, thrownValue = $fc2e98617fc942d3$var$workInProgressThrownValue;
            switch($fc2e98617fc942d3$var$workInProgressSuspendedReason){
                case 8:
                    $fc2e98617fc942d3$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $fc2e98617fc942d3$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $fc2e98617fc942d3$var$workInProgressSuspendedReason;
                    $fc2e98617fc942d3$var$workInProgressSuspendedReason = 0;
                    $fc2e98617fc942d3$var$workInProgressThrownValue = null;
                    $fc2e98617fc942d3$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $fc2e98617fc942d3$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $fc2e98617fc942d3$var$workInProgressSuspendedReason, $fc2e98617fc942d3$var$workInProgressSuspendedReason = 0, $fc2e98617fc942d3$var$workInProgressThrownValue = null, $fc2e98617fc942d3$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $fc2e98617fc942d3$var$workLoopSync();
        exitStatus = $fc2e98617fc942d3$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $fc2e98617fc942d3$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $fc2e98617fc942d3$var$lastContextDependency = $fc2e98617fc942d3$var$currentlyRenderingFiber$1 = null;
    $fc2e98617fc942d3$var$executionContext = prevExecutionContext;
    $fc2e98617fc942d3$var$ReactSharedInternals.H = prevDispatcher;
    $fc2e98617fc942d3$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $fc2e98617fc942d3$var$workInProgress && ($fc2e98617fc942d3$var$workInProgressRoot = null, $fc2e98617fc942d3$var$workInProgressRootRenderLanes = 0, $fc2e98617fc942d3$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $fc2e98617fc942d3$var$workLoopSync() {
    for(; null !== $fc2e98617fc942d3$var$workInProgress;)$fc2e98617fc942d3$var$performUnitOfWork($fc2e98617fc942d3$var$workInProgress);
}
function $fc2e98617fc942d3$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $fc2e98617fc942d3$var$executionContext;
    $fc2e98617fc942d3$var$executionContext |= 2;
    var prevDispatcher = $fc2e98617fc942d3$var$pushDispatcher(), prevAsyncDispatcher = $fc2e98617fc942d3$var$pushAsyncDispatcher();
    $fc2e98617fc942d3$var$workInProgressRoot !== root || $fc2e98617fc942d3$var$workInProgressRootRenderLanes !== lanes ? ($fc2e98617fc942d3$var$workInProgressTransitions = null, $fc2e98617fc942d3$var$workInProgressRootRenderTargetTime = $fc2e98617fc942d3$var$now() + 500, $fc2e98617fc942d3$var$prepareFreshStack(root, lanes)) : $fc2e98617fc942d3$var$workInProgressRootIsPrerendering = $fc2e98617fc942d3$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $fc2e98617fc942d3$var$workInProgressSuspendedReason && null !== $fc2e98617fc942d3$var$workInProgress) {
            lanes = $fc2e98617fc942d3$var$workInProgress;
            var thrownValue = $fc2e98617fc942d3$var$workInProgressThrownValue;
            b: switch($fc2e98617fc942d3$var$workInProgressSuspendedReason){
                case 1:
                    $fc2e98617fc942d3$var$workInProgressSuspendedReason = 0;
                    $fc2e98617fc942d3$var$workInProgressThrownValue = null;
                    $fc2e98617fc942d3$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($fc2e98617fc942d3$var$isThenableResolved(thrownValue)) {
                        $fc2e98617fc942d3$var$workInProgressSuspendedReason = 0;
                        $fc2e98617fc942d3$var$workInProgressThrownValue = null;
                        $fc2e98617fc942d3$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $fc2e98617fc942d3$var$workInProgressSuspendedReason && 9 !== $fc2e98617fc942d3$var$workInProgressSuspendedReason || $fc2e98617fc942d3$var$workInProgressRoot !== root || ($fc2e98617fc942d3$var$workInProgressSuspendedReason = 7);
                        $fc2e98617fc942d3$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $fc2e98617fc942d3$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $fc2e98617fc942d3$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $fc2e98617fc942d3$var$isThenableResolved(thrownValue) ? ($fc2e98617fc942d3$var$workInProgressSuspendedReason = 0, $fc2e98617fc942d3$var$workInProgressThrownValue = null, $fc2e98617fc942d3$var$replaySuspendedUnitOfWork(lanes)) : ($fc2e98617fc942d3$var$workInProgressSuspendedReason = 0, $fc2e98617fc942d3$var$workInProgressThrownValue = null, $fc2e98617fc942d3$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($fc2e98617fc942d3$var$workInProgress.tag){
                        case 26:
                            resource = $fc2e98617fc942d3$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $fc2e98617fc942d3$var$workInProgress;
                            if (resource ? $fc2e98617fc942d3$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $fc2e98617fc942d3$var$workInProgressSuspendedReason = 0;
                                $fc2e98617fc942d3$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $fc2e98617fc942d3$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($fc2e98617fc942d3$var$workInProgress = returnFiber, $fc2e98617fc942d3$var$completeUnitOfWork(returnFiber)) : $fc2e98617fc942d3$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $fc2e98617fc942d3$var$workInProgressSuspendedReason = 0;
                    $fc2e98617fc942d3$var$workInProgressThrownValue = null;
                    $fc2e98617fc942d3$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $fc2e98617fc942d3$var$workInProgressSuspendedReason = 0;
                    $fc2e98617fc942d3$var$workInProgressThrownValue = null;
                    $fc2e98617fc942d3$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $fc2e98617fc942d3$var$resetWorkInProgressStack();
                    $fc2e98617fc942d3$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(462));
            }
        }
        $fc2e98617fc942d3$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $fc2e98617fc942d3$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $fc2e98617fc942d3$var$lastContextDependency = $fc2e98617fc942d3$var$currentlyRenderingFiber$1 = null;
    $fc2e98617fc942d3$var$ReactSharedInternals.H = prevDispatcher;
    $fc2e98617fc942d3$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $fc2e98617fc942d3$var$executionContext = prevExecutionContext;
    if (null !== $fc2e98617fc942d3$var$workInProgress) return 0;
    $fc2e98617fc942d3$var$workInProgressRoot = null;
    $fc2e98617fc942d3$var$workInProgressRootRenderLanes = 0;
    $fc2e98617fc942d3$var$finishQueueingConcurrentUpdates();
    return $fc2e98617fc942d3$var$workInProgressRootExitStatus;
}
function $fc2e98617fc942d3$var$workLoopConcurrentByScheduler() {
    for(; null !== $fc2e98617fc942d3$var$workInProgress && !$fc2e98617fc942d3$var$shouldYield();)$fc2e98617fc942d3$var$performUnitOfWork($fc2e98617fc942d3$var$workInProgress);
}
function $fc2e98617fc942d3$var$performUnitOfWork(unitOfWork) {
    var next = $fc2e98617fc942d3$var$beginWork(unitOfWork.alternate, unitOfWork, $fc2e98617fc942d3$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $fc2e98617fc942d3$var$completeUnitOfWork(unitOfWork) : $fc2e98617fc942d3$var$workInProgress = next;
}
function $fc2e98617fc942d3$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $fc2e98617fc942d3$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $fc2e98617fc942d3$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $fc2e98617fc942d3$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $fc2e98617fc942d3$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $fc2e98617fc942d3$var$resetHooksOnUnwind(next);
        default:
            $fc2e98617fc942d3$var$unwindInterruptedWork(current, next), next = $fc2e98617fc942d3$var$workInProgress = $fc2e98617fc942d3$var$resetWorkInProgress(next, $fc2e98617fc942d3$var$entangledRenderLanes), next = $fc2e98617fc942d3$var$beginWork(current, next, $fc2e98617fc942d3$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $fc2e98617fc942d3$var$completeUnitOfWork(unitOfWork) : $fc2e98617fc942d3$var$workInProgress = next;
}
function $fc2e98617fc942d3$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $fc2e98617fc942d3$var$lastContextDependency = $fc2e98617fc942d3$var$currentlyRenderingFiber$1 = null;
    $fc2e98617fc942d3$var$resetHooksOnUnwind(unitOfWork);
    $fc2e98617fc942d3$var$thenableState$1 = null;
    $fc2e98617fc942d3$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($fc2e98617fc942d3$var$throwException(root, returnFiber, unitOfWork, thrownValue, $fc2e98617fc942d3$var$workInProgressRootRenderLanes)) {
            $fc2e98617fc942d3$var$workInProgressRootExitStatus = 1;
            $fc2e98617fc942d3$var$logUncaughtError(root, $fc2e98617fc942d3$var$createCapturedValueAtFiber(thrownValue, root.current));
            $fc2e98617fc942d3$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $fc2e98617fc942d3$var$workInProgress = returnFiber, error;
        $fc2e98617fc942d3$var$workInProgressRootExitStatus = 1;
        $fc2e98617fc942d3$var$logUncaughtError(root, $fc2e98617fc942d3$var$createCapturedValueAtFiber(thrownValue, root.current));
        $fc2e98617fc942d3$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($fc2e98617fc942d3$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($fc2e98617fc942d3$var$workInProgressRootIsPrerendering || 0 !== ($fc2e98617fc942d3$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($fc2e98617fc942d3$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $fc2e98617fc942d3$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $fc2e98617fc942d3$var$unwindUnitOfWork(unitOfWork, root);
    } else $fc2e98617fc942d3$var$completeUnitOfWork(unitOfWork);
}
function $fc2e98617fc942d3$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $fc2e98617fc942d3$var$unwindUnitOfWork(completedWork, $fc2e98617fc942d3$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $fc2e98617fc942d3$var$completeWork(completedWork.alternate, completedWork, $fc2e98617fc942d3$var$entangledRenderLanes);
        if (null !== next) {
            $fc2e98617fc942d3$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $fc2e98617fc942d3$var$workInProgress = completedWork;
            return;
        }
        $fc2e98617fc942d3$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $fc2e98617fc942d3$var$workInProgressRootExitStatus && ($fc2e98617fc942d3$var$workInProgressRootExitStatus = 5);
}
function $fc2e98617fc942d3$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $fc2e98617fc942d3$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $fc2e98617fc942d3$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $fc2e98617fc942d3$var$workInProgress = unitOfWork;
            return;
        }
        $fc2e98617fc942d3$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $fc2e98617fc942d3$var$workInProgressRootExitStatus = 6;
    $fc2e98617fc942d3$var$workInProgress = null;
}
function $fc2e98617fc942d3$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $fc2e98617fc942d3$var$flushPendingEffects();
    while (0 !== $fc2e98617fc942d3$var$pendingEffectsStatus);
    if (0 !== ($fc2e98617fc942d3$var$executionContext & 6)) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $fc2e98617fc942d3$var$concurrentlyUpdatedLanes;
        $fc2e98617fc942d3$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $fc2e98617fc942d3$var$workInProgressRoot && ($fc2e98617fc942d3$var$workInProgress = $fc2e98617fc942d3$var$workInProgressRoot = null, $fc2e98617fc942d3$var$workInProgressRootRenderLanes = 0);
        $fc2e98617fc942d3$var$pendingFinishedWork = finishedWork;
        $fc2e98617fc942d3$var$pendingEffectsRoot = root;
        $fc2e98617fc942d3$var$pendingEffectsLanes = lanes;
        $fc2e98617fc942d3$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $fc2e98617fc942d3$var$pendingPassiveTransitions = transitions;
        $fc2e98617fc942d3$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $fc2e98617fc942d3$var$scheduleCallback$1($fc2e98617fc942d3$var$NormalPriority$1, function() {
            $fc2e98617fc942d3$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $fc2e98617fc942d3$var$ReactSharedInternals.T;
            $fc2e98617fc942d3$var$ReactSharedInternals.T = null;
            transitions = $fc2e98617fc942d3$var$ReactDOMSharedInternals.p;
            $fc2e98617fc942d3$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $fc2e98617fc942d3$var$executionContext;
            $fc2e98617fc942d3$var$executionContext |= 4;
            try {
                $fc2e98617fc942d3$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $fc2e98617fc942d3$var$executionContext = spawnedLane, $fc2e98617fc942d3$var$ReactDOMSharedInternals.p = transitions, $fc2e98617fc942d3$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $fc2e98617fc942d3$var$pendingEffectsStatus = 1;
        $fc2e98617fc942d3$var$flushMutationEffects();
        $fc2e98617fc942d3$var$flushLayoutEffects();
        $fc2e98617fc942d3$var$flushSpawnedWork();
    }
}
function $fc2e98617fc942d3$var$flushMutationEffects() {
    if (1 === $fc2e98617fc942d3$var$pendingEffectsStatus) {
        $fc2e98617fc942d3$var$pendingEffectsStatus = 0;
        var root = $fc2e98617fc942d3$var$pendingEffectsRoot, finishedWork = $fc2e98617fc942d3$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $fc2e98617fc942d3$var$ReactSharedInternals.T;
            $fc2e98617fc942d3$var$ReactSharedInternals.T = null;
            var previousPriority = $fc2e98617fc942d3$var$ReactDOMSharedInternals.p;
            $fc2e98617fc942d3$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $fc2e98617fc942d3$var$executionContext;
            $fc2e98617fc942d3$var$executionContext |= 4;
            try {
                $fc2e98617fc942d3$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $fc2e98617fc942d3$var$selectionInformation, curFocusedElem = $fc2e98617fc942d3$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $fc2e98617fc942d3$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $fc2e98617fc942d3$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $fc2e98617fc942d3$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $fc2e98617fc942d3$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $fc2e98617fc942d3$var$_enabled = !!$fc2e98617fc942d3$var$eventsEnabled;
                $fc2e98617fc942d3$var$selectionInformation = $fc2e98617fc942d3$var$eventsEnabled = null;
            } finally{
                $fc2e98617fc942d3$var$executionContext = prevExecutionContext, $fc2e98617fc942d3$var$ReactDOMSharedInternals.p = previousPriority, $fc2e98617fc942d3$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $fc2e98617fc942d3$var$pendingEffectsStatus = 2;
    }
}
function $fc2e98617fc942d3$var$flushLayoutEffects() {
    if (2 === $fc2e98617fc942d3$var$pendingEffectsStatus) {
        $fc2e98617fc942d3$var$pendingEffectsStatus = 0;
        var root = $fc2e98617fc942d3$var$pendingEffectsRoot, finishedWork = $fc2e98617fc942d3$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $fc2e98617fc942d3$var$ReactSharedInternals.T;
            $fc2e98617fc942d3$var$ReactSharedInternals.T = null;
            var previousPriority = $fc2e98617fc942d3$var$ReactDOMSharedInternals.p;
            $fc2e98617fc942d3$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $fc2e98617fc942d3$var$executionContext;
            $fc2e98617fc942d3$var$executionContext |= 4;
            try {
                $fc2e98617fc942d3$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $fc2e98617fc942d3$var$executionContext = prevExecutionContext, $fc2e98617fc942d3$var$ReactDOMSharedInternals.p = previousPriority, $fc2e98617fc942d3$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $fc2e98617fc942d3$var$pendingEffectsStatus = 3;
    }
}
function $fc2e98617fc942d3$var$flushSpawnedWork() {
    if (4 === $fc2e98617fc942d3$var$pendingEffectsStatus || 3 === $fc2e98617fc942d3$var$pendingEffectsStatus) {
        $fc2e98617fc942d3$var$pendingEffectsStatus = 0;
        $fc2e98617fc942d3$var$requestPaint();
        var root = $fc2e98617fc942d3$var$pendingEffectsRoot, finishedWork = $fc2e98617fc942d3$var$pendingFinishedWork, lanes = $fc2e98617fc942d3$var$pendingEffectsLanes, recoverableErrors = $fc2e98617fc942d3$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $fc2e98617fc942d3$var$pendingEffectsStatus = 5 : ($fc2e98617fc942d3$var$pendingEffectsStatus = 0, $fc2e98617fc942d3$var$pendingFinishedWork = $fc2e98617fc942d3$var$pendingEffectsRoot = null, $fc2e98617fc942d3$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($fc2e98617fc942d3$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $fc2e98617fc942d3$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($fc2e98617fc942d3$var$injectedHook && "function" === typeof $fc2e98617fc942d3$var$injectedHook.onCommitFiberRoot) try {
            $fc2e98617fc942d3$var$injectedHook.onCommitFiberRoot($fc2e98617fc942d3$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $fc2e98617fc942d3$var$ReactSharedInternals.T;
            remainingLanes = $fc2e98617fc942d3$var$ReactDOMSharedInternals.p;
            $fc2e98617fc942d3$var$ReactDOMSharedInternals.p = 2;
            $fc2e98617fc942d3$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $fc2e98617fc942d3$var$ReactSharedInternals.T = finishedWork, $fc2e98617fc942d3$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($fc2e98617fc942d3$var$pendingEffectsLanes & 3) && $fc2e98617fc942d3$var$flushPendingEffects();
        $fc2e98617fc942d3$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $fc2e98617fc942d3$var$rootWithNestedUpdates ? $fc2e98617fc942d3$var$nestedUpdateCount++ : ($fc2e98617fc942d3$var$nestedUpdateCount = 0, $fc2e98617fc942d3$var$rootWithNestedUpdates = root) : $fc2e98617fc942d3$var$nestedUpdateCount = 0;
        $fc2e98617fc942d3$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $fc2e98617fc942d3$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $fc2e98617fc942d3$var$releaseCache(remainingLanes)));
}
function $fc2e98617fc942d3$var$flushPendingEffects() {
    $fc2e98617fc942d3$var$flushMutationEffects();
    $fc2e98617fc942d3$var$flushLayoutEffects();
    $fc2e98617fc942d3$var$flushSpawnedWork();
    return $fc2e98617fc942d3$var$flushPassiveEffects();
}
function $fc2e98617fc942d3$var$flushPassiveEffects() {
    if (5 !== $fc2e98617fc942d3$var$pendingEffectsStatus) return !1;
    var root = $fc2e98617fc942d3$var$pendingEffectsRoot, remainingLanes = $fc2e98617fc942d3$var$pendingEffectsRemainingLanes;
    $fc2e98617fc942d3$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $fc2e98617fc942d3$var$lanesToEventPriority($fc2e98617fc942d3$var$pendingEffectsLanes), prevTransition = $fc2e98617fc942d3$var$ReactSharedInternals.T, previousPriority = $fc2e98617fc942d3$var$ReactDOMSharedInternals.p;
    try {
        $fc2e98617fc942d3$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $fc2e98617fc942d3$var$ReactSharedInternals.T = null;
        renderPriority = $fc2e98617fc942d3$var$pendingPassiveTransitions;
        $fc2e98617fc942d3$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $fc2e98617fc942d3$var$pendingEffectsRoot, lanes = $fc2e98617fc942d3$var$pendingEffectsLanes;
        $fc2e98617fc942d3$var$pendingEffectsStatus = 0;
        $fc2e98617fc942d3$var$pendingFinishedWork = $fc2e98617fc942d3$var$pendingEffectsRoot = null;
        $fc2e98617fc942d3$var$pendingEffectsLanes = 0;
        if (0 !== ($fc2e98617fc942d3$var$executionContext & 6)) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(331));
        var prevExecutionContext = $fc2e98617fc942d3$var$executionContext;
        $fc2e98617fc942d3$var$executionContext |= 4;
        $fc2e98617fc942d3$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $fc2e98617fc942d3$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $fc2e98617fc942d3$var$executionContext = prevExecutionContext;
        $fc2e98617fc942d3$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($fc2e98617fc942d3$var$injectedHook && "function" === typeof $fc2e98617fc942d3$var$injectedHook.onPostCommitFiberRoot) try {
            $fc2e98617fc942d3$var$injectedHook.onPostCommitFiberRoot($fc2e98617fc942d3$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $fc2e98617fc942d3$var$ReactDOMSharedInternals.p = previousPriority, $fc2e98617fc942d3$var$ReactSharedInternals.T = prevTransition, $fc2e98617fc942d3$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $fc2e98617fc942d3$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $fc2e98617fc942d3$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $fc2e98617fc942d3$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $fc2e98617fc942d3$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($fc2e98617fc942d3$var$markRootUpdated$1(rootFiber, 2), $fc2e98617fc942d3$var$ensureRootIsScheduled(rootFiber));
}
function $fc2e98617fc942d3$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $fc2e98617fc942d3$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $fc2e98617fc942d3$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $fc2e98617fc942d3$var$legacyErrorBoundariesThatAlreadyFailed || !$fc2e98617fc942d3$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $fc2e98617fc942d3$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $fc2e98617fc942d3$var$createClassErrorUpdate(2);
                instance = $fc2e98617fc942d3$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($fc2e98617fc942d3$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $fc2e98617fc942d3$var$markRootUpdated$1(instance, 2), $fc2e98617fc942d3$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $fc2e98617fc942d3$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $fc2e98617fc942d3$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($fc2e98617fc942d3$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $fc2e98617fc942d3$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $fc2e98617fc942d3$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $fc2e98617fc942d3$var$workInProgressRoot === root && ($fc2e98617fc942d3$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $fc2e98617fc942d3$var$workInProgressRootExitStatus || 3 === $fc2e98617fc942d3$var$workInProgressRootExitStatus && ($fc2e98617fc942d3$var$workInProgressRootRenderLanes & 62914560) === $fc2e98617fc942d3$var$workInProgressRootRenderLanes && 300 > $fc2e98617fc942d3$var$now() - $fc2e98617fc942d3$var$globalMostRecentFallbackTime ? 0 === ($fc2e98617fc942d3$var$executionContext & 2) && $fc2e98617fc942d3$var$prepareFreshStack(root, 0) : $fc2e98617fc942d3$var$workInProgressRootPingedLanes |= pingedLanes, $fc2e98617fc942d3$var$workInProgressSuspendedRetryLanes === $fc2e98617fc942d3$var$workInProgressRootRenderLanes && ($fc2e98617fc942d3$var$workInProgressSuspendedRetryLanes = 0));
    $fc2e98617fc942d3$var$ensureRootIsScheduled(root);
}
function $fc2e98617fc942d3$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $fc2e98617fc942d3$var$claimNextRetryLane());
    boundaryFiber = $fc2e98617fc942d3$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($fc2e98617fc942d3$var$markRootUpdated$1(boundaryFiber, retryLane), $fc2e98617fc942d3$var$ensureRootIsScheduled(boundaryFiber));
}
function $fc2e98617fc942d3$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $fc2e98617fc942d3$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $fc2e98617fc942d3$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $fc2e98617fc942d3$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $fc2e98617fc942d3$var$scheduleCallback$1(priorityLevel, callback) {
    return $fc2e98617fc942d3$var$scheduleCallback$3(priorityLevel, callback);
}
var $fc2e98617fc942d3$var$firstScheduledRoot = null, $fc2e98617fc942d3$var$lastScheduledRoot = null, $fc2e98617fc942d3$var$didScheduleMicrotask = !1, $fc2e98617fc942d3$var$mightHavePendingSyncWork = !1, $fc2e98617fc942d3$var$isFlushingWork = !1, $fc2e98617fc942d3$var$currentEventTransitionLane = 0;
function $fc2e98617fc942d3$var$ensureRootIsScheduled(root) {
    root !== $fc2e98617fc942d3$var$lastScheduledRoot && null === root.next && (null === $fc2e98617fc942d3$var$lastScheduledRoot ? $fc2e98617fc942d3$var$firstScheduledRoot = $fc2e98617fc942d3$var$lastScheduledRoot = root : $fc2e98617fc942d3$var$lastScheduledRoot = $fc2e98617fc942d3$var$lastScheduledRoot.next = root);
    $fc2e98617fc942d3$var$mightHavePendingSyncWork = !0;
    $fc2e98617fc942d3$var$didScheduleMicrotask || ($fc2e98617fc942d3$var$didScheduleMicrotask = !0, $fc2e98617fc942d3$var$scheduleImmediateRootScheduleTask());
}
function $fc2e98617fc942d3$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$fc2e98617fc942d3$var$isFlushingWork && $fc2e98617fc942d3$var$mightHavePendingSyncWork) {
        $fc2e98617fc942d3$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $fc2e98617fc942d3$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $fc2e98617fc942d3$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $fc2e98617fc942d3$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $fc2e98617fc942d3$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $fc2e98617fc942d3$var$getNextLanes(root$170, root$170 === $fc2e98617fc942d3$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $fc2e98617fc942d3$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $fc2e98617fc942d3$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $fc2e98617fc942d3$var$isFlushingWork = !1;
    }
}
function $fc2e98617fc942d3$var$processRootScheduleInImmediateTask() {
    $fc2e98617fc942d3$var$processRootScheduleInMicrotask();
}
function $fc2e98617fc942d3$var$processRootScheduleInMicrotask() {
    $fc2e98617fc942d3$var$mightHavePendingSyncWork = $fc2e98617fc942d3$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $fc2e98617fc942d3$var$currentEventTransitionLane && $fc2e98617fc942d3$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $fc2e98617fc942d3$var$currentEventTransitionLane);
    for(var currentTime = $fc2e98617fc942d3$var$now(), prev = null, root = $fc2e98617fc942d3$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $fc2e98617fc942d3$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $fc2e98617fc942d3$var$firstScheduledRoot = next : prev.next = next, null === next && ($fc2e98617fc942d3$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $fc2e98617fc942d3$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $fc2e98617fc942d3$var$pendingEffectsStatus && 5 !== $fc2e98617fc942d3$var$pendingEffectsStatus || $fc2e98617fc942d3$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $fc2e98617fc942d3$var$currentEventTransitionLane && ($fc2e98617fc942d3$var$currentEventTransitionLane = 0);
}
function $fc2e98617fc942d3$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $fc2e98617fc942d3$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $fc2e98617fc942d3$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $fc2e98617fc942d3$var$workInProgressRoot;
    suspendedLanes = $fc2e98617fc942d3$var$workInProgressRootRenderLanes;
    suspendedLanes = $fc2e98617fc942d3$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $fc2e98617fc942d3$var$workInProgressSuspendedReason || 9 === $fc2e98617fc942d3$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $fc2e98617fc942d3$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $fc2e98617fc942d3$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $fc2e98617fc942d3$var$cancelCallback$1(pingedLanes);
        switch($fc2e98617fc942d3$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $fc2e98617fc942d3$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $fc2e98617fc942d3$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $fc2e98617fc942d3$var$IdlePriority;
                break;
            default:
                suspendedLanes = $fc2e98617fc942d3$var$NormalPriority$1;
        }
        pingedLanes = $fc2e98617fc942d3$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $fc2e98617fc942d3$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $fc2e98617fc942d3$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $fc2e98617fc942d3$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $fc2e98617fc942d3$var$pendingEffectsStatus && 5 !== $fc2e98617fc942d3$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($fc2e98617fc942d3$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $fc2e98617fc942d3$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $fc2e98617fc942d3$var$getNextLanes(root, root === $fc2e98617fc942d3$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $fc2e98617fc942d3$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $fc2e98617fc942d3$var$scheduleTaskForRootDuringMicrotask(root, $fc2e98617fc942d3$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $fc2e98617fc942d3$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $fc2e98617fc942d3$var$performSyncWorkOnRoot(root, lanes) {
    if ($fc2e98617fc942d3$var$flushPendingEffects()) return null;
    $fc2e98617fc942d3$var$performWorkOnRoot(root, lanes, !0);
}
function $fc2e98617fc942d3$var$scheduleImmediateRootScheduleTask() {
    $fc2e98617fc942d3$var$scheduleMicrotask(function() {
        0 !== ($fc2e98617fc942d3$var$executionContext & 6) ? $fc2e98617fc942d3$var$scheduleCallback$3($fc2e98617fc942d3$var$ImmediatePriority, $fc2e98617fc942d3$var$processRootScheduleInImmediateTask) : $fc2e98617fc942d3$var$processRootScheduleInMicrotask();
    });
}
function $fc2e98617fc942d3$var$requestTransitionLane() {
    if (0 === $fc2e98617fc942d3$var$currentEventTransitionLane) {
        var actionScopeLane = $fc2e98617fc942d3$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $fc2e98617fc942d3$var$nextTransitionUpdateLane, $fc2e98617fc942d3$var$nextTransitionUpdateLane <<= 1, 0 === ($fc2e98617fc942d3$var$nextTransitionUpdateLane & 261888) && ($fc2e98617fc942d3$var$nextTransitionUpdateLane = 256));
        $fc2e98617fc942d3$var$currentEventTransitionLane = actionScopeLane;
    }
    return $fc2e98617fc942d3$var$currentEventTransitionLane;
}
function $fc2e98617fc942d3$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $fc2e98617fc942d3$var$sanitizeURL("" + actionProp);
}
function $fc2e98617fc942d3$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $fc2e98617fc942d3$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $fc2e98617fc942d3$var$coerceFormActionProp((nativeEventTarget[$fc2e98617fc942d3$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$fc2e98617fc942d3$var$internalPropsKey] || null) ? $fc2e98617fc942d3$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $fc2e98617fc942d3$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $fc2e98617fc942d3$var$currentEventTransitionLane) {
                                var formData = submitter ? $fc2e98617fc942d3$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $fc2e98617fc942d3$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $fc2e98617fc942d3$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $fc2e98617fc942d3$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $fc2e98617fc942d3$var$i$jscomp$inline_1577 = 0; $fc2e98617fc942d3$var$i$jscomp$inline_1577 < $fc2e98617fc942d3$var$simpleEventPluginEvents.length; $fc2e98617fc942d3$var$i$jscomp$inline_1577++){
    var $fc2e98617fc942d3$var$eventName$jscomp$inline_1578 = $fc2e98617fc942d3$var$simpleEventPluginEvents[$fc2e98617fc942d3$var$i$jscomp$inline_1577], $fc2e98617fc942d3$var$domEventName$jscomp$inline_1579 = $fc2e98617fc942d3$var$eventName$jscomp$inline_1578.toLowerCase(), $fc2e98617fc942d3$var$capitalizedEvent$jscomp$inline_1580 = $fc2e98617fc942d3$var$eventName$jscomp$inline_1578[0].toUpperCase() + $fc2e98617fc942d3$var$eventName$jscomp$inline_1578.slice(1);
    $fc2e98617fc942d3$var$registerSimpleEvent($fc2e98617fc942d3$var$domEventName$jscomp$inline_1579, "on" + $fc2e98617fc942d3$var$capitalizedEvent$jscomp$inline_1580);
}
$fc2e98617fc942d3$var$registerSimpleEvent($fc2e98617fc942d3$var$ANIMATION_END, "onAnimationEnd");
$fc2e98617fc942d3$var$registerSimpleEvent($fc2e98617fc942d3$var$ANIMATION_ITERATION, "onAnimationIteration");
$fc2e98617fc942d3$var$registerSimpleEvent($fc2e98617fc942d3$var$ANIMATION_START, "onAnimationStart");
$fc2e98617fc942d3$var$registerSimpleEvent("dblclick", "onDoubleClick");
$fc2e98617fc942d3$var$registerSimpleEvent("focusin", "onFocus");
$fc2e98617fc942d3$var$registerSimpleEvent("focusout", "onBlur");
$fc2e98617fc942d3$var$registerSimpleEvent($fc2e98617fc942d3$var$TRANSITION_RUN, "onTransitionRun");
$fc2e98617fc942d3$var$registerSimpleEvent($fc2e98617fc942d3$var$TRANSITION_START, "onTransitionStart");
$fc2e98617fc942d3$var$registerSimpleEvent($fc2e98617fc942d3$var$TRANSITION_CANCEL, "onTransitionCancel");
$fc2e98617fc942d3$var$registerSimpleEvent($fc2e98617fc942d3$var$TRANSITION_END, "onTransitionEnd");
$fc2e98617fc942d3$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$fc2e98617fc942d3$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$fc2e98617fc942d3$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$fc2e98617fc942d3$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$fc2e98617fc942d3$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$fc2e98617fc942d3$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$fc2e98617fc942d3$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$fc2e98617fc942d3$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$fc2e98617fc942d3$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$fc2e98617fc942d3$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $fc2e98617fc942d3$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $fc2e98617fc942d3$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($fc2e98617fc942d3$var$mediaEventTypes));
function $fc2e98617fc942d3$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $fc2e98617fc942d3$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $fc2e98617fc942d3$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $fc2e98617fc942d3$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$fc2e98617fc942d3$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$fc2e98617fc942d3$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($fc2e98617fc942d3$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $fc2e98617fc942d3$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $fc2e98617fc942d3$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $fc2e98617fc942d3$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $fc2e98617fc942d3$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$fc2e98617fc942d3$var$listeningMarker]) {
        rootContainerElement[$fc2e98617fc942d3$var$listeningMarker] = !0;
        $fc2e98617fc942d3$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($fc2e98617fc942d3$var$nonDelegatedEvents.has(domEventName) || $fc2e98617fc942d3$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $fc2e98617fc942d3$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$fc2e98617fc942d3$var$listeningMarker] || (ownerDocument[$fc2e98617fc942d3$var$listeningMarker] = !0, $fc2e98617fc942d3$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $fc2e98617fc942d3$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($fc2e98617fc942d3$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $fc2e98617fc942d3$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $fc2e98617fc942d3$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $fc2e98617fc942d3$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$fc2e98617fc942d3$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $fc2e98617fc942d3$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $fc2e98617fc942d3$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $fc2e98617fc942d3$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $fc2e98617fc942d3$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $fc2e98617fc942d3$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $fc2e98617fc942d3$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $fc2e98617fc942d3$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $fc2e98617fc942d3$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $fc2e98617fc942d3$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $fc2e98617fc942d3$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $fc2e98617fc942d3$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $fc2e98617fc942d3$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $fc2e98617fc942d3$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $fc2e98617fc942d3$var$SyntheticTouchEvent;
                        break;
                    case $fc2e98617fc942d3$var$ANIMATION_END:
                    case $fc2e98617fc942d3$var$ANIMATION_ITERATION:
                    case $fc2e98617fc942d3$var$ANIMATION_START:
                        SyntheticEventCtor = $fc2e98617fc942d3$var$SyntheticAnimationEvent;
                        break;
                    case $fc2e98617fc942d3$var$TRANSITION_END:
                        SyntheticEventCtor = $fc2e98617fc942d3$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $fc2e98617fc942d3$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $fc2e98617fc942d3$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $fc2e98617fc942d3$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $fc2e98617fc942d3$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $fc2e98617fc942d3$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $fc2e98617fc942d3$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($fc2e98617fc942d3$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $fc2e98617fc942d3$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($fc2e98617fc942d3$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$fc2e98617fc942d3$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $fc2e98617fc942d3$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $fc2e98617fc942d3$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $fc2e98617fc942d3$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $fc2e98617fc942d3$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $fc2e98617fc942d3$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $fc2e98617fc942d3$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $fc2e98617fc942d3$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $fc2e98617fc942d3$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $fc2e98617fc942d3$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $fc2e98617fc942d3$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $fc2e98617fc942d3$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $fc2e98617fc942d3$var$getTargetInstForChangeEvent;
                else if ($fc2e98617fc942d3$var$isTextInputElement(reactName)) {
                    if ($fc2e98617fc942d3$var$isInputEventSupported) getTargetInstFunc = $fc2e98617fc942d3$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $fc2e98617fc942d3$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $fc2e98617fc942d3$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $fc2e98617fc942d3$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $fc2e98617fc942d3$var$getTargetInstForChangeEvent) : getTargetInstFunc = $fc2e98617fc942d3$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $fc2e98617fc942d3$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $fc2e98617fc942d3$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $fc2e98617fc942d3$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($fc2e98617fc942d3$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $fc2e98617fc942d3$var$activeElement = handleEventFunc, $fc2e98617fc942d3$var$activeElementInst = targetInst, $fc2e98617fc942d3$var$lastSelection = null;
                    break;
                case "focusout":
                    $fc2e98617fc942d3$var$lastSelection = $fc2e98617fc942d3$var$activeElementInst = $fc2e98617fc942d3$var$activeElement = null;
                    break;
                case "mousedown":
                    $fc2e98617fc942d3$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $fc2e98617fc942d3$var$mouseDown = !1;
                    $fc2e98617fc942d3$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($fc2e98617fc942d3$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $fc2e98617fc942d3$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($fc2e98617fc942d3$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $fc2e98617fc942d3$var$isComposing ? $fc2e98617fc942d3$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($fc2e98617fc942d3$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($fc2e98617fc942d3$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $fc2e98617fc942d3$var$isComposing && (fallbackData = $fc2e98617fc942d3$var$getData()) : ($fc2e98617fc942d3$var$root = nativeEventTarget, $fc2e98617fc942d3$var$startText = "value" in $fc2e98617fc942d3$var$root ? $fc2e98617fc942d3$var$root.value : $fc2e98617fc942d3$var$root.textContent, $fc2e98617fc942d3$var$isComposing = !0)), handleEventFunc = $fc2e98617fc942d3$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $fc2e98617fc942d3$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $fc2e98617fc942d3$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $fc2e98617fc942d3$var$canUseTextInputEvent ? $fc2e98617fc942d3$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $fc2e98617fc942d3$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $fc2e98617fc942d3$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $fc2e98617fc942d3$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $fc2e98617fc942d3$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $fc2e98617fc942d3$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $fc2e98617fc942d3$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $fc2e98617fc942d3$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $fc2e98617fc942d3$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($fc2e98617fc942d3$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $fc2e98617fc942d3$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($fc2e98617fc942d3$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $fc2e98617fc942d3$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $fc2e98617fc942d3$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $fc2e98617fc942d3$var$getListener(target, registrationName), null != stateNode && listeners.unshift($fc2e98617fc942d3$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $fc2e98617fc942d3$var$getListener(target, registrationName), null != stateNode && listeners.push($fc2e98617fc942d3$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $fc2e98617fc942d3$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $fc2e98617fc942d3$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $fc2e98617fc942d3$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($fc2e98617fc942d3$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($fc2e98617fc942d3$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $fc2e98617fc942d3$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $fc2e98617fc942d3$var$normalizeMarkupForTextOrAttribute(clientText);
    return $fc2e98617fc942d3$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $fc2e98617fc942d3$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $fc2e98617fc942d3$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $fc2e98617fc942d3$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $fc2e98617fc942d3$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $fc2e98617fc942d3$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $fc2e98617fc942d3$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $fc2e98617fc942d3$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $fc2e98617fc942d3$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $fc2e98617fc942d3$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $fc2e98617fc942d3$var$setProp(domElement, tag, "name", props.name, props, null), $fc2e98617fc942d3$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $fc2e98617fc942d3$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $fc2e98617fc942d3$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($fc2e98617fc942d3$var$setProp(domElement, tag, "encType", props.encType, props, null), $fc2e98617fc942d3$var$setProp(domElement, tag, "method", props.method, props, null), $fc2e98617fc942d3$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $fc2e98617fc942d3$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $fc2e98617fc942d3$var$noop$1);
            break;
        case "onScroll":
            null != value && $fc2e98617fc942d3$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $fc2e98617fc942d3$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $fc2e98617fc942d3$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $fc2e98617fc942d3$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $fc2e98617fc942d3$var$listenToNonDelegatedEvent("toggle", domElement);
            $fc2e98617fc942d3$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $fc2e98617fc942d3$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $fc2e98617fc942d3$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $fc2e98617fc942d3$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $fc2e98617fc942d3$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $fc2e98617fc942d3$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $fc2e98617fc942d3$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $fc2e98617fc942d3$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $fc2e98617fc942d3$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $fc2e98617fc942d3$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $fc2e98617fc942d3$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $fc2e98617fc942d3$var$aliases.get(key) || key, $fc2e98617fc942d3$var$setValueForAttribute(domElement, key, value);
    }
}
function $fc2e98617fc942d3$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $fc2e98617fc942d3$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $fc2e98617fc942d3$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $fc2e98617fc942d3$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $fc2e98617fc942d3$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $fc2e98617fc942d3$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $fc2e98617fc942d3$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$fc2e98617fc942d3$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$fc2e98617fc942d3$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $fc2e98617fc942d3$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $fc2e98617fc942d3$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $fc2e98617fc942d3$var$listenToNonDelegatedEvent("error", domElement);
            $fc2e98617fc942d3$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(137, tag));
                    default:
                        $fc2e98617fc942d3$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $fc2e98617fc942d3$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $fc2e98617fc942d3$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $fc2e98617fc942d3$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $fc2e98617fc942d3$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $fc2e98617fc942d3$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $fc2e98617fc942d3$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $fc2e98617fc942d3$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $fc2e98617fc942d3$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $fc2e98617fc942d3$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $fc2e98617fc942d3$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(91));
                    break;
                default:
                    $fc2e98617fc942d3$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $fc2e98617fc942d3$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $fc2e98617fc942d3$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $fc2e98617fc942d3$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $fc2e98617fc942d3$var$listenToNonDelegatedEvent("toggle", domElement);
            $fc2e98617fc942d3$var$listenToNonDelegatedEvent("cancel", domElement);
            $fc2e98617fc942d3$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $fc2e98617fc942d3$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $fc2e98617fc942d3$var$mediaEventTypes.length; hasSrc++)$fc2e98617fc942d3$var$listenToNonDelegatedEvent($fc2e98617fc942d3$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $fc2e98617fc942d3$var$listenToNonDelegatedEvent("error", domElement);
            $fc2e98617fc942d3$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $fc2e98617fc942d3$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $fc2e98617fc942d3$var$listenToNonDelegatedEvent("error", domElement), $fc2e98617fc942d3$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(137, tag));
                default:
                    $fc2e98617fc942d3$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($fc2e98617fc942d3$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $fc2e98617fc942d3$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $fc2e98617fc942d3$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $fc2e98617fc942d3$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $fc2e98617fc942d3$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $fc2e98617fc942d3$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $fc2e98617fc942d3$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $fc2e98617fc942d3$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $fc2e98617fc942d3$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $fc2e98617fc942d3$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $fc2e98617fc942d3$var$updateOptions(domElement, !!lastProps, tag, !0) : $fc2e98617fc942d3$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $fc2e98617fc942d3$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $fc2e98617fc942d3$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $fc2e98617fc942d3$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $fc2e98617fc942d3$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $fc2e98617fc942d3$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $fc2e98617fc942d3$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $fc2e98617fc942d3$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($fc2e98617fc942d3$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $fc2e98617fc942d3$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $fc2e98617fc942d3$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $fc2e98617fc942d3$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $fc2e98617fc942d3$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $fc2e98617fc942d3$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $fc2e98617fc942d3$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $fc2e98617fc942d3$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $fc2e98617fc942d3$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $fc2e98617fc942d3$var$eventsEnabled = null, $fc2e98617fc942d3$var$selectionInformation = null;
function $fc2e98617fc942d3$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $fc2e98617fc942d3$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $fc2e98617fc942d3$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $fc2e98617fc942d3$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $fc2e98617fc942d3$var$currentPopstateTransitionEvent = null;
function $fc2e98617fc942d3$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $fc2e98617fc942d3$var$currentPopstateTransitionEvent) return !1;
        $fc2e98617fc942d3$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $fc2e98617fc942d3$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $fc2e98617fc942d3$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $fc2e98617fc942d3$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $fc2e98617fc942d3$var$localPromise = "function" === typeof Promise ? Promise : void 0, $fc2e98617fc942d3$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $fc2e98617fc942d3$var$localPromise ? function(callback) {
    return $fc2e98617fc942d3$var$localPromise.resolve(null).then(callback).catch($fc2e98617fc942d3$var$handleErrorInNextTick);
} : $fc2e98617fc942d3$var$scheduleTimeout;
function $fc2e98617fc942d3$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $fc2e98617fc942d3$var$isSingletonScope(type) {
    return "head" === type;
}
function $fc2e98617fc942d3$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $fc2e98617fc942d3$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $fc2e98617fc942d3$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $fc2e98617fc942d3$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$fc2e98617fc942d3$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $fc2e98617fc942d3$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $fc2e98617fc942d3$var$retryIfBlockedOn(hydrationInstance);
}
function $fc2e98617fc942d3$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $fc2e98617fc942d3$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $fc2e98617fc942d3$var$clearContainerSparingly(node);
                $fc2e98617fc942d3$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $fc2e98617fc942d3$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$fc2e98617fc942d3$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $fc2e98617fc942d3$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $fc2e98617fc942d3$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $fc2e98617fc942d3$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $fc2e98617fc942d3$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $fc2e98617fc942d3$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $fc2e98617fc942d3$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $fc2e98617fc942d3$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $fc2e98617fc942d3$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $fc2e98617fc942d3$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $fc2e98617fc942d3$var$previousHydratableOnEnteringScopedSingleton = null;
function $fc2e98617fc942d3$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $fc2e98617fc942d3$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $fc2e98617fc942d3$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $fc2e98617fc942d3$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $fc2e98617fc942d3$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(451));
    }
}
function $fc2e98617fc942d3$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $fc2e98617fc942d3$var$detachDeletedInstance(instance);
}
var $fc2e98617fc942d3$var$preloadPropsMap = new Map(), $fc2e98617fc942d3$var$preconnectsSet = new Set();
function $fc2e98617fc942d3$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $fc2e98617fc942d3$var$previousDispatcher = $fc2e98617fc942d3$var$ReactDOMSharedInternals.d;
$fc2e98617fc942d3$var$ReactDOMSharedInternals.d = {
    f: $fc2e98617fc942d3$var$flushSyncWork,
    r: $fc2e98617fc942d3$var$requestFormReset,
    D: $fc2e98617fc942d3$var$prefetchDNS,
    C: $fc2e98617fc942d3$var$preconnect,
    L: $fc2e98617fc942d3$var$preload,
    m: $fc2e98617fc942d3$var$preloadModule,
    X: $fc2e98617fc942d3$var$preinitScript,
    S: $fc2e98617fc942d3$var$preinitStyle,
    M: $fc2e98617fc942d3$var$preinitModuleScript
};
function $fc2e98617fc942d3$var$flushSyncWork() {
    var previousWasRendering = $fc2e98617fc942d3$var$previousDispatcher.f(), wasRendering = $fc2e98617fc942d3$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $fc2e98617fc942d3$var$requestFormReset(form) {
    var formInst = $fc2e98617fc942d3$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $fc2e98617fc942d3$var$requestFormReset$1(formInst) : $fc2e98617fc942d3$var$previousDispatcher.r(form);
}
var $fc2e98617fc942d3$var$globalDocument = "undefined" === typeof document ? null : document;
function $fc2e98617fc942d3$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $fc2e98617fc942d3$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $fc2e98617fc942d3$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $fc2e98617fc942d3$var$preconnectsSet.has(limitedEscapedHref) || ($fc2e98617fc942d3$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $fc2e98617fc942d3$var$setInitialProperties(href, "link", rel), $fc2e98617fc942d3$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $fc2e98617fc942d3$var$prefetchDNS(href) {
    $fc2e98617fc942d3$var$previousDispatcher.D(href);
    $fc2e98617fc942d3$var$preconnectAs("dns-prefetch", href, null);
}
function $fc2e98617fc942d3$var$preconnect(href, crossOrigin) {
    $fc2e98617fc942d3$var$previousDispatcher.C(href, crossOrigin);
    $fc2e98617fc942d3$var$preconnectAs("preconnect", href, crossOrigin);
}
function $fc2e98617fc942d3$var$preload(href, as, options) {
    $fc2e98617fc942d3$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $fc2e98617fc942d3$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $fc2e98617fc942d3$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $fc2e98617fc942d3$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $fc2e98617fc942d3$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $fc2e98617fc942d3$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $fc2e98617fc942d3$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $fc2e98617fc942d3$var$getStyleKey(href);
                break;
            case "script":
                key = $fc2e98617fc942d3$var$getScriptKey(href);
        }
        $fc2e98617fc942d3$var$preloadPropsMap.has(key) || (href = $fc2e98617fc942d3$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $fc2e98617fc942d3$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($fc2e98617fc942d3$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($fc2e98617fc942d3$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $fc2e98617fc942d3$var$setInitialProperties(as, "link", href), $fc2e98617fc942d3$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $fc2e98617fc942d3$var$preloadModule(href, options) {
    $fc2e98617fc942d3$var$previousDispatcher.m(href, options);
    var ownerDocument = $fc2e98617fc942d3$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $fc2e98617fc942d3$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $fc2e98617fc942d3$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $fc2e98617fc942d3$var$getScriptKey(href);
        }
        if (!$fc2e98617fc942d3$var$preloadPropsMap.has(key) && (href = $fc2e98617fc942d3$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $fc2e98617fc942d3$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($fc2e98617fc942d3$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $fc2e98617fc942d3$var$setInitialProperties(as, "link", href);
            $fc2e98617fc942d3$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $fc2e98617fc942d3$var$preinitStyle(href, precedence, options) {
    $fc2e98617fc942d3$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $fc2e98617fc942d3$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $fc2e98617fc942d3$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $fc2e98617fc942d3$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($fc2e98617fc942d3$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $fc2e98617fc942d3$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $fc2e98617fc942d3$var$preloadPropsMap.get(key)) && $fc2e98617fc942d3$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $fc2e98617fc942d3$var$markNodeAsHoistable(link);
                $fc2e98617fc942d3$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $fc2e98617fc942d3$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $fc2e98617fc942d3$var$preinitScript(src, options) {
    $fc2e98617fc942d3$var$previousDispatcher.X(src, options);
    var ownerDocument = $fc2e98617fc942d3$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $fc2e98617fc942d3$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $fc2e98617fc942d3$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($fc2e98617fc942d3$var$getScriptSelectorFromKey(key)), resource || (src = $fc2e98617fc942d3$var$assign({
            src: src,
            async: !0
        }, options), (options = $fc2e98617fc942d3$var$preloadPropsMap.get(key)) && $fc2e98617fc942d3$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $fc2e98617fc942d3$var$markNodeAsHoistable(resource), $fc2e98617fc942d3$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $fc2e98617fc942d3$var$preinitModuleScript(src, options) {
    $fc2e98617fc942d3$var$previousDispatcher.M(src, options);
    var ownerDocument = $fc2e98617fc942d3$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $fc2e98617fc942d3$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $fc2e98617fc942d3$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($fc2e98617fc942d3$var$getScriptSelectorFromKey(key)), resource || (src = $fc2e98617fc942d3$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $fc2e98617fc942d3$var$preloadPropsMap.get(key)) && $fc2e98617fc942d3$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $fc2e98617fc942d3$var$markNodeAsHoistable(resource), $fc2e98617fc942d3$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $fc2e98617fc942d3$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $fc2e98617fc942d3$var$rootInstanceStackCursor.current) ? $fc2e98617fc942d3$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $fc2e98617fc942d3$var$getStyleKey(pendingProps.href), pendingProps = $fc2e98617fc942d3$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $fc2e98617fc942d3$var$getStyleKey(pendingProps.href);
                var styles$243 = $fc2e98617fc942d3$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($fc2e98617fc942d3$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $fc2e98617fc942d3$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $fc2e98617fc942d3$var$preloadPropsMap.set(type, pendingProps), styles$243 || $fc2e98617fc942d3$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $fc2e98617fc942d3$var$getScriptKey(pendingProps), pendingProps = $fc2e98617fc942d3$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(444, type));
    }
}
function $fc2e98617fc942d3$var$getStyleKey(href) {
    return 'href="' + $fc2e98617fc942d3$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $fc2e98617fc942d3$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $fc2e98617fc942d3$var$stylesheetPropsFromRawProps(rawProps) {
    return $fc2e98617fc942d3$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $fc2e98617fc942d3$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $fc2e98617fc942d3$var$setInitialProperties(key, "link", preloadProps), $fc2e98617fc942d3$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $fc2e98617fc942d3$var$getScriptKey(src) {
    return '[src="' + $fc2e98617fc942d3$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $fc2e98617fc942d3$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $fc2e98617fc942d3$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $fc2e98617fc942d3$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $fc2e98617fc942d3$var$markNodeAsHoistable(instance), instance;
            var styleProps = $fc2e98617fc942d3$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $fc2e98617fc942d3$var$markNodeAsHoistable(instance);
            $fc2e98617fc942d3$var$setInitialProperties(instance, "style", styleProps);
            $fc2e98617fc942d3$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $fc2e98617fc942d3$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($fc2e98617fc942d3$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $fc2e98617fc942d3$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $fc2e98617fc942d3$var$stylesheetPropsFromRawProps(props);
            (styleProps = $fc2e98617fc942d3$var$preloadPropsMap.get(styleProps)) && $fc2e98617fc942d3$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $fc2e98617fc942d3$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $fc2e98617fc942d3$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $fc2e98617fc942d3$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $fc2e98617fc942d3$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($fc2e98617fc942d3$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $fc2e98617fc942d3$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $fc2e98617fc942d3$var$preloadPropsMap.get(instance$249)) instance = $fc2e98617fc942d3$var$assign({}, props), $fc2e98617fc942d3$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $fc2e98617fc942d3$var$markNodeAsHoistable(styleProps);
            $fc2e98617fc942d3$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $fc2e98617fc942d3$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $fc2e98617fc942d3$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $fc2e98617fc942d3$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $fc2e98617fc942d3$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $fc2e98617fc942d3$var$tagCaches = null;
function $fc2e98617fc942d3$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $fc2e98617fc942d3$var$tagCaches) {
        var cache = new Map();
        var caches = $fc2e98617fc942d3$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $fc2e98617fc942d3$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$fc2e98617fc942d3$var$internalHoistableMarker] || node[$fc2e98617fc942d3$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $fc2e98617fc942d3$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $fc2e98617fc942d3$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $fc2e98617fc942d3$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $fc2e98617fc942d3$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $fc2e98617fc942d3$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($fc2e98617fc942d3$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $fc2e98617fc942d3$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $fc2e98617fc942d3$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $fc2e98617fc942d3$var$stylesheetPropsFromRawProps(props);
            (key = $fc2e98617fc942d3$var$preloadPropsMap.get(key)) && $fc2e98617fc942d3$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $fc2e98617fc942d3$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $fc2e98617fc942d3$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $fc2e98617fc942d3$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $fc2e98617fc942d3$var$estimatedBytesWithinLimit = 0;
function $fc2e98617fc942d3$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $fc2e98617fc942d3$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $fc2e98617fc942d3$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $fc2e98617fc942d3$var$estimatedBytesWithinLimit && ($fc2e98617fc942d3$var$estimatedBytesWithinLimit = 62500 * $fc2e98617fc942d3$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $fc2e98617fc942d3$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $fc2e98617fc942d3$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $fc2e98617fc942d3$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $fc2e98617fc942d3$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $fc2e98617fc942d3$var$precedencesByRoot = null;
function $fc2e98617fc942d3$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $fc2e98617fc942d3$var$precedencesByRoot = new Map(), resources.forEach($fc2e98617fc942d3$var$insertStylesheetIntoRoot, state), $fc2e98617fc942d3$var$precedencesByRoot = null, $fc2e98617fc942d3$var$onUnsuspend.call(state));
}
function $fc2e98617fc942d3$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $fc2e98617fc942d3$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $fc2e98617fc942d3$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $fc2e98617fc942d3$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $fc2e98617fc942d3$var$HostTransitionContext = {
    $$typeof: $fc2e98617fc942d3$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $fc2e98617fc942d3$var$sharedNotPendingObject,
    _currentValue2: $fc2e98617fc942d3$var$sharedNotPendingObject,
    _threadCount: 0
};
function $fc2e98617fc942d3$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $fc2e98617fc942d3$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $fc2e98617fc942d3$var$createLaneMap(0);
    this.hiddenUpdates = $fc2e98617fc942d3$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $fc2e98617fc942d3$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $fc2e98617fc942d3$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $fc2e98617fc942d3$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $fc2e98617fc942d3$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $fc2e98617fc942d3$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $fc2e98617fc942d3$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $fc2e98617fc942d3$var$emptyContextObject;
    parentComponent = $fc2e98617fc942d3$var$emptyContextObject;
    return parentComponent;
}
function $fc2e98617fc942d3$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $fc2e98617fc942d3$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $fc2e98617fc942d3$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $fc2e98617fc942d3$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($fc2e98617fc942d3$var$scheduleUpdateOnFiber(element, rootFiber, lane), $fc2e98617fc942d3$var$entangleTransitions(element, rootFiber, lane));
}
function $fc2e98617fc942d3$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $fc2e98617fc942d3$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $fc2e98617fc942d3$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $fc2e98617fc942d3$var$markRetryLaneImpl(fiber, retryLane);
}
function $fc2e98617fc942d3$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $fc2e98617fc942d3$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $fc2e98617fc942d3$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $fc2e98617fc942d3$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $fc2e98617fc942d3$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $fc2e98617fc942d3$var$requestUpdateLane();
        lane = $fc2e98617fc942d3$var$getBumpedLaneForHydrationByLane(lane);
        var root = $fc2e98617fc942d3$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $fc2e98617fc942d3$var$scheduleUpdateOnFiber(root, fiber, lane);
        $fc2e98617fc942d3$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $fc2e98617fc942d3$var$_enabled = !0;
function $fc2e98617fc942d3$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $fc2e98617fc942d3$var$ReactSharedInternals.T;
    $fc2e98617fc942d3$var$ReactSharedInternals.T = null;
    var previousPriority = $fc2e98617fc942d3$var$ReactDOMSharedInternals.p;
    try {
        $fc2e98617fc942d3$var$ReactDOMSharedInternals.p = 2, $fc2e98617fc942d3$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $fc2e98617fc942d3$var$ReactDOMSharedInternals.p = previousPriority, $fc2e98617fc942d3$var$ReactSharedInternals.T = prevTransition;
    }
}
function $fc2e98617fc942d3$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $fc2e98617fc942d3$var$ReactSharedInternals.T;
    $fc2e98617fc942d3$var$ReactSharedInternals.T = null;
    var previousPriority = $fc2e98617fc942d3$var$ReactDOMSharedInternals.p;
    try {
        $fc2e98617fc942d3$var$ReactDOMSharedInternals.p = 8, $fc2e98617fc942d3$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $fc2e98617fc942d3$var$ReactDOMSharedInternals.p = previousPriority, $fc2e98617fc942d3$var$ReactSharedInternals.T = prevTransition;
    }
}
function $fc2e98617fc942d3$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($fc2e98617fc942d3$var$_enabled) {
        var blockedOn = $fc2e98617fc942d3$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $fc2e98617fc942d3$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $fc2e98617fc942d3$var$return_targetInst, targetContainer), $fc2e98617fc942d3$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($fc2e98617fc942d3$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($fc2e98617fc942d3$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $fc2e98617fc942d3$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $fc2e98617fc942d3$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $fc2e98617fc942d3$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $fc2e98617fc942d3$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $fc2e98617fc942d3$var$ensureRootIsScheduled(fiber);
                                0 === ($fc2e98617fc942d3$var$executionContext & 6) && ($fc2e98617fc942d3$var$workInProgressRootRenderTargetTime = $fc2e98617fc942d3$var$now() + 500, $fc2e98617fc942d3$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $fc2e98617fc942d3$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $fc2e98617fc942d3$var$scheduleUpdateOnFiber(root, fiber, 2), $fc2e98617fc942d3$var$flushSyncWork$1(), $fc2e98617fc942d3$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $fc2e98617fc942d3$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $fc2e98617fc942d3$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $fc2e98617fc942d3$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $fc2e98617fc942d3$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $fc2e98617fc942d3$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $fc2e98617fc942d3$var$getEventTarget(nativeEvent);
    return $fc2e98617fc942d3$var$findInstanceBlockingTarget(nativeEvent);
}
var $fc2e98617fc942d3$var$return_targetInst = null;
function $fc2e98617fc942d3$var$findInstanceBlockingTarget(targetNode) {
    $fc2e98617fc942d3$var$return_targetInst = null;
    targetNode = $fc2e98617fc942d3$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $fc2e98617fc942d3$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $fc2e98617fc942d3$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $fc2e98617fc942d3$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $fc2e98617fc942d3$var$return_targetInst = targetNode;
    return null;
}
function $fc2e98617fc942d3$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($fc2e98617fc942d3$var$getCurrentPriorityLevel()){
                case $fc2e98617fc942d3$var$ImmediatePriority:
                    return 2;
                case $fc2e98617fc942d3$var$UserBlockingPriority:
                    return 8;
                case $fc2e98617fc942d3$var$NormalPriority$1:
                case $fc2e98617fc942d3$var$LowPriority:
                    return 32;
                case $fc2e98617fc942d3$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $fc2e98617fc942d3$var$hasScheduledReplayAttempt = !1, $fc2e98617fc942d3$var$queuedFocus = null, $fc2e98617fc942d3$var$queuedDrag = null, $fc2e98617fc942d3$var$queuedMouse = null, $fc2e98617fc942d3$var$queuedPointers = new Map(), $fc2e98617fc942d3$var$queuedPointerCaptures = new Map(), $fc2e98617fc942d3$var$queuedExplicitHydrationTargets = [], $fc2e98617fc942d3$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $fc2e98617fc942d3$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $fc2e98617fc942d3$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $fc2e98617fc942d3$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $fc2e98617fc942d3$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $fc2e98617fc942d3$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $fc2e98617fc942d3$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $fc2e98617fc942d3$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $fc2e98617fc942d3$var$getInstanceFromNode(blockedOn), null !== blockedOn && $fc2e98617fc942d3$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $fc2e98617fc942d3$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $fc2e98617fc942d3$var$queuedFocus = $fc2e98617fc942d3$var$accumulateOrCreateContinuousQueuedReplayableEvent($fc2e98617fc942d3$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $fc2e98617fc942d3$var$queuedDrag = $fc2e98617fc942d3$var$accumulateOrCreateContinuousQueuedReplayableEvent($fc2e98617fc942d3$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $fc2e98617fc942d3$var$queuedMouse = $fc2e98617fc942d3$var$accumulateOrCreateContinuousQueuedReplayableEvent($fc2e98617fc942d3$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $fc2e98617fc942d3$var$queuedPointers.set(pointerId, $fc2e98617fc942d3$var$accumulateOrCreateContinuousQueuedReplayableEvent($fc2e98617fc942d3$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $fc2e98617fc942d3$var$queuedPointerCaptures.set(pointerId, $fc2e98617fc942d3$var$accumulateOrCreateContinuousQueuedReplayableEvent($fc2e98617fc942d3$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $fc2e98617fc942d3$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $fc2e98617fc942d3$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $fc2e98617fc942d3$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $fc2e98617fc942d3$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $fc2e98617fc942d3$var$runWithPriority(queuedTarget.priority, function() {
                        $fc2e98617fc942d3$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $fc2e98617fc942d3$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $fc2e98617fc942d3$var$runWithPriority(queuedTarget.priority, function() {
                        $fc2e98617fc942d3$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $fc2e98617fc942d3$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $fc2e98617fc942d3$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $fc2e98617fc942d3$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $fc2e98617fc942d3$var$currentReplayingEvent = null;
        } else return targetContainers = $fc2e98617fc942d3$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $fc2e98617fc942d3$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $fc2e98617fc942d3$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $fc2e98617fc942d3$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $fc2e98617fc942d3$var$replayUnblockedEvents() {
    $fc2e98617fc942d3$var$hasScheduledReplayAttempt = !1;
    null !== $fc2e98617fc942d3$var$queuedFocus && $fc2e98617fc942d3$var$attemptReplayContinuousQueuedEvent($fc2e98617fc942d3$var$queuedFocus) && ($fc2e98617fc942d3$var$queuedFocus = null);
    null !== $fc2e98617fc942d3$var$queuedDrag && $fc2e98617fc942d3$var$attemptReplayContinuousQueuedEvent($fc2e98617fc942d3$var$queuedDrag) && ($fc2e98617fc942d3$var$queuedDrag = null);
    null !== $fc2e98617fc942d3$var$queuedMouse && $fc2e98617fc942d3$var$attemptReplayContinuousQueuedEvent($fc2e98617fc942d3$var$queuedMouse) && ($fc2e98617fc942d3$var$queuedMouse = null);
    $fc2e98617fc942d3$var$queuedPointers.forEach($fc2e98617fc942d3$var$attemptReplayContinuousQueuedEventInMap);
    $fc2e98617fc942d3$var$queuedPointerCaptures.forEach($fc2e98617fc942d3$var$attemptReplayContinuousQueuedEventInMap);
}
function $fc2e98617fc942d3$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $fc2e98617fc942d3$var$hasScheduledReplayAttempt || ($fc2e98617fc942d3$var$hasScheduledReplayAttempt = !0, $3Txiq.unstable_scheduleCallback($3Txiq.unstable_NormalPriority, $fc2e98617fc942d3$var$replayUnblockedEvents)));
}
var $fc2e98617fc942d3$var$lastScheduledReplayQueue = null;
function $fc2e98617fc942d3$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $fc2e98617fc942d3$var$lastScheduledReplayQueue !== formReplayingQueue && ($fc2e98617fc942d3$var$lastScheduledReplayQueue = formReplayingQueue, $3Txiq.unstable_scheduleCallback($3Txiq.unstable_NormalPriority, function() {
        $fc2e98617fc942d3$var$lastScheduledReplayQueue === formReplayingQueue && ($fc2e98617fc942d3$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $fc2e98617fc942d3$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $fc2e98617fc942d3$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $fc2e98617fc942d3$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $fc2e98617fc942d3$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $fc2e98617fc942d3$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $fc2e98617fc942d3$var$queuedFocus && $fc2e98617fc942d3$var$scheduleCallbackIfUnblocked($fc2e98617fc942d3$var$queuedFocus, unblocked);
    null !== $fc2e98617fc942d3$var$queuedDrag && $fc2e98617fc942d3$var$scheduleCallbackIfUnblocked($fc2e98617fc942d3$var$queuedDrag, unblocked);
    null !== $fc2e98617fc942d3$var$queuedMouse && $fc2e98617fc942d3$var$scheduleCallbackIfUnblocked($fc2e98617fc942d3$var$queuedMouse, unblocked);
    $fc2e98617fc942d3$var$queuedPointers.forEach(unblock);
    $fc2e98617fc942d3$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $fc2e98617fc942d3$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $fc2e98617fc942d3$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $fc2e98617fc942d3$var$queuedExplicitHydrationTargets.length && (i = $fc2e98617fc942d3$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$fc2e98617fc942d3$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $fc2e98617fc942d3$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$fc2e98617fc942d3$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $fc2e98617fc942d3$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$fc2e98617fc942d3$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $fc2e98617fc942d3$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $fc2e98617fc942d3$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $fc2e98617fc942d3$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $fc2e98617fc942d3$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$fc2e98617fc942d3$var$ReactDOMHydrationRoot.prototype.render = $fc2e98617fc942d3$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(409));
    var current = root.current, lane = $fc2e98617fc942d3$var$requestUpdateLane();
    $fc2e98617fc942d3$var$updateContainerImpl(current, lane, children, root, null, null);
};
$fc2e98617fc942d3$var$ReactDOMHydrationRoot.prototype.unmount = $fc2e98617fc942d3$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $fc2e98617fc942d3$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $fc2e98617fc942d3$var$flushSyncWork$1();
        container[$fc2e98617fc942d3$var$internalContainerInstanceKey] = null;
    }
};
function $fc2e98617fc942d3$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$fc2e98617fc942d3$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $fc2e98617fc942d3$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $fc2e98617fc942d3$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $fc2e98617fc942d3$var$queuedExplicitHydrationTargets[i].priority; i++);
        $fc2e98617fc942d3$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $fc2e98617fc942d3$var$attemptExplicitHydrationTarget(target);
    }
};
var $fc2e98617fc942d3$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $lDJXT.version;
if ("19.2.7" !== $fc2e98617fc942d3$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(527, $fc2e98617fc942d3$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.7"));
$fc2e98617fc942d3$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $fc2e98617fc942d3$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $fc2e98617fc942d3$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $fc2e98617fc942d3$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.7",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $fc2e98617fc942d3$var$ReactSharedInternals,
    reconcilerVersion: "19.2.7"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $fc2e98617fc942d3$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$fc2e98617fc942d3$var$hook$jscomp$inline_2348.isDisabled && $fc2e98617fc942d3$var$hook$jscomp$inline_2348.supportsFiber) try {
        $fc2e98617fc942d3$var$rendererID = $fc2e98617fc942d3$var$hook$jscomp$inline_2348.inject($fc2e98617fc942d3$var$internals$jscomp$inline_2347), $fc2e98617fc942d3$var$injectedHook = $fc2e98617fc942d3$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$fc2e98617fc942d3$export$882461b6382ed46c = function(container, options) {
    if (!$fc2e98617fc942d3$var$isValidContainer(container)) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $fc2e98617fc942d3$var$defaultOnUncaughtError, onCaughtError = $fc2e98617fc942d3$var$defaultOnCaughtError, onRecoverableError = $fc2e98617fc942d3$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $fc2e98617fc942d3$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $fc2e98617fc942d3$var$defaultOnDefaultTransitionIndicator);
    container[$fc2e98617fc942d3$var$internalContainerInstanceKey] = options.current;
    $fc2e98617fc942d3$var$listenToAllSupportedEvents(container);
    return new $fc2e98617fc942d3$var$ReactDOMRoot(options);
};
$fc2e98617fc942d3$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$fc2e98617fc942d3$var$isValidContainer(container)) throw Error($fc2e98617fc942d3$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $fc2e98617fc942d3$var$defaultOnUncaughtError, onCaughtError = $fc2e98617fc942d3$var$defaultOnCaughtError, onRecoverableError = $fc2e98617fc942d3$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $fc2e98617fc942d3$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $fc2e98617fc942d3$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $fc2e98617fc942d3$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $fc2e98617fc942d3$var$requestUpdateLane();
    isStrictMode = $fc2e98617fc942d3$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $fc2e98617fc942d3$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $fc2e98617fc942d3$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $fc2e98617fc942d3$var$markRootUpdated$1(initialChildren, options);
    $fc2e98617fc942d3$var$ensureRootIsScheduled(initialChildren);
    container[$fc2e98617fc942d3$var$internalContainerInstanceKey] = initialChildren.current;
    $fc2e98617fc942d3$var$listenToAllSupportedEvents(container);
    return new $fc2e98617fc942d3$var$ReactDOMHydrationRoot(initialChildren);
};
$fc2e98617fc942d3$export$83d89fbfd8236492 = "19.2.7";

});
parcelRegister("3Txiq", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9zNJA"));

});
parcelRegister("9zNJA", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $6f8df61d4cf646a2$export$c4744153514ff05d; }, function (v) { return $6f8df61d4cf646a2$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $6f8df61d4cf646a2$export$3e506c1ccc9cc1a7; }, function (v) { return $6f8df61d4cf646a2$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $6f8df61d4cf646a2$export$e26fe2ed2fa76875; }, function (v) { return $6f8df61d4cf646a2$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $6f8df61d4cf646a2$export$502329bbf4b505b1; }, function (v) { return $6f8df61d4cf646a2$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $6f8df61d4cf646a2$export$6e3807111c4874c4; }, function (v) { return $6f8df61d4cf646a2$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $6f8df61d4cf646a2$export$c27134553091fb3a; }, function (v) { return $6f8df61d4cf646a2$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $6f8df61d4cf646a2$export$33ee1acdc04fd2a2; }, function (v) { return $6f8df61d4cf646a2$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $6f8df61d4cf646a2$export$b00a404bbd5edef2; }, function (v) { return $6f8df61d4cf646a2$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $6f8df61d4cf646a2$export$d66a1c1c77bd778b; }, function (v) { return $6f8df61d4cf646a2$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $6f8df61d4cf646a2$export$d3dfb8e4810cb555; }, function (v) { return $6f8df61d4cf646a2$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $6f8df61d4cf646a2$export$72fdf0e06517287b; }, function (v) { return $6f8df61d4cf646a2$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $6f8df61d4cf646a2$export$816d2913ae6b83b1; }, function (v) { return $6f8df61d4cf646a2$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $6f8df61d4cf646a2$export$61bcfe829111a1d0; }, function (v) { return $6f8df61d4cf646a2$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $6f8df61d4cf646a2$export$7ee8c9beb337bc3f; }, function (v) { return $6f8df61d4cf646a2$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $6f8df61d4cf646a2$export$b5836b71941fa3ed; }, function (v) { return $6f8df61d4cf646a2$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $6f8df61d4cf646a2$export$cf845f2c119da08a; }, function (v) { return $6f8df61d4cf646a2$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6f8df61d4cf646a2$export$c4744153514ff05d;
var $6f8df61d4cf646a2$export$3e506c1ccc9cc1a7;
var $6f8df61d4cf646a2$export$e26fe2ed2fa76875;
var $6f8df61d4cf646a2$export$502329bbf4b505b1;
var $6f8df61d4cf646a2$export$6e3807111c4874c4;
var $6f8df61d4cf646a2$export$c27134553091fb3a;
var $6f8df61d4cf646a2$export$33ee1acdc04fd2a2;
var $6f8df61d4cf646a2$export$b00a404bbd5edef2;
var $6f8df61d4cf646a2$export$d66a1c1c77bd778b;
var $6f8df61d4cf646a2$export$d3dfb8e4810cb555;
var $6f8df61d4cf646a2$export$72fdf0e06517287b;
var $6f8df61d4cf646a2$export$816d2913ae6b83b1;
var $6f8df61d4cf646a2$export$61bcfe829111a1d0;
var $6f8df61d4cf646a2$export$7ee8c9beb337bc3f;
var $6f8df61d4cf646a2$export$b5836b71941fa3ed;
var $6f8df61d4cf646a2$export$cf845f2c119da08a;
"use strict";
function $6f8df61d4cf646a2$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $6f8df61d4cf646a2$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $6f8df61d4cf646a2$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $6f8df61d4cf646a2$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $6f8df61d4cf646a2$var$compare(left, last)) rightIndex < length && 0 > $6f8df61d4cf646a2$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $6f8df61d4cf646a2$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $6f8df61d4cf646a2$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$6f8df61d4cf646a2$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $6f8df61d4cf646a2$var$localPerformance = performance;
    $6f8df61d4cf646a2$export$c4744153514ff05d = function() {
        return $6f8df61d4cf646a2$var$localPerformance.now();
    };
} else {
    var $6f8df61d4cf646a2$var$localDate = Date, $6f8df61d4cf646a2$var$initialTime = $6f8df61d4cf646a2$var$localDate.now();
    $6f8df61d4cf646a2$export$c4744153514ff05d = function() {
        return $6f8df61d4cf646a2$var$localDate.now() - $6f8df61d4cf646a2$var$initialTime;
    };
}
var $6f8df61d4cf646a2$var$taskQueue = [], $6f8df61d4cf646a2$var$timerQueue = [], $6f8df61d4cf646a2$var$taskIdCounter = 1, $6f8df61d4cf646a2$var$currentTask = null, $6f8df61d4cf646a2$var$currentPriorityLevel = 3, $6f8df61d4cf646a2$var$isPerformingWork = !1, $6f8df61d4cf646a2$var$isHostCallbackScheduled = !1, $6f8df61d4cf646a2$var$isHostTimeoutScheduled = !1, $6f8df61d4cf646a2$var$needsPaint = !1, $6f8df61d4cf646a2$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $6f8df61d4cf646a2$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $6f8df61d4cf646a2$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $6f8df61d4cf646a2$var$advanceTimers(currentTime) {
    for(var timer = $6f8df61d4cf646a2$var$peek($6f8df61d4cf646a2$var$timerQueue); null !== timer;){
        if (null === timer.callback) $6f8df61d4cf646a2$var$pop($6f8df61d4cf646a2$var$timerQueue);
        else if (timer.startTime <= currentTime) $6f8df61d4cf646a2$var$pop($6f8df61d4cf646a2$var$timerQueue), timer.sortIndex = timer.expirationTime, $6f8df61d4cf646a2$var$push($6f8df61d4cf646a2$var$taskQueue, timer);
        else break;
        timer = $6f8df61d4cf646a2$var$peek($6f8df61d4cf646a2$var$timerQueue);
    }
}
function $6f8df61d4cf646a2$var$handleTimeout(currentTime) {
    $6f8df61d4cf646a2$var$isHostTimeoutScheduled = !1;
    $6f8df61d4cf646a2$var$advanceTimers(currentTime);
    if (!$6f8df61d4cf646a2$var$isHostCallbackScheduled) {
        if (null !== $6f8df61d4cf646a2$var$peek($6f8df61d4cf646a2$var$taskQueue)) $6f8df61d4cf646a2$var$isHostCallbackScheduled = !0, $6f8df61d4cf646a2$var$isMessageLoopRunning || ($6f8df61d4cf646a2$var$isMessageLoopRunning = !0, $6f8df61d4cf646a2$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $6f8df61d4cf646a2$var$peek($6f8df61d4cf646a2$var$timerQueue);
            null !== firstTimer && $6f8df61d4cf646a2$var$requestHostTimeout($6f8df61d4cf646a2$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $6f8df61d4cf646a2$var$isMessageLoopRunning = !1, $6f8df61d4cf646a2$var$taskTimeoutID = -1, $6f8df61d4cf646a2$var$frameInterval = 5, $6f8df61d4cf646a2$var$startTime = -1;
function $6f8df61d4cf646a2$var$shouldYieldToHost() {
    return $6f8df61d4cf646a2$var$needsPaint ? !0 : $6f8df61d4cf646a2$export$c4744153514ff05d() - $6f8df61d4cf646a2$var$startTime < $6f8df61d4cf646a2$var$frameInterval ? !1 : !0;
}
function $6f8df61d4cf646a2$var$performWorkUntilDeadline() {
    $6f8df61d4cf646a2$var$needsPaint = !1;
    if ($6f8df61d4cf646a2$var$isMessageLoopRunning) {
        var currentTime = $6f8df61d4cf646a2$export$c4744153514ff05d();
        $6f8df61d4cf646a2$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $6f8df61d4cf646a2$var$isHostCallbackScheduled = !1;
                $6f8df61d4cf646a2$var$isHostTimeoutScheduled && ($6f8df61d4cf646a2$var$isHostTimeoutScheduled = !1, $6f8df61d4cf646a2$var$localClearTimeout($6f8df61d4cf646a2$var$taskTimeoutID), $6f8df61d4cf646a2$var$taskTimeoutID = -1);
                $6f8df61d4cf646a2$var$isPerformingWork = !0;
                var previousPriorityLevel = $6f8df61d4cf646a2$var$currentPriorityLevel;
                try {
                    b: {
                        $6f8df61d4cf646a2$var$advanceTimers(currentTime);
                        for($6f8df61d4cf646a2$var$currentTask = $6f8df61d4cf646a2$var$peek($6f8df61d4cf646a2$var$taskQueue); null !== $6f8df61d4cf646a2$var$currentTask && !($6f8df61d4cf646a2$var$currentTask.expirationTime > currentTime && $6f8df61d4cf646a2$var$shouldYieldToHost());){
                            var callback = $6f8df61d4cf646a2$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $6f8df61d4cf646a2$var$currentTask.callback = null;
                                $6f8df61d4cf646a2$var$currentPriorityLevel = $6f8df61d4cf646a2$var$currentTask.priorityLevel;
                                var continuationCallback = callback($6f8df61d4cf646a2$var$currentTask.expirationTime <= currentTime);
                                currentTime = $6f8df61d4cf646a2$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $6f8df61d4cf646a2$var$currentTask.callback = continuationCallback;
                                    $6f8df61d4cf646a2$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $6f8df61d4cf646a2$var$currentTask === $6f8df61d4cf646a2$var$peek($6f8df61d4cf646a2$var$taskQueue) && $6f8df61d4cf646a2$var$pop($6f8df61d4cf646a2$var$taskQueue);
                                $6f8df61d4cf646a2$var$advanceTimers(currentTime);
                            } else $6f8df61d4cf646a2$var$pop($6f8df61d4cf646a2$var$taskQueue);
                            $6f8df61d4cf646a2$var$currentTask = $6f8df61d4cf646a2$var$peek($6f8df61d4cf646a2$var$taskQueue);
                        }
                        if (null !== $6f8df61d4cf646a2$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $6f8df61d4cf646a2$var$peek($6f8df61d4cf646a2$var$timerQueue);
                            null !== firstTimer && $6f8df61d4cf646a2$var$requestHostTimeout($6f8df61d4cf646a2$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $6f8df61d4cf646a2$var$currentTask = null, $6f8df61d4cf646a2$var$currentPriorityLevel = previousPriorityLevel, $6f8df61d4cf646a2$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $6f8df61d4cf646a2$var$schedulePerformWorkUntilDeadline() : $6f8df61d4cf646a2$var$isMessageLoopRunning = !1;
        }
    }
}
var $6f8df61d4cf646a2$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $6f8df61d4cf646a2$var$localSetImmediate) $6f8df61d4cf646a2$var$schedulePerformWorkUntilDeadline = function() {
    $6f8df61d4cf646a2$var$localSetImmediate($6f8df61d4cf646a2$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $6f8df61d4cf646a2$var$channel = new MessageChannel(), $6f8df61d4cf646a2$var$port = $6f8df61d4cf646a2$var$channel.port2;
    $6f8df61d4cf646a2$var$channel.port1.onmessage = $6f8df61d4cf646a2$var$performWorkUntilDeadline;
    $6f8df61d4cf646a2$var$schedulePerformWorkUntilDeadline = function() {
        $6f8df61d4cf646a2$var$port.postMessage(null);
    };
} else $6f8df61d4cf646a2$var$schedulePerformWorkUntilDeadline = function() {
    $6f8df61d4cf646a2$var$localSetTimeout($6f8df61d4cf646a2$var$performWorkUntilDeadline, 0);
};
function $6f8df61d4cf646a2$var$requestHostTimeout(callback, ms) {
    $6f8df61d4cf646a2$var$taskTimeoutID = $6f8df61d4cf646a2$var$localSetTimeout(function() {
        callback($6f8df61d4cf646a2$export$c4744153514ff05d());
    }, ms);
}
$6f8df61d4cf646a2$export$3e506c1ccc9cc1a7 = 5;
$6f8df61d4cf646a2$export$e26fe2ed2fa76875 = 1;
$6f8df61d4cf646a2$export$502329bbf4b505b1 = 4;
$6f8df61d4cf646a2$export$6e3807111c4874c4 = 3;
$6f8df61d4cf646a2$export$c27134553091fb3a = null;
$6f8df61d4cf646a2$export$33ee1acdc04fd2a2 = 2;
$6f8df61d4cf646a2$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$6f8df61d4cf646a2$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $6f8df61d4cf646a2$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$6f8df61d4cf646a2$export$d3dfb8e4810cb555 = function() {
    return $6f8df61d4cf646a2$var$currentPriorityLevel;
};
$6f8df61d4cf646a2$export$72fdf0e06517287b = function(eventHandler) {
    switch($6f8df61d4cf646a2$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $6f8df61d4cf646a2$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $6f8df61d4cf646a2$var$currentPriorityLevel;
    $6f8df61d4cf646a2$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $6f8df61d4cf646a2$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$6f8df61d4cf646a2$export$816d2913ae6b83b1 = function() {
    $6f8df61d4cf646a2$var$needsPaint = !0;
};
$6f8df61d4cf646a2$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $6f8df61d4cf646a2$var$currentPriorityLevel;
    $6f8df61d4cf646a2$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $6f8df61d4cf646a2$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$6f8df61d4cf646a2$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $6f8df61d4cf646a2$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $6f8df61d4cf646a2$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $6f8df61d4cf646a2$var$push($6f8df61d4cf646a2$var$timerQueue, priorityLevel), null === $6f8df61d4cf646a2$var$peek($6f8df61d4cf646a2$var$taskQueue) && priorityLevel === $6f8df61d4cf646a2$var$peek($6f8df61d4cf646a2$var$timerQueue) && ($6f8df61d4cf646a2$var$isHostTimeoutScheduled ? ($6f8df61d4cf646a2$var$localClearTimeout($6f8df61d4cf646a2$var$taskTimeoutID), $6f8df61d4cf646a2$var$taskTimeoutID = -1) : $6f8df61d4cf646a2$var$isHostTimeoutScheduled = !0, $6f8df61d4cf646a2$var$requestHostTimeout($6f8df61d4cf646a2$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $6f8df61d4cf646a2$var$push($6f8df61d4cf646a2$var$taskQueue, priorityLevel), $6f8df61d4cf646a2$var$isHostCallbackScheduled || $6f8df61d4cf646a2$var$isPerformingWork || ($6f8df61d4cf646a2$var$isHostCallbackScheduled = !0, $6f8df61d4cf646a2$var$isMessageLoopRunning || ($6f8df61d4cf646a2$var$isMessageLoopRunning = !0, $6f8df61d4cf646a2$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$6f8df61d4cf646a2$export$b5836b71941fa3ed = $6f8df61d4cf646a2$var$shouldYieldToHost;
$6f8df61d4cf646a2$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $6f8df61d4cf646a2$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $6f8df61d4cf646a2$var$currentPriorityLevel;
        $6f8df61d4cf646a2$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $6f8df61d4cf646a2$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("lDJXT", function(module, exports) {
'use strict';

module.exports = (parcelRequire("ydj4E"));

});

parcelRegister("6UFvd", function(module, exports) {
'use strict';
function $50882a8f8be77b25$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($50882a8f8be77b25$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$50882a8f8be77b25$var$checkDCE();

module.exports = (parcelRequire("kmxDr"));

});
parcelRegister("kmxDr", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $ed2ff3f7f16eba0e$export$69ce8ef3fe5cead0; }, function (v) { return $ed2ff3f7f16eba0e$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $ed2ff3f7f16eba0e$export$d39a5bbd09211389; }, function (v) { return $ed2ff3f7f16eba0e$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $ed2ff3f7f16eba0e$export$cd75ccfd720a3cd4; }, function (v) { return $ed2ff3f7f16eba0e$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $ed2ff3f7f16eba0e$export$a0816fa17a9e79be; }, function (v) { return $ed2ff3f7f16eba0e$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $ed2ff3f7f16eba0e$export$7292efcadded39f3; }, function (v) { return $ed2ff3f7f16eba0e$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $ed2ff3f7f16eba0e$export$da407abadb9b8f86; }, function (v) { return $ed2ff3f7f16eba0e$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $ed2ff3f7f16eba0e$export$314cfea32580671c; }, function (v) { return $ed2ff3f7f16eba0e$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $ed2ff3f7f16eba0e$export$513ccb98c53b8039; }, function (v) { return $ed2ff3f7f16eba0e$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $ed2ff3f7f16eba0e$export$dbca993bc2d264a; }, function (v) { return $ed2ff3f7f16eba0e$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $ed2ff3f7f16eba0e$export$4797a8006f0655d0; }, function (v) { return $ed2ff3f7f16eba0e$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $ed2ff3f7f16eba0e$export$c78a37762a8d58e1; }, function (v) { return $ed2ff3f7f16eba0e$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $ed2ff3f7f16eba0e$export$606f11b2eb45ecc6; }, function (v) { return $ed2ff3f7f16eba0e$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $ed2ff3f7f16eba0e$export$f7e8a0bf92324b1e; }, function (v) { return $ed2ff3f7f16eba0e$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $ed2ff3f7f16eba0e$export$83d89fbfd8236492; }, function (v) { return $ed2ff3f7f16eba0e$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ed2ff3f7f16eba0e$export$69ce8ef3fe5cead0;
var $ed2ff3f7f16eba0e$export$d39a5bbd09211389;
var $ed2ff3f7f16eba0e$export$cd75ccfd720a3cd4;
var $ed2ff3f7f16eba0e$export$a0816fa17a9e79be;
var $ed2ff3f7f16eba0e$export$7292efcadded39f3;
var $ed2ff3f7f16eba0e$export$da407abadb9b8f86;
var $ed2ff3f7f16eba0e$export$314cfea32580671c;
var $ed2ff3f7f16eba0e$export$513ccb98c53b8039;
var $ed2ff3f7f16eba0e$export$dbca993bc2d264a;
var $ed2ff3f7f16eba0e$export$4797a8006f0655d0;
var $ed2ff3f7f16eba0e$export$c78a37762a8d58e1;
var $ed2ff3f7f16eba0e$export$606f11b2eb45ecc6;
var $ed2ff3f7f16eba0e$export$f7e8a0bf92324b1e;
var $ed2ff3f7f16eba0e$export$83d89fbfd8236492;
"use strict";

var $lDJXT = parcelRequire("lDJXT");
function $ed2ff3f7f16eba0e$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $ed2ff3f7f16eba0e$var$noop() {}
var $ed2ff3f7f16eba0e$var$Internals = {
    d: {
        f: $ed2ff3f7f16eba0e$var$noop,
        r: function() {
            throw Error($ed2ff3f7f16eba0e$var$formatProdErrorMessage(522));
        },
        D: $ed2ff3f7f16eba0e$var$noop,
        C: $ed2ff3f7f16eba0e$var$noop,
        L: $ed2ff3f7f16eba0e$var$noop,
        m: $ed2ff3f7f16eba0e$var$noop,
        X: $ed2ff3f7f16eba0e$var$noop,
        S: $ed2ff3f7f16eba0e$var$noop,
        M: $ed2ff3f7f16eba0e$var$noop
    },
    p: 0,
    findDOMNode: null
}, $ed2ff3f7f16eba0e$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $ed2ff3f7f16eba0e$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $ed2ff3f7f16eba0e$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $ed2ff3f7f16eba0e$var$ReactSharedInternals = $lDJXT.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $ed2ff3f7f16eba0e$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$ed2ff3f7f16eba0e$export$69ce8ef3fe5cead0 = $ed2ff3f7f16eba0e$var$Internals;
$ed2ff3f7f16eba0e$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($ed2ff3f7f16eba0e$var$formatProdErrorMessage(299));
    return $ed2ff3f7f16eba0e$var$createPortal$1(children, container, null, key);
};
$ed2ff3f7f16eba0e$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $ed2ff3f7f16eba0e$var$ReactSharedInternals.T, previousUpdatePriority = $ed2ff3f7f16eba0e$var$Internals.p;
    try {
        if ($ed2ff3f7f16eba0e$var$ReactSharedInternals.T = null, $ed2ff3f7f16eba0e$var$Internals.p = 2, fn) return fn();
    } finally{
        $ed2ff3f7f16eba0e$var$ReactSharedInternals.T = previousTransition, $ed2ff3f7f16eba0e$var$Internals.p = previousUpdatePriority, $ed2ff3f7f16eba0e$var$Internals.d.f();
    }
};
$ed2ff3f7f16eba0e$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $ed2ff3f7f16eba0e$var$Internals.d.C(href, options));
};
$ed2ff3f7f16eba0e$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $ed2ff3f7f16eba0e$var$Internals.d.D(href);
};
$ed2ff3f7f16eba0e$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $ed2ff3f7f16eba0e$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $ed2ff3f7f16eba0e$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $ed2ff3f7f16eba0e$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$ed2ff3f7f16eba0e$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $ed2ff3f7f16eba0e$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $ed2ff3f7f16eba0e$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $ed2ff3f7f16eba0e$var$Internals.d.M(href);
    }
};
$ed2ff3f7f16eba0e$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $ed2ff3f7f16eba0e$var$getCrossOriginStringAs(as, options.crossOrigin);
        $ed2ff3f7f16eba0e$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$ed2ff3f7f16eba0e$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $ed2ff3f7f16eba0e$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $ed2ff3f7f16eba0e$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $ed2ff3f7f16eba0e$var$Internals.d.m(href);
    }
};
$ed2ff3f7f16eba0e$export$4797a8006f0655d0 = function(form) {
    $ed2ff3f7f16eba0e$var$Internals.d.r(form);
};
$ed2ff3f7f16eba0e$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$ed2ff3f7f16eba0e$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $ed2ff3f7f16eba0e$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$ed2ff3f7f16eba0e$export$f7e8a0bf92324b1e = function() {
    return $ed2ff3f7f16eba0e$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$ed2ff3f7f16eba0e$export$83d89fbfd8236492 = "19.2.7";

});



parcelRegister("aDFrW", function(module, exports) {

$parcel$export(module.exports, "c", function () { return $7bedb2f011a41f42$export$db3b6bfb95261072; }, function (v) { return $7bedb2f011a41f42$export$db3b6bfb95261072 = v; });
/**
 * @license React
 * react-compiler-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7bedb2f011a41f42$export$db3b6bfb95261072;
"use strict";

var $lDJXT = parcelRequire("lDJXT");
var $7bedb2f011a41f42$require$ReactSharedInternals = $lDJXT.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
$7bedb2f011a41f42$export$db3b6bfb95261072 = function(size) {
    return $7bedb2f011a41f42$require$ReactSharedInternals.H.useMemoCache(size);
};

});

var $8920b4c3826f24f1$exports = {};
$parcel$extendImportMap({
    "7WUtL": "01.ee1945dc.webp",
    "af8aa": "02.c4828df1.webp",
    "4yruO": "03.03c24727.webp",
    "5WWjA": "04.88acad22.webp",
    "1B4W6": "05.953a6fcd.webp",
    "7tkWV": "06.314e6c1e.webp",
    "ijwLV": "07.11dadb70.webp",
    "h6jk3": "08.f8780dfb.webp",
    "e3MDb": "09.e5976783.webp"
});

var $217385444e3d1677$exports = {};
'use strict';

$217385444e3d1677$exports = (parcelRequire("ajr9Q"));



var $lDJXT = parcelRequire("lDJXT");
var $6d3b784170d7cd9b$exports = {};
'use strict';
function $6d3b784170d7cd9b$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($6d3b784170d7cd9b$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$6d3b784170d7cd9b$var$checkDCE();

$6d3b784170d7cd9b$exports = (parcelRequire("lEmfK"));



var $2cf3419409a8d23a$exports = {};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

$2cf3419409a8d23a$exports = (parcelRequire("aDFrW"));






var $lDJXT = parcelRequire("lDJXT");
function $cac52ab6427d584a$export$d59a452d6b3a29e2() {
    const $ = (0, $2cf3419409a8d23a$exports.c)(3);
    const [copied, setCopied] = (0, $lDJXT.useState)(false);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (text)=>{
            navigator.clipboard?.writeText(text).then(()=>{
                setCopied(true);
                window.setTimeout(()=>setCopied(false), 1400);
            }, $cac52ab6427d584a$var$_temp);
        };
        $[0] = t0;
    } else t0 = $[0];
    const copy = t0;
    let t1;
    if ($[1] !== copied) {
        t1 = {
            copied: copied,
            copy: copy
        };
        $[1] = copied;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
}
function $cac52ab6427d584a$var$_temp() {}




var $lDJXT = parcelRequire("lDJXT");
function $ec797a31f053fa32$export$93d4e7f90805808f() {
    const $ = (0, $2cf3419409a8d23a$exports.c)(5);
    const [theme, setTheme] = (0, $lDJXT.useState)($ec797a31f053fa32$var$_temp);
    let t0;
    let t1;
    if ($[0] !== theme) {
        t0 = ()=>{
            document.documentElement.setAttribute("data-theme", theme);
            try {
                localStorage.setItem("rc-theme", theme);
            } catch  {}
        };
        t1 = [
            theme
        ];
        $[0] = theme;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $lDJXT.useEffect)(t0, t1);
    let t2;
    if ($[3] !== theme) {
        t2 = [
            theme,
            setTheme
        ];
        $[3] = theme;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
}
function $ec797a31f053fa32$var$_temp() {
    return document.documentElement.getAttribute("data-theme") || "dark";
}




var $lDJXT = parcelRequire("lDJXT");
function $0ee366ceeb6b9dab$export$ea86cd170f22eba6(ids) {
    const $ = (0, $2cf3419409a8d23a$exports.c)(3);
    const [active, setActive] = (0, $lDJXT.useState)(ids[0]);
    let t0;
    let t1;
    if ($[0] !== ids) {
        t0 = ()=>{
            const observer = new IntersectionObserver((entries)=>{
                const visible = entries.filter($0ee366ceeb6b9dab$var$_temp).sort($0ee366ceeb6b9dab$var$_temp2);
                if (visible[0]) setActive(visible[0].target.id);
            }, {
                rootMargin: "-15% 0px -75% 0px",
                threshold: 0
            });
            ids.forEach((id)=>{
                const el = document.getElementById(id);
                if (el) observer.observe(el);
            });
            return ()=>observer.disconnect();
        };
        t1 = [
            ids
        ];
        $[0] = ids;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $lDJXT.useEffect)(t0, t1);
    return active;
}
function $0ee366ceeb6b9dab$var$_temp2(a, b) {
    return a.boundingClientRect.top - b.boundingClientRect.top;
}
function $0ee366ceeb6b9dab$var$_temp(e) {
    return e.isIntersecting;
}




/**
 * Single import boundary for the local library.
 *
 * The example deliberately imports the library *source* (`../../src`) rather
 * than the built package, so editing `src/` hot-reloads the docs instantly
 * with no rebuild step. Centralising it here means that relative path — and
 * the choice of source-vs-package — lives in exactly one file. If you ever
 * want the example to exercise the published build instead, change only the
 * specifiers below to `react-carousel-latest` / `react-carousel-latest/presets`.
 */ 

var $lDJXT = parcelRequire("lDJXT");

function $5c6707516b7f4999$var$Icon({ size: size = 24, name: name, children: children, ...rest }) {
    return /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: `lucide lucide-${name}`,
        ...rest,
        children: children
    });
}
function $5c6707516b7f4999$export$29ab0a58e0457c56(props) {
    return /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)($5c6707516b7f4999$var$Icon, {
        name: "chevron-left",
        ...props,
        children: /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("path", {
            d: "m15 18-6-6 6-6"
        })
    });
}
function $5c6707516b7f4999$export$6172d85aadfc9b96(props) {
    return /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)($5c6707516b7f4999$var$Icon, {
        name: "chevron-right",
        ...props,
        children: /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("path", {
            d: "m9 18 6-6-6-6"
        })
    });
}
function $5c6707516b7f4999$export$c4e18b17bff7fe5b(props) {
    return /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)($5c6707516b7f4999$var$Icon, {
        name: "arrow-up-right",
        ...props,
        children: [
            /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("path", {
                d: "M7 7h10v10"
            }),
            /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("path", {
                d: "M7 17 17 7"
            })
        ]
    });
}



const $7a9371b51650a71c$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $7a9371b51650a71c$export$9de1236619d9e756 = /*@__PURE__*/ $7a9371b51650a71c$var$checkStringStartsWith("--");
const $7a9371b51650a71c$var$startsAsVariableToken = /*@__PURE__*/ $7a9371b51650a71c$var$checkStringStartsWith("var(--");
const $7a9371b51650a71c$export$31f9caa2600b5723 = (value)=>{
    const startsWithToken = $7a9371b51650a71c$var$startsAsVariableToken(value);
    if (!startsWithToken) return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return $7a9371b51650a71c$var$singleCssVariableRegex.test(value.split("/*")[0].trim());
};
const $7a9371b51650a71c$var$singleCssVariableRegex = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;
/**
 * Check if a value contains a CSS variable anywhere (e.g. inside calc()).
 * Unlike isCSSVariableToken which checks if the value IS a var() token,
 * this checks if the value CONTAINS var() somewhere in the string.
 */ function $7a9371b51650a71c$export$df8f90ab5d0b05fa(value) {
    if (typeof value !== "string") return false;
    // Strip comments to avoid false positives
    return value.split("/*")[0].includes("var(--");
}


/**
 * Generate a list of every possible transform key.
 */ const $36352b87224ae25e$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 *
 * `pathRotation` is a transform for routing purposes (skipped from raw
 * style application, wired to the transform composite, flags transform
 * dirty) but is intentionally NOT in `transformPropOrder` — it is
 * composed onto `rotate` at the build sites, not serialized in its own
 * slot, and must stay out of the order-array consumers (parse-transform,
 * unit-conversion, keys-position).
 */ const $36352b87224ae25e$export$7b42a0094fb00b6e = /*@__PURE__*/ (()=>new Set([
        ...$36352b87224ae25e$export$280dc01950909d86,
        "pathRotation"
    ]))();


const $e042a75e641eeb74$var$radToDeg = (rad)=>rad * 180 / Math.PI;
const $e042a75e641eeb74$var$rotate = (v)=>{
    const angle = $e042a75e641eeb74$var$radToDeg(Math.atan2(v[1], v[0]));
    return $e042a75e641eeb74$var$rebaseAngle(angle);
};
const $e042a75e641eeb74$var$matrix2dParsers = {
    x: 4,
    y: 5,
    translateX: 4,
    translateY: 5,
    scaleX: 0,
    scaleY: 3,
    scale: (v)=>(Math.abs(v[0]) + Math.abs(v[3])) / 2,
    rotate: $e042a75e641eeb74$var$rotate,
    rotateZ: $e042a75e641eeb74$var$rotate,
    skewX: (v)=>$e042a75e641eeb74$var$radToDeg(Math.atan(v[1])),
    skewY: (v)=>$e042a75e641eeb74$var$radToDeg(Math.atan(v[2])),
    skew: (v)=>(Math.abs(v[1]) + Math.abs(v[2])) / 2
};
const $e042a75e641eeb74$var$rebaseAngle = (angle)=>{
    angle = angle % 360;
    if (angle < 0) angle += 360;
    return angle;
};
const $e042a75e641eeb74$var$rotateZ = $e042a75e641eeb74$var$rotate;
const $e042a75e641eeb74$var$scaleX = (v)=>Math.sqrt(v[0] * v[0] + v[1] * v[1]);
const $e042a75e641eeb74$var$scaleY = (v)=>Math.sqrt(v[4] * v[4] + v[5] * v[5]);
const $e042a75e641eeb74$var$matrix3dParsers = {
    x: 12,
    y: 13,
    z: 14,
    translateX: 12,
    translateY: 13,
    translateZ: 14,
    scaleX: $e042a75e641eeb74$var$scaleX,
    scaleY: $e042a75e641eeb74$var$scaleY,
    scale: (v)=>($e042a75e641eeb74$var$scaleX(v) + $e042a75e641eeb74$var$scaleY(v)) / 2,
    rotateX: (v)=>$e042a75e641eeb74$var$rebaseAngle($e042a75e641eeb74$var$radToDeg(Math.atan2(v[6], v[5]))),
    rotateY: (v)=>$e042a75e641eeb74$var$rebaseAngle($e042a75e641eeb74$var$radToDeg(Math.atan2(-v[2], v[0]))),
    rotateZ: $e042a75e641eeb74$var$rotateZ,
    rotate: $e042a75e641eeb74$var$rotateZ,
    skewX: (v)=>$e042a75e641eeb74$var$radToDeg(Math.atan(v[4])),
    skewY: (v)=>$e042a75e641eeb74$var$radToDeg(Math.atan(v[1])),
    skew: (v)=>(Math.abs(v[1]) + Math.abs(v[4])) / 2
};
function $e042a75e641eeb74$export$1f10c01143b9f089(name) {
    return name.includes("scale") ? 1 : 0;
}
function $e042a75e641eeb74$export$f9111f9e16b73a26(transform, name) {
    if (!transform || transform === "none") return $e042a75e641eeb74$export$1f10c01143b9f089(name);
    const matrix3dMatch = transform.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
    let parsers;
    let match;
    if (matrix3dMatch) {
        parsers = $e042a75e641eeb74$var$matrix3dParsers;
        match = matrix3dMatch;
    } else {
        const matrix2dMatch = transform.match(/^matrix\(([-\d.e\s,]+)\)$/u);
        parsers = $e042a75e641eeb74$var$matrix2dParsers;
        match = matrix2dMatch;
    }
    if (!match) return $e042a75e641eeb74$export$1f10c01143b9f089(name);
    const valueParser = parsers[name];
    const values = match[1].split(",").map($e042a75e641eeb74$var$convertTransformToNumber);
    return typeof valueParser === "function" ? valueParser(values) : values[valueParser];
}
const $e042a75e641eeb74$export$bcd97e0e03ba17f6 = (instance, name)=>{
    const { transform: transform = "none" } = getComputedStyle(instance);
    return $e042a75e641eeb74$export$f9111f9e16b73a26(transform, name);
};
function $e042a75e641eeb74$var$convertTransformToNumber(value) {
    return parseFloat(value.trim());
}


/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $167289942d86b7aa$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $167289942d86b7aa$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $167289942d86b7aa$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}


/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $5a3532f8b2a8e80b$export$3bb0b4ff1037b8dd = (from, to, progress)=>{
    return from + (to - from) * progress;
};


function $b173916de606703a$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $b173916de606703a$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$b173916de606703a$var$isIdentityScale(scale) || !$b173916de606703a$var$isIdentityScale(scaleX) || !$b173916de606703a$var$isIdentityScale(scaleY);
}
function $b173916de606703a$export$a545127cf1fbb600(values) {
    return $b173916de606703a$export$bdf30dca883ea463(values) || $b173916de606703a$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function $b173916de606703a$export$bf80f5f8f4dc327f(values) {
    return $b173916de606703a$var$is2DTranslate(values.x) || $b173916de606703a$var$is2DTranslate(values.y);
}
function $b173916de606703a$var$is2DTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $5dcf16df13ee8113$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $5dcf16df13ee8113$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $5dcf16df13ee8113$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $5dcf16df13ee8113$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $5dcf16df13ee8113$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $5dcf16df13ee8113$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $5dcf16df13ee8113$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $5dcf16df13ee8113$export$d80074982803af5c(box, { x: x, y: y }) {
    $5dcf16df13ee8113$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $5dcf16df13ee8113$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
const $5dcf16df13ee8113$var$TREE_SCALE_SNAP_MIN = 0.999999999999;
const $5dcf16df13ee8113$var$TREE_SCALE_SNAP_MAX = 1.0000000000001;
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $5dcf16df13ee8113$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const { visualElement: visualElement } = node.options;
        if (visualElement && visualElement.props.style && visualElement.props.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) {
            $5dcf16df13ee8113$export$a807a5ce5ebb3895(box.x, -node.scroll.offset.x);
            $5dcf16df13ee8113$export$a807a5ce5ebb3895(box.y, -node.scroll.offset.y);
        }
        if (delta) {
            // Incoporate each ancestor's scale into a cumulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $5dcf16df13ee8113$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $b173916de606703a$export$a545127cf1fbb600)(node.latestValues)) $5dcf16df13ee8113$export$58b16271041fbfb(box, node.latestValues, node.layout?.layoutBox);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ if (treeScale.x < $5dcf16df13ee8113$var$TREE_SCALE_SNAP_MAX && treeScale.x > $5dcf16df13ee8113$var$TREE_SCALE_SNAP_MIN) treeScale.x = 1.0;
    if (treeScale.y < $5dcf16df13ee8113$var$TREE_SCALE_SNAP_MAX && treeScale.y > $5dcf16df13ee8113$var$TREE_SCALE_SNAP_MIN) treeScale.y = 1.0;
}
function $5dcf16df13ee8113$export$a807a5ce5ebb3895(axis, distance) {
    axis.min += distance;
    axis.max += distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $5dcf16df13ee8113$export$625f1dd140a2f5e7(axis, axisTranslate, axisScale, boxScale, axisOrigin = 0.5) {
    const originPoint = (0, $5a3532f8b2a8e80b$export$3bb0b4ff1037b8dd)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $5dcf16df13ee8113$export$e8e3a712e9ebf422(axis, axisTranslate, axisScale, originPoint, boxScale);
}
function $5dcf16df13ee8113$var$resolveAxisTranslate(value, axis) {
    if (typeof value === "string") return parseFloat(value) / 100 * (axis.max - axis.min);
    return value;
}
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $5dcf16df13ee8113$export$58b16271041fbfb(box, transform, sourceBox) {
    const resolveBox = sourceBox ?? box;
    $5dcf16df13ee8113$export$625f1dd140a2f5e7(box.x, $5dcf16df13ee8113$var$resolveAxisTranslate(transform.x, resolveBox.x), transform.scaleX, transform.scale, transform.originX);
    $5dcf16df13ee8113$export$625f1dd140a2f5e7(box.y, $5dcf16df13ee8113$var$resolveAxisTranslate(transform.y, resolveBox.y), transform.scaleY, transform.scale, transform.originY);
}


function $0ba608e5edcfe666$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $167289942d86b7aa$export$d3955c6a8f65a36b)((0, $167289942d86b7aa$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $0ba608e5edcfe666$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $0ba608e5edcfe666$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $5dcf16df13ee8113$export$a807a5ce5ebb3895)(viewportBox.x, scroll.offset.x);
        (0, $5dcf16df13ee8113$export$a807a5ce5ebb3895)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}


const $5c2f00f5f770efa1$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);



const $6c578834c45b15a9$export$c66c0d5db2a205d = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    ...(0, $36352b87224ae25e$export$280dc01950909d86)
]);


/**
 * ValueType for "auto"
 */ const $f63be726a8f22df1$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};


const $30bb3117a82170b4$export$7d15b64cf5a3a4c4 = (min, max, v)=>{
    if (v > max) return max;
    if (v < min) return min;
    return v;
};


const $28ce2452c8c92de3$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $28ce2452c8c92de3$export$58f0f39f63f3cf42 = {
    ...$28ce2452c8c92de3$export$98e628dec113755e,
    transform: (v)=>(0, $30bb3117a82170b4$export$7d15b64cf5a3a4c4)(0, 1, v)
};
const $28ce2452c8c92de3$export$dcdf75081b88279d = {
    ...$28ce2452c8c92de3$export$98e628dec113755e,
    default: 1
};


/*#__NO_SIDE_EFFECTS__*/ const $9e4fa4b20312155c$var$createUnitType = (unit)=>({
        test: (v)=>typeof v === "string" && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $9e4fa4b20312155c$export$41fc368e1a942b97 = /*@__PURE__*/ $9e4fa4b20312155c$var$createUnitType("deg");
const $9e4fa4b20312155c$export$626336c2cd4b14de = /*@__PURE__*/ $9e4fa4b20312155c$var$createUnitType("%");
const $9e4fa4b20312155c$export$91c0eda1d06bf008 = /*@__PURE__*/ $9e4fa4b20312155c$var$createUnitType("px");
const $9e4fa4b20312155c$export$f91e8c45a95a32f2 = /*@__PURE__*/ $9e4fa4b20312155c$var$createUnitType("vh");
const $9e4fa4b20312155c$export$aed3d7b7d206c196 = /*@__PURE__*/ $9e4fa4b20312155c$var$createUnitType("vw");
const $9e4fa4b20312155c$export$44e2e1705876d7ed = /*@__PURE__*/ (()=>({
        ...$9e4fa4b20312155c$export$626336c2cd4b14de,
        parse: (v)=>$9e4fa4b20312155c$export$626336c2cd4b14de.parse(v) / 100,
        transform: (v)=>$9e4fa4b20312155c$export$626336c2cd4b14de.transform(v * 100)
    }))();


/**
 * Tests a provided value against a ValueType
 */ const $dbfd278086675303$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);


/**
 * A list of value types commonly used for dimensions
 */ const $6a9df0f0656297d2$export$d176691c1998a1f5 = [
    (0, $28ce2452c8c92de3$export$98e628dec113755e),
    (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    (0, $9e4fa4b20312155c$export$626336c2cd4b14de),
    (0, $9e4fa4b20312155c$export$41fc368e1a942b97),
    (0, $9e4fa4b20312155c$export$aed3d7b7d206c196),
    (0, $9e4fa4b20312155c$export$f91e8c45a95a32f2),
    (0, $f63be726a8f22df1$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $6a9df0f0656297d2$export$eefdd52e3ccae428 = (v)=>$6a9df0f0656297d2$export$d176691c1998a1f5.find((0, $dbfd278086675303$export$6eae4d0a6a7ca7cd)(v));



let $8a16204eb729eee3$export$491112666e282270 = ()=>{};
let $8a16204eb729eee3$export$f5708dca728d7177 = ()=>{};
var $8a16204eb729eee3$var$check, $8a16204eb729eee3$var$message, $8a16204eb729eee3$var$errorCode, $8a16204eb729eee3$var$check1, $8a16204eb729eee3$var$message1, $8a16204eb729eee3$var$errorCode1;

/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $46fc6ca0056ca4d1$export$65583ed5a868f2d9 = (v)=>/^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(v);



/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $feb2bebc49ce9f3d$var$splitCSSVariableRegex = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
/^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function $feb2bebc49ce9f3d$export$b9f0c1f373aee2b0(current) {
    const match = $feb2bebc49ce9f3d$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token1, token2, fallback] = match;
    return [
        `--${token1 ?? token2}`,
        fallback
    ];
}
const $feb2bebc49ce9f3d$var$maxDepth = 4;
function $feb2bebc49ce9f3d$export$289398774300c991(current, element, depth = 1) {
    (0, $8a16204eb729eee3$export$f5708dca728d7177)(depth <= $feb2bebc49ce9f3d$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`, "max-css-var-depth");
    const [token, fallback] = $feb2bebc49ce9f3d$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $46fc6ca0056ca4d1$export$65583ed5a868f2d9)(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return (0, $7a9371b51650a71c$export$31f9caa2600b5723)(fallback) ? $feb2bebc49ce9f3d$export$289398774300c991(fallback, element, depth + 1) : fallback;
}



function $f559ff50c2d404da$export$5a98a90409277f5a(keyframes) {
    for(let i = 1; i < keyframes.length; i++)keyframes[i] ?? (keyframes[i] = keyframes[i - 1]);
}






const $1f4b975191a25b78$export$8e5250d1aa9bf370 = (v)=>v === (0, $28ce2452c8c92de3$export$98e628dec113755e) || v === (0, $9e4fa4b20312155c$export$91c0eda1d06bf008);
const $1f4b975191a25b78$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $1f4b975191a25b78$var$nonTranslationalTransformKeys = (0, $36352b87224ae25e$export$280dc01950909d86).filter((key)=>!$1f4b975191a25b78$var$transformKeys.has(key));
function $1f4b975191a25b78$export$39d4bc9655f3f632(visualElement) {
    const removedTransforms = [];
    $1f4b975191a25b78$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
const $1f4b975191a25b78$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0", boxSizing: boxSizing })=>{
        const width = x.max - x.min;
        return boxSizing === "border-box" ? width : width - parseFloat(paddingLeft) - parseFloat(paddingRight);
    },
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0", boxSizing: boxSizing })=>{
        const height = y.max - y.min;
        return boxSizing === "border-box" ? height : height - parseFloat(paddingTop) - parseFloat(paddingBottom);
    },
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: (_bbox, { transform: transform })=>(0, $e042a75e641eeb74$export$f9111f9e16b73a26)(transform, "x"),
    y: (_bbox, { transform: transform })=>(0, $e042a75e641eeb74$export$f9111f9e16b73a26)(transform, "y")
};
// Alias translate longform names
$1f4b975191a25b78$export$781d46a8aa670d52.translateX = $1f4b975191a25b78$export$781d46a8aa670d52.x;
$1f4b975191a25b78$export$781d46a8aa670d52.translateY = $1f4b975191a25b78$export$781d46a8aa670d52.y;


/*#__NO_SIDE_EFFECTS__*/ const $df2228348c5a149c$export$8793edee2d425525 = (any)=>any;


const $dcfd83e0153bc5a7$export$dd826089e3c5e502 = {};


const $8cb19c39f45d3cb5$export$71ecace0a033b35a = [
    "setup",
    "read",
    "resolveKeyframes",
    "preUpdate",
    "update",
    "preRender",
    "render",
    "postRender"
];


const $a9d4288c548593bd$export$84ce9a476f53d110 = {
    value: null,
    addProjectionMetrics: null
};


function $fce8438bc87fa5ca$export$b995e5e85f5c8289(runNextFrame, stepName) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new Set();
    let nextFrame = new Set();
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    let latestFrameData = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    let numCalls = 0;
    function triggerCallback(callback) {
        if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
        }
        numCalls++;
        callback(latestFrameData);
    }
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            queue.add(callback);
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.delete(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            latestFrameData = frameData;
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            // Swap this frame and the next to avoid GC
            const prevFrame = thisFrame;
            thisFrame = nextFrame;
            nextFrame = prevFrame;
            // Execute this frame
            thisFrame.forEach(triggerCallback);
            /**
             * If we're recording stats then
             */ if (stepName && (0, $a9d4288c548593bd$export$84ce9a476f53d110).value) (0, $a9d4288c548593bd$export$84ce9a476f53d110).value.frameloop[stepName].push(numCalls);
            numCalls = 0;
            // Clear the frame so no callbacks remain. This is to avoid
            // memory leaks should this render step not run for a while.
            thisFrame.clear();
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $010d1e62b8d86088$var$maxElapsed = 40;
function $010d1e62b8d86088$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    const flagRunNextFrame = ()=>runNextFrame = true;
    const steps = (0, $8cb19c39f45d3cb5$export$71ecace0a033b35a).reduce((acc, key)=>{
        acc[key] = (0, $fce8438bc87fa5ca$export$b995e5e85f5c8289)(flagRunNextFrame, allowKeepAlive ? key : undefined);
        return acc;
    }, {});
    const { setup: setup, read: read, resolveKeyframes: resolveKeyframes, preUpdate: preUpdate, update: update, preRender: preRender, render: render, postRender: postRender } = steps;
    const processBatch = ()=>{
        const useManualTiming = (0, $dcfd83e0153bc5a7$export$dd826089e3c5e502).useManualTiming;
        const timestamp = useManualTiming ? state.timestamp : performance.now();
        runNextFrame = false;
        if (!useManualTiming) state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $010d1e62b8d86088$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        // Unrolled render loop for better per-frame performance
        setup.process(state);
        read.process(state);
        resolveKeyframes.process(state);
        preUpdate.process(state);
        update.process(state);
        preRender.process(state);
        render.process(state);
        postRender.process(state);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = (0, $8cb19c39f45d3cb5$export$71ecace0a033b35a).reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>{
        for(let i = 0; i < (0, $8cb19c39f45d3cb5$export$71ecace0a033b35a).length; i++)steps[(0, $8cb19c39f45d3cb5$export$71ecace0a033b35a)[i]].cancel(process);
    };
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}


const { schedule: $99c45f49fc7b5e17$export$2cef06c20297c17d, cancel: $99c45f49fc7b5e17$export$ec99c0ef4978dccb, state: $99c45f49fc7b5e17$export$fff89137e9e818ce, steps: $99c45f49fc7b5e17$export$1811c3a7e3af92f0 } = /* @__PURE__ */ (0, $010d1e62b8d86088$export$510b0596a933801a)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $df2228348c5a149c$export$8793edee2d425525), true);


const $22e7011c70149f46$var$toResolve = new Set();
let $22e7011c70149f46$var$isScheduled = false;
let $22e7011c70149f46$var$anyNeedsMeasurement = false;
let $22e7011c70149f46$var$isForced = false;
function $22e7011c70149f46$var$measureAllKeyframes() {
    if ($22e7011c70149f46$var$anyNeedsMeasurement) {
        const resolversToMeasure = Array.from($22e7011c70149f46$var$toResolve).filter((resolver)=>resolver.needsMeasurement);
        const elementsToMeasure = new Set(resolversToMeasure.map((resolver)=>resolver.element));
        const transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */ elementsToMeasure.forEach((element)=>{
            const removedTransforms = (0, $1f4b975191a25b78$export$39d4bc9655f3f632)(element);
            if (!removedTransforms.length) return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureInitialState());
        // Write
        elementsToMeasure.forEach((element)=>{
            element.render();
            const restore = transformsToRestore.get(element);
            if (restore) restore.forEach(([key, value])=>{
                element.getValue(key)?.set(value);
            });
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureEndState());
        // Write
        resolversToMeasure.forEach((resolver)=>{
            if (resolver.suspendedScrollY !== undefined) window.scrollTo(0, resolver.suspendedScrollY);
        });
    }
    $22e7011c70149f46$var$anyNeedsMeasurement = false;
    $22e7011c70149f46$var$isScheduled = false;
    $22e7011c70149f46$var$toResolve.forEach((resolver)=>resolver.complete($22e7011c70149f46$var$isForced));
    $22e7011c70149f46$var$toResolve.clear();
}
function $22e7011c70149f46$var$readAllKeyframes() {
    $22e7011c70149f46$var$toResolve.forEach((resolver)=>{
        resolver.readKeyframes();
        if (resolver.needsMeasurement) $22e7011c70149f46$var$anyNeedsMeasurement = true;
    });
}
function $22e7011c70149f46$export$78b96d2a12593b05() {
    $22e7011c70149f46$var$isForced = true;
    $22e7011c70149f46$var$readAllKeyframes();
    $22e7011c70149f46$var$measureAllKeyframes();
    $22e7011c70149f46$var$isForced = false;
}
class $22e7011c70149f46$export$74d34ca3182f1750 {
    scheduleResolve() {
        this.state = "scheduled";
        if (this.isAsync) {
            $22e7011c70149f46$var$toResolve.add(this);
            if (!$22e7011c70149f46$var$isScheduled) {
                $22e7011c70149f46$var$isScheduled = true;
                (0, $99c45f49fc7b5e17$export$2cef06c20297c17d).read($22e7011c70149f46$var$readAllKeyframes);
                (0, $99c45f49fc7b5e17$export$2cef06c20297c17d).resolveKeyframes($22e7011c70149f46$var$measureAllKeyframes);
            }
        } else {
            this.readKeyframes();
            this.complete();
        }
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name, element: element, motionValue: motionValue } = this;
        // If initial keyframe is null we need to read it from the DOM
        if (unresolvedKeyframes[0] === null) {
            const currentValue = motionValue?.get();
            // TODO: This doesn't work if the final keyframe is a wildcard
            const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
            if (currentValue !== undefined) unresolvedKeyframes[0] = currentValue;
            else if (element && name) {
                const valueAsRead = element.readValue(name, finalKeyframe);
                if (valueAsRead !== undefined && valueAsRead !== null) unresolvedKeyframes[0] = valueAsRead;
            }
            if (unresolvedKeyframes[0] === undefined) unresolvedKeyframes[0] = finalKeyframe;
            if (motionValue && currentValue === undefined) motionValue.set(unresolvedKeyframes[0]);
        }
        (0, $f559ff50c2d404da$export$5a98a90409277f5a)(unresolvedKeyframes);
    }
    setFinalKeyframe() {}
    measureInitialState() {}
    renderEndStyles() {}
    measureEndState() {}
    complete(isForcedComplete = false) {
        this.state = "complete";
        this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, isForcedComplete);
        $22e7011c70149f46$var$toResolve.delete(this);
    }
    cancel() {
        if (this.state === "scheduled") {
            $22e7011c70149f46$var$toResolve.delete(this);
            this.state = "pending";
        }
    }
    resume() {
        if (this.state === "pending") this.scheduleResolve();
    }
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element, isAsync = false){
        this.state = "pending";
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */ this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */ this.needsMeasurement = false;
        this.unresolvedKeyframes = [
            ...unresolvedKeyframes
        ];
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
}


/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $c15154993d23bf7c$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/u.test(v);


function $f465330bcfc0dfac$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $c15154993d23bf7c$export$ade84c85e44a6cb1)(value);
    else return true;
}




// If this number is a decimal, make it just five decimal places
// to avoid exponents
const $e3a52c4e75385c2f$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;


const $16d80d5fb8f921ef$export$2444ca58c08448e4 = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;


function $6d54fb496a9ff5f4$export$b931b78cbb3caf86(v) {
    return v == null;
}


const $0e26e6e5babece3e$export$ed808ff6ecd39e8d = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;


/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $ba19b54b42cdef0e$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean(typeof v === "string" && (0, $0e26e6e5babece3e$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && !(0, $6d54fb496a9ff5f4$export$b931b78cbb3caf86)(v) && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $ba19b54b42cdef0e$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (typeof v !== "string") return v;
        const [a, b, c, alpha] = v.match((0, $16d80d5fb8f921ef$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $e9667985f15d8b60$var$clampRgbUnit = (v)=>(0, $30bb3117a82170b4$export$7d15b64cf5a3a4c4)(0, 255, v);
const $e9667985f15d8b60$export$7a99c86b5b1f4c9e = {
    ...(0, $28ce2452c8c92de3$export$98e628dec113755e),
    transform: (v)=>Math.round($e9667985f15d8b60$var$clampRgbUnit(v))
};
const $e9667985f15d8b60$export$4e46ac54fc82cf3b = {
    test: /*@__PURE__*/ (0, $ba19b54b42cdef0e$export$2c8400d58aca05e)("rgb", "red"),
    parse: /*@__PURE__*/ (0, $ba19b54b42cdef0e$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $e9667985f15d8b60$export$7a99c86b5b1f4c9e.transform(red) + ", " + $e9667985f15d8b60$export$7a99c86b5b1f4c9e.transform(green) + ", " + $e9667985f15d8b60$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $e3a52c4e75385c2f$export$83d2e9e3e4ee39ed)((0, $28ce2452c8c92de3$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $4eef939f0e8ec87d$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $4eef939f0e8ec87d$export$834dfc94dde4b3d8 = {
    test: /*@__PURE__*/ (0, $ba19b54b42cdef0e$export$2c8400d58aca05e)("#"),
    parse: $4eef939f0e8ec87d$var$parseHex,
    transform: (0, $e9667985f15d8b60$export$4e46ac54fc82cf3b).transform
};






const $34b3b29b05ecaf20$export$810b04175080204c = {
    test: /*@__PURE__*/ (0, $ba19b54b42cdef0e$export$2c8400d58aca05e)("hsl", "hue"),
    parse: /*@__PURE__*/ (0, $ba19b54b42cdef0e$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $9e4fa4b20312155c$export$626336c2cd4b14de).transform((0, $e3a52c4e75385c2f$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $9e4fa4b20312155c$export$626336c2cd4b14de).transform((0, $e3a52c4e75385c2f$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $e3a52c4e75385c2f$export$83d2e9e3e4ee39ed)((0, $28ce2452c8c92de3$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



const $16b5f49e2c085406$export$35e9368ef982300f = {
    test: (v)=>(0, $e9667985f15d8b60$export$4e46ac54fc82cf3b).test(v) || (0, $4eef939f0e8ec87d$export$834dfc94dde4b3d8).test(v) || (0, $34b3b29b05ecaf20$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $e9667985f15d8b60$export$4e46ac54fc82cf3b).test(v)) return (0, $e9667985f15d8b60$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $34b3b29b05ecaf20$export$810b04175080204c).test(v)) return (0, $34b3b29b05ecaf20$export$810b04175080204c).parse(v);
        else return (0, $4eef939f0e8ec87d$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return typeof v === "string" ? v : v.hasOwnProperty("red") ? (0, $e9667985f15d8b60$export$4e46ac54fc82cf3b).transform(v) : (0, $34b3b29b05ecaf20$export$810b04175080204c).transform(v);
    },
    getAnimatableNone: (v)=>{
        const parsed = $16b5f49e2c085406$export$35e9368ef982300f.parse(v);
        parsed.alpha = 0;
        return $16b5f49e2c085406$export$35e9368ef982300f.transform(parsed);
    }
};


const $04700b73f4b41be2$export$740b69c5fad25dba = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;




function $bd4dae80ad095149$var$test(v) {
    return isNaN(v) && typeof v === "string" && (v.match((0, $16d80d5fb8f921ef$export$2444ca58c08448e4))?.length || 0) + (v.match((0, $04700b73f4b41be2$export$740b69c5fad25dba))?.length || 0) > 0;
}
const $bd4dae80ad095149$var$NUMBER_TOKEN = "number";
const $bd4dae80ad095149$var$COLOR_TOKEN = "color";
const $bd4dae80ad095149$var$VAR_TOKEN = "var";
const $bd4dae80ad095149$var$VAR_FUNCTION_TOKEN = "var(";
const $bd4dae80ad095149$var$SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
const $bd4dae80ad095149$var$complexRegex = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function $bd4dae80ad095149$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const values = [];
    const indexes = {
        color: [],
        number: [],
        var: []
    };
    const types = [];
    let i = 0;
    const tokenised = originalValue.replace($bd4dae80ad095149$var$complexRegex, (parsedValue)=>{
        if ((0, $16b5f49e2c085406$export$35e9368ef982300f).test(parsedValue)) {
            indexes.color.push(i);
            types.push($bd4dae80ad095149$var$COLOR_TOKEN);
            values.push((0, $16b5f49e2c085406$export$35e9368ef982300f).parse(parsedValue));
        } else if (parsedValue.startsWith($bd4dae80ad095149$var$VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push($bd4dae80ad095149$var$VAR_TOKEN);
            values.push(parsedValue);
        } else {
            indexes.number.push(i);
            types.push($bd4dae80ad095149$var$NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return $bd4dae80ad095149$var$SPLIT_TOKEN;
    });
    const split = tokenised.split($bd4dae80ad095149$var$SPLIT_TOKEN);
    return {
        values: values,
        split: split,
        indexes: indexes,
        types: types
    };
}
function $bd4dae80ad095149$var$parseComplexValue(v) {
    return $bd4dae80ad095149$export$b61fc7c44bf646d5(v).values;
}
function $bd4dae80ad095149$var$buildTransformer({ split: split, types: types }) {
    const numSections = split.length;
    return (v)=>{
        let output = "";
        for(let i = 0; i < numSections; i++){
            output += split[i];
            if (v[i] !== undefined) {
                const type = types[i];
                if (type === $bd4dae80ad095149$var$NUMBER_TOKEN) output += (0, $e3a52c4e75385c2f$export$83d2e9e3e4ee39ed)(v[i]);
                else if (type === $bd4dae80ad095149$var$COLOR_TOKEN) output += (0, $16b5f49e2c085406$export$35e9368ef982300f).transform(v[i]);
                else output += v[i];
            }
        }
        return output;
    };
}
function $bd4dae80ad095149$var$createTransformer(source) {
    return $bd4dae80ad095149$var$buildTransformer($bd4dae80ad095149$export$b61fc7c44bf646d5(source));
}
const $bd4dae80ad095149$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : (0, $16b5f49e2c085406$export$35e9368ef982300f).test(v) ? (0, $16b5f49e2c085406$export$35e9368ef982300f).getAnimatableNone(v) : v;
/**
 * Convert a parsed value to its zero equivalent, but preserve numbers
 * that act as divisors in CSS calc() expressions.
 *
 * analyseComplexValue extracts numbers from CSS strings and puts the
 * surrounding text into a `split` template array. For example:
 *   "calc(var(--gap) / 5)"  →  values: [var(--gap), 5]
 *                               split:  ["calc(", " / ", ")"]
 *
 * When building a zero-equivalent for animation, naively zeroing all
 * numbers turns the divisor into 0 → "calc(var(--gap) / 0)" → NaN.
 * We detect this by checking whether the text preceding a number
 * (split[i]) ends with "/" — the CSS calc division operator.
 */ const $bd4dae80ad095149$var$convertToZero = (value, splitBefore)=>{
    if (typeof value === "number") return splitBefore?.trim().endsWith("/") ? value : 0;
    return $bd4dae80ad095149$var$convertNumbersToZero(value);
};
function $bd4dae80ad095149$var$getAnimatableNone(v) {
    const info = $bd4dae80ad095149$export$b61fc7c44bf646d5(v);
    const transformer = $bd4dae80ad095149$var$buildTransformer(info);
    return transformer(info.values.map((value, i)=>$bd4dae80ad095149$var$convertToZero(value, info.split[i])));
}
const $bd4dae80ad095149$export$83a0e34f1302825b = {
    test: $bd4dae80ad095149$var$test,
    parse: $bd4dae80ad095149$var$parseComplexValue,
    createTransformer: $bd4dae80ad095149$var$createTransformer,
    getAnimatableNone: $bd4dae80ad095149$var$getAnimatableNone
};





/**
 * Properties that should default to 1 or 100%
 */ const $18e27dda09e79540$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $18e27dda09e79540$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $16d80d5fb8f921ef$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $18e27dda09e79540$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $18e27dda09e79540$var$functionRegex = /\b([a-z-]*)\(.*?\)/gu;
const $18e27dda09e79540$export$3dea766d36a8935f = {
    ...(0, $bd4dae80ad095149$export$83a0e34f1302825b),
    getAnimatableNone: (v)=>{
        const functions = v.match($18e27dda09e79540$var$functionRegex);
        return functions ? functions.map($18e27dda09e79540$var$applyDefaultFilter).join(" ") : v;
    }
};



const $6b44e6e72f45faed$export$d99f0801a68bbcf1 = {
    ...(0, $bd4dae80ad095149$export$83a0e34f1302825b),
    getAnimatableNone: (v)=>{
        const parsed = (0, $bd4dae80ad095149$export$83a0e34f1302825b).parse(v);
        const transformer = (0, $bd4dae80ad095149$export$83a0e34f1302825b).createTransformer(v);
        return transformer(parsed.map((v)=>typeof v === "number" ? 0 : typeof v === "object" ? {
                ...v,
                alpha: 1
            } : v));
    }
};






const $da2e941d387d2a3e$export$7d260a2a5f8bc19e = {
    ...(0, $28ce2452c8c92de3$export$98e628dec113755e),
    transform: Math.round
};






const $cde97f498b052526$export$f2e4285fee37e26 = {
    rotate: (0, $9e4fa4b20312155c$export$41fc368e1a942b97),
    /**
     * Internal channel for `transition.path` orientToPath. Composed onto
     * `rotate` at the transform-build sites so the user's `rotate` is
     * never read or overwritten. Not part of `transformPropOrder`.
     */ pathRotation: (0, $9e4fa4b20312155c$export$41fc368e1a942b97),
    rotateX: (0, $9e4fa4b20312155c$export$41fc368e1a942b97),
    rotateY: (0, $9e4fa4b20312155c$export$41fc368e1a942b97),
    rotateZ: (0, $9e4fa4b20312155c$export$41fc368e1a942b97),
    scale: $28ce2452c8c92de3$export$dcdf75081b88279d,
    scaleX: (0, $28ce2452c8c92de3$export$dcdf75081b88279d),
    scaleY: (0, $28ce2452c8c92de3$export$dcdf75081b88279d),
    scaleZ: (0, $28ce2452c8c92de3$export$dcdf75081b88279d),
    skew: (0, $9e4fa4b20312155c$export$41fc368e1a942b97),
    skewX: (0, $9e4fa4b20312155c$export$41fc368e1a942b97),
    skewY: (0, $9e4fa4b20312155c$export$41fc368e1a942b97),
    distance: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    translateX: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    translateY: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    translateZ: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    x: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    y: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    z: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    perspective: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    transformPerspective: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    opacity: (0, $28ce2452c8c92de3$export$58f0f39f63f3cf42),
    originX: (0, $9e4fa4b20312155c$export$44e2e1705876d7ed),
    originY: (0, $9e4fa4b20312155c$export$44e2e1705876d7ed),
    originZ: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008)
};


const $b25fc8af8fd91cde$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    borderTopWidth: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    borderRightWidth: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    borderRadius: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    maxWidth: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    height: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    maxHeight: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    top: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    right: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    bottom: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    left: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    inset: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    insetBlock: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    insetBlockStart: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    insetBlockEnd: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    insetInline: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    insetInlineStart: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    insetInlineEnd: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    paddingTop: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    paddingRight: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    paddingBottom: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    paddingLeft: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    paddingBlock: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    paddingBlockStart: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    paddingBlockEnd: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    paddingInline: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    paddingInlineStart: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    paddingInlineEnd: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    margin: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    marginTop: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    marginRight: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    marginBottom: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    marginLeft: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    marginBlock: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    marginBlockStart: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    marginBlockEnd: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    marginInline: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    marginInlineStart: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    marginInlineEnd: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    // Typography
    fontSize: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    // Misc
    backgroundPositionX: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    backgroundPositionY: (0, $9e4fa4b20312155c$export$91c0eda1d06bf008),
    ...(0, $cde97f498b052526$export$f2e4285fee37e26),
    zIndex: (0, $da2e941d387d2a3e$export$7d260a2a5f8bc19e),
    // SVG
    fillOpacity: (0, $28ce2452c8c92de3$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $28ce2452c8c92de3$export$58f0f39f63f3cf42),
    numOctaves: (0, $da2e941d387d2a3e$export$7d260a2a5f8bc19e)
};


/**
 * A map of default value types for common values
 */ const $d55b63c959885d17$export$98cd7c72c5a731fb = {
    ...(0, $b25fc8af8fd91cde$export$eec14432cd1cb67b),
    color: // Color props
    $16b5f49e2c085406$export$35e9368ef982300f,
    backgroundColor: (0, $16b5f49e2c085406$export$35e9368ef982300f),
    outlineColor: (0, $16b5f49e2c085406$export$35e9368ef982300f),
    fill: (0, $16b5f49e2c085406$export$35e9368ef982300f),
    stroke: (0, $16b5f49e2c085406$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $16b5f49e2c085406$export$35e9368ef982300f),
    borderTopColor: (0, $16b5f49e2c085406$export$35e9368ef982300f),
    borderRightColor: (0, $16b5f49e2c085406$export$35e9368ef982300f),
    borderBottomColor: (0, $16b5f49e2c085406$export$35e9368ef982300f),
    borderLeftColor: (0, $16b5f49e2c085406$export$35e9368ef982300f),
    filter: $18e27dda09e79540$export$3dea766d36a8935f,
    WebkitFilter: (0, $18e27dda09e79540$export$3dea766d36a8935f),
    mask: $6b44e6e72f45faed$export$d99f0801a68bbcf1,
    WebkitMask: (0, $6b44e6e72f45faed$export$d99f0801a68bbcf1)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $d55b63c959885d17$export$67d1babe0338d23b = (key)=>$d55b63c959885d17$export$98cd7c72c5a731fb[key];


const $236aa77bd269cade$var$customTypes = /*@__PURE__*/ new Set([
    (0, $18e27dda09e79540$export$3dea766d36a8935f),
    (0, $6b44e6e72f45faed$export$d99f0801a68bbcf1)
]);
function $236aa77bd269cade$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $d55b63c959885d17$export$67d1babe0338d23b)(key);
    if (!$236aa77bd269cade$var$customTypes.has(defaultValueType)) defaultValueType = (0, $bd4dae80ad095149$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}


/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */ const $c120f2b26b875b33$var$invalidTemplates = new Set([
    "auto",
    "none",
    "0"
]);
function $c120f2b26b875b33$export$8cc4958f8e540f37(unresolvedKeyframes, noneKeyframeIndexes, name) {
    let i = 0;
    let animatableTemplate = undefined;
    while(i < unresolvedKeyframes.length && !animatableTemplate){
        const keyframe = unresolvedKeyframes[i];
        if (typeof keyframe === "string" && !$c120f2b26b875b33$var$invalidTemplates.has(keyframe) && (0, $bd4dae80ad095149$export$b61fc7c44bf646d5)(keyframe).values.length) animatableTemplate = unresolvedKeyframes[i];
        i++;
    }
    if (animatableTemplate && name) for (const noneIndex of noneKeyframeIndexes)unresolvedKeyframes[noneIndex] = (0, $236aa77bd269cade$export$cea0cedcb94873b5)(name, animatableTemplate);
}



class $4122ffdcead494af$export$4983792d11b61017 extends (0, $22e7011c70149f46$export$74d34ca3182f1750) {
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, element: element, name: name } = this;
        if (!element || !element.current) return;
        super.readKeyframes();
        /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */ for(let i = 0; i < unresolvedKeyframes.length; i++){
            let keyframe = unresolvedKeyframes[i];
            if (typeof keyframe === "string") {
                keyframe = keyframe.trim();
                if ((0, $7a9371b51650a71c$export$31f9caa2600b5723)(keyframe)) {
                    const resolved = (0, $feb2bebc49ce9f3d$export$289398774300c991)(keyframe, element.current);
                    if (resolved !== undefined) unresolvedKeyframes[i] = resolved;
                    if (i === unresolvedKeyframes.length - 1) this.finalKeyframe = keyframe;
                }
            }
        }
        /**
         * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
         * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
         * have a far bigger performance impact.
         */ this.resolveNoneKeyframes();
        /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */ if (!(0, $6c578834c45b15a9$export$c66c0d5db2a205d).has(name) || unresolvedKeyframes.length !== 2) return;
        const [origin, target] = unresolvedKeyframes;
        const originType = (0, $6a9df0f0656297d2$export$eefdd52e3ccae428)(origin);
        const targetType = (0, $6a9df0f0656297d2$export$eefdd52e3ccae428)(target);
        /**
         * If one keyframe contains embedded CSS variables (e.g. in calc()) and the other
         * doesn't, we need to measure to convert to pixels. This handles GitHub issue #3410.
         */ const originHasVar = (0, $7a9371b51650a71c$export$df8f90ab5d0b05fa)(origin);
        const targetHasVar = (0, $7a9371b51650a71c$export$df8f90ab5d0b05fa)(target);
        if (originHasVar !== targetHasVar && (0, $1f4b975191a25b78$export$781d46a8aa670d52)[name]) {
            this.needsMeasurement = true;
            return;
        }
        /**
         * Either we don't recognise these value types or we can animate between them.
         */ if (originType === targetType) return;
        /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */ if ((0, $1f4b975191a25b78$export$8e5250d1aa9bf370)(originType) && (0, $1f4b975191a25b78$export$8e5250d1aa9bf370)(targetType)) for(let i = 0; i < unresolvedKeyframes.length; i++){
            const value = unresolvedKeyframes[i];
            if (typeof value === "string") unresolvedKeyframes[i] = parseFloat(value);
        }
        else if ((0, $1f4b975191a25b78$export$781d46a8aa670d52)[name]) /**
             * Else, the only way to resolve this is by measuring the element.
             */ this.needsMeasurement = true;
    }
    resolveNoneKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        const noneKeyframeIndexes = [];
        for(let i = 0; i < unresolvedKeyframes.length; i++)if (unresolvedKeyframes[i] === null || (0, $f465330bcfc0dfac$export$e56af863d5645d5f)(unresolvedKeyframes[i])) noneKeyframeIndexes.push(i);
        if (noneKeyframeIndexes.length) (0, $c120f2b26b875b33$export$8cc4958f8e540f37)(unresolvedKeyframes, noneKeyframeIndexes, name);
    }
    measureInitialState() {
        const { element: element, unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        if (!element || !element.current) return;
        if (name === "height") this.suspendedScrollY = window.pageYOffset;
        this.measuredOrigin = (0, $1f4b975191a25b78$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        unresolvedKeyframes[0] = this.measuredOrigin;
        // Set final key frame to measure after next render
        const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
        if (measureKeyframe !== undefined) element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
    }
    measureEndState() {
        const { element: element, name: name, unresolvedKeyframes: unresolvedKeyframes } = this;
        if (!element || !element.current) return;
        const value = element.getValue(name);
        value && value.jump(this.measuredOrigin, false);
        const finalKeyframeIndex = unresolvedKeyframes.length - 1;
        const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
        unresolvedKeyframes[finalKeyframeIndex] = (0, $1f4b975191a25b78$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        if (finalKeyframe !== null && this.finalKeyframe === undefined) this.finalKeyframe = finalKeyframe;
        // If we removed transform values, reapply them before the next render
        if (this.removedTransforms?.length) this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue])=>{
            element.getValue(unsetTransformName).set(unsetTransformValue);
        });
        this.resolveNoneKeyframes();
    }
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element){
        super(unresolvedKeyframes, onComplete, name, motionValue, element, true);
    }
}


/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ /*#__NO_SIDE_EFFECTS__*/ const $8c69a35cd8e97a0e$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
/*#__NO_SIDE_EFFECTS__*/ const $8c69a35cd8e97a0e$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;

function $ac9e1874010206ff$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $ac9e1874010206ff$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $ac9e1874010206ff$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


class $c4eb4b324793743d$export$e7dff9482a5fd23c {
    add(handler) {
        (0, $ac9e1874010206ff$export$20e507e47fae79fd)(this.subscriptions, handler);
        return ()=>(0, $ac9e1874010206ff$export$fe2d9b4e03920b4c)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
    constructor(){
        this.subscriptions = [];
    }
}




const $9a4f03c441e5ce3b$export$c9f584638d388483 = (name)=>name.startsWith("--");


function $7d17a81e5fded5cd$export$37a5fde709c1db82(element, name, value) {
    (0, $9a4f03c441e5ce3b$export$c9f584638d388483)(name) ? element.style.setProperty(name, value) : element.style[name] = value;
}


/*#__NO_SIDE_EFFECTS__*/ function $14639c1e88dc2b50$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}


/**
 * Add the ability for test suites to manually set support flags
 * to better test more environments.
 */ const $bd0cf4030f079b89$export$e3ad02c335474dee = {};


function $d5fc0b98e4387233$export$1964673d5ec13c3a(callback, supportsFlag) {
    const memoized = (0, $14639c1e88dc2b50$export$7c73462e0d25e514)(callback);
    return ()=>(0, $bd0cf4030f079b89$export$e3ad02c335474dee)[supportsFlag] ?? memoized();
}


const $3f9a599698bdb8d8$export$20d68f04f30763a5 = /* @__PURE__ */ (0, $d5fc0b98e4387233$export$1964673d5ec13c3a)(()=>window.ScrollTimeline !== undefined, "scrollTimeline");
const $3f9a599698bdb8d8$export$206321d8c5f8fd38 = /* @__PURE__ */ (0, $d5fc0b98e4387233$export$1964673d5ec13c3a)(()=>window.ViewTimeline !== undefined, "viewTimeline");


const $72239d9463d4dc67$var$isNotNull = (value)=>value !== null;
function $72239d9463d4dc67$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }, finalKeyframe, speed = 1) {
    const resolvedKeyframes = keyframes.filter($72239d9463d4dc67$var$isNotNull);
    const useFirstKeyframe = speed < 0 || repeat && repeatType !== "loop" && repeat % 2 === 1;
    const index = useFirstKeyframe ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}


class $cf5f10bff69b6976$export$655db786091c33e0 {
    get finished() {
        return this._finished;
    }
    updateFinished() {
        this._finished = new Promise((resolve)=>{
            this.resolve = resolve;
        });
    }
    notifyFinished() {
        this.resolve();
    }
    /**
     * Allows the animation to be awaited.
     *
     * @deprecated Use `finished` instead.
     */ then(onResolve, onReject) {
        return this.finished.then(onResolve, onReject);
    }
    constructor(){
        this.updateFinished();
    }
}


const $2ac10515ff3039be$export$d921fb2475e2900c = {
    layout: 0,
    mainThread: 0,
    waapi: 0
};



/*#__NO_SIDE_EFFECTS__*/ const $9abbf8f7fcfa8eac$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";



const $50ebe79380e53e0a$export$866c1d07a1ac2ab = /*@__PURE__*/ (0, $d5fc0b98e4387233$export$1964673d5ec13c3a)(()=>{
    try {
        document.createElement("div").animate({
            opacity: 0
        }, {
            easing: "linear(0, 1)"
        });
    } catch (e) {
        return false;
    }
    return true;
}, "linearEasing");


const $b47a4d242577a65f$export$66d3851e2b1ec912 = (easing, duration, resolution = 10 // as milliseconds
)=>{
    let points = "";
    const numPoints = Math.max(Math.round(duration / resolution), 2);
    for(let i = 0; i < numPoints; i++)points += Math.round(easing(i / (numPoints - 1)) * 10000) / 10000 + ", ";
    return `linear(${points.substring(0, points.length - 2)})`;
};


const $24e8937db5237467$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;



const $93cf0475eed23869$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: /*@__PURE__*/ (0, $24e8937db5237467$export$2523b8f0bd8f44cb)([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: /*@__PURE__*/ (0, $24e8937db5237467$export$2523b8f0bd8f44cb)([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: /*@__PURE__*/ (0, $24e8937db5237467$export$2523b8f0bd8f44cb)([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: /*@__PURE__*/ (0, $24e8937db5237467$export$2523b8f0bd8f44cb)([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};


function $20a06b1e8430a587$export$916ea73bcd3a6030(easing, duration) {
    if (!easing) return undefined;
    else if (typeof easing === "function") return (0, $50ebe79380e53e0a$export$866c1d07a1ac2ab)() ? (0, $b47a4d242577a65f$export$66d3851e2b1ec912)(easing, duration) : "ease-out";
    else if ((0, $9abbf8f7fcfa8eac$export$ff43f99925d7366b)(easing)) return (0, $24e8937db5237467$export$2523b8f0bd8f44cb)(easing);
    else if (Array.isArray(easing)) return easing.map((segmentEasing)=>$20a06b1e8430a587$export$916ea73bcd3a6030(segmentEasing, duration) || (0, $93cf0475eed23869$export$2cf569f5e2221176).easeOut);
    else return (0, $93cf0475eed23869$export$2cf569f5e2221176)[easing];
}


function $d1855fb9fd25799c$export$d896de52f97cb615(element, valueName, keyframes, { delay: delay = 0, duration: duration = 300, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease = "easeOut", times: times } = {}, pseudoElement) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $20a06b1e8430a587$export$916ea73bcd3a6030)(ease, duration);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    if ((0, $a9d4288c548593bd$export$84ce9a476f53d110).value) (0, $2ac10515ff3039be$export$d921fb2475e2900c).waapi++;
    const options = {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    };
    if (pseudoElement) options.pseudoElement = pseudoElement;
    const animation = element.animate(keyframeOptions, options);
    if ((0, $a9d4288c548593bd$export$84ce9a476f53d110).value) animation.finished.finally(()=>{
        (0, $2ac10515ff3039be$export$d921fb2475e2900c).waapi--;
    });
    return animation;
}



function $f98aaa7bcf02649c$export$6ab7812f1bac68be(type) {
    return typeof type === "function" && "applyToOptions" in type;
}


function $ce8f9d625671d889$export$a31269144d66b4a({ type: type, ...options }) {
    if ((0, $f98aaa7bcf02649c$export$6ab7812f1bac68be)(type) && (0, $50ebe79380e53e0a$export$866c1d07a1ac2ab)()) return type.applyToOptions(options);
    else {
        options.duration ?? (options.duration = 300);
        options.ease ?? (options.ease = "easeOut");
    }
    return options;
}


/**
 * NativeAnimation implements AnimationPlaybackControls for the browser's Web Animations API.
 */ class $9c8050a79f839804$export$6c0f9803d8aa7219 extends (0, $cf5f10bff69b6976$export$655db786091c33e0) {
    play() {
        if (this.isStopped) return;
        this.manualStartTime = null;
        this.animation.play();
        if (this.state === "finished") this.updateFinished();
    }
    pause() {
        this.animation.pause();
    }
    complete() {
        this.animation.finish?.();
    }
    cancel() {
        try {
            this.animation.cancel();
        } catch (e) {}
    }
    stop() {
        if (this.isStopped) return;
        this.isStopped = true;
        const { state: state } = this;
        if (state === "idle" || state === "finished") return;
        if (this.updateMotionValue) this.updateMotionValue();
        else this.commitStyles();
        if (!this.isPseudoElement) this.cancel();
    }
    /**
     * WAAPI doesn't natively have any interruption capabilities.
     *
     * In this method, we commit styles back to the DOM before cancelling
     * the animation.
     *
     * This is designed to be overridden by NativeAnimationExtended, which
     * will create a renderless JS animation and sample it twice to calculate
     * its current value, "previous" value, and therefore allow
     * Motion to also correctly calculate velocity for any subsequent animation
     * while deferring the commit until the next animation frame.
     */ commitStyles() {
        const element = this.options?.element;
        if (!this.isPseudoElement && element?.isConnected) this.animation.commitStyles?.();
    }
    get duration() {
        const duration = this.animation.effect?.getComputedTiming?.().duration || 0;
        return (0, $8c69a35cd8e97a0e$export$f64c3bfbc58eec0f)(Number(duration));
    }
    get iterationDuration() {
        const { delay: delay = 0 } = this.options || {};
        return this.duration + (0, $8c69a35cd8e97a0e$export$f64c3bfbc58eec0f)(delay);
    }
    get time() {
        return (0, $8c69a35cd8e97a0e$export$f64c3bfbc58eec0f)(Number(this.animation.currentTime) || 0);
    }
    set time(newTime) {
        const wasFinished = this.finishedTime !== null;
        this.manualStartTime = null;
        this.finishedTime = null;
        this.animation.currentTime = (0, $8c69a35cd8e97a0e$export$fc3e7e8557f8c8c7)(newTime);
        if (wasFinished) this.animation.pause();
    }
    /**
     * The playback speed of the animation.
     * 1 = normal speed, 2 = double speed, 0.5 = half speed.
     */ get speed() {
        return this.animation.playbackRate;
    }
    set speed(newSpeed) {
        // Allow backwards playback after finishing
        if (newSpeed < 0) this.finishedTime = null;
        this.animation.playbackRate = newSpeed;
    }
    get state() {
        return this.finishedTime !== null ? "finished" : this.animation.playState;
    }
    get startTime() {
        return this.manualStartTime ?? Number(this.animation.startTime);
    }
    set startTime(newStartTime) {
        this.manualStartTime = this.animation.startTime = newStartTime;
    }
    /**
     * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
     */ attachTimeline({ timeline: timeline, rangeStart: rangeStart, rangeEnd: rangeEnd, observe: observe }) {
        if (this.allowFlatten) this.animation.effect?.updateTiming({
            easing: "linear"
        });
        this.animation.onfinish = null;
        if (timeline && (0, $3f9a599698bdb8d8$export$20d68f04f30763a5)()) {
            this.animation.timeline = timeline;
            if (rangeStart) this.animation.rangeStart = rangeStart;
            if (rangeEnd) this.animation.rangeEnd = rangeEnd;
            return 0, $df2228348c5a149c$export$8793edee2d425525;
        } else return observe(this);
    }
    constructor(options){
        super();
        this.finishedTime = null;
        this.isStopped = false;
        /**
         * Tracks a manually-set start time that takes precedence over WAAPI's
         * dynamic startTime. This is cleared when play() or time setter is called,
         * allowing WAAPI to take over timing.
         */ this.manualStartTime = null;
        if (!options) return;
        const { element: element, name: name, keyframes: keyframes, pseudoElement: pseudoElement, allowFlatten: allowFlatten = false, finalKeyframe: finalKeyframe, onComplete: onComplete } = options;
        this.isPseudoElement = Boolean(pseudoElement);
        this.allowFlatten = allowFlatten;
        this.options = options;
        (0, $8a16204eb729eee3$export$f5708dca728d7177)(typeof options.type !== "string", `Mini animate() doesn't support "type" as a string.`, "mini-spring");
        const transition = (0, $ce8f9d625671d889$export$a31269144d66b4a)(options);
        this.animation = (0, $d1855fb9fd25799c$export$d896de52f97cb615)(element, name, keyframes, transition, pseudoElement);
        if (transition.autoplay === false) this.animation.pause();
        this.animation.onfinish = ()=>{
            this.finishedTime = this.time;
            if (!pseudoElement) {
                const keyframe = (0, $72239d9463d4dc67$export$14de59408fad90b)(keyframes, this.options, finalKeyframe, this.speed);
                if (this.updateMotionValue) this.updateMotionValue(keyframe);
                /**
                 * If we can, we want to commit the final style as set by the user,
                 * rather than the computed keyframe value supplied by the animation.
                 * We always do this, even when a motion value is present, to prevent
                 * a visual flash in Firefox where the WAAPI animation's fill is removed
                 * during cancel() before the scheduled render can apply the correct value.
                 */ (0, $7d17a81e5fded5cd$export$37a5fde709c1db82)(element, name, keyframe);
                this.animation.cancel();
            }
            onComplete?.();
            this.notifyFinished();
        };
    }
}


/**
 * A list of values that can be hardware-accelerated.
 */ const $84840151a90d6487$export$a27eefbd8fb5e404 = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform"
]);



const { schedule: $073347fc5f8d46b9$export$bb76eed83315504c, cancel: $073347fc5f8d46b9$export$3252729004b8456e } = /* @__PURE__ */ (0, $010d1e62b8d86088$export$510b0596a933801a)(queueMicrotask, false);




let $08568323a95fcb6c$var$now;
function $08568323a95fcb6c$var$clearTime() {
    $08568323a95fcb6c$var$now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */ const $08568323a95fcb6c$export$2da9be4cfdb689b1 = {
    now: ()=>{
        if ($08568323a95fcb6c$var$now === undefined) $08568323a95fcb6c$export$2da9be4cfdb689b1.set((0, $99c45f49fc7b5e17$export$fff89137e9e818ce).isProcessing || (0, $dcfd83e0153bc5a7$export$dd826089e3c5e502).useManualTiming ? (0, $99c45f49fc7b5e17$export$fff89137e9e818ce).timestamp : performance.now());
        return $08568323a95fcb6c$var$now;
    },
    set: (newTime)=>{
        $08568323a95fcb6c$var$now = newTime;
        queueMicrotask($08568323a95fcb6c$var$clearTime);
    }
};


const $8719be7ef375b7e3$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $8719be7ef375b7e3$export$3d227df54007d73a = ()=>({
        x: $8719be7ef375b7e3$export$ff25708b37f72782(),
        y: $8719be7ef375b7e3$export$ff25708b37f72782()
    });
const $8719be7ef375b7e3$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $8719be7ef375b7e3$export$6459fc9e86be362e = ()=>({
        x: $8719be7ef375b7e3$export$6db76765312617ac(),
        y: $8719be7ef375b7e3$export$6db76765312617ac()
    });


/*
  Convert velocity into velocity per second
*/ /*#__NO_SIDE_EFFECTS__*/ const $77cedc7ab71c951f$export$eab0632f7ad4f9d7 = (velocity, frameDuration)=>frameDuration ? velocity * (1000 / frameDuration) : 0;




/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */ const $273b0f90a77f315f$var$MAX_VELOCITY_DELTA = 30;
const $273b0f90a77f315f$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $273b0f90a77f315f$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $273b0f90a77f315f$export$8cea36d14ee64562 {
    setCurrent(current) {
        this.current = current;
        this.updatedAt = (0, $08568323a95fcb6c$export$2da9be4cfdb689b1).now();
        if (this.canTrackVelocity === null && current !== undefined) this.canTrackVelocity = $273b0f90a77f315f$var$isFloat(this.current);
    }
    setPrevFrameValue(prevFrameValue = this.current) {
        this.prevFrameValue = prevFrameValue;
        this.prevUpdatedAt = this.updatedAt;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $c4eb4b324793743d$export$e7dff9482a5fd23c)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $99c45f49fc7b5e17$export$2cef06c20297c17d).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v) {
        if (!this.passiveEffect) this.updateAndNotify(v);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = undefined;
        this.prevFrameValue = prev;
        this.prevUpdatedAt = this.updatedAt - delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v, endAnimation = true) {
        this.updateAndNotify(v);
        this.prev = v;
        this.prevUpdatedAt = this.prevFrameValue = undefined;
        endAnimation && this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    dirty() {
        this.events.change?.notify(this.current);
    }
    addDependent(dependent) {
        if (!this.dependents) this.dependents = new Set();
        this.dependents.add(dependent);
    }
    removeDependent(dependent) {
        if (this.dependents) this.dependents.delete(dependent);
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($273b0f90a77f315f$export$67fcd818a264039d.current) $273b0f90a77f315f$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        const currentTime = (0, $08568323a95fcb6c$export$2da9be4cfdb689b1).now();
        if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > $273b0f90a77f315f$var$MAX_VELOCITY_DELTA) return 0;
        const delta = Math.min(this.updatedAt - this.prevUpdatedAt, $273b0f90a77f315f$var$MAX_VELOCITY_DELTA);
        // Casts because of parseFloat's poor typing
        return (0, $77cedc7ab71c951f$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.dependents?.clear();
        this.events.destroy?.notify();
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     */ constructor(init, options = {}){
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = null;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v)=>{
            const currentTime = (0, $08568323a95fcb6c$export$2da9be4cfdb689b1).now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */ if (this.updatedAt !== currentTime) this.setPrevFrameValue();
            this.prev = this.current;
            this.setCurrent(v);
            // Update update subscribers
            if (this.current !== this.prev) {
                this.events.change?.notify(this.current);
                if (this.dependents) for (const dependent of this.dependents)dependent.dirty();
            }
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.owner = options.owner;
    }
}
function $273b0f90a77f315f$export$ce8bdc721e76545f(init, options) {
    return new $273b0f90a77f315f$export$8cea36d14ee64562(init, options);
}








/**
 * A list of all ValueTypes
 */ const $f1ef732a60901700$var$valueTypes = [
    ...(0, $6a9df0f0656297d2$export$d176691c1998a1f5),
    (0, $16b5f49e2c085406$export$35e9368ef982300f),
    (0, $bd4dae80ad095149$export$83a0e34f1302825b)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $f1ef732a60901700$export$950e7e59ea1ffed7 = (v)=>$f1ef732a60901700$var$valueTypes.find((0, $dbfd278086675303$export$6eae4d0a6a7ca7cd)(v));



const $228619a30364a4fb$export$bc2a978a17abfdde = new WeakMap();


function $f6c92e10f2e25836$export$aa71198ceeaf53ce(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}


/**
 * Decides if the supplied variable is variant label
 */ function $2ce69ad985562542$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}


const $b987648e534a47ff$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $b987648e534a47ff$export$1405a65085f40b9 = [
    "initial",
    ...$b987648e534a47ff$export$16e45afcc206d3a8
];


function $1c1117fe46ce7cc3$export$4b3c3bd8d910d78d(props) {
    return (0, $f6c92e10f2e25836$export$aa71198ceeaf53ce)(props.animate) || (0, $b987648e534a47ff$export$1405a65085f40b9).some((name)=>(0, $2ce69ad985562542$export$720b90e312cea233)(props[name]));
}
function $1c1117fe46ce7cc3$export$ce46fa4165cdec40(props) {
    return Boolean($1c1117fe46ce7cc3$export$4b3c3bd8d910d78d(props) || props.variants);
}





/**
 * Updates motion values from props changes.
 * Uses `any` type for element to avoid circular dependencies with VisualElement.
 */ function $c569d3a391523c16$export$9a552858d5197f6e(element, next, prev) {
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $5c2f00f5f770efa1$export$605d60a2578142d3)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $5c2f00f5f770efa1$export$605d60a2578142d3)(prevValue)) /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $273b0f90a77f315f$export$ce8bdc721e76545f)(nextValue, {
            owner: element
        }));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                if (existingValue.liveStyle === true) existingValue.jump(nextValue);
                else if (!existingValue.hasAnimated) existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $273b0f90a77f315f$export$ce8bdc721e76545f)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}


// Does this device prefer reduced motion? Returns `null` server-side.
const $b1fe882392fe243e$export$ff7706047246b98b = {
    current: null
};
const $b1fe882392fe243e$export$6476d16e2fd2d0db = {
    current: false
};


const $e661cb0259238a23$var$isBrowser = typeof window !== "undefined";
function $e661cb0259238a23$export$ca9f41fb23dded3d() {
    (0, $b1fe882392fe243e$export$6476d16e2fd2d0db).current = true;
    if (!$e661cb0259238a23$var$isBrowser) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $b1fe882392fe243e$export$ff7706047246b98b).current = motionMediaQuery.matches;
        motionMediaQuery.addEventListener("change", setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $b1fe882392fe243e$export$ff7706047246b98b).current = false;
}


function $ccb7954dd8fa45b5$var$getValueState(visualElement) {
    const state = [
        {},
        {}
    ];
    visualElement?.values.forEach((value, key)=>{
        state[0][key] = value.get();
        state[1][key] = value.getVelocity();
    });
    return state;
}
function $ccb7954dd8fa45b5$export$d68f140c4d9b48bc(props, definition, custom, visualElement) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") {
        const [current, velocity] = $ccb7954dd8fa45b5$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") {
        const [current, velocity] = $ccb7954dd8fa45b5$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    return definition;
}




const $c767192007352310$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
/**
 * Static feature definitions - can be injected by framework layer
 */ let $c767192007352310$var$featureDefinitions = {};
/**
 * Set feature definitions for all VisualElements.
 * This should be called by the framework layer (e.g., framer-motion) during initialization.
 */ function $c767192007352310$export$8ad214844176d967(definitions) {
    $c767192007352310$var$featureDefinitions = definitions;
}
/**
 * Get the current feature definitions
 */ function $c767192007352310$export$e183cb9c018608ba() {
    return $c767192007352310$var$featureDefinitions;
}
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $c767192007352310$export$fa8b653c0f3714e5 {
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
        return {};
    }
    mount(instance) {
        /**
         * If this element has been mounted before (e.g. after a Suspense
         * unmount/remount), reset motion values to their initial state
         * so animations replay correctly from initial → animate.
         */ if (this.hasBeenMounted) for(const key in this.initialValues){
            this.values.get(key)?.jump(this.initialValues[key]);
            this.latestValues[key] = this.initialValues[key];
        }
        this.current = instance;
        (0, $228619a30364a4fb$export$bc2a978a17abfdde).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        /**
         * Determine reduced motion preference. Only initialize the matchMedia
         * listener if we actually need the dynamic value (i.e., when config
         * is neither "never" nor "always").
         */ if (this.reducedMotionConfig === "never") this.shouldReduceMotion = false;
        else if (this.reducedMotionConfig === "always") this.shouldReduceMotion = true;
        else {
            if (!(0, $b1fe882392fe243e$export$6476d16e2fd2d0db).current) (0, $e661cb0259238a23$export$ca9f41fb23dded3d)();
            this.shouldReduceMotion = (0, $b1fe882392fe243e$export$ff7706047246b98b).current;
        }
        /**
         * Set whether animations should be skipped based on the config.
         */ this.shouldSkipAnimations = this.skipAnimationsConfig ?? false;
        this.parent?.addChild(this);
        this.update(this.props, this.presenceContext);
        this.hasBeenMounted = true;
    }
    unmount() {
        this.projection && this.projection.unmount();
        (0, $99c45f49fc7b5e17$export$ec99c0ef4978dccb)(this.notifyUpdate);
        (0, $99c45f49fc7b5e17$export$ec99c0ef4978dccb)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.valueSubscriptions.clear();
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent?.removeChild(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features){
            const feature = this.features[key];
            if (feature) {
                feature.unmount();
                feature.isMounted = false;
            }
        }
        this.current = null;
    }
    addChild(child) {
        this.children.add(child);
        this.enteringChildren ?? (this.enteringChildren = new Set());
        this.enteringChildren.add(child);
    }
    removeChild(child) {
        this.children.delete(child);
        this.enteringChildren && this.enteringChildren.delete(child);
    }
    bindToMotionValue(key, value) {
        if (this.valueSubscriptions.has(key)) this.valueSubscriptions.get(key)();
        if (value.accelerate && (0, $84840151a90d6487$export$a27eefbd8fb5e404).has(key) && this.current instanceof HTMLElement) {
            const { factory: factory, keyframes: keyframes, times: times, ease: ease, duration: duration } = value.accelerate;
            const animation = new (0, $9c8050a79f839804$export$6c0f9803d8aa7219)({
                element: this.current,
                name: key,
                keyframes: keyframes,
                times: times,
                ease: ease,
                duration: (0, $8c69a35cd8e97a0e$export$fc3e7e8557f8c8c7)(duration)
            });
            const cleanup = factory(animation);
            this.valueSubscriptions.set(key, ()=>{
                cleanup();
                animation.cancel();
            });
            return;
        }
        const valueIsTransform = (0, $36352b87224ae25e$export$7b42a0094fb00b6e).has(key);
        if (valueIsTransform && this.onBindTransform) this.onBindTransform();
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $99c45f49fc7b5e17$export$2cef06c20297c17d).preRender(this.notifyUpdate);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
            this.scheduleRender();
        });
        let removeSyncCheck;
        if (typeof window !== "undefined" && window.MotionCheckAppearSync) removeSyncCheck = window.MotionCheckAppearSync(this, key, value);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            if (removeSyncCheck) removeSyncCheck();
        // Defer to MotionValue.on("change") auto-stop so React 19 remounts
        // can resubscribe before the animation is cancelled (#3315).
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    updateFeatures() {
        let key = "animation";
        for(key in $c767192007352310$var$featureDefinitions){
            const featureDefinition = $c767192007352310$var$featureDefinitions[key];
            if (!featureDefinition) continue;
            const { isEnabled: isEnabled, Feature: FeatureConstructor } = featureDefinition;
            /**
             * If this feature is enabled but not active, make a new instance.
             */ if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) this.features[key] = new FeatureConstructor(this);
            /**
             * If we have a feature, mount or update it.
             */ if (this.features[key]) {
                const feature = this.features[key];
                if (feature.isMounted) feature.update();
                else {
                    feature.mount();
                    feature.isMounted = true;
                }
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $8719be7ef375b7e3$export$6459fc9e86be362e)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $c767192007352310$var$propEventHandlers.length; i++){
            const key = $c767192007352310$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listenerName = "on" + key;
            const listener = props[listenerName];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $c569d3a391523c16$export$9a552858d5197f6e)(this, this.scrapeMotionValuesFromProps(props, this.prevProps || {}, this), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        const existingValue = this.values.get(key);
        if (value !== existingValue) {
            if (existingValue) this.removeValue(key);
            this.bindToMotionValue(key, value);
            this.values.set(key, value);
            this.latestValues[key] = value.get();
        }
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $273b0f90a77f315f$export$ce8bdc721e76545f)(defaultValue === null ? undefined : defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key, target) {
        let value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : this.getBaseTargetFromProps(this.props, key) ?? this.readValueFromInstance(this.current, key, this.options);
        if (value !== undefined && value !== null) {
            if (typeof value === "string" && ((0, $46fc6ca0056ca4d1$export$65583ed5a868f2d9)(value) || (0, $c15154993d23bf7c$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
            else if (!(0, $f1ef732a60901700$export$950e7e59ea1ffed7)(value) && (0, $bd4dae80ad095149$export$83a0e34f1302825b).test(target)) value = (0, $236aa77bd269cade$export$cea0cedcb94873b5)(key, target);
            this.setBaseTarget(key, (0, $5c2f00f5f770efa1$export$605d60a2578142d3)(value) ? value.get() : value);
        }
        return (0, $5c2f00f5f770efa1$export$605d60a2578142d3)(value) ? value.get() : value;
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        const { initial: initial } = this.props;
        let valueFromInitial;
        if (typeof initial === "string" || typeof initial === "object") {
            const variant = (0, $ccb7954dd8fa45b5$export$d68f140c4d9b48bc)(this.props, initial, this.presenceContext?.custom);
            if (variant) valueFromInitial = variant[key];
        }
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $5c2f00f5f770efa1$export$605d60a2578142d3)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $c4eb4b324793743d$export$e7dff9482a5fd23c)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
    scheduleRenderMicrotask() {
        (0, $073347fc5f8d46b9$export$bb76eed83315504c).render(this.render);
    }
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, skipAnimations: skipAnimations, blockInitialAnimation: blockInitialAnimation, visualState: visualState }, options = {}){
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * Decides whether animations should be skipped for this VisualElement.
         * Useful for E2E tests and visual regression testing.
         */ this.shouldSkipAnimations = false;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        this.KeyframeResolver = (0, $22e7011c70149f46$export$74d34ca3182f1750);
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * Track whether this element has been mounted before, to detect
         * remounts after Suspense unmount/remount cycles.
         */ this.hasBeenMounted = false;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.renderScheduledAt = 0.0;
        this.scheduleRender = ()=>{
            const now = (0, $08568323a95fcb6c$export$2da9be4cfdb689b1).now();
            if (this.renderScheduledAt < now) {
                this.renderScheduledAt = now;
                (0, $99c45f49fc7b5e17$export$2cef06c20297c17d).render(this.render, false, true);
            }
        };
        const { latestValues: latestValues, renderState: renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.skipAnimationsConfig = skipAnimations;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = (0, $1c1117fe46ce7cc3$export$4b3c3bd8d910d78d)(props);
        this.isVariantNode = (0, $1c1117fe46ce7cc3$export$ce46fa4165cdec40)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't necessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {}, this);
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $5c2f00f5f770efa1$export$605d60a2578142d3)(value)) value.set(latestValues[key]);
        }
    }
}


class $0a9a8d9d630bcec1$export$e49735c2a366bdc7 extends (0, $c767192007352310$export$fa8b653c0f3714e5) {
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        const style = props.style;
        return style ? style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $5c2f00f5f770efa1$export$605d60a2578142d3)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
    constructor(){
        super(...arguments);
        this.KeyframeResolver = (0, $4122ffdcead494af$export$4983792d11b61017);
    }
}


/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $72efb9c3ae96b8cc$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};








const $1212c10686ee6b28$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $1212c10686ee6b28$var$numTransforms = (0, $36352b87224ae25e$export$280dc01950909d86).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $1212c10686ee6b28$export$bdc96e0d5c8f914(latestValues, transform, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    let transformIsDefault = true;
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $1212c10686ee6b28$var$numTransforms; i++){
        const key = (0, $36352b87224ae25e$export$280dc01950909d86)[i];
        const value = latestValues[key];
        if (value === undefined) continue;
        let valueIsDefault = true;
        if (typeof value === "number") valueIsDefault = value === (key.startsWith("scale") ? 1 : 0);
        else {
            const parsed = parseFloat(value);
            valueIsDefault = key.startsWith("scale") ? parsed === 1 : parsed === 0;
        }
        if (!valueIsDefault || transformTemplate) {
            const valueAsType = (0, $72efb9c3ae96b8cc$export$453ef540a9a1bd6b)(value, (0, $b25fc8af8fd91cde$export$eec14432cd1cb67b)[key]);
            if (!valueIsDefault) {
                transformIsDefault = false;
                const transformName = $1212c10686ee6b28$var$translateAlias[key] || key;
                transformString += `${transformName}(${valueAsType}) `;
            }
            if (transformTemplate) transform[key] = valueAsType;
        }
    }
    // `pathRotation` composes onto `rotate` as a separate additive term so
    // the user's `rotate` is never clobbered. Deliberately not a slot in
    // `transformPropOrder`.
    const pathRotation = latestValues.pathRotation;
    if (pathRotation) {
        transformIsDefault = false;
        transformString += `rotate(${(0, $72efb9c3ae96b8cc$export$453ef540a9a1bd6b)(pathRotation, (0, $b25fc8af8fd91cde$export$eec14432cd1cb67b).pathRotation)}) `;
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (transformIsDefault) transformString = "none";
    return transformString;
}


function $59e3de0eaa252cc3$export$bb517f8b40f8e99d(state, latestValues, transformTemplate) {
    const { style: style, vars: vars, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept separately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        if ((0, $36352b87224ae25e$export$7b42a0094fb00b6e).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            continue;
        } else if ((0, $7a9371b51650a71c$export$9de1236619d9e756)(key)) {
            vars[key] = value;
            continue;
        } else {
            // Convert the value to its default value type, ie 0 -> "0px"
            const valueAsType = (0, $72efb9c3ae96b8cc$export$453ef540a9a1bd6b)(value, (0, $b25fc8af8fd91cde$export$eec14432cd1cb67b)[key]);
            if (key.startsWith("origin")) {
                // If this is a transform origin, flag and enable further transform-origin processing
                hasTransformOrigin = true;
                transformOrigin[key] = valueAsType;
            } else style[key] = valueAsType;
        }
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $1212c10686ee6b28$export$bdc96e0d5c8f914)(latestValues, state.transform, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}


function $7b9d6bc4e7295613$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    const elementStyle = element.style;
    let key;
    for(key in style)// CSSStyleDeclaration has [index: number]: string; in the types, so we use that as key type.
    elementStyle[key] = style[key];
    // Write projection styles directly to element style
    projection?.applyProjectionStyles(elementStyle, styleProp);
    for(key in vars)// Loop over any CSS variables and assign those.
    // They can only be assigned using `setProperty`.
    elementStyle.setProperty(key, vars[key]);
}






function $7303774124a6d74b$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $7303774124a6d74b$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $9e4fa4b20312155c$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $7303774124a6d74b$export$fafff692be55225d(latest, node.target.x);
        const y = $7303774124a6d74b$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};




const $a8c36d98bfc86dce$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        const shadow = (0, $bd4dae80ad095149$export$83a0e34f1302825b).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $bd4dae80ad095149$export$83a0e34f1302825b).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $5a3532f8b2a8e80b$export$3bb0b4ff1037b8dd)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};


const $dbed2e9ad4f0fb29$export$91ddd985b97788d1 = {
    borderRadius: {
        ...(0, $7303774124a6d74b$export$5eafb6257a5844c),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, $7303774124a6d74b$export$5eafb6257a5844c),
    borderTopRightRadius: (0, $7303774124a6d74b$export$5eafb6257a5844c),
    borderBottomLeftRadius: (0, $7303774124a6d74b$export$5eafb6257a5844c),
    borderBottomRightRadius: (0, $7303774124a6d74b$export$5eafb6257a5844c),
    boxShadow: (0, $a8c36d98bfc86dce$export$eb0bc629e74dcf8)
};
function $dbed2e9ad4f0fb29$export$de9e7791c71225fd(correctors) {
    for(const key in correctors){
        $dbed2e9ad4f0fb29$export$91ddd985b97788d1[key] = correctors[key];
        if ((0, $7a9371b51650a71c$export$9de1236619d9e756)(key)) $dbed2e9ad4f0fb29$export$91ddd985b97788d1[key].isCSSVariable = true;
    }
}


function $8d96ae9b61209f6c$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $36352b87224ae25e$export$7b42a0094fb00b6e).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $dbed2e9ad4f0fb29$export$91ddd985b97788d1)[key] || key === "opacity");
}


function $48d0e82004f65075$export$16da615486abaa45(props, prevProps, visualElement) {
    const style = props.style;
    const prevStyle = prevProps?.style;
    const newValues = {};
    if (!style) return newValues;
    for(const key in style)if ((0, $5c2f00f5f770efa1$export$605d60a2578142d3)(style[key]) || prevStyle && (0, $5c2f00f5f770efa1$export$605d60a2578142d3)(prevStyle[key]) || (0, $8d96ae9b61209f6c$export$6d27ce8e3de1c3cf)(key, props) || visualElement?.getValue(key)?.liveStyle !== undefined) newValues[key] = style[key];
    return newValues;
}


function $5a7da86f893fb71e$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $5a7da86f893fb71e$export$23fea75b03ac16b3 extends (0, $0a9a8d9d630bcec1$export$e49735c2a366bdc7) {
    readValueFromInstance(instance, key) {
        if ((0, $36352b87224ae25e$export$7b42a0094fb00b6e).has(key)) return this.projection?.isProjecting ? (0, $e042a75e641eeb74$export$1f10c01143b9f089)(key) : (0, $e042a75e641eeb74$export$bcd97e0e03ba17f6)(instance, key);
        else {
            const computedStyle = $5a7da86f893fb71e$export$3735103072e4a80(instance);
            const value = ((0, $7a9371b51650a71c$export$9de1236619d9e756)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $0ba608e5edcfe666$export$d8718b6a7e5c624e)(instance, transformPagePoint);
    }
    build(renderState, latestValues, props) {
        (0, $59e3de0eaa252cc3$export$bb517f8b40f8e99d)(renderState, latestValues, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $48d0e82004f65075$export$16da615486abaa45)(props, prevProps, visualElement);
    }
    constructor(){
        super(...arguments);
        this.type = "html";
        this.renderInstance = (0, $7b9d6bc4e7295613$export$1a32bf6229c258c0);
    }
}





function $758fee5398ecdb01$export$9fd24a634729c672(str) {
    return str.replace(/([A-Z])/g, (match)=>`-${match.toLowerCase()}`);
}



const $0718cc9b371efc31$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $0718cc9b371efc31$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 *
 * Note: We use unitless values for stroke-dasharray and stroke-dashoffset
 * because Safari incorrectly scales px values when the page is zoomed.
 */ function $0718cc9b371efc31$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $0718cc9b371efc31$var$dashKeys : $0718cc9b371efc31$var$camelKeys;
    // Build the dash offset (unitless to avoid Safari zoom bug)
    attrs[keys.offset] = `${-offset}`;
    // Build the dash array (unitless to avoid Safari zoom bug)
    attrs[keys.array] = `${length} ${spacing}`;
}


/**
 * CSS Motion Path properties that should remain as CSS styles on SVG elements.
 */ const $ddde5c5d91c6280e$var$cssMotionPathProperties = [
    "offsetDistance",
    "offsetPath",
    "offsetRotate",
    "offsetAnchor"
];
/**
 * Build SVG visual attributes, like cx and style.transform
 */ function $ddde5c5d91c6280e$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, attrScale: attrScale, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, isSVGTag, transformTemplate, styleProp) {
    (0, $59e3de0eaa252cc3$export$bb517f8b40f8e99d)(state, latest, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style } = state;
    /**
     * However, we apply transforms as CSS transforms.
     * So if we detect a transform, transformOrigin we take it from attrs and copy it into style.
     */ if (attrs.transform) {
        style.transform = attrs.transform;
        delete attrs.transform;
    }
    if (style.transform || attrs.transformOrigin) {
        style.transformOrigin = attrs.transformOrigin ?? "50% 50%";
        delete attrs.transformOrigin;
    }
    if (style.transform) {
        /**
         * SVG's element transform-origin uses its own median as a reference.
         * Therefore, transformBox becomes a fill-box
         */ style.transformBox = styleProp?.transformBox ?? "fill-box";
        delete attrs.transformBox;
    }
    for (const key of $ddde5c5d91c6280e$var$cssMotionPathProperties)if (attrs[key] !== undefined) {
        style[key] = attrs[key];
        delete attrs[key];
    }
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $0718cc9b371efc31$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ const $b2ae1e46e61dcf50$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);


const $e3f757a10dc3d22d$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";





function $c3988d71de6125d7$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $7b9d6bc4e7295613$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $b2ae1e46e61dcf50$export$28931db5d57958e5).has(key) ? (0, $758fee5398ecdb01$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}





function $d2c40603d8a0b7dd$export$16da615486abaa45(props, prevProps, visualElement) {
    const newValues = (0, $48d0e82004f65075$export$16da615486abaa45)(props, prevProps, visualElement);
    for(const key in props)if ((0, $5c2f00f5f770efa1$export$605d60a2578142d3)(props[key]) || (0, $5c2f00f5f770efa1$export$605d60a2578142d3)(prevProps[key])) {
        const targetKey = (0, $36352b87224ae25e$export$280dc01950909d86).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}


class $95c0e86dc00a91eb$export$86bcdffbaf733d84 extends (0, $0a9a8d9d630bcec1$export$e49735c2a366bdc7) {
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $36352b87224ae25e$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $d55b63c959885d17$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $b2ae1e46e61dcf50$export$28931db5d57958e5).has(key) ? (0, $758fee5398ecdb01$export$9fd24a634729c672)(key) : key;
        return instance.getAttribute(key);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $d2c40603d8a0b7dd$export$16da615486abaa45)(props, prevProps, visualElement);
    }
    build(renderState, latestValues, props) {
        (0, $ddde5c5d91c6280e$export$5475d24f125d7053)(renderState, latestValues, this.isSVGTag, props.transformTemplate, props.style);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $c3988d71de6125d7$export$c5f8399d19a7394b)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $e3f757a10dc3d22d$export$6328ce7565ea1049)(instance.tagName);
        super.mount(instance);
    }
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
        this.measureInstanceViewportBox = (0, $8719be7ef375b7e3$export$6459fc9e86be362e);
    }
}



var $lDJXT = parcelRequire("lDJXT");
/**
 * We keep these listed separately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $fde482068af1a632$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];


function $1a93bf402f02661b$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $fde482068af1a632$export$40209c4c512158e6).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/u.test(Component)) return true;
    return false;
}


const $49c295e100cc1fa8$export$56ba0183203348f5 = (Component, options)=>{
    /**
     * Use explicit isSVG override if provided, otherwise auto-detect
     */ const isSVG = options.isSVG ?? (0, $1a93bf402f02661b$export$88f3fc2fd3766989)(Component);
    return isSVG ? new (0, $95c0e86dc00a91eb$export$86bcdffbaf733d84)(options) : new (0, $5a7da86f893fb71e$export$23fea75b03ac16b3)(options, {
        allowProjection: Component !== (0, $lDJXT.Fragment)
    });
};






var $lDJXT = parcelRequire("lDJXT");

var $lDJXT = parcelRequire("lDJXT");
"use client";
const $23a1c66422693cdf$export$a3579ca508007a95 = (0, $lDJXT.createContext)({});



var $lDJXT = parcelRequire("lDJXT");
"use client";
const $e898c547a0d3c47f$export$40f10139ecf1f171 = (0, $lDJXT.createContext)({
    strict: false
});



var $lDJXT = parcelRequire("lDJXT");
"use client";
/**
 * @public
 */ const $2e5a0dbb8f9367a1$export$22a697fb29aac98d = (0, $lDJXT.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});



var $lDJXT = parcelRequire("lDJXT");
"use client";
const $21f5bc764d05f0f1$export$2285bbca2c666415 = /* @__PURE__ */ (0, $lDJXT.createContext)({});



var $lDJXT = parcelRequire("lDJXT");


function $36712e9181cfe874$export$12fc32fc096a04a3(props, context) {
    if ((0, $1c1117fe46ce7cc3$export$4b3c3bd8d910d78d)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $2ce69ad985562542$export$720b90e312cea233)(initial) ? initial : undefined,
            animate: (0, $2ce69ad985562542$export$720b90e312cea233)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}


"use client";
function $a86962202dbf5880$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $36712e9181cfe874$export$12fc32fc096a04a3)(props, (0, $lDJXT.useContext)((0, $21f5bc764d05f0f1$export$2285bbca2c666415)));
    return (0, $lDJXT.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $a86962202dbf5880$var$variantLabelsAsDependency(initial),
        $a86962202dbf5880$var$variantLabelsAsDependency(animate)
    ]);
}
function $a86962202dbf5880$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}




var $lDJXT = parcelRequire("lDJXT");


var $lDJXT = parcelRequire("lDJXT");
const $e1f8c883ab857d3a$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });


"use client";
function $c33cb1b1d14f3850$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $5c2f00f5f770efa1$export$605d60a2578142d3)(source[key]) && !(0, $8d96ae9b61209f6c$export$6d27ce8e3de1c3cf)(key, props)) target[key] = source[key];
}
function $c33cb1b1d14f3850$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState) {
    return (0, $lDJXT.useMemo)(()=>{
        const state = (0, $e1f8c883ab857d3a$export$8940b483cf52eeda)();
        (0, $59e3de0eaa252cc3$export$bb517f8b40f8e99d)(state, visualState, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $c33cb1b1d14f3850$var$useStyle(props, visualState) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $c33cb1b1d14f3850$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $c33cb1b1d14f3850$var$useInitialMotionValues(props, visualState));
    return style;
}
function $c33cb1b1d14f3850$export$57be0a314572d87d(props, visualState) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $c33cb1b1d14f3850$var$useStyle(props, visualState);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}




var $lDJXT = parcelRequire("lDJXT");


const $6ed975310bbb2175$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $e1f8c883ab857d3a$export$8940b483cf52eeda)(),
        attrs: {}
    });


"use client";
function $f699e3b80a854a01$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $lDJXT.useMemo)(()=>{
        const state = (0, $6ed975310bbb2175$export$41be8b43e1c4d4f9)();
        (0, $ddde5c5d91c6280e$export$5475d24f125d7053)(state, visualState, (0, $e3f757a10dc3d22d$export$6328ce7565ea1049)(Component), props.transformTemplate, props.style);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $c33cb1b1d14f3850$export$40dafdb8630c956b)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}



/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $e5848196f58e9108$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "propagate",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $e5848196f58e9108$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || $e5848196f58e9108$var$validMotionProps.has(key);
}


let $5b7ee62f18f465b5$var$shouldForward = (key)=>!(0, $e5848196f58e9108$export$2f9c46555243bf04)(key);
function $5b7ee62f18f465b5$export$59d6962c470509a5(isValidProp) {
    if (typeof isValidProp !== "function") return;
    // Explicitly filter our events
    $5b7ee62f18f465b5$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $e5848196f58e9108$export$2f9c46555243bf04)(key) : isValidProp(key);
}
/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     *
     * String concatenation prevents bundlers like webpack (e.g. Storybook)
     * from statically resolving this optional dependency at build time.
     */ const emotionPkg = "@emotion/is-prop-valid";
    $5b7ee62f18f465b5$export$59d6962c470509a5(require(emotionPkg).default);
} catch  {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $5b7ee62f18f465b5$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ((0, $5c2f00f5f770efa1$export$605d60a2578142d3)(props[key])) continue;
        if ($5b7ee62f18f465b5$var$shouldForward(key) || forwardMotionProps === true && (0, $e5848196f58e9108$export$2f9c46555243bf04)(key) || !isDom && !(0, $e5848196f58e9108$export$2f9c46555243bf04)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}



"use client";
function $12be3e2b7853eb8d$export$e25bb1e5b53cbdff(Component, props, ref, { latestValues: latestValues }, isStatic, forwardMotionProps = false, isSVG) {
    const useVisualProps = isSVG ?? (0, $1a93bf402f02661b$export$88f3fc2fd3766989)(Component) ? (0, $f699e3b80a854a01$export$84309c4f53cb1bd5) : (0, $c33cb1b1d14f3850$export$57be0a314572d87d);
    const visualProps = useVisualProps(props, latestValues, isStatic, Component);
    const filteredProps = (0, $5b7ee62f18f465b5$export$d697c39a2985a4c)(props, typeof Component === "string", forwardMotionProps);
    const elementProps = Component !== (0, $lDJXT.Fragment) ? {
        ...filteredProps,
        ...visualProps,
        ref: ref
    } : {};
    /**
     * If component has been handed a motion value as its child,
     * memoise its initial value and render that. Subsequent updates
     * will be handled by the onChange handler
     */ const { children: children } = props;
    const renderedChildren = (0, $lDJXT.useMemo)(()=>(0, $5c2f00f5f770efa1$export$605d60a2578142d3)(children) ? children.get() : children, [
        children
    ]);
    return (0, $lDJXT.createElement)(Component, {
        ...elementProps,
        children: renderedChildren
    });
}





/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 */ function $eb85c9930d01bb56$export$fcc2206ecb6d74b(value) {
    return (0, $5c2f00f5f770efa1$export$605d60a2578142d3)(value) ? value.get() : value;
}



var $lDJXT = parcelRequire("lDJXT");


var $lDJXT = parcelRequire("lDJXT");
"use client";
/**
 * @public
 */ const $c9c492548b4996c8$export$f224e4635b6f8ce2 = /* @__PURE__ */ (0, $lDJXT.createContext)(null);



var $lDJXT = parcelRequire("lDJXT");
"use client";
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $4db5e17be01a6cf1$export$fe4300aa8eebea86(init) {
    const ref = (0, $lDJXT.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}


"use client";
function $ff321636090451e6$var$makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState }, props, context, presenceContext) {
    const state = {
        latestValues: $ff321636090451e6$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    return state;
}
function $ff321636090451e6$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $eb85c9930d01bb56$export$fcc2206ecb6d74b)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $1c1117fe46ce7cc3$export$4b3c3bd8d910d78d)(props);
    const isVariantNode$1 = (0, $1c1117fe46ce7cc3$export$ce46fa4165cdec40)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $f6c92e10f2e25836$export$aa71198ceeaf53ce)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        for(let i = 0; i < list.length; i++){
            const resolved = (0, $ccb7954dd8fa45b5$export$d68f140c4d9b48bc)(props, list[i]);
            if (resolved) {
                const { transitionEnd: transitionEnd, transition: transition, ...target } = resolved;
                for(const key in target){
                    let valueTarget = target[key];
                    if (Array.isArray(valueTarget)) {
                        /**
                         * Take final keyframe if the initial animation is blocked because
                         * we want to initialise at the end of that blocked animation.
                         */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                        valueTarget = valueTarget[index];
                    }
                    if (valueTarget !== null) values[key] = valueTarget;
                }
                for(const key in transitionEnd)values[key] = transitionEnd[key];
            }
        }
    }
    return values;
}
const $ff321636090451e6$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $lDJXT.useContext)((0, $21f5bc764d05f0f1$export$2285bbca2c666415));
        const presenceContext = (0, $lDJXT.useContext)((0, $c9c492548b4996c8$export$f224e4635b6f8ce2));
        const make = ()=>$ff321636090451e6$var$makeState(config, props, context, presenceContext);
        return isStatic ? make() : (0, $4db5e17be01a6cf1$export$fe4300aa8eebea86)(make);
    };



"use client";
const $d0d2552dfaa33347$export$851cf1f78cb3feac = /*@__PURE__*/ (0, $ff321636090451e6$export$e91e107bc6d03a8e)({
    scrapeMotionValuesFromProps: (0, $48d0e82004f65075$export$16da615486abaa45),
    createRenderState: (0, $e1f8c883ab857d3a$export$8940b483cf52eeda)
});





"use client";
const $c019473c47d96311$export$9922240e40b88c48 = /*@__PURE__*/ (0, $ff321636090451e6$export$e91e107bc6d03a8e)({
    scrapeMotionValuesFromProps: (0, $d2c40603d8a0b7dd$export$16da615486abaa45),
    createRenderState: (0, $6ed975310bbb2175$export$41be8b43e1c4d4f9)
});



const $78df76a2bdd1f112$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
let $78df76a2bdd1f112$var$isInitialized = false;
/**
 * Initialize feature definitions with isEnabled checks.
 * This must be called before any motion components are rendered.
 */ function $78df76a2bdd1f112$export$e7d3655c4e2f701f() {
    if ($78df76a2bdd1f112$var$isInitialized) return;
    const initialFeatureDefinitions = {};
    for(const key in $78df76a2bdd1f112$var$featureProps)initialFeatureDefinitions[key] = {
        isEnabled: (props)=>$78df76a2bdd1f112$var$featureProps[key].some((name)=>!!props[name])
    };
    (0, $c767192007352310$export$8ad214844176d967)(initialFeatureDefinitions);
    $78df76a2bdd1f112$var$isInitialized = true;
}
/**
 * Get the current feature definitions, initializing if needed.
 */ function $78df76a2bdd1f112$export$350148171c356c79() {
    $78df76a2bdd1f112$export$e7d3655c4e2f701f();
    return (0, $c767192007352310$export$e183cb9c018608ba)();
}




function $f0acec10e3e7de19$export$449561ec5703cdc8(features) {
    const featureDefinitions = (0, $78df76a2bdd1f112$export$350148171c356c79)();
    for(const key in features)featureDefinitions[key] = {
        ...featureDefinitions[key],
        ...features[key]
    };
    (0, $c767192007352310$export$8ad214844176d967)(featureDefinitions);
}


const $bdd2568f25115569$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");



var $lDJXT = parcelRequire("lDJXT");
"use client";
/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $fd08529cfbd9f43f$export$c684914703d321fd(visualState, visualElement, externalRef) {
    /**
     * Store externalRef in a ref to avoid including it in the useCallback
     * dependency array. Including externalRef in dependencies causes issues
     * with libraries like Radix UI that create new callback refs on each render
     * when using asChild - this would cause the callback to be recreated,
     * triggering element remounts and breaking AnimatePresence exit animations.
     */ const externalRefContainer = (0, $lDJXT.useRef)(externalRef);
    (0, $lDJXT.useInsertionEffect)(()=>{
        externalRefContainer.current = externalRef;
    });
    // Store cleanup function returned by callback refs (React 19 feature)
    const refCleanup = (0, $lDJXT.useRef)(null);
    return (0, $lDJXT.useCallback)((instance)=>{
        if (instance) visualState.onMount?.(instance);
        if (visualElement) instance ? visualElement.mount(instance) : visualElement.unmount();
        const ref = externalRefContainer.current;
        if (typeof ref === "function") {
            if (instance) {
                const cleanup = ref(instance);
                if (typeof cleanup === "function") refCleanup.current = cleanup;
            } else if (refCleanup.current) {
                refCleanup.current();
                refCleanup.current = null;
            } else ref(instance);
        } else if (ref) ref.current = instance;
    }, [
        visualElement
    ]);
}



const $c1e5bc0c7cb59406$export$ed7b8fa9dbf0105d = "framerAppearId";
const $c1e5bc0c7cb59406$export$8592e1c077c890a6 = "data-" + (0, $758fee5398ecdb01$export$9fd24a634729c672)($c1e5bc0c7cb59406$export$ed7b8fa9dbf0105d);



var $lDJXT = parcelRequire("lDJXT");





var $lDJXT = parcelRequire("lDJXT");
"use client";
/**
 * Internal, exported only for usage in Framer
 */ const $2fc2c794e9434d17$export$da5f7b802957459a = (0, $lDJXT.createContext)({});


function $f172ef57cf979a54$export$dedd81df7bc1307(ref) {
    return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}



var $lDJXT = parcelRequire("lDJXT");
const $e3db5c15fb33b6e4$export$4e09c449d6c407f7 = typeof window !== "undefined";


"use client";
const $52576d8d24deba82$export$700979bc83e7db82 = (0, $e3db5c15fb33b6e4$export$4e09c449d6c407f7) ? (0, $lDJXT.useLayoutEffect) : (0, $lDJXT.useEffect);


"use client";
function $3aea85b051363b30$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement, ProjectionNodeConstructor, isSVG) {
    const { visualElement: parent } = (0, $lDJXT.useContext)((0, $21f5bc764d05f0f1$export$2285bbca2c666415));
    const lazyContext = (0, $lDJXT.useContext)((0, $e898c547a0d3c47f$export$40f10139ecf1f171));
    const presenceContext = (0, $lDJXT.useContext)((0, $c9c492548b4996c8$export$f224e4635b6f8ce2));
    const motionConfig = (0, $lDJXT.useContext)((0, $2e5a0dbb8f9367a1$export$22a697fb29aac98d));
    const reducedMotionConfig = motionConfig.reducedMotion;
    const skipAnimations = motionConfig.skipAnimations;
    const visualElementRef = (0, $lDJXT.useRef)(null);
    /**
     * Track whether the component has been through React's commit phase.
     * Used to detect when LazyMotion features load after the component has mounted.
     */ const hasMountedOnce = (0, $lDJXT.useRef)(false);
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) {
        visualElementRef.current = createVisualElement(Component, {
            visualState: visualState,
            parent: parent,
            props: props,
            presenceContext: presenceContext,
            blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
            reducedMotionConfig: reducedMotionConfig,
            skipAnimations: skipAnimations,
            isSVG: isSVG
        });
        /**
         * If the component has already mounted before features loaded (e.g. via
         * LazyMotion with async feature loading), we need to force the initial
         * animation to run. Otherwise state changes that occurred before features
         * loaded will be lost and the element will snap to its final state.
         */ if (hasMountedOnce.current && visualElementRef.current) visualElementRef.current.manuallyAnimateOnMount = true;
    }
    const visualElement = visualElementRef.current;
    /**
     * Load Motion gesture and animation features. These are rendered as renderless
     * components so each feature can optionally make use of React lifecycle methods.
     */ const initialLayoutGroupConfig = (0, $lDJXT.useContext)((0, $2fc2c794e9434d17$export$da5f7b802957459a));
    if (visualElement && !visualElement.projection && ProjectionNodeConstructor && (visualElement.type === "html" || visualElement.type === "svg")) $3aea85b051363b30$var$createProjectionNode(visualElementRef.current, props, ProjectionNodeConstructor, initialLayoutGroupConfig);
    const isMounted = (0, $lDJXT.useRef)(false);
    (0, $lDJXT.useInsertionEffect)(()=>{
        /**
         * Check the component has already mounted before calling
         * `update` unnecessarily. This ensures we skip the initial update.
         */ if (visualElement && isMounted.current) visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const optimisedAppearId = props[0, $c1e5bc0c7cb59406$export$8592e1c077c890a6];
    const wantsHandoff = (0, $lDJXT.useRef)(Boolean(optimisedAppearId) && typeof window !== "undefined" && !window.MotionHandoffIsComplete?.(optimisedAppearId) && window.MotionHasOptimisedAnimation?.(optimisedAppearId));
    (0, $52576d8d24deba82$export$700979bc83e7db82)(()=>{
        /**
         * Track that this component has mounted. This is used to detect when
         * LazyMotion features load after the component has already committed.
         */ hasMountedOnce.current = true;
        if (!visualElement) return;
        isMounted.current = true;
        window.MotionIsMounted = true;
        visualElement.updateFeatures();
        visualElement.scheduleRenderMicrotask();
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $lDJXT.useEffect)(()=>{
        if (!visualElement) return;
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        if (wantsHandoff.current) {
            // This ensures all future calls to animateChanges() in this component will run in useEffect
            queueMicrotask(()=>{
                window.MotionHandoffMarkAsComplete?.(optimisedAppearId);
            });
            wantsHandoff.current = false;
        }
        /**
         * Now we've finished triggering animations for this element we
         * can wipe the enteringChildren set for the next render.
         */ visualElement.enteringChildren = undefined;
    });
    return visualElement;
}
function $3aea85b051363b30$var$createProjectionNode(visualElement, props, ProjectionNodeConstructor, initialPromotionConfig) {
    const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll, layoutRoot: layoutRoot, layoutAnchor: layoutAnchor, layoutCrossfade: layoutCrossfade } = props;
    visualElement.projection = new ProjectionNodeConstructor(visualElement.latestValues, props["data-framer-portal-id"] ? undefined : $3aea85b051363b30$var$getClosestProjectingNode(visualElement.parent));
    visualElement.projection.setOptions({
        layoutId: layoutId,
        layout: layout,
        alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $f172ef57cf979a54$export$dedd81df7bc1307)(dragConstraints),
        visualElement: visualElement,
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */ animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig: initialPromotionConfig,
        crossfade: layoutCrossfade,
        layoutScroll: layoutScroll,
        layoutRoot: layoutRoot,
        layoutAnchor: layoutAnchor
    });
}
function $3aea85b051363b30$var$getClosestProjectingNode(visualElement) {
    if (!visualElement) return undefined;
    return visualElement.options.allowProjection !== false ? visualElement.projection : $3aea85b051363b30$var$getClosestProjectingNode(visualElement.parent);
}


"use client";
/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $a4c6f22072829696$export$46b7e4b9dc6110c3(Component, { forwardMotionProps: forwardMotionProps = false, type: type } = {}, preloadedFeatures, createVisualElement) {
    preloadedFeatures && (0, $f0acec10e3e7de19$export$449561ec5703cdc8)(preloadedFeatures);
    /**
     * Determine whether to use SVG or HTML rendering based on:
     * 1. Explicit `type` option (highest priority)
     * 2. Auto-detection via `isSVGComponent`
     */ const isSVG = type ? type === "svg" : (0, $1a93bf402f02661b$export$88f3fc2fd3766989)(Component);
    const useVisualState = isSVG ? (0, $c019473c47d96311$export$9922240e40b88c48) : (0, $d0d2552dfaa33347$export$851cf1f78cb3feac);
    function MotionDOMComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, $lDJXT.useContext)((0, $2e5a0dbb8f9367a1$export$22a697fb29aac98d)),
            ...props,
            layoutId: $a4c6f22072829696$var$useLayoutId(props)
        };
        const { isStatic: isStatic } = configAndProps;
        const context = (0, $a86962202dbf5880$export$c5638d843b37a176)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && typeof window !== "undefined") {
            $a4c6f22072829696$var$useStrictMode(configAndProps, preloadedFeatures);
            const layoutProjection = $a4c6f22072829696$var$getProjectionFunctionality(configAndProps);
            MeasureLayout = layoutProjection.MeasureLayout;
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $3aea85b051363b30$export$dc0335d73ab0b115)(Component, visualState, configAndProps, createVisualElement, layoutProjection.ProjectionNode, isSVG);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return (0, $217385444e3d1677$exports.jsxs)((0, $21f5bc764d05f0f1$export$2285bbca2c666415).Provider, {
            value: context,
            children: [
                MeasureLayout && context.visualElement ? (0, $217385444e3d1677$exports.jsx)(MeasureLayout, {
                    visualElement: context.visualElement,
                    ...configAndProps
                }) : null,
                (0, $12be3e2b7853eb8d$export$e25bb1e5b53cbdff)(Component, props, (0, $fd08529cfbd9f43f$export$c684914703d321fd)(visualState, context.visualElement, externalRef), visualState, isStatic, forwardMotionProps, isSVG)
            ]
        });
    }
    MotionDOMComponent.displayName = `motion.${typeof Component === "string" ? Component : `create(${Component.displayName ?? Component.name ?? ""})`}`;
    const ForwardRefMotionComponent = (0, $lDJXT.forwardRef)(MotionDOMComponent);
    ForwardRefMotionComponent[0, $bdd2568f25115569$export$28e2e4cce424ae23] = Component;
    return ForwardRefMotionComponent;
}
function $a4c6f22072829696$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $lDJXT.useContext)((0, $23a1c66422693cdf$export$a3579ca508007a95)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}
function $a4c6f22072829696$var$useStrictMode(configAndProps, preloadedFeatures) {
    const isStrict = (0, $lDJXT.useContext)((0, $e898c547a0d3c47f$export$40f10139ecf1f171)).strict;
}
function $a4c6f22072829696$var$getProjectionFunctionality(props) {
    const featureDefinitions = (0, $78df76a2bdd1f112$export$350148171c356c79)();
    const { drag: drag, layout: layout } = featureDefinitions;
    if (!drag && !layout) return {};
    const combined = {
        ...drag,
        ...layout
    };
    return {
        MeasureLayout: drag?.isEnabled(props) || layout?.isEnabled(props) ? combined.MeasureLayout : undefined,
        ProjectionNode: combined.ProjectionNode
    };
}


function $aca54ab863ad2bab$export$a28d6df673050e18(preloadedFeatures, createVisualElement) {
    if (typeof Proxy === "undefined") return 0, $a4c6f22072829696$export$46b7e4b9dc6110c3;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    const factory = (Component, options)=>{
        return (0, $a4c6f22072829696$export$46b7e4b9dc6110c3)(Component, options, preloadedFeatures, createVisualElement);
    };
    /**
     * Support for deprecated`motion(Component)` pattern
     */ const deprecatedFactoryFunction = (Component, options)=>{
        return factory(Component, options);
    };
    return new Proxy(deprecatedFactoryFunction, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            if (key === "create") return factory;
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, (0, $a4c6f22072829696$export$46b7e4b9dc6110c3)(key, undefined, preloadedFeatures, createVisualElement));
            return componentCache.get(key);
        }
    });
}



function $ce15ba87bccd1c3b$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $ccb7954dd8fa45b5$export$d68f140c4d9b48bc)(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}


/**
 * If `transition` has `inherit: true`, shallow-merge it with
 * `parentTransition` (child keys win) and strip the `inherit` key.
 * Otherwise return `transition` unchanged.
 */ function $231df4a5a6e9d9d6$export$b180037f8f468d61(transition, parentTransition) {
    if (transition?.inherit && parentTransition) {
        const { inherit: _, ...rest } = transition;
        return {
            ...parentTransition,
            ...rest
        };
    }
    return transition;
}


function $e6a44c6e4fc3283d$export$7c1391340308742e(transition, key) {
    const valueTransition = transition?.[key] ?? transition?.["default"] ?? transition;
    if (valueTransition !== transition) return (0, $231df4a5a6e9d9d6$export$b180037f8f468d61)(valueTransition, transition);
    return valueTransition;
}






const $8f3c3c3fa9fdb4ef$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};


/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $cb29a2a6ae2c9801$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $273b0f90a77f315f$export$ce8bdc721e76545f)(value));
}
function $cb29a2a6ae2c9801$var$resolveFinalValueInKeyframes(v) {
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $8f3c3c3fa9fdb4ef$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
}
function $cb29a2a6ae2c9801$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $ce15ba87bccd1c3b$export$7b1b1c981f4f0558)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved || {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = $cb29a2a6ae2c9801$var$resolveFinalValueInKeyframes(target[key]);
        $cb29a2a6ae2c9801$var$setMotionValue(visualElement, key, value);
    }
}




function $5122c894cb444a6b$export$98397f3adbf6259f(value) {
    return Boolean((0, $5c2f00f5f770efa1$export$605d60a2578142d3)(value) && value.add);
}


function $1758461b0718b682$export$3ac5aed310be0bee(visualElement, key) {
    const willChange = visualElement.getValue("willChange");
    /**
     * It could be that a user has set willChange to a regular MotionValue,
     * in which case we can't add the value to it.
     */ if ((0, $5122c894cb444a6b$export$98397f3adbf6259f)(willChange)) return willChange.add(key);
    else if (!willChange && (0, $dcfd83e0153bc5a7$export$dd826089e3c5e502).WillChange) {
        const newWillChange = new (0, $dcfd83e0153bc5a7$export$dd826089e3c5e502).WillChange("auto");
        visualElement.addValue("willChange", newWillChange);
        newWillChange.add(key);
    }
}



function $64421ba86c14703e$export$5f8d21e84d1d84fc(visualElement) {
    return visualElement.props[0, $c1e5bc0c7cb59406$export$8592e1c077c890a6];
}





/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $49331bd461989f84$export$a4627e546088548d = (...transformers)=>transformers.reduce((a, b)=>(v)=>b(a(v)));











// Adapted from https://gist.github.com/mjackson/5311256
function $2478dc78f1f42078$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $2478dc78f1f42078$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $2478dc78f1f42078$var$hueToRgb(p, q, hue + 1 / 3);
        green = $2478dc78f1f42078$var$hueToRgb(p, q, hue);
        blue = $2478dc78f1f42078$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}



function $8c0b38f866adf8b3$export$a6f92d4bae65c0f1(a, b) {
    return (p)=>p > 0 ? b : a;
}



// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $42ff6941cf49a69b$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    const expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
const $42ff6941cf49a69b$var$colorTypes = [
    (0, $4eef939f0e8ec87d$export$834dfc94dde4b3d8),
    (0, $e9667985f15d8b60$export$4e46ac54fc82cf3b),
    (0, $34b3b29b05ecaf20$export$810b04175080204c)
];
const $42ff6941cf49a69b$var$getColorType = (v)=>$42ff6941cf49a69b$var$colorTypes.find((type)=>type.test(v));
function $42ff6941cf49a69b$var$asRGBA(color) {
    const type = $42ff6941cf49a69b$var$getColorType(color);
    (0, $8a16204eb729eee3$export$491112666e282270)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`, "color-not-animatable");
    if (!Boolean(type)) return false;
    let model = type.parse(color);
    if (type === (0, $34b3b29b05ecaf20$export$810b04175080204c)) // TODO Remove this cast - needed since Motion's stricter typing
    model = (0, $2478dc78f1f42078$export$6ae64dbcd6bfc33e)(model);
    return model;
}
const $42ff6941cf49a69b$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $42ff6941cf49a69b$var$asRGBA(from);
    const toRGBA = $42ff6941cf49a69b$var$asRGBA(to);
    if (!fromRGBA || !toRGBA) return (0, $8c0b38f866adf8b3$export$a6f92d4bae65c0f1)(from, to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $42ff6941cf49a69b$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $42ff6941cf49a69b$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $42ff6941cf49a69b$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $5a3532f8b2a8e80b$export$3bb0b4ff1037b8dd)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $e9667985f15d8b60$export$4e46ac54fc82cf3b).transform(blended);
    };
};




const $996829fad835c2e2$export$e5a55ae567dd4ac7 = new Set([
    "none",
    "hidden"
]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */ function $996829fad835c2e2$export$fed62ccc3fb1a568(origin, target) {
    if ($996829fad835c2e2$export$e5a55ae567dd4ac7.has(origin)) return (p)=>p <= 0 ? origin : target;
    else return (p)=>p >= 1 ? target : origin;
}


function $c4a4838610092360$var$mixNumber(a, b) {
    return (p)=>(0, $5a3532f8b2a8e80b$export$3bb0b4ff1037b8dd)(a, b, p);
}
function $c4a4838610092360$export$36ec24672cd098e0(a) {
    if (typeof a === "number") return $c4a4838610092360$var$mixNumber;
    else if (typeof a === "string") return (0, $7a9371b51650a71c$export$31f9caa2600b5723)(a) ? (0, $8c0b38f866adf8b3$export$a6f92d4bae65c0f1) : (0, $16b5f49e2c085406$export$35e9368ef982300f).test(a) ? (0, $42ff6941cf49a69b$export$51e568cf5c039bac) : $c4a4838610092360$export$65516310a87d8205;
    else if (Array.isArray(a)) return $c4a4838610092360$export$3bbefa2f402845c4;
    else if (typeof a === "object") return (0, $16b5f49e2c085406$export$35e9368ef982300f).test(a) ? (0, $42ff6941cf49a69b$export$51e568cf5c039bac) : $c4a4838610092360$export$ebc23b6840c51ba1;
    return 0, $8c0b38f866adf8b3$export$a6f92d4bae65c0f1;
}
function $c4a4838610092360$export$3bbefa2f402845c4(a, b) {
    const output = [
        ...a
    ];
    const numValues = output.length;
    const blendValue = a.map((v, i)=>$c4a4838610092360$export$36ec24672cd098e0(v)(v, b[i]));
    return (p)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](p);
        return output;
    };
}
function $c4a4838610092360$export$ebc23b6840c51ba1(a, b) {
    const output = {
        ...a,
        ...b
    };
    const blendValue = {};
    for(const key in output)if (a[key] !== undefined && b[key] !== undefined) blendValue[key] = $c4a4838610092360$export$36ec24672cd098e0(a[key])(a[key], b[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
}
function $c4a4838610092360$var$matchOrder(origin, target) {
    const orderedOrigin = [];
    const pointers = {
        color: 0,
        var: 0,
        number: 0
    };
    for(let i = 0; i < target.values.length; i++){
        const type = target.types[i];
        const originIndex = origin.indexes[type][pointers[type]];
        const originValue = origin.values[originIndex] ?? 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
const $c4a4838610092360$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $bd4dae80ad095149$export$83a0e34f1302825b).createTransformer(target);
    const originStats = (0, $bd4dae80ad095149$export$b61fc7c44bf646d5)(origin);
    const targetStats = (0, $bd4dae80ad095149$export$b61fc7c44bf646d5)(target);
    const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) {
        if ((0, $996829fad835c2e2$export$e5a55ae567dd4ac7).has(origin) && !targetStats.values.length || (0, $996829fad835c2e2$export$e5a55ae567dd4ac7).has(target) && !originStats.values.length) return (0, $996829fad835c2e2$export$fed62ccc3fb1a568)(origin, target);
        return (0, $49331bd461989f84$export$a4627e546088548d)($c4a4838610092360$export$3bbefa2f402845c4($c4a4838610092360$var$matchOrder(originStats, targetStats), targetStats.values), template);
    } else {
        (0, $8a16204eb729eee3$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`, "complex-values-different");
        return (0, $8c0b38f866adf8b3$export$a6f92d4bae65c0f1)(origin, target);
    }
};



function $4f789841eadc2908$export$2c9e8a9632a706b2(from, to, p) {
    if (typeof from === "number" && typeof to === "number" && typeof p === "number") return (0, $5a3532f8b2a8e80b$export$3bb0b4ff1037b8dd)(from, to, p);
    const mixer = (0, $c4a4838610092360$export$36ec24672cd098e0)(from);
    return mixer(from, to);
}




const $5c4499f16fe9a8ca$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: (keepAlive = true)=>(0, $99c45f49fc7b5e17$export$2cef06c20297c17d).update(passTimestamp, keepAlive),
        stop: ()=>(0, $99c45f49fc7b5e17$export$ec99c0ef4978dccb)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $99c45f49fc7b5e17$export$fff89137e9e818ce).isProcessing ? (0, $99c45f49fc7b5e17$export$fff89137e9e818ce).timestamp : (0, $08568323a95fcb6c$export$2da9be4cfdb689b1).now()
    };
};




/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $e698608348893376$export$f4ff70a5b4808fd8 = 20000;
function $e698608348893376$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $e698608348893376$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $e698608348893376$export$f4ff70a5b4808fd8 ? Infinity : duration;
}




/**
 * Create a progress => progress easing function from a generator.
 */ function $06549d77299a65a7$export$7f1511d09ee75a99(options, scale = 100, createGenerator) {
    const generator = createGenerator({
        ...options,
        keyframes: [
            0,
            scale
        ]
    });
    const duration = Math.min((0, $e698608348893376$export$cbdd6b3d40ea54e2)(generator), (0, $e698608348893376$export$f4ff70a5b4808fd8));
    return {
        type: "keyframes",
        ease: (progress)=>{
            return generator.next(duration * progress).value / scale;
        },
        duration: (0, $8c69a35cd8e97a0e$export$f64c3bfbc58eec0f)(duration)
    };
}


const $89a797273bdaa855$var$springDefaults = {
    // Default spring physics
    stiffness: 100,
    damping: 10,
    mass: 1.0,
    velocity: 0.0,
    // Default duration/bounce-based options
    duration: 800,
    bounce: 0.3,
    visualDuration: 0.3,
    // Rest thresholds
    restSpeed: {
        granular: 0.01,
        default: 2
    },
    restDelta: {
        granular: 0.005,
        default: 0.5
    },
    // Limits
    minDuration: 0.01,
    maxDuration: 10.0,
    minDamping: 0.05,
    maxDamping: 1
};
function $89a797273bdaa855$var$calcAngularFreq(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}
const $89a797273bdaa855$var$rootIterations = 12;
function $89a797273bdaa855$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $89a797273bdaa855$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
/**
 * This is ported from the Framer implementation of duration-based spring resolution.
 */ const $89a797273bdaa855$var$safeMin = 0.001;
function $89a797273bdaa855$var$findSpring({ duration: duration = $89a797273bdaa855$var$springDefaults.duration, bounce: bounce = $89a797273bdaa855$var$springDefaults.bounce, velocity: velocity = $89a797273bdaa855$var$springDefaults.velocity, mass: mass = $89a797273bdaa855$var$springDefaults.mass }) {
    let envelope;
    let derivative;
    (0, $8a16204eb729eee3$export$491112666e282270)(duration <= (0, $8c69a35cd8e97a0e$export$fc3e7e8557f8c8c7)($89a797273bdaa855$var$springDefaults.maxDuration), "Spring duration must be 10 seconds or less", "spring-duration-limit");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $30bb3117a82170b4$export$7d15b64cf5a3a4c4)($89a797273bdaa855$var$springDefaults.minDamping, $89a797273bdaa855$var$springDefaults.maxDamping, dampingRatio);
    duration = (0, $30bb3117a82170b4$export$7d15b64cf5a3a4c4)($89a797273bdaa855$var$springDefaults.minDuration, $89a797273bdaa855$var$springDefaults.maxDuration, (0, $8c69a35cd8e97a0e$export$f64c3bfbc58eec0f)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $89a797273bdaa855$var$calcAngularFreq(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $89a797273bdaa855$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $89a797273bdaa855$var$calcAngularFreq(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $89a797273bdaa855$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$89a797273bdaa855$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $89a797273bdaa855$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $8c69a35cd8e97a0e$export$fc3e7e8557f8c8c7)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: $89a797273bdaa855$var$springDefaults.stiffness,
        damping: $89a797273bdaa855$var$springDefaults.damping,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $89a797273bdaa855$var$durationKeys = [
    "duration",
    "bounce"
];
const $89a797273bdaa855$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $89a797273bdaa855$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $89a797273bdaa855$var$getSpringOptions(options) {
    let springOptions = {
        velocity: $89a797273bdaa855$var$springDefaults.velocity,
        stiffness: $89a797273bdaa855$var$springDefaults.stiffness,
        damping: $89a797273bdaa855$var$springDefaults.damping,
        mass: $89a797273bdaa855$var$springDefaults.mass,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$89a797273bdaa855$var$isSpringType(options, $89a797273bdaa855$var$physicsKeys) && $89a797273bdaa855$var$isSpringType(options, $89a797273bdaa855$var$durationKeys)) {
        // Time-defined springs should ignore inherited velocity.
        // Velocity from interrupted animations can cause findSpring()
        // to compute wildly different spring parameters, leading to
        // massive oscillation on small-range animations.
        springOptions.velocity = 0;
        if (options.visualDuration) {
            const visualDuration = options.visualDuration;
            const root = 2 * Math.PI / (visualDuration * 1.2);
            const stiffness = root * root;
            const damping = 2 * (0, $30bb3117a82170b4$export$7d15b64cf5a3a4c4)(0.05, 1, 1 - (options.bounce || 0)) * Math.sqrt(stiffness);
            springOptions = {
                ...springOptions,
                mass: $89a797273bdaa855$var$springDefaults.mass,
                stiffness: stiffness,
                damping: damping
            };
        } else {
            const derived = $89a797273bdaa855$var$findSpring({
                ...options,
                velocity: 0
            });
            springOptions = {
                ...springOptions,
                ...derived,
                mass: $89a797273bdaa855$var$springDefaults.mass
            };
            springOptions.isResolvedFromDuration = true;
        }
    }
    return springOptions;
}
function $89a797273bdaa855$export$b36281d89752ae66(optionsOrVisualDuration = $89a797273bdaa855$var$springDefaults.visualDuration, bounce = $89a797273bdaa855$var$springDefaults.bounce) {
    const options = typeof optionsOrVisualDuration !== "object" ? {
        visualDuration: optionsOrVisualDuration,
        keyframes: [
            0,
            1
        ],
        bounce: bounce
    } : optionsOrVisualDuration;
    let { restSpeed: restSpeed, restDelta: restDelta } = options;
    const origin = options.keyframes[0];
    const target = options.keyframes[options.keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, duration: duration, velocity: velocity, isResolvedFromDuration: isResolvedFromDuration } = $89a797273bdaa855$var$getSpringOptions({
        ...options,
        velocity: -(0, $8c69a35cd8e97a0e$export$f64c3bfbc58eec0f)(options.velocity || 0)
    });
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $8c69a35cd8e97a0e$export$f64c3bfbc58eec0f)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? $89a797273bdaa855$var$springDefaults.restSpeed.granular : $89a797273bdaa855$var$springDefaults.restSpeed.default);
    restDelta || (restDelta = isGranularScale ? $89a797273bdaa855$var$springDefaults.restDelta.granular : $89a797273bdaa855$var$springDefaults.restDelta.default);
    let resolveSpring;
    let resolveVelocity;
    // Underdamped coefficients, hoisted for use in the inlined next() hot path
    let angularFreq;
    let A;
    let sinCoeff;
    let cosCoeff;
    if (dampingRatio < 1) {
        angularFreq = $89a797273bdaa855$var$calcAngularFreq(undampedAngularFreq, dampingRatio);
        A = (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq;
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * (A * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
        // Analytical derivative of underdamped spring (px/ms)
        sinCoeff = dampingRatio * undampedAngularFreq * A + initialDelta * angularFreq;
        cosCoeff = dampingRatio * undampedAngularFreq * initialDelta - A * angularFreq;
        resolveVelocity = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return envelope * (sinCoeff * Math.sin(angularFreq * t) + cosCoeff * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) {
        // Critically damped spring
        resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
        // Analytical derivative of critically damped spring (px/ms)
        const C = initialVelocity + undampedAngularFreq * initialDelta;
        resolveVelocity = (t)=>Math.exp(-undampedAngularFreq * t) * (undampedAngularFreq * C * t - initialVelocity);
    } else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
        // Analytical derivative of overdamped spring (px/ms)
        const P = (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / dampedAngularFreq;
        const sinhCoeff = dampingRatio * undampedAngularFreq * P - initialDelta * dampedAngularFreq;
        const coshCoeff = dampingRatio * undampedAngularFreq * initialDelta - P * dampedAngularFreq;
        resolveVelocity = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return envelope * (sinhCoeff * Math.sinh(freqForT) + coshCoeff * Math.cosh(freqForT));
        };
    }
    const generator = {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        velocity: (t)=>(0, $8c69a35cd8e97a0e$export$fc3e7e8557f8c8c7)(resolveVelocity(t)),
        next: (t)=>{
            /**
             * For underdamped physics springs we need both position and
             * velocity each tick. Compute shared trig values once to avoid
             * duplicate Math.exp/sin/cos calls on the hot path.
             */ if (!isResolvedFromDuration && dampingRatio < 1) {
                const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                const sin = Math.sin(angularFreq * t);
                const cos = Math.cos(angularFreq * t);
                const current = target - envelope * (A * sin + initialDelta * cos);
                const currentVelocity = (0, $8c69a35cd8e97a0e$export$fc3e7e8557f8c8c7)(envelope * (sinCoeff * sin + cosCoeff * cos));
                state.done = Math.abs(currentVelocity) <= restSpeed && Math.abs(target - current) <= restDelta;
                state.value = state.done ? target : current;
                return state;
            }
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                const currentVelocity = (0, $8c69a35cd8e97a0e$export$fc3e7e8557f8c8c7)(resolveVelocity(t));
                state.done = Math.abs(currentVelocity) <= restSpeed && Math.abs(target - current) <= restDelta;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        },
        toString: ()=>{
            const calculatedDuration = Math.min((0, $e698608348893376$export$cbdd6b3d40ea54e2)(generator), (0, $e698608348893376$export$f4ff70a5b4808fd8));
            const easing = (0, $b47a4d242577a65f$export$66d3851e2b1ec912)((progress)=>generator.next(calculatedDuration * progress).value, calculatedDuration, 30);
            return calculatedDuration + "ms " + easing;
        },
        toTransition: ()=>{}
    };
    return generator;
}
$89a797273bdaa855$export$b36281d89752ae66.applyToOptions = (options)=>{
    const generatorOptions = (0, $06549d77299a65a7$export$7f1511d09ee75a99)(options, 100, $89a797273bdaa855$export$b36281d89752ae66);
    options.ease = generatorOptions.ease;
    options.duration = (0, $8c69a35cd8e97a0e$export$fc3e7e8557f8c8c7)(generatorOptions.duration);
    options.type = "keyframes";
    return options;
};



const $c276dc295f589f71$var$velocitySampleDuration = 5; // ms
function $c276dc295f589f71$export$279c5e002bb29070(resolveValue, t, current) {
    const prevT = Math.max(t - $c276dc295f589f71$var$velocitySampleDuration, 0);
    return (0, $77cedc7ab71c951f$export$eab0632f7ad4f9d7)(current - resolveValue(prevT), t - prevT);
}


function $5e0e45c7eef704dc$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $89a797273bdaa855$export$b36281d89752ae66)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $c276dc295f589f71$export$279c5e002bb29070)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}



/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticeably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $c0c890b6105ef6cd$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $c0c890b6105ef6cd$var$subdivisionPrecision = 0.0000001;
const $c0c890b6105ef6cd$var$subdivisionMaxIterations = 12;
function $c0c890b6105ef6cd$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $c0c890b6105ef6cd$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $c0c890b6105ef6cd$var$subdivisionPrecision && ++i < $c0c890b6105ef6cd$var$subdivisionMaxIterations);
    return currentT;
}
/*#__NO_SIDE_EFFECTS__*/ function $c0c890b6105ef6cd$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $df2228348c5a149c$export$8793edee2d425525;
    const getTForX = (aX)=>$c0c890b6105ef6cd$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $c0c890b6105ef6cd$var$calcBezier(getTForX(t), mY1, mY2);
}


const $f1c472ab975b648d$export$929e5a82286172a6 = /*@__PURE__*/ (0, $c0c890b6105ef6cd$export$2c575fa1d20488bd)(0.42, 0, 1, 1);
const $f1c472ab975b648d$export$57636bb43b1ccbb0 = /*@__PURE__*/ (0, $c0c890b6105ef6cd$export$2c575fa1d20488bd)(0, 0, 0.58, 1);
const $f1c472ab975b648d$export$c07234257a03d5e9 = /*@__PURE__*/ (0, $c0c890b6105ef6cd$export$2c575fa1d20488bd)(0.42, 0, 0.58, 1);




// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
/*#__NO_SIDE_EFFECTS__*/ const $e843365ebc365c8b$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;


// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
/*#__NO_SIDE_EFFECTS__*/ const $489554926451bb9a$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);


const $8203cac7b38090fa$export$77edfce482316a60 = /*@__PURE__*/ (0, $c0c890b6105ef6cd$export$2c575fa1d20488bd)(0.33, 1.53, 0.69, 0.99);
const $8203cac7b38090fa$export$b01116c84cdfe1a2 = /*@__PURE__*/ (0, $489554926451bb9a$export$2c07eeff45156d4d)($8203cac7b38090fa$export$77edfce482316a60);
const $8203cac7b38090fa$export$ddc5fd596f6c71b2 = /*@__PURE__*/ (0, $e843365ebc365c8b$export$f946554fb8aeaf0d)($8203cac7b38090fa$export$b01116c84cdfe1a2);


const $dd1e9a9d80b64cc9$export$6b0af63b873d419e = (p)=>p >= 1 ? 1 : (p *= 2) < 1 ? 0.5 * (0, $8203cac7b38090fa$export$b01116c84cdfe1a2)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));





const $9dbc3d97c787557f$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $9dbc3d97c787557f$export$c8d67a19199d1a50 = (0, $489554926451bb9a$export$2c07eeff45156d4d)($9dbc3d97c787557f$export$e444123e42d03385);
const $9dbc3d97c787557f$export$30d3455eee55bed5 = (0, $e843365ebc365c8b$export$f946554fb8aeaf0d)($9dbc3d97c787557f$export$e444123e42d03385);





const $8c36d2e3753a3541$var$easingLookup = {
    linear: (0, $df2228348c5a149c$export$8793edee2d425525),
    easeIn: $f1c472ab975b648d$export$929e5a82286172a6,
    easeInOut: $f1c472ab975b648d$export$c07234257a03d5e9,
    easeOut: $f1c472ab975b648d$export$57636bb43b1ccbb0,
    circIn: $9dbc3d97c787557f$export$e444123e42d03385,
    circInOut: $9dbc3d97c787557f$export$30d3455eee55bed5,
    circOut: $9dbc3d97c787557f$export$c8d67a19199d1a50,
    backIn: $8203cac7b38090fa$export$b01116c84cdfe1a2,
    backInOut: $8203cac7b38090fa$export$ddc5fd596f6c71b2,
    backOut: $8203cac7b38090fa$export$77edfce482316a60,
    anticipate: $dd1e9a9d80b64cc9$export$6b0af63b873d419e
};
const $8c36d2e3753a3541$var$isValidEasing = (easing)=>{
    return typeof easing === "string";
};
const $8c36d2e3753a3541$export$ef97fe084f156ca4 = (definition)=>{
    if ((0, $9abbf8f7fcfa8eac$export$ff43f99925d7366b)(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $8a16204eb729eee3$export$f5708dca728d7177)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`, "cubic-bezier-length");
        const [x1, y1, x2, y2] = definition;
        return (0, $c0c890b6105ef6cd$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if ($8c36d2e3753a3541$var$isValidEasing(definition)) {
        // Else lookup from table
        (0, $8a16204eb729eee3$export$f5708dca728d7177)($8c36d2e3753a3541$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`, "invalid-easing-type");
        return $8c36d2e3753a3541$var$easingLookup[definition];
    }
    return definition;
};

/*#__NO_SIDE_EFFECTS__*/ const $91d057701fda9ae3$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};


/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.
*/ /*#__NO_SIDE_EFFECTS__*/ const $d1110b161f695fe9$export$504d7abb21fa8c9 = (from, to, value)=>{
    const range = to - from;
    return range ? (value - from) / range : 1;
};



function $27e74eff4318410b$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || (0, $dcfd83e0153bc5a7$export$dd826089e3c5e502).mix || (0, $4f789841eadc2908$export$2c9e8a9632a706b2);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $df2228348c5a149c$export$8793edee2d425525) : ease;
            mixer = (0, $49331bd461989f84$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revisit this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $27e74eff4318410b$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $8a16204eb729eee3$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length", "range-length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    if (inputLength === 2 && output[0] === output[1]) return ()=>output[1];
    const isZeroDeltaRange = input[0] === input[1];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $27e74eff4318410b$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        if (isZeroDeltaRange && v < input[0]) return output[0];
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $d1110b161f695fe9$export$504d7abb21fa8c9)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $30bb3117a82170b4$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}




function $0a8998bec56a0a37$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $d1110b161f695fe9$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $5a3532f8b2a8e80b$export$3bb0b4ff1037b8dd)(min, 1, offsetProgress));
    }
}


function $359e7bb3bf886b8e$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $0a8998bec56a0a37$export$dafee61230cf05c6)(offset, arr.length - 1);
    return offset;
}


function $5338dc3a9fc4e38a$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}


function $058ddfffcb4ee2ba$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $f1c472ab975b648d$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $058ddfffcb4ee2ba$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $91d057701fda9ae3$export$216948827bbdc797)(ease) ? ease.map((0, $8c36d2e3753a3541$export$ef97fe084f156ca4)) : (0, $8c36d2e3753a3541$export$ef97fe084f156ca4)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $5338dc3a9fc4e38a$export$2a91b4e3a4539316)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $359e7bb3bf886b8e$export$24dbcec0b26e6d9d)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $27e74eff4318410b$export$89e29e4ab65e70a9)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $058ddfffcb4ee2ba$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}








const $0860dafe737caef5$var$transitionTypeMap = {
    decay: (0, $5e0e45c7eef704dc$export$ee3ff3a17106998),
    inertia: $5e0e45c7eef704dc$export$ee3ff3a17106998,
    tween: (0, $058ddfffcb4ee2ba$export$d25ddfdf17c3ad3e),
    keyframes: (0, $058ddfffcb4ee2ba$export$d25ddfdf17c3ad3e),
    spring: $89a797273bdaa855$export$b36281d89752ae66
};
function $0860dafe737caef5$export$98db6ef1242dfa2(transition) {
    if (typeof transition.type === "string") transition.type = $0860dafe737caef5$var$transitionTypeMap[transition.type];
}



const $26236bfd94a3a5dc$var$percentToProgress = (percent)=>percent / 100;
class $26236bfd94a3a5dc$export$3394f837405475c7 extends (0, $cf5f10bff69b6976$export$655db786091c33e0) {
    initAnimation() {
        const { options: options } = this;
        (0, $0860dafe737caef5$export$98db6ef1242dfa2)(options);
        const { type: type = (0, $058ddfffcb4ee2ba$export$d25ddfdf17c3ad3e), repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType, velocity: velocity = 0 } = options;
        let { keyframes: keyframes$1 } = options;
        const generatorFactory = type || (0, $058ddfffcb4ee2ba$export$d25ddfdf17c3ad3e);
        if (generatorFactory !== (0, $058ddfffcb4ee2ba$export$d25ddfdf17c3ad3e) && typeof keyframes$1[0] !== "number") {
            this.mixKeyframes = (0, $49331bd461989f84$export$a4627e546088548d)($26236bfd94a3a5dc$var$percentToProgress, (0, $4f789841eadc2908$export$2c9e8a9632a706b2)(keyframes$1[0], keyframes$1[1]));
            keyframes$1 = [
                0,
                100
            ];
        }
        const generator = generatorFactory({
            ...options,
            keyframes: keyframes$1
        });
        /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */ if (repeatType === "mirror") this.mirroredGenerator = generatorFactory({
            ...options,
            keyframes: [
                ...keyframes$1
            ].reverse(),
            velocity: -velocity
        });
        /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */ if (generator.calculatedDuration === null) generator.calculatedDuration = (0, $e698608348893376$export$cbdd6b3d40ea54e2)(generator);
        const { calculatedDuration: calculatedDuration } = generator;
        this.calculatedDuration = calculatedDuration;
        this.resolvedDuration = calculatedDuration + repeatDelay;
        this.totalDuration = this.resolvedDuration * (repeat + 1) - repeatDelay;
        this.generator = generator;
    }
    updateTime(timestamp) {
        const animationTime = Math.round(timestamp - this.startTime) * this.playbackSpeed;
        // Update currentTime
        if (this.holdTime !== null) this.currentTime = this.holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        this.currentTime = animationTime;
    }
    tick(timestamp, sample = false) {
        const { generator: generator, totalDuration: totalDuration, mixKeyframes: mixKeyframes, mirroredGenerator: mirroredGenerator, resolvedDuration: resolvedDuration, calculatedDuration: calculatedDuration } = this;
        if (this.startTime === null) return generator.next(0);
        const { delay: delay = 0, keyframes: keyframes, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, type: type, onUpdate: onUpdate, finalKeyframe: finalKeyframe } = this.options;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (this.speed > 0) this.startTime = Math.min(this.startTime, timestamp);
        else if (this.speed < 0) this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
        if (sample) this.currentTime = timestamp;
        else this.updateTime(timestamp);
        // Rebase on delay
        const timeWithoutDelay = this.currentTime - delay * (this.playbackSpeed >= 0 ? 1 : -1);
        const isInDelayPhase = this.playbackSpeed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        this.currentTime = Math.max(timeWithoutDelay, 0);
        // If this animation has finished, set the current time  to the total duration.
        if (this.state === "finished" && this.holdTime === null) this.currentTime = totalDuration;
        let elapsed = this.currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, $30bb3117a82170b4$export$7d15b64cf5a3a4c4)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ let state;
        if (isInDelayPhase) {
            this.delayState.value = keyframes[0];
            state = this.delayState;
        } else state = frameGenerator.next(elapsed);
        if (mixKeyframes && !isInDelayPhase) state.value = mixKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = this.playbackSpeed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
        const isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
        // TODO: The exception for inertia could be cleaner here
        if (isAnimationFinished && type !== (0, $5e0e45c7eef704dc$export$ee3ff3a17106998)) state.value = (0, $72239d9463d4dc67$export$14de59408fad90b)(keyframes, this.options, finalKeyframe, this.speed);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) this.finish();
        return state;
    }
    /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */ then(resolve, reject) {
        return this.finished.then(resolve, reject);
    }
    get duration() {
        return (0, $8c69a35cd8e97a0e$export$f64c3bfbc58eec0f)(this.calculatedDuration);
    }
    get iterationDuration() {
        const { delay: delay = 0 } = this.options || {};
        return this.duration + (0, $8c69a35cd8e97a0e$export$f64c3bfbc58eec0f)(delay);
    }
    get time() {
        return (0, $8c69a35cd8e97a0e$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    set time(newTime) {
        newTime = (0, $8c69a35cd8e97a0e$export$fc3e7e8557f8c8c7)(newTime);
        this.currentTime = newTime;
        if (this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0) this.holdTime = newTime;
        else if (this.driver) this.startTime = this.driver.now() - newTime / this.playbackSpeed;
        if (this.driver) this.driver.start(false);
        else {
            this.startTime = 0;
            this.state = "paused";
            this.holdTime = newTime;
            this.tick(newTime);
        }
    }
    /**
     * Returns the generator's velocity at the current time in units/second.
     * Uses the analytical derivative when available (springs), avoiding
     * the MotionValue's frame-dependent velocity estimation.
     */ getGeneratorVelocity() {
        const t = this.currentTime;
        if (t <= 0) return this.options.velocity || 0;
        if (this.generator.velocity) return this.generator.velocity(t);
        // Fallback: finite difference
        const current = this.generator.next(t).value;
        return (0, $c276dc295f589f71$export$279c5e002bb29070)((s)=>this.generator.next(s).value, t, current);
    }
    get speed() {
        return this.playbackSpeed;
    }
    set speed(newSpeed) {
        const hasChanged = this.playbackSpeed !== newSpeed;
        if (hasChanged && this.driver) this.updateTime((0, $08568323a95fcb6c$export$2da9be4cfdb689b1).now());
        this.playbackSpeed = newSpeed;
        if (hasChanged && this.driver) this.time = (0, $8c69a35cd8e97a0e$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    play() {
        if (this.isStopped) return;
        const { driver: driver = (0, $5c4499f16fe9a8ca$export$c1033964b5ad7fef), startTime: startTime } = this.options;
        if (!this.driver) this.driver = driver((timestamp)=>this.tick(timestamp));
        this.options.onPlay?.();
        const now = this.driver.now();
        if (this.state === "finished") {
            this.updateFinished();
            this.startTime = now;
        } else if (this.holdTime !== null) this.startTime = now - this.holdTime;
        else if (!this.startTime) this.startTime = startTime ?? now;
        if (this.state === "finished" && this.speed < 0) this.startTime += this.calculatedDuration;
        this.holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ this.state = "running";
        this.driver.start();
    }
    pause() {
        this.state = "paused";
        this.updateTime((0, $08568323a95fcb6c$export$2da9be4cfdb689b1).now());
        this.holdTime = this.currentTime;
    }
    complete() {
        if (this.state !== "running") this.play();
        this.state = "finished";
        this.holdTime = null;
    }
    finish() {
        this.notifyFinished();
        this.teardown();
        this.state = "finished";
        this.options.onComplete?.();
    }
    cancel() {
        this.holdTime = null;
        this.startTime = 0;
        this.tick(0);
        this.teardown();
        this.options.onCancel?.();
    }
    teardown() {
        this.state = "idle";
        this.stopDriver();
        this.startTime = this.holdTime = null;
        (0, $2ac10515ff3039be$export$d921fb2475e2900c).mainThread--;
    }
    stopDriver() {
        if (!this.driver) return;
        this.driver.stop();
        this.driver = undefined;
    }
    sample(sampleTime) {
        this.startTime = 0;
        return this.tick(sampleTime, true);
    }
    attachTimeline(timeline) {
        if (this.options.allowFlatten) {
            this.options.type = "keyframes";
            this.options.ease = "linear";
            this.initAnimation();
        }
        this.driver?.stop();
        return timeline.observe(this);
    }
    constructor(options){
        super();
        this.state = "idle";
        this.startTime = null;
        this.isStopped = false;
        /**
         * The current time of the animation.
         */ this.currentTime = 0;
        /**
         * The time at which the animation was paused.
         */ this.holdTime = null;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */ this.playbackSpeed = 1;
        /**
         * Reusable state object for the delay phase to avoid
         * allocating a new object every frame.
         */ this.delayState = {
            done: false,
            value: undefined
        };
        /**
         * This method is bound to the instance to fix a pattern where
         * animation.stop is returned as a reference from a useEffect.
         */ this.stop = ()=>{
            const { motionValue: motionValue } = this.options;
            if (motionValue && motionValue.updatedAt !== (0, $08568323a95fcb6c$export$2da9be4cfdb689b1).now()) this.tick((0, $08568323a95fcb6c$export$2da9be4cfdb689b1).now());
            this.isStopped = true;
            if (this.state === "idle") return;
            this.teardown();
            this.options.onStop?.();
        };
        (0, $2ac10515ff3039be$export$d921fb2475e2900c).mainThread++;
        this.options = options;
        this.initAnimation();
        this.play();
        if (options.autoplay === false) this.pause();
    }
}
// Legacy function support
function $26236bfd94a3a5dc$export$ee9b76de7353d815(options) {
    return new $26236bfd94a3a5dc$export$3394f837405475c7(options);
}











const $f9856ae770abb1c2$var$unsupportedEasingFunctions = {
    anticipate: $dd1e9a9d80b64cc9$export$6b0af63b873d419e,
    backInOut: $8203cac7b38090fa$export$ddc5fd596f6c71b2,
    circInOut: $9dbc3d97c787557f$export$30d3455eee55bed5
};
function $f9856ae770abb1c2$var$isUnsupportedEase(key) {
    return key in $f9856ae770abb1c2$var$unsupportedEasingFunctions;
}
function $f9856ae770abb1c2$export$5195f232c29d1f82(transition) {
    if (typeof transition.ease === "string" && $f9856ae770abb1c2$var$isUnsupportedEase(transition.ease)) transition.ease = $f9856ae770abb1c2$var$unsupportedEasingFunctions[transition.ease];
}


/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $4ce9cfa57c5a6898$var$sampleDelta = 10; //ms
class $4ce9cfa57c5a6898$export$bd2cd6a048093d96 extends (0, $9c8050a79f839804$export$6c0f9803d8aa7219) {
    /**
     * WAAPI doesn't natively have any interruption capabilities.
     *
     * Rather than read committed styles back out of the DOM, we can
     * create a renderless JS animation and sample it twice to calculate
     * its current value, "previous" value, and therefore allow
     * Motion to calculate velocity for any subsequent animation.
     */ updateMotionValue(value) {
        const { motionValue: motionValue, onUpdate: onUpdate, onComplete: onComplete, element: element, ...options } = this.options;
        if (!motionValue) return;
        if (value !== undefined) {
            motionValue.set(value);
            return;
        }
        const sampleAnimation = new (0, $26236bfd94a3a5dc$export$3394f837405475c7)({
            ...options,
            autoplay: false
        });
        /**
         * Use wall-clock elapsed time for sampling.
         * Under CPU load, WAAPI's currentTime may not reflect actual
         * elapsed time, causing incorrect sampling and visual jumps.
         */ const sampleTime = Math.max($4ce9cfa57c5a6898$var$sampleDelta, (0, $08568323a95fcb6c$export$2da9be4cfdb689b1).now() - this.startTime);
        const delta = (0, $30bb3117a82170b4$export$7d15b64cf5a3a4c4)(0, $4ce9cfa57c5a6898$var$sampleDelta, sampleTime - $4ce9cfa57c5a6898$var$sampleDelta);
        const current = sampleAnimation.sample(sampleTime).value;
        /**
         * Write the estimated value to inline style so it persists
         * after cancel(), covering the async gap before the next
         * animation starts.
         */ const { name: name } = this.options;
        if (element && name) (0, $7d17a81e5fded5cd$export$37a5fde709c1db82)(element, name, current);
        motionValue.setWithVelocity(sampleAnimation.sample(Math.max(0, sampleTime - delta)).value, current, delta);
        sampleAnimation.stop();
    }
    constructor(options){
        /**
         * The base NativeAnimation function only supports a subset
         * of Motion easings, and WAAPI also only supports some
         * easing functions via string/cubic-bezier definitions.
         *
         * This function replaces those unsupported easing functions
         * with a JS easing function. This will later get compiled
         * to a linear() easing function.
         */ (0, $f9856ae770abb1c2$export$5195f232c29d1f82)(options);
        /**
         * Ensure we replace the transition type with a generator function
         * before passing to WAAPI.
         *
         * TODO: Does this have a better home? It could be shared with
         * JSAnimation.
         */ (0, $0860dafe737caef5$export$98db6ef1242dfa2)(options);
        super(options);
        /**
         * Only set startTime when the animation should autoplay.
         * Setting startTime on a paused WAAPI animation unpauses it
         * (per the WAAPI spec), which breaks autoplay: false.
         */ if (options.startTime !== undefined && options.autoplay !== false) this.startTime = options.startTime;
        this.options = options;
    }
}





/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $abf22f9a8e35f01d$export$65676b58b122bc38 = (value, name)=>{
    // If the list of keys that might be non-animatable grows, replace with Set
    if (name === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $bd4dae80ad095149$export$83a0e34f1302825b).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};


function $9d8db8af115e4518$var$hasKeyframesChanged(keyframes) {
    const current = keyframes[0];
    if (keyframes.length === 1) return true;
    for(let i = 0; i < keyframes.length; i++){
        if (keyframes[i] !== current) return true;
    }
}
function $9d8db8af115e4518$export$1b109e6c9968df4f(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */ const originKeyframe = keyframes[0];
    if (originKeyframe === null) return false;
    /**
     * These aren't traditionally animatable but we do support them.
     * In future we could look into making this more generic or replacing
     * this function with mix() === mixImmediate
     */ if (name === "display" || name === "visibility") return true;
    const targetKeyframe = keyframes[keyframes.length - 1];
    const isOriginAnimatable = (0, $abf22f9a8e35f01d$export$65676b58b122bc38)(originKeyframe, name);
    const isTargetAnimatable = (0, $abf22f9a8e35f01d$export$65676b58b122bc38)(targetKeyframe, name);
    (0, $8a16204eb729eee3$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${name} from "${originKeyframe}" to "${targetKeyframe}". "${isOriginAnimatable ? targetKeyframe : originKeyframe}" is not an animatable value.`, "value-not-animatable");
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) return false;
    return $9d8db8af115e4518$var$hasKeyframesChanged(keyframes) || (type === "spring" || (0, $f98aaa7bcf02649c$export$6ab7812f1bac68be)(type)) && velocity;
}


function $6431eae97be97e62$export$b2585dd3c345da47(options) {
    options.duration = 0;
    options.type = "keyframes";
}





const $c4ac75d67e99b126$var$browserColorFunctions = /^(?:oklch|oklab|lab|lch|color|color-mix|light-dark)\(/;
function $c4ac75d67e99b126$export$1af9e65d1501d15(keyframes) {
    for(let i = 0; i < keyframes.length; i++){
        if (typeof keyframes[i] === "string" && $c4ac75d67e99b126$var$browserColorFunctions.test(keyframes[i])) return true;
    }
    return false;
}


const $414f9694e53a4671$var$colorProperties = new Set([
    "color",
    "backgroundColor",
    "outlineColor",
    "fill",
    "stroke",
    "borderColor",
    "borderTopColor",
    "borderRightColor",
    "borderBottomColor",
    "borderLeftColor"
]);
const $414f9694e53a4671$var$supportsWaapi = /*@__PURE__*/ (0, $14639c1e88dc2b50$export$7c73462e0d25e514)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));
function $414f9694e53a4671$export$ea92bde116fda821(options) {
    const { motionValue: motionValue, name: name, repeatDelay: repeatDelay, repeatType: repeatType, damping: damping, type: type, keyframes: keyframes } = options;
    const subject = motionValue?.owner?.current;
    /**
     * We use this check instead of isHTMLElement() because we explicitly
     * **don't** want elements in different timing contexts (i.e. popups)
     * to be accelerated, as it's not possible to sync these animations
     * properly with those driven from the main window frameloop.
     */ if (!(subject instanceof HTMLElement)) return false;
    const { onUpdate: onUpdate, transformTemplate: transformTemplate } = motionValue.owner.getProps();
    return $414f9694e53a4671$var$supportsWaapi() && name && /**
         * Force WAAPI for color properties with browser-only color formats
         * (oklch, oklab, lab, lch, etc.) that the JS animation path can't parse.
         */ ((0, $84840151a90d6487$export$a27eefbd8fb5e404).has(name) || $414f9694e53a4671$var$colorProperties.has(name) && (0, $c4ac75d67e99b126$export$1af9e65d1501d15)(keyframes)) && (name !== "transform" || !transformTemplate) && /**
         * If we're outputting values to onUpdate then we can't use WAAPI as there's
         * no way to read the value from WAAPI every frame.
         */ !onUpdate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
}


/**
 * Maximum time allowed between an animation being created and it being
 * resolved for us to use the latter as the start time.
 *
 * This is to ensure that while we prefer to "start" an animation as soon
 * as it's triggered, we also want to avoid a visual jump if there's a big delay
 * between these two moments.
 */ const $59bed37e2037c4ea$var$MAX_RESOLVE_DELAY = 40;
class $59bed37e2037c4ea$export$b9855e2a7dee3dd2 extends (0, $cf5f10bff69b6976$export$655db786091c33e0) {
    onKeyframesResolved(keyframes, finalKeyframe, options, sync) {
        this.keyframeResolver = undefined;
        const { name: name, type: type, velocity: velocity, delay: delay, isHandoff: isHandoff, onUpdate: onUpdate } = options;
        this.resolvedAt = (0, $08568323a95fcb6c$export$2da9be4cfdb689b1).now();
        /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */ let canAnimateValue = true;
        if (!(0, $9d8db8af115e4518$export$1b109e6c9968df4f)(keyframes, name, type, velocity)) {
            canAnimateValue = false;
            if ((0, $dcfd83e0153bc5a7$export$dd826089e3c5e502).instantAnimations || !delay) onUpdate?.((0, $72239d9463d4dc67$export$14de59408fad90b)(keyframes, options, finalKeyframe));
            keyframes[0] = keyframes[keyframes.length - 1];
            (0, $6431eae97be97e62$export$b2585dd3c345da47)(options);
            options.repeat = 0;
        }
        /**
         * Resolve startTime for the animation.
         *
         * This method uses the createdAt and resolvedAt to calculate the
         * animation startTime. *Ideally*, we would use the createdAt time as t=0
         * as the following frame would then be the first frame of the animation in
         * progress, which would feel snappier.
         *
         * However, if there's a delay (main thread work) between the creation of
         * the animation and the first committed frame, we prefer to use resolvedAt
         * to avoid a sudden jump into the animation.
         */ const startTime = sync ? !this.resolvedAt ? this.createdAt : this.resolvedAt - this.createdAt > $59bed37e2037c4ea$var$MAX_RESOLVE_DELAY ? this.resolvedAt : this.createdAt : undefined;
        const resolvedOptions = {
            startTime: startTime,
            finalKeyframe: finalKeyframe,
            ...options,
            keyframes: keyframes
        };
        /**
         * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
         * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
         * optimised animation.
         *
         * Also skip WAAPI when keyframes aren't animatable, as the resolved
         * values may not be valid CSS and would trigger browser warnings.
         */ const useWaapi = canAnimateValue && !isHandoff && (0, $414f9694e53a4671$export$ea92bde116fda821)(resolvedOptions);
        const element = resolvedOptions.motionValue?.owner?.current;
        let animation;
        if (useWaapi) try {
            animation = new (0, $4ce9cfa57c5a6898$export$bd2cd6a048093d96)({
                ...resolvedOptions,
                element: element
            });
        } catch  {
            animation = new (0, $26236bfd94a3a5dc$export$3394f837405475c7)(resolvedOptions);
        }
        else animation = new (0, $26236bfd94a3a5dc$export$3394f837405475c7)(resolvedOptions);
        animation.finished.then(()=>{
            this.notifyFinished();
        }).catch((0, $df2228348c5a149c$export$8793edee2d425525));
        if (this.pendingTimeline) {
            this.stopTimeline = animation.attachTimeline(this.pendingTimeline);
            this.pendingTimeline = undefined;
        }
        this._animation = animation;
    }
    get finished() {
        if (!this._animation) return this._finished;
        else return this.animation.finished;
    }
    then(onResolve, _onReject) {
        return this.finished.finally(onResolve).then(()=>{});
    }
    get animation() {
        if (!this._animation) {
            this.keyframeResolver?.resume();
            (0, $22e7011c70149f46$export$78b96d2a12593b05)();
        }
        return this._animation;
    }
    get duration() {
        return this.animation.duration;
    }
    get iterationDuration() {
        return this.animation.iterationDuration;
    }
    get time() {
        return this.animation.time;
    }
    set time(newTime) {
        this.animation.time = newTime;
    }
    get speed() {
        return this.animation.speed;
    }
    get state() {
        return this.animation.state;
    }
    set speed(newSpeed) {
        this.animation.speed = newSpeed;
    }
    get startTime() {
        return this.animation.startTime;
    }
    attachTimeline(timeline) {
        if (this._animation) this.stopTimeline = this.animation.attachTimeline(timeline);
        else this.pendingTimeline = timeline;
        return ()=>this.stop();
    }
    play() {
        this.animation.play();
    }
    pause() {
        this.animation.pause();
    }
    complete() {
        this.animation.complete();
    }
    cancel() {
        if (this._animation) this.animation.cancel();
        this.keyframeResolver?.cancel();
    }
    constructor({ autoplay: autoplay = true, delay: delay = 0, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", keyframes: keyframes, name: name, motionValue: motionValue, element: element, ...options }){
        super();
        /**
         * Bound to support return animation.stop pattern
         */ this.stop = ()=>{
            if (this._animation) {
                this._animation.stop();
                this.stopTimeline?.();
            }
            this.keyframeResolver?.cancel();
        };
        this.createdAt = (0, $08568323a95fcb6c$export$2da9be4cfdb689b1).now();
        const optionsWithDefaults = {
            autoplay: autoplay,
            delay: delay,
            type: type,
            repeat: repeat,
            repeatDelay: repeatDelay,
            repeatType: repeatType,
            name: name,
            motionValue: motionValue,
            element: element,
            ...options
        };
        const KeyframeResolver$1 = element?.KeyframeResolver || (0, $22e7011c70149f46$export$74d34ca3182f1750);
        this.keyframeResolver = new KeyframeResolver$1(keyframes, (resolvedKeyframes, finalKeyframe, forced)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe, optionsWithDefaults, !forced), name, motionValue, element);
        this.keyframeResolver?.scheduleResolve();
    }
}






const $c355d826c4dcd748$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $c355d826c4dcd748$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $c355d826c4dcd748$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $c355d826c4dcd748$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $c355d826c4dcd748$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $c355d826c4dcd748$var$keyframesTransition;
    else if ((0, $36352b87224ae25e$export$7b42a0094fb00b6e).has(valueKey)) return valueKey.startsWith("scale") ? $c355d826c4dcd748$var$criticallyDampedSpring(keyframes[1]) : $c355d826c4dcd748$var$underDampedSpring;
    return $c355d826c4dcd748$var$ease;
};



const $177a969f2d97fd56$var$orchestrationKeys = new Set([
    "when",
    "delay",
    "delayChildren",
    "staggerChildren",
    "staggerDirection",
    "repeat",
    "repeatType",
    "repeatDelay",
    "from",
    "elapsed"
]);
/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $177a969f2d97fd56$export$ca8e47dc8ed5a9d7(transition) {
    for(const key in transition){
        if (!$177a969f2d97fd56$var$orchestrationKeys.has(key)) return true;
    }
    return false;
}



const $b2af294d9dfd3397$export$90b3dfc33ff3548 = (name, value, target, transition = {}, element, isHandoff)=>(onComplete)=>{
        const valueTransition = (0, $e6a44c6e4fc3283d$export$7c1391340308742e)(transition, name) || {};
        /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */ const delay = valueTransition.delay || transition.delay || 0;
        /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $8c69a35cd8e97a0e$export$fc3e7e8557f8c8c7)(delay);
        const options = {
            keyframes: Array.isArray(target) ? target : [
                null,
                target
            ],
            ease: "easeOut",
            velocity: value.getVelocity(),
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            },
            name: name,
            motionValue: value,
            element: isHandoff ? undefined : element
        };
        /**
     * If there's no transition defined for this value, we can generate
     * unique transition settings for this value.
     */ if (!(0, $177a969f2d97fd56$export$ca8e47dc8ed5a9d7)(valueTransition)) Object.assign(options, (0, $c355d826c4dcd748$export$262124b154b9f1c0)(name, options));
        /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */ options.duration && (options.duration = (0, $8c69a35cd8e97a0e$export$fc3e7e8557f8c8c7)(options.duration));
        options.repeatDelay && (options.repeatDelay = (0, $8c69a35cd8e97a0e$export$fc3e7e8557f8c8c7)(options.repeatDelay));
        /**
     * Support deprecated way to set initial value. Prefer keyframe syntax.
     */ if (options.from !== undefined) options.keyframes[0] = options.from;
        let shouldSkip = false;
        if (options.type === false || options.duration === 0 && !options.repeatDelay) {
            (0, $6431eae97be97e62$export$b2585dd3c345da47)(options);
            if (options.delay === 0) shouldSkip = true;
        }
        if ((0, $dcfd83e0153bc5a7$export$dd826089e3c5e502).instantAnimations || (0, $dcfd83e0153bc5a7$export$dd826089e3c5e502).skipAnimations || element?.shouldSkipAnimations || valueTransition.skipAnimations) {
            shouldSkip = true;
            (0, $6431eae97be97e62$export$b2585dd3c345da47)(options);
            options.delay = 0;
        }
        /**
     * If the transition type or easing has been explicitly set by the user
     * then we don't want to allow flattening the animation.
     */ options.allowFlatten = !valueTransition.type && !valueTransition.ease;
        /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */ if (shouldSkip && !isHandoff && value.get() !== undefined) {
            const finalKeyframe = (0, $72239d9463d4dc67$export$14de59408fad90b)(options.keyframes, valueTransition);
            if (finalKeyframe !== undefined) {
                (0, $99c45f49fc7b5e17$export$2cef06c20297c17d).update(()=>{
                    options.onUpdate(finalKeyframe);
                    options.onComplete();
                });
                return;
            }
        }
        return valueTransition.isSync ? new (0, $26236bfd94a3a5dc$export$3394f837405475c7)(options) : new (0, $59bed37e2037c4ea$export$b9855e2a7dee3dd2)(options);
    };



/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $df5fa623c82040e9$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $df5fa623c82040e9$export$68cacfeee78d98d2(visualElement, targetAndTransition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    let { transition: transition, transitionEnd: transitionEnd, ...target } = targetAndTransition;
    const defaultTransition = visualElement.getDefaultTransition();
    transition = transition ? (0, $231df4a5a6e9d9d6$export$b180037f8f468d61)(transition, defaultTransition) : defaultTransition;
    const reduceMotion = transition?.reduceMotion;
    const skipAnimations = transition?.skipAnimations;
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    const path = transition?.path;
    if (path) // path mutates `target` to claim x/y; loop below skips them.
    path.animateVisualElement(visualElement, target, transition, delay, animations);
    for(const key in target){
        const value = visualElement.getValue(key, visualElement.latestValues[key] ?? null);
        const valueTarget = target[key];
        if (valueTarget === undefined || animationTypeState && $df5fa623c82040e9$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            ...(0, $e6a44c6e4fc3283d$export$7c1391340308742e)(transition || {}, key)
        };
        if (skipAnimations) valueTransition.skipAnimations = true;
        /**
         * If the value is already at the defined target, skip the animation.
         * We still re-assert the value via frame.update to take precedence
         * over any stale transitionEnd callbacks from previous animations.
         */ const currentValue = value.get();
        if (currentValue !== undefined && !value.isAnimating() && !Array.isArray(valueTarget) && valueTarget === currentValue && !valueTransition.velocity) {
            (0, $99c45f49fc7b5e17$export$2cef06c20297c17d).update(()=>value.set(valueTarget));
            continue;
        }
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ let isHandoff = false;
        if (window.MotionHandoffAnimation) {
            const appearId = (0, $64421ba86c14703e$export$5f8d21e84d1d84fc)(visualElement);
            if (appearId) {
                const startTime = window.MotionHandoffAnimation(appearId, key, (0, $99c45f49fc7b5e17$export$2cef06c20297c17d));
                if (startTime !== null) {
                    valueTransition.startTime = startTime;
                    isHandoff = true;
                }
            }
        }
        (0, $1758461b0718b682$export$3ac5aed310be0bee)(visualElement, key);
        const shouldReduceMotion = reduceMotion ?? visualElement.shouldReduceMotion;
        value.start((0, $b2af294d9dfd3397$export$90b3dfc33ff3548)(key, value, valueTarget, shouldReduceMotion && (0, $6c578834c45b15a9$export$c66c0d5db2a205d).has(key) ? {
            type: false
        } : valueTransition, visualElement, isHandoff));
        const animation = value.animation;
        if (animation) animations.push(animation);
    }
    if (transitionEnd) {
        const applyTransitionEnd = ()=>(0, $99c45f49fc7b5e17$export$2cef06c20297c17d).update(()=>{
                transitionEnd && (0, $cb29a2a6ae2c9801$export$1f61c53461aff4a5)(visualElement, transitionEnd);
            });
        if (animations.length) Promise.all(animations).then(applyTransitionEnd);
        else applyTransitionEnd();
    }
    return animations;
}



function $094bc3ef14a2fb5d$export$6e01cb2cb232d79b(children, child, delayChildren, staggerChildren = 0, staggerDirection = 1) {
    const index = Array.from(children).sort((a, b)=>a.sortNodePosition(b)).indexOf(child);
    const numChildren = children.size;
    const maxStaggerDuration = (numChildren - 1) * staggerChildren;
    const delayIsFunction = typeof delayChildren === "function";
    return delayIsFunction ? delayChildren(index, numChildren) : staggerDirection === 1 ? index * staggerChildren : maxStaggerDuration - index * staggerChildren;
}



function $6c27bc5f40cbe119$export$4709dc300705b2af(visualElement, variant, options = {}) {
    const resolved = (0, $ce15ba87bccd1c3b$export$7b1b1c981f4f0558)(visualElement, variant, options.type === "exit" ? visualElement.presenceContext?.custom : undefined);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $df5fa623c82040e9$export$68cacfeee78d98d2)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $6c27bc5f40cbe119$var$animateChildren(visualElement, variant, forwardDelay, delayChildren, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $6c27bc5f40cbe119$var$animateChildren(visualElement, variant, delay = 0, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    for (const child of visualElement.variantChildren){
        child.notify("AnimationStart", variant);
        animations.push($6c27bc5f40cbe119$export$4709dc300705b2af(child, variant, {
            ...options,
            delay: delay + (typeof delayChildren === "function" ? 0 : delayChildren) + (0, $094bc3ef14a2fb5d$export$6e01cb2cb232d79b)(visualElement.variantChildren, child, delayChildren, staggerChildren, staggerDirection)
        }).then(()=>child.notify("AnimationComplete", variant)));
    }
    return Promise.all(animations);
}


function $69d89e1b07a531ef$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $6c27bc5f40cbe119$export$4709dc300705b2af)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $6c27bc5f40cbe119$export$4709dc300705b2af)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $ce15ba87bccd1c3b$export$7b1b1c981f4f0558)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $df5fa623c82040e9$export$68cacfeee78d98d2)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>{
        visualElement.notify("AnimationComplete", definition);
    });
}





const $d861e04760045e21$var$numVariantProps = (0, $b987648e534a47ff$export$1405a65085f40b9).length;
/**
 * Get variant context from a visual element's parent chain.
 * Uses `any` type for visualElement to avoid circular dependencies.
 */ function $d861e04760045e21$export$6669f52f7ffa343b(visualElement) {
    if (!visualElement) return undefined;
    if (!visualElement.isControllingVariants) {
        const context = visualElement.parent ? $d861e04760045e21$export$6669f52f7ffa343b(visualElement.parent) || {} : {};
        if (visualElement.props.initial !== undefined) context.initial = visualElement.props.initial;
        return context;
    }
    const context = {};
    for(let i = 0; i < $d861e04760045e21$var$numVariantProps; i++){
        const name = (0, $b987648e534a47ff$export$1405a65085f40b9)[i];
        const prop = visualElement.props[name];
        if ((0, $2ce69ad985562542$export$720b90e312cea233)(prop) || prop === false) context[name] = prop;
    }
    return context;
}






function $76ebfb563ddf6b9a$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}



const $6cd6f612df97866f$var$reversePriorityOrder = [
    ...(0, $b987648e534a47ff$export$16e45afcc206d3a8)
].reverse();
const $6cd6f612df97866f$var$numAnimationTypes = (0, $b987648e534a47ff$export$16e45afcc206d3a8).length;
function $6cd6f612df97866f$var$createAnimateFunction(visualElement) {
    return (animations)=>{
        return Promise.all(animations.map(({ animation: animation, options: options })=>(0, $69d89e1b07a531ef$export$ff62cf473653f109)(visualElement, animation, options)));
    };
}
function $6cd6f612df97866f$export$bb53502b7a672aa8(visualElement) {
    let animate = $6cd6f612df97866f$var$createAnimateFunction(visualElement);
    let state = $6cd6f612df97866f$var$createState();
    let isInitialRender = true;
    /**
     * Track whether the animation state has been reset (e.g. via StrictMode
     * double-invocation or Suspense unmount/remount). On the first
     * animateChanges() call after a reset we need to behave like the initial
     * render for variant-inheritance checks, even though isInitialRender is
     * already false.
     */ let wasReset = false;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (type)=>(acc, definition)=>{
            const resolved = (0, $ce15ba87bccd1c3b$export$7b1b1c981f4f0558)(visualElement, definition, type === "exit" ? visualElement.presenceContext?.custom : undefined);
            if (resolved) {
                const { transition: transition, transitionEnd: transitionEnd, ...target } = resolved;
                acc = {
                    ...acc,
                    ...target,
                    ...transitionEnd
                };
            }
            return acc;
        };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(changedActiveType) {
        const { props: props } = visualElement;
        const context = (0, $d861e04760045e21$export$6669f52f7ffa343b)(visualElement.parent) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $6cd6f612df97866f$var$numAnimationTypes; i++){
            const type = $6cd6f612df97866f$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $2ce69ad985562542$export$720b90e312cea233)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            if (isInherited && (isInitialRender || wasReset) && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $f6c92e10f2e25836$export$aa71198ceeaf53ce)(prop) || typeof prop === "boolean") continue;
            /**
             * If exit is already active and wasn't just activated, skip
             * re-processing to prevent interrupting running exit animations.
             * Re-resolving exit with a changed custom value can start new
             * value animations that stop the originals, leaving the exit
             * animation promise unresolved and the component stuck in the DOM.
             */ if (type === "exit" && typeState.isActive && activeDelta !== true) {
                if (typeState.prevResolvedValues) encounteredKeys = {
                    ...encounteredKeys,
                    ...typeState.prevResolvedValues
                };
                continue;
            }
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $6cd6f612df97866f$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            let handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues(type), {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = false;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ let valueHasChanged = false;
                if ((0, $8f3c3c3fa9fdb4ef$export$9153ad4c4999f4a0)(next) && (0, $8f3c3c3fa9fdb4ef$export$9153ad4c4999f4a0)(prev)) valueHasChanged = !(0, $76ebfb563ddf6b9a$export$90e866afbd6b9f1a)(next, prev) || variantDidChange;
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined && next !== null) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if ((isInitialRender || wasReset) && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to skip this animation
             * unless the inherited variants haven't changed on this render.
             */ const willAnimateViaParent = isInherited && variantDidChange;
            const needsAnimating = !willAnimateViaParent || handledRemovedValues;
            if (shouldAnimateType && needsAnimating) animations.push(...definitionList.map((animation)=>{
                const options = {
                    type: type
                };
                /**
                     * If we're performing the initial animation, but we're not
                     * rendering at the same time as the variant-controlling parent,
                     * we want to use the parent's transition to calculate the stagger.
                     */ if (typeof animation === "string" && (isInitialRender || wasReset) && !willAnimateViaParent && visualElement.manuallyAnimateOnMount && visualElement.parent) {
                    const { parent: parent } = visualElement;
                    const parentVariant = (0, $ce15ba87bccd1c3b$export$7b1b1c981f4f0558)(parent, animation);
                    if (parent.enteringChildren && parentVariant) {
                        const { delayChildren: delayChildren } = parentVariant.transition || {};
                        options.delay = (0, $094bc3ef14a2fb5d$export$6e01cb2cb232d79b)(parent.enteringChildren, visualElement, delayChildren);
                    }
                }
                return {
                    animation: animation,
                    options: options
                };
            }));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            /**
             * If the initial prop contains a transition we can use that, otherwise
             * allow the animation function to use the visual element's default.
             */ if (typeof props.initial !== "boolean") {
                const initialTransition = (0, $ce15ba87bccd1c3b$export$7b1b1c981f4f0558)(visualElement, Array.isArray(props.initial) ? props.initial[0] : props.initial);
                if (initialTransition && initialTransition.transition) fallbackAnimation.transition = initialTransition.transition;
            }
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = true;
                // @ts-expect-error - @mattgperry to figure if we should do something here
                fallbackAnimation[key] = fallbackTarget ?? null;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        wasReset = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive) {
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        visualElement.variantChildren?.forEach((child)=>child.animationState?.setActive(type, isActive));
        state[type].isActive = isActive;
        const animations = animateChanges(type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state,
        reset: ()=>{
            state = $6cd6f612df97866f$var$createState();
            wasReset = true;
        }
    };
}
function $6cd6f612df97866f$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $76ebfb563ddf6b9a$export$90e866afbd6b9f1a)(next, prev);
    return false;
}
function $6cd6f612df97866f$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $6cd6f612df97866f$var$createState() {
    return {
        animate: $6cd6f612df97866f$var$createTypeState(true),
        whileInView: $6cd6f612df97866f$var$createTypeState(),
        whileHover: $6cd6f612df97866f$var$createTypeState(),
        whileTap: $6cd6f612df97866f$var$createTypeState(),
        whileDrag: $6cd6f612df97866f$var$createTypeState(),
        whileFocus: $6cd6f612df97866f$var$createTypeState(),
        exit: $6cd6f612df97866f$var$createTypeState()
    };
}

/**
 * Feature base class for extending VisualElement functionality.
 * Features are plugins that can be mounted/unmounted to add behavior
 * like gestures, animations, or layout tracking.
 */ class $26080a271792ef8a$export$6e91cf7616333d5 {
    update() {}
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
}


class $2e3fcc23fd02ca58$export$b45b3fe5caabdca extends (0, $26080a271792ef8a$export$6e91cf7616333d5) {
    updateAnimationControlsSubscription() {
        const { animate: animate } = this.node.getProps();
        if ((0, $f6c92e10f2e25836$export$aa71198ceeaf53ce)(animate)) this.unmountControls = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {
        this.node.animationState.reset();
        this.unmountControls?.();
    }
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $6cd6f612df97866f$export$bb53502b7a672aa8)(node));
    }
}



let $bfc03f0b27c7695b$var$id = 0;
class $bfc03f0b27c7695b$export$4989d1eb6104cc6c extends (0, $26080a271792ef8a$export$6e91cf7616333d5) {
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent, onExitComplete: onExitComplete } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        if (isPresent && prevIsPresent === false) {
            /**
             * When re-entering, if the exit animation already completed
             * (element is at rest), reset to initial values so the enter
             * animation replays from the correct position.
             */ if (this.isExitComplete) {
                const { initial: initial, custom: custom } = this.node.getProps();
                if (typeof initial === "string" || typeof initial === "object" && initial !== null && !Array.isArray(initial)) {
                    const resolved = (0, $ce15ba87bccd1c3b$export$7b1b1c981f4f0558)(this.node, initial, custom);
                    if (resolved) {
                        const { transition: transition, transitionEnd: transitionEnd, ...target } = resolved;
                        for(const key in target)this.node.getValue(key)?.jump(target[key]);
                    }
                }
                this.node.animationState.reset();
                this.node.animationState.animateChanges();
            } else this.node.animationState.setActive("exit", false);
            this.isExitComplete = false;
            return;
        }
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent);
        if (onExitComplete && !isPresent) exitAnimation.then(()=>{
            this.isExitComplete = true;
            onExitComplete(this.id);
        });
    }
    mount() {
        const { register: register, onExitComplete: onExitComplete } = this.node.presenceContext || {};
        if (onExitComplete) onExitComplete(this.id);
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
    constructor(){
        super(...arguments);
        this.id = $bfc03f0b27c7695b$var$id++;
        this.isExitComplete = false;
    }
}


const $61435b153a491fc2$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $2e3fcc23fd02ca58$export$b45b3fe5caabdca)
    },
    exit: {
        Feature: (0, $bfc03f0b27c7695b$export$4989d1eb6104cc6c)
    }
};




function $c6c2e3791712db82$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}


const $3cec24e0364f7039$var$SCALE_PRECISION = 0.0001;
const $3cec24e0364f7039$var$SCALE_MIN = 1 - $3cec24e0364f7039$var$SCALE_PRECISION;
const $3cec24e0364f7039$var$SCALE_MAX = 1 + $3cec24e0364f7039$var$SCALE_PRECISION;
const $3cec24e0364f7039$var$TRANSLATE_PRECISION = 0.01;
const $3cec24e0364f7039$var$TRANSLATE_MIN = 0 - $3cec24e0364f7039$var$TRANSLATE_PRECISION;
const $3cec24e0364f7039$var$TRANSLATE_MAX = 0 + $3cec24e0364f7039$var$TRANSLATE_PRECISION;
function $3cec24e0364f7039$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $3cec24e0364f7039$export$28d0384c4b79bde2(value, target, maxDistance) {
    return Math.abs(value - target) <= maxDistance;
}
function $3cec24e0364f7039$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $5a3532f8b2a8e80b$export$3bb0b4ff1037b8dd)(source.min, source.max, delta.origin);
    delta.scale = $3cec24e0364f7039$export$c1c127004b72a37(target) / $3cec24e0364f7039$export$c1c127004b72a37(source);
    delta.translate = (0, $5a3532f8b2a8e80b$export$3bb0b4ff1037b8dd)(target.min, target.max, delta.origin) - delta.originPoint;
    if (delta.scale >= $3cec24e0364f7039$var$SCALE_MIN && delta.scale <= $3cec24e0364f7039$var$SCALE_MAX || isNaN(delta.scale)) delta.scale = 1.0;
    if (delta.translate >= $3cec24e0364f7039$var$TRANSLATE_MIN && delta.translate <= $3cec24e0364f7039$var$TRANSLATE_MAX || isNaN(delta.translate)) delta.translate = 0.0;
}
function $3cec24e0364f7039$export$c0d25e96fc67d310(delta, source, target, origin) {
    $3cec24e0364f7039$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $3cec24e0364f7039$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $3cec24e0364f7039$export$cabef5b392704b41(target, relative, parent, anchor = 0) {
    const anchorPoint = anchor ? (0, $5a3532f8b2a8e80b$export$3bb0b4ff1037b8dd)(parent.min, parent.max, anchor) : parent.min;
    target.min = anchorPoint + relative.min;
    target.max = target.min + $3cec24e0364f7039$export$c1c127004b72a37(relative);
}
function $3cec24e0364f7039$export$426154f9d100f99(target, relative, parent, anchor) {
    $3cec24e0364f7039$export$cabef5b392704b41(target.x, relative.x, parent.x, anchor?.x);
    $3cec24e0364f7039$export$cabef5b392704b41(target.y, relative.y, parent.y, anchor?.y);
}
function $3cec24e0364f7039$export$ecd3d3bef81102c3(target, layout, parent, anchor = 0) {
    const anchorPoint = anchor ? (0, $5a3532f8b2a8e80b$export$3bb0b4ff1037b8dd)(parent.min, parent.max, anchor) : parent.min;
    target.min = layout.min - anchorPoint;
    target.max = target.min + $3cec24e0364f7039$export$c1c127004b72a37(layout);
}
function $3cec24e0364f7039$export$2785bfcc929c5650(target, layout, parent, anchor) {
    $3cec24e0364f7039$export$ecd3d3bef81102c3(target.x, layout.x, parent.x, anchor?.x);
    $3cec24e0364f7039$export$ecd3d3bef81102c3(target.y, layout.y, parent.y, anchor?.y);
}

function $677cd175d6f56db8$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}

const $7d4abd4ea4a9f329$var$keyboardAccessibleElements = new Set([
    "BUTTON",
    "INPUT",
    "SELECT",
    "TEXTAREA",
    "A"
]);
/**
 * Checks if an element is natively keyboard accessible (focusable).
 * Used by the press gesture to determine if we need to add tabIndex.
 */ function $7d4abd4ea4a9f329$export$5f6976e2f961e8b7(element) {
    return $7d4abd4ea4a9f329$var$keyboardAccessibleElements.has(element.tagName) || element.isContentEditable === true;
}
const $7d4abd4ea4a9f329$var$textInputElements = new Set([
    "INPUT",
    "SELECT",
    "TEXTAREA"
]);
/**
 * Checks if an element has text selection or direct interaction behavior
 * that should block drag gestures from starting.
 *
 * This specifically targets form controls where the user might want to select
 * text or interact with the control (e.g., sliders, dropdowns).
 *
 * Buttons and links are NOT included because they don't have click-and-move
 * actions of their own - they only respond to click events, so dragging
 * should still work when initiated from these elements.
 */ function $7d4abd4ea4a9f329$export$41e5a41992b76128(element) {
    return $7d4abd4ea4a9f329$var$textInputElements.has(element.tagName) || element.isContentEditable === true;
}

const $04cb160e67a0ea6d$export$a6cdc56e425d0d0a = (value)=>typeof value === "object" && value !== null;


/**
 * Checks if an element is an SVG element in a way
 * that works across iframes
 */ function $a73c01e48b6f8ee0$export$17eda790a720ec57(element) {
    return (0, $04cb160e67a0ea6d$export$a6cdc56e425d0d0a)(element) && "ownerSVGElement" in element;
}


function $0da12101cded0c58$export$90ceba2564a894f8(elementOrSelector, scope, selectorCache) {
    if (elementOrSelector == null) return [];
    if (elementOrSelector instanceof EventTarget) return [
        elementOrSelector
    ];
    else if (typeof elementOrSelector === "string") {
        let root = document;
        if (scope) root = scope.current;
        const elements = selectorCache?.[elementOrSelector] ?? root.querySelectorAll(elementOrSelector);
        return elements ? Array.from(elements) : [];
    }
    return Array.from(elementOrSelector).filter((element)=>element != null);
}


const $0977eda132aa31a4$var$resizeHandlers = new WeakMap();
let $0977eda132aa31a4$var$observer;
const $0977eda132aa31a4$var$getSize = (borderBoxAxis, svgAxis, htmlAxis)=>(target, borderBoxSize)=>{
        if (borderBoxSize && borderBoxSize[0]) return borderBoxSize[0][borderBoxAxis + "Size"];
        else if ((0, $a73c01e48b6f8ee0$export$17eda790a720ec57)(target) && "getBBox" in target) return target.getBBox()[svgAxis];
        else return target[htmlAxis];
    };
const $0977eda132aa31a4$var$getWidth = /*@__PURE__*/ $0977eda132aa31a4$var$getSize("inline", "width", "offsetWidth");
const $0977eda132aa31a4$var$getHeight = /*@__PURE__*/ $0977eda132aa31a4$var$getSize("block", "height", "offsetHeight");
function $0977eda132aa31a4$var$notifyTarget({ target: target, borderBoxSize: borderBoxSize }) {
    $0977eda132aa31a4$var$resizeHandlers.get(target)?.forEach((handler)=>{
        handler(target, {
            get width () {
                return $0977eda132aa31a4$var$getWidth(target, borderBoxSize);
            },
            get height () {
                return $0977eda132aa31a4$var$getHeight(target, borderBoxSize);
            }
        });
    });
}
function $0977eda132aa31a4$var$notifyAll(entries) {
    entries.forEach($0977eda132aa31a4$var$notifyTarget);
}
function $0977eda132aa31a4$var$createResizeObserver() {
    if (typeof ResizeObserver === "undefined") return;
    $0977eda132aa31a4$var$observer = new ResizeObserver($0977eda132aa31a4$var$notifyAll);
}
function $0977eda132aa31a4$export$81a0e12ec749d682(target, handler) {
    if (!$0977eda132aa31a4$var$observer) $0977eda132aa31a4$var$createResizeObserver();
    const elements = (0, $0da12101cded0c58$export$90ceba2564a894f8)(target);
    elements.forEach((element)=>{
        let elementHandlers = $0977eda132aa31a4$var$resizeHandlers.get(element);
        if (!elementHandlers) {
            elementHandlers = new Set();
            $0977eda132aa31a4$var$resizeHandlers.set(element, elementHandlers);
        }
        elementHandlers.add(handler);
        $0977eda132aa31a4$var$observer?.observe(element);
    });
    return ()=>{
        elements.forEach((element)=>{
            const elementHandlers = $0977eda132aa31a4$var$resizeHandlers.get(element);
            elementHandlers?.delete(handler);
            if (!elementHandlers?.size) $0977eda132aa31a4$var$observer?.unobserve(element);
        });
    };
}


const $b800ded455ef533e$var$windowCallbacks = new Set();
let $b800ded455ef533e$var$windowResizeHandler;
function $b800ded455ef533e$var$createWindowResizeHandler() {
    $b800ded455ef533e$var$windowResizeHandler = ()=>{
        const info = {
            get width () {
                return window.innerWidth;
            },
            get height () {
                return window.innerHeight;
            }
        };
        $b800ded455ef533e$var$windowCallbacks.forEach((callback)=>callback(info));
    };
    window.addEventListener("resize", $b800ded455ef533e$var$windowResizeHandler);
}
function $b800ded455ef533e$export$7fc81011b72cd94d(callback) {
    $b800ded455ef533e$var$windowCallbacks.add(callback);
    if (!$b800ded455ef533e$var$windowResizeHandler) $b800ded455ef533e$var$createWindowResizeHandler();
    return ()=>{
        $b800ded455ef533e$var$windowCallbacks.delete(callback);
        if (!$b800ded455ef533e$var$windowCallbacks.size && typeof $b800ded455ef533e$var$windowResizeHandler === "function") {
            window.removeEventListener("resize", $b800ded455ef533e$var$windowResizeHandler);
            $b800ded455ef533e$var$windowResizeHandler = undefined;
        }
    };
}


function $fb15b79aace0dbcc$export$4380c87abf28fdf(a, b) {
    return typeof a === "function" ? (0, $b800ded455ef533e$export$7fc81011b72cd94d)(a) : (0, $0977eda132aa31a4$export$81a0e12ec749d682)(a, b);
}

const $8c06e427fb97e53d$export$9e9bc3c487fccc00 = {
    x: false,
    y: false
};
function $8c06e427fb97e53d$export$1b3dd616664938e4() {
    return $8c06e427fb97e53d$export$9e9bc3c487fccc00.x || $8c06e427fb97e53d$export$9e9bc3c487fccc00.y;
}


function $49ef81f7d858a2cd$export$64d8a3fd7eb621d5(axis) {
    if (axis === "x" || axis === "y") {
        if ((0, $8c06e427fb97e53d$export$9e9bc3c487fccc00)[axis]) return null;
        else {
            (0, $8c06e427fb97e53d$export$9e9bc3c487fccc00)[axis] = true;
            return ()=>{
                (0, $8c06e427fb97e53d$export$9e9bc3c487fccc00)[axis] = false;
            };
        }
    } else {
        if ((0, $8c06e427fb97e53d$export$9e9bc3c487fccc00).x || (0, $8c06e427fb97e53d$export$9e9bc3c487fccc00).y) return null;
        else {
            (0, $8c06e427fb97e53d$export$9e9bc3c487fccc00).x = (0, $8c06e427fb97e53d$export$9e9bc3c487fccc00).y = true;
            return ()=>{
                (0, $8c06e427fb97e53d$export$9e9bc3c487fccc00).x = (0, $8c06e427fb97e53d$export$9e9bc3c487fccc00).y = false;
            };
        }
    }
}




const $d1d5b7f809794a2a$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};


function $7bbf8abca28d5486$export$12f84bb882d06e1a(event) {
    return {
        point: {
            x: event.pageX,
            y: event.pageY
        }
    };
}
const $7bbf8abca28d5486$export$c404e80f92c98d29 = (handler)=>(event)=>(0, $d1d5b7f809794a2a$export$a4cf9c8a4b063a6e)(event) && handler(event, $7bbf8abca28d5486$export$12f84bb882d06e1a(event));


function $ab84e27352805a65$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $c6c2e3791712db82$export$b1d829ddf82884aa)(target, eventName, (0, $7bbf8abca28d5486$export$c404e80f92c98d29)(handler), options);
}



// Fixes https://github.com/motiondivision/motion/issues/2270
const $744c5569eb3a50b1$export$d533d84f9871c879 = ({ current: current })=>{
    return current ? current.ownerDocument.defaultView : null;
};







const $67164393e69851d5$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $67164393e69851d5$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $67164393e69851d5$export$9f17032d917177de(a.x, b.x);
    const yDelta = $67164393e69851d5$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}


const $77cee1f99467ec6e$var$overflowStyles = /*#__PURE__*/ new Set([
    "auto",
    "scroll"
]);
/**
 * @internal
 */ class $77cee1f99467ec6e$export$d9c66232c9c4689c {
    /**
     * Start tracking scroll on ancestors and window.
     */ startScrollTracking(element) {
        // Store initial scroll positions for scrollable ancestors
        let current = element.parentElement;
        while(current){
            const style = getComputedStyle(current);
            if ($77cee1f99467ec6e$var$overflowStyles.has(style.overflowX) || $77cee1f99467ec6e$var$overflowStyles.has(style.overflowY)) this.scrollPositions.set(current, {
                x: current.scrollLeft,
                y: current.scrollTop
            });
            current = current.parentElement;
        }
        // Track window scroll
        this.scrollPositions.set(window, {
            x: window.scrollX,
            y: window.scrollY
        });
        // Capture listener catches element scroll events as they bubble
        window.addEventListener("scroll", this.onElementScroll, {
            capture: true
        });
        // Direct window scroll listener (window scroll doesn't bubble)
        window.addEventListener("scroll", this.onWindowScroll);
        this.removeScrollListeners = ()=>{
            window.removeEventListener("scroll", this.onElementScroll, {
                capture: true
            });
            window.removeEventListener("scroll", this.onWindowScroll);
        };
    }
    /**
     * Handle scroll compensation during drag.
     *
     * For element scroll: adjusts history origin since pageX/pageY doesn't change.
     * For window scroll: adjusts lastMoveEventInfo since pageX/pageY would change.
     */ handleScroll(target) {
        const initial = this.scrollPositions.get(target);
        if (!initial) return;
        const isWindow = target === window;
        const current = isWindow ? {
            x: window.scrollX,
            y: window.scrollY
        } : {
            x: target.scrollLeft,
            y: target.scrollTop
        };
        const delta = {
            x: current.x - initial.x,
            y: current.y - initial.y
        };
        if (delta.x === 0 && delta.y === 0) return;
        if (isWindow) // Window scroll: pageX/pageY changes, so update lastMoveEventInfo
        {
            if (this.lastMoveEventInfo) {
                this.lastMoveEventInfo.point.x += delta.x;
                this.lastMoveEventInfo.point.y += delta.y;
            }
        } else // Element scroll: pageX/pageY unchanged, so adjust history origin
        if (this.history.length > 0) {
            this.history[0].x -= delta.x;
            this.history[0].y -= delta.y;
        }
        this.scrollPositions.set(target, current);
        (0, $99c45f49fc7b5e17$export$2cef06c20297c17d).update(this.updatePoint, true);
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        this.removeScrollListeners && this.removeScrollListeners();
        this.scrollPositions.clear();
        (0, $99c45f49fc7b5e17$export$ec99c0ef4978dccb)(this.updatePoint);
    }
    constructor(event, handlers, { transformPagePoint: transformPagePoint, contextWindow: contextWindow = window, dragSnapToOrigin: dragSnapToOrigin = false, distanceThreshold: distanceThreshold = 3, element: element } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * Raw (untransformed) event info, re-transformed each frame
         * so transformPagePoint sees the current parent matrix.
         * @internal
         */ this.lastRawMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        /**
         * @internal
         */ this.contextWindow = window;
        /**
         * Scroll positions of scrollable ancestors and window.
         * @internal
         */ this.scrollPositions = new Map();
        /**
         * Cleanup function for scroll listeners.
         * @internal
         */ this.removeScrollListeners = null;
        this.onElementScroll = (event)=>{
            this.handleScroll(event.target);
        };
        this.onWindowScroll = ()=>{
            this.handleScroll(window);
        };
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            // Re-transform raw point through current transformPagePoint so
            // animated parent transforms (e.g. rotation) are picked up each frame
            if (this.lastRawMoveEventInfo) this.lastMoveEventInfo = $77cee1f99467ec6e$var$transformPoint(this.lastRawMoveEventInfo, this.transformPagePoint);
            const info = $77cee1f99467ec6e$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursor.
            const isDistancePastThreshold = (0, $67164393e69851d5$export$503a1d513f12e38b)(info.offset, {
                x: 0,
                y: 0
            }) >= this.distanceThreshold;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point } = info;
            const { timestamp: timestamp } = (0, $99c45f49fc7b5e17$export$fff89137e9e818ce);
            this.history.push({
                ...point,
                timestamp: timestamp
            });
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastRawMoveEventInfo = info;
            this.lastMoveEventInfo = $77cee1f99467ec6e$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $99c45f49fc7b5e17$export$2cef06c20297c17d).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            const { onEnd: onEnd, onSessionEnd: onSessionEnd, resumeAnimation: resumeAnimation } = this.handlers;
            // Resume animation if dragSnapToOrigin is set OR if no drag started (user just clicked)
            // This ensures constraint animations continue when interrupted by a click
            if (this.dragSnapToOrigin || !this.startEvent) resumeAnimation && resumeAnimation();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const panInfo = $77cee1f99467ec6e$var$getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : $77cee1f99467ec6e$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $d1d5b7f809794a2a$export$a4cf9c8a4b063a6e)(event)) return;
        this.dragSnapToOrigin = dragSnapToOrigin;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.distanceThreshold = distanceThreshold;
        this.contextWindow = contextWindow || window;
        const info = (0, $7bbf8abca28d5486$export$12f84bb882d06e1a)(event);
        const initialInfo = $77cee1f99467ec6e$var$transformPoint(info, this.transformPagePoint);
        const { point: point } = initialInfo;
        const { timestamp: timestamp } = (0, $99c45f49fc7b5e17$export$fff89137e9e818ce);
        this.history = [
            {
                ...point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, $77cee1f99467ec6e$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $49331bd461989f84$export$a4627e546088548d)((0, $ab84e27352805a65$export$fcff2e64e6676b81)(this.contextWindow, "pointermove", this.handlePointerMove), (0, $ab84e27352805a65$export$fcff2e64e6676b81)(this.contextWindow, "pointerup", this.handlePointerUp), (0, $ab84e27352805a65$export$fcff2e64e6676b81)(this.contextWindow, "pointercancel", this.handlePointerUp));
        // Start scroll tracking if element provided
        if (element) this.startScrollTracking(element);
    }
}
function $77cee1f99467ec6e$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $77cee1f99467ec6e$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $77cee1f99467ec6e$var$getPanInfo({ point: point }, history) {
    return {
        point: point,
        delta: $77cee1f99467ec6e$var$subtractPoint(point, $77cee1f99467ec6e$var$lastDevicePoint(history)),
        offset: $77cee1f99467ec6e$var$subtractPoint(point, $77cee1f99467ec6e$var$startDevicePoint(history)),
        velocity: $77cee1f99467ec6e$var$getVelocity(history, 0.1)
    };
}
function $77cee1f99467ec6e$var$startDevicePoint(history) {
    return history[0];
}
function $77cee1f99467ec6e$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $77cee1f99467ec6e$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $77cee1f99467ec6e$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $8c69a35cd8e97a0e$export$fc3e7e8557f8c8c7)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    /**
     * If the selected point is the pointer-down origin (history[0]),
     * there are better movement points available, and the time gap
     * is suspiciously large (>2x timeDelta), use the next point instead.
     * This prevents stale pointer-down points from diluting velocity
     * in hold-then-flick gestures.
     */ if (timestampedPoint === history[0] && history.length > 2 && lastPoint.timestamp - timestampedPoint.timestamp > (0, $8c69a35cd8e97a0e$export$fc3e7e8557f8c8c7)(timeDelta) * 2) timestampedPoint = history[1];
    const time = (0, $8c69a35cd8e97a0e$export$f64c3bfbc58eec0f)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}




/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $ff2520f38016ad5d$export$b3c764d3fca3ffe3(point, { min: min, max: max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $5a3532f8b2a8e80b$export$3bb0b4ff1037b8dd)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $5a3532f8b2a8e80b$export$3bb0b4ff1037b8dd)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $ff2520f38016ad5d$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $ff2520f38016ad5d$export$4e9195bf7793bc78(layoutBox, { top: top, left: left, bottom: bottom, right: right }) {
    return {
        x: $ff2520f38016ad5d$export$690c180aa5775042(layoutBox.x, left, right),
        y: $ff2520f38016ad5d$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $ff2520f38016ad5d$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $ff2520f38016ad5d$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $ff2520f38016ad5d$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $ff2520f38016ad5d$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $ff2520f38016ad5d$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $3cec24e0364f7039$export$c1c127004b72a37)(source);
    const targetLength = (0, $3cec24e0364f7039$export$c1c127004b72a37)(target);
    if (targetLength > sourceLength) origin = (0, $d1110b161f695fe9$export$504d7abb21fa8c9)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $d1110b161f695fe9$export$504d7abb21fa8c9)(source.min, source.max - targetLength, target.min);
    return (0, $30bb3117a82170b4$export$7d15b64cf5a3a4c4)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $ff2520f38016ad5d$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $ff2520f38016ad5d$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $ff2520f38016ad5d$export$7c5eaef8f4723d22(dragElastic = $ff2520f38016ad5d$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $ff2520f38016ad5d$export$a3366d3bac43a742;
    return {
        x: $ff2520f38016ad5d$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $ff2520f38016ad5d$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $ff2520f38016ad5d$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $ff2520f38016ad5d$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $ff2520f38016ad5d$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $ff2520f38016ad5d$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}


const $3a50d9cb07dd2466$export$f0a15892c27dc07c = new WeakMap();
class $3a50d9cb07dd2466$export$86bff71f18910307 {
    start(originEvent, { snapToCursor: snapToCursor = false, distanceThreshold: distanceThreshold } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext: presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            if (snapToCursor) this.snapToCursor((0, $7bbf8abca28d5486$export$12f84bb882d06e1a)(event).point);
            this.stopAnimation();
        };
        const onStart = (event, info)=>{
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag, dragPropagation: dragPropagation, onDragStart: onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openDragLock) this.openDragLock();
                this.openDragLock = (0, $49ef81f7d858a2cd$export$64d8a3fd7eb621d5)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openDragLock) return;
            }
            this.latestPointerEvent = event;
            this.latestPanInfo = info;
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin and pointer offset
             */ (0, $677cd175d6f56db8$export$b789de563eb43b1)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $9e4fa4b20312155c$export$626336c2cd4b14de).test(current)) {
                    const { projection: projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, $3cec24e0364f7039$export$c1c127004b72a37)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) (0, $99c45f49fc7b5e17$export$2cef06c20297c17d).update(()=>onDragStart(event, info), false, true);
            (0, $1758461b0718b682$export$3ac5aed310be0bee)(this.visualElement, "transform");
            const { animationState: animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            this.latestPointerEvent = event;
            this.latestPanInfo = info;
            const { dragPropagation: dragPropagation, dragDirectionLock: dragDirectionLock, onDirectionLock: onDirectionLock, onDrag: onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openDragLock) return;
            const { offset: offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $3a50d9cb07dd2466$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ if (onDrag) (0, $99c45f49fc7b5e17$export$2cef06c20297c17d).update(()=>onDrag(event, info), false, true);
        };
        const onSessionEnd = (event, info)=>{
            this.latestPointerEvent = event;
            this.latestPanInfo = info;
            this.stop(event, info);
            this.latestPointerEvent = null;
            this.latestPanInfo = null;
        };
        const resumeAnimation = ()=>{
            const { dragSnapToOrigin: snap } = this.getProps();
            if (snap || this.constraints) this.startAnimation({
                x: 0,
                y: 0
            });
        };
        const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
        this.panSession = new (0, $77cee1f99467ec6e$export$d9c66232c9c4689c)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd,
            resumeAnimation: resumeAnimation
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint(),
            dragSnapToOrigin: dragSnapToOrigin,
            distanceThreshold: distanceThreshold,
            contextWindow: (0, $744c5569eb3a50b1$export$d533d84f9871c879)(this.visualElement),
            element: this.visualElement.current
        });
    }
    /**
     * @internal
     */ stop(event, panInfo) {
        const finalEvent = event || this.latestPointerEvent;
        const finalPanInfo = panInfo || this.latestPanInfo;
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging || !finalPanInfo || !finalEvent) return;
        const { velocity: velocity } = finalPanInfo;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd } = this.getProps();
        if (onDragEnd) (0, $99c45f49fc7b5e17$export$2cef06c20297c17d).postRender(()=>onDragEnd(finalEvent, finalPanInfo));
    }
    /**
     * @internal
     */ cancel() {
        this.isDragging = false;
        const { projection: projection, animationState: animationState } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.endPanSession();
        const { dragPropagation: dragPropagation } = this.getProps();
        if (!dragPropagation && this.openDragLock) {
            this.openDragLock();
            this.openDragLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    /**
     * Clean up the pan session without modifying other drag state.
     * This is used during unmount to ensure event listeners are removed
     * without affecting projection animations or drag locks.
     * @internal
     */ endPanSession() {
        this.panSession && this.panSession.end();
        this.panSession = undefined;
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$3a50d9cb07dd2466$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $ff2520f38016ad5d$export$b3c764d3fca3ffe3)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        const { dragConstraints: dragConstraints, dragElastic: dragElastic } = this.getProps();
        const layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : this.visualElement.projection?.layout;
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $f172ef57cf979a54$export$dedd81df7bc1307)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $ff2520f38016ad5d$export$4e9195bf7793bc78)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $ff2520f38016ad5d$export$7c5eaef8f4723d22)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative. This only applies to relative (non-ref)
         * constraints, as ref-based constraints from calcViewportConstraints are already in the
         * correct coordinate space for the motion value transform offset.
         */ if (prevConstraints !== this.constraints && !(0, $f172ef57cf979a54$export$dedd81df7bc1307)(dragConstraints) && layout && this.constraints && !this.hasMutatedConstraints) (0, $677cd175d6f56db8$export$b789de563eb43b1)((axis)=>{
            if (this.constraints !== false && this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $ff2520f38016ad5d$export$e9672cc4c36a8b87)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints: onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, $f172ef57cf979a54$export$dedd81df7bc1307)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $8a16204eb729eee3$export$f5708dca728d7177)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.", "drag-constraints-ref");
        const { projection: projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        /**
         * Refresh the root scroll offset so the constraint's viewport box
         * translates to correct page coordinates. The scroll captured at
         * drag mount can be stale if the document was scrolled afterwards —
         * e.g. via the browser restoring scroll on refresh, or an ancestor
         * layout effect running after this element's mount (#2829).
         *
         * Clear the cached scroll first so `updateScroll` bypasses its
         * per-animationId cache and re-reads the live value.
         */ if (projection.root) {
            projection.root.scroll = undefined;
            projection.root.updateScroll();
        }
        const constraintsBox = (0, $0ba608e5edcfe666$export$6a597be7a7940a96)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $ff2520f38016ad5d$export$4228500f19d4cdf7)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $167289942d86b7aa$export$b6b9cd4198191a47)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $167289942d86b7aa$export$d3955c6a8f65a36b)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag, dragMomentum: dragMomentum, dragElastic: dragElastic, dragTransition: dragTransition, dragSnapToOrigin: dragSnapToOrigin, onDragTransitionEnd: onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $677cd175d6f56db8$export$b789de563eb43b1)((axis)=>{
            if (!$3a50d9cb07dd2466$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin === true || dragSnapToOrigin === axis) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        (0, $1758461b0718b682$export$3ac5aed310be0bee)(this.visualElement, axis);
        return axisValue.start((0, $b2af294d9dfd3397$export$90b3dfc33ff3548)(axis, axisValue, 0, transition, this.visualElement, false));
    }
    stopAnimation() {
        (0, $677cd175d6f56db8$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = `_drag${axis.toUpperCase()}`;
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, this.visualElement.latestValues[axis] ?? 0);
    }
    snapToCursor(point) {
        (0, $677cd175d6f56db8$export$b789de563eb43b1)((axis)=>{
            const { drag: drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$3a50d9cb07dd2466$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min, max: max } = projection.layout.layoutBox[axis];
                /**
                 * The layout measurement includes the current transform value,
                 * so we need to add it back to get the correct snap position.
                 * This fixes an issue where elements with initial coordinates
                 * would snap to the wrong position on the first drag.
                 */ const current = axisValue.get() || 0;
                axisValue.set(point[axis] - (0, $5a3532f8b2a8e80b$export$3bb0b4ff1037b8dd)(min, max, 0.5) + current);
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag: drag, dragConstraints: dragConstraints } = this.getProps();
        const { projection: projection } = this.visualElement;
        if (!(0, $f172ef57cf979a54$export$dedd81df7bc1307)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $677cd175d6f56db8$export$b789de563eb43b1)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue && this.constraints !== false) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $ff2520f38016ad5d$export$13abbfca044ca46d)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        /**
         * Reset constraints so resolveConstraints() will recalculate them
         * with the freshly measured layout rather than returning the cached value.
         */ this.constraints = false;
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $677cd175d6f56db8$export$b789de563eb43b1)((axis)=>{
            if (!$3a50d9cb07dd2466$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min, max: max } = this.constraints[axis];
            axisValue.set((0, $5a3532f8b2a8e80b$export$3bb0b4ff1037b8dd)(min, max, boxProgress[axis]));
        });
        /**
         * Flush the updated transform to the DOM synchronously to prevent
         * a visual flash at the element's CSS layout position (0,0) when
         * the transform was stripped for measurement.
         */ this.visualElement.render();
    }
    addListeners() {
        if (!this.visualElement.current) return;
        $3a50d9cb07dd2466$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $ab84e27352805a65$export$fcff2e64e6676b81)(element, "pointerdown", (event)=>{
            const { drag: drag, dragListener: dragListener = true } = this.getProps();
            const target = event.target;
            /**
             * Only block drag if clicking on a text input child element
             * (input, textarea, select, contenteditable) where users might
             * want to select text or interact with the control.
             *
             * Buttons and links don't block drag since they don't have
             * click-and-move actions of their own.
             */ const isClickingTextInputChild = target !== element && (0, $7d4abd4ea4a9f329$export$41e5a41992b76128)(target);
            if (drag && dragListener && !isClickingTextInputChild) this.start(event);
        });
        /**
         * If using ref-based constraints, observe both the draggable element
         * and the constraint container for size changes via ResizeObserver.
         * Setup is deferred because dragConstraints.current is null when
         * addListeners first runs (React hasn't committed the ref yet).
         */ let stopResizeObservers;
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints } = this.getProps();
            if ((0, $f172ef57cf979a54$export$dedd81df7bc1307)(dragConstraints) && dragConstraints.current) {
                this.constraints = this.resolveRefConstraints();
                if (!stopResizeObservers) stopResizeObservers = $3a50d9cb07dd2466$var$startResizeObservers(element, dragConstraints.current, ()=>this.scalePositionWithinConstraints());
            }
        };
        const { projection: projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        (0, $99c45f49fc7b5e17$export$2cef06c20297c17d).read(measureDragConstraints);
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $c6c2e3791712db82$export$b1d829ddf82884aa)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $677cd175d6f56db8$export$b789de563eb43b1)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
            stopResizeObservers && stopResizeObservers();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false, dragDirectionLock: dragDirectionLock = false, dragPropagation: dragPropagation = false, dragConstraints: dragConstraints = false, dragElastic: dragElastic = (0, $ff2520f38016ad5d$export$a3366d3bac43a742), dragMomentum: dragMomentum = true } = props;
        return {
            ...props,
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        };
    }
    constructor(visualElement){
        this.openDragLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $8719be7ef375b7e3$export$6459fc9e86be362e)();
        /**
         * The latest pointer event. Used as fallback when the `cancel` and `stop` functions are called without arguments.
         */ this.latestPointerEvent = null;
        /**
         * The latest pan info. Used as fallback when the `cancel` and `stop` functions are called without arguments.
         */ this.latestPanInfo = null;
        this.visualElement = visualElement;
    }
}
function $3a50d9cb07dd2466$var$skipFirstCall(callback) {
    let isFirst = true;
    return ()=>{
        if (isFirst) {
            isFirst = false;
            return;
        }
        callback();
    };
}
function $3a50d9cb07dd2466$var$startResizeObservers(element, constraintsElement, onResize) {
    const stopElement = (0, $fb15b79aace0dbcc$export$4380c87abf28fdf)(element, $3a50d9cb07dd2466$var$skipFirstCall(onResize));
    const stopContainer = (0, $fb15b79aace0dbcc$export$4380c87abf28fdf)(constraintsElement, $3a50d9cb07dd2466$var$skipFirstCall(onResize));
    return ()=>{
        stopElement();
        stopContainer();
    };
}
function $3a50d9cb07dd2466$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $3a50d9cb07dd2466$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}


class $cf651a164871d0d1$export$5d97dc2872682820 extends (0, $26080a271792ef8a$export$6e91cf7616333d5) {
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls: dragControls } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, $df2228348c5a149c$export$8793edee2d425525);
    }
    update() {
        const { dragControls: dragControls } = this.node.getProps();
        const { dragControls: prevDragControls } = this.node.prevProps || {};
        if (dragControls !== prevDragControls) {
            this.removeGroupControls();
            if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        }
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
        /**
         * In React 19, during list reorder reconciliation, components may
         * briefly unmount and remount while the drag is still active. If we're
         * actively dragging, we should NOT end the pan session - it will
         * continue tracking pointer events via its window-level listeners.
         *
         * The pan session will be properly cleaned up when:
         * 1. The drag ends naturally (pointerup/pointercancel)
         * 2. The component is truly removed from the DOM
         */ if (!this.controls.isDragging) this.controls.endPanSession();
    }
    constructor(node){
        super(node);
        this.removeGroupControls = (0, $df2228348c5a149c$export$8793edee2d425525);
        this.removeListeners = (0, $df2228348c5a149c$export$8793edee2d425525);
        this.controls = new (0, $3a50d9cb07dd2466$export$86bff71f18910307)(node);
    }
}







const $a6a5796c309a9c3f$var$asyncHandler = (handler)=>(event, info)=>{
        if (handler) (0, $99c45f49fc7b5e17$export$2cef06c20297c17d).update(()=>handler(event, info), false, true);
    };
class $a6a5796c309a9c3f$export$b4f8f1ee75ce5859 extends (0, $26080a271792ef8a$export$6e91cf7616333d5) {
    onPointerDown(pointerDownEvent) {
        this.session = new (0, $77cee1f99467ec6e$export$d9c66232c9c4689c)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint(),
            contextWindow: (0, $744c5569eb3a50b1$export$d533d84f9871c879)(this.node)
        });
    }
    createPanHandlers() {
        const { onPanSessionStart: onPanSessionStart, onPanStart: onPanStart, onPan: onPan, onPanEnd: onPanEnd } = this.node.getProps();
        return {
            onSessionStart: $a6a5796c309a9c3f$var$asyncHandler(onPanSessionStart),
            onStart: $a6a5796c309a9c3f$var$asyncHandler(onPanStart),
            onMove: $a6a5796c309a9c3f$var$asyncHandler(onPan),
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) (0, $99c45f49fc7b5e17$export$2cef06c20297c17d).postRender(()=>onPanEnd(event, info));
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, $ab84e27352805a65$export$fcff2e64e6676b81)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, $df2228348c5a149c$export$8793edee2d425525);
    }
}



/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $f42f1e16c437e190$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};



var $lDJXT = parcelRequire("lDJXT");

var $lDJXT = parcelRequire("lDJXT");

"use client";
/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed from the tree,
 * but `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $0e7b3aaffef9bb23$export$2a8c16d82a0a0e26(subscribe = true) {
    const context = (0, $lDJXT.useContext)((0, $c9c492548b4996c8$export$f224e4635b6f8ce2));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent, onExitComplete: onExitComplete, register: register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $lDJXT.useId)();
    (0, $lDJXT.useEffect)(()=>{
        if (subscribe) return register(id);
    }, [
        subscribe
    ]);
    const safeToRemove = (0, $lDJXT.useCallback)(()=>subscribe && onExitComplete && onExitComplete(id), [
        id,
        onExitComplete,
        subscribe
    ]);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $0e7b3aaffef9bb23$export$8249053f690ea39a() {
    return $0e7b3aaffef9bb23$export$ee27c052bca048fb((0, $lDJXT.useContext)((0, $c9c492548b4996c8$export$f224e4635b6f8ce2)));
}
function $0e7b3aaffef9bb23$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}




"use client";
/**
 * Track whether we've taken any snapshots yet. If not,
 * we can safely skip notification of didUpdate.
 *
 * Difficult to capture in a test but to prevent flickering
 * we must set this to true either on update or unmount.
 * Running `next-env/layout-id` in Safari will show this behaviour if broken.
 */ let $63e7e4e4795e2f03$var$hasTakenAnySnapshot = false;
class $63e7e4e4795e2f03$var$MeasureLayoutWithContext extends (0, $lDJXT.Component) {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: switchLayoutGroup, layoutId: layoutId } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            if ($63e7e4e4795e2f03$var$hasTakenAnySnapshot) projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                layoutDependency: this.props.layoutDependency,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, $f42f1e16c437e190$export$97db156a3ed1593b).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency, visualElement: visualElement, drag: drag, isPresent: isPresent } = this.props;
        const { projection: projection } = visualElement;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (prevProps.layoutDependency !== layoutDependency) projection.setOptions({
            ...projection.options,
            layoutDependency: layoutDependency
        });
        $63e7e4e4795e2f03$var$hasTakenAnySnapshot = true;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined || prevProps.isPresent !== isPresent) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $99c45f49fc7b5e17$export$2cef06c20297c17d).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { visualElement: visualElement, layoutAnchor: layoutAnchor } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            projection.options.layoutAnchor = layoutAnchor;
            projection.root.didUpdate();
            (0, $073347fc5f8d46b9$export$bb76eed83315504c).postRender(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection: projection } = visualElement;
        $63e7e4e4795e2f03$var$hasTakenAnySnapshot = true;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function $63e7e4e4795e2f03$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $0e7b3aaffef9bb23$export$2a8c16d82a0a0e26)();
    const layoutGroup = (0, $lDJXT.useContext)((0, $23a1c66422693cdf$export$a3579ca508007a95));
    return (0, $217385444e3d1677$exports.jsx)($63e7e4e4795e2f03$var$MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $lDJXT.useContext)((0, $2fc2c794e9434d17$export$da5f7b802957459a)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}






function $381798ab51269767$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $5c2f00f5f770efa1$export$605d60a2578142d3)(value) ? value : (0, $273b0f90a77f315f$export$ce8bdc721e76545f)(value);
    motionValue$1.start((0, $b2af294d9dfd3397$export$90b3dfc33ff3548)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}












/**
 * Timeout defined in ms
 */ function $49c68038313e0aca$export$1391212d75b2ee65(callback, timeout) {
    const start = (0, $08568323a95fcb6c$export$2da9be4cfdb689b1).now();
    const checkElapsed = ({ timestamp: timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $99c45f49fc7b5e17$export$ec99c0ef4978dccb)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $99c45f49fc7b5e17$export$2cef06c20297c17d).setup(checkElapsed, true);
    return ()=>(0, $99c45f49fc7b5e17$export$ec99c0ef4978dccb)(checkElapsed);
}
function $49c68038313e0aca$export$fcd451ca460f8a2a(callback, timeout) {
    return $49c68038313e0aca$export$1391212d75b2ee65(callback, (0, $8c69a35cd8e97a0e$export$fc3e7e8557f8c8c7)(timeout));
}




/**
 * Checks if an element is specifically an SVGSVGElement (the root SVG element)
 * in a way that works across iframes
 */ function $ed8c3aa27b4dbaf4$export$66957ea77182581d(element) {
    return (0, $a73c01e48b6f8ee0$export$17eda790a720ec57)(element) && element.tagName === "svg";
}








const $3c483c293c3d84c2$var$borderLabels = [
    "borderTopLeftRadius",
    "borderTopRightRadius",
    "borderBottomLeftRadius",
    "borderBottomRightRadius"
];
const $3c483c293c3d84c2$var$numBorders = $3c483c293c3d84c2$var$borderLabels.length;
const $3c483c293c3d84c2$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $3c483c293c3d84c2$var$isPx = (value)=>typeof value === "number" || (0, $9e4fa4b20312155c$export$91c0eda1d06bf008).test(value);
function $3c483c293c3d84c2$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $5a3532f8b2a8e80b$export$3bb0b4ff1037b8dd)(0, lead.opacity ?? 1, $3c483c293c3d84c2$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $5a3532f8b2a8e80b$export$3bb0b4ff1037b8dd)(follow.opacity ?? 1, 0, $3c483c293c3d84c2$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $5a3532f8b2a8e80b$export$3bb0b4ff1037b8dd)(follow.opacity ?? 1, lead.opacity ?? 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $3c483c293c3d84c2$var$numBorders; i++){
        const borderLabel = $3c483c293c3d84c2$var$borderLabels[i];
        let followRadius = $3c483c293c3d84c2$var$getRadius(follow, borderLabel);
        let leadRadius = $3c483c293c3d84c2$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $3c483c293c3d84c2$var$isPx(followRadius) === $3c483c293c3d84c2$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $5a3532f8b2a8e80b$export$3bb0b4ff1037b8dd)($3c483c293c3d84c2$var$asNumber(followRadius), $3c483c293c3d84c2$var$asNumber(leadRadius), progress), 0);
            if ((0, $9e4fa4b20312155c$export$626336c2cd4b14de).test(leadRadius) || (0, $9e4fa4b20312155c$export$626336c2cd4b14de).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $5a3532f8b2a8e80b$export$3bb0b4ff1037b8dd)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $3c483c293c3d84c2$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
const $3c483c293c3d84c2$var$easeCrossfadeIn = /*@__PURE__*/ $3c483c293c3d84c2$var$compress(0, 0.5, (0, $9dbc3d97c787557f$export$c8d67a19199d1a50));
const $3c483c293c3d84c2$var$easeCrossfadeOut = /*@__PURE__*/ $3c483c293c3d84c2$var$compress(0.5, 0.95, (0, $df2228348c5a149c$export$8793edee2d425525));
function $3c483c293c3d84c2$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $d1110b161f695fe9$export$504d7abb21fa8c9)(min, max, p));
    };
}


/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $d9ea561cb1f2e9a5$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $d9ea561cb1f2e9a5$export$c53fd88f45d77e4b(box, originBox) {
    $d9ea561cb1f2e9a5$export$a0230ae482601ae8(box.x, originBox.x);
    $d9ea561cb1f2e9a5$export$a0230ae482601ae8(box.y, originBox.y);
}
/**
 * Reset a delta to the provided origin box.
 *
 * This is a mutative operation.
 */ function $d9ea561cb1f2e9a5$export$8ead6a7d6b225ef(delta, originDelta) {
    delta.translate = originDelta.translate;
    delta.scale = originDelta.scale;
    delta.originPoint = originDelta.originPoint;
    delta.origin = originDelta.origin;
}







/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $a64418aef0267491$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $5dcf16df13ee8113$export$2290ec7febe36dd6)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $5dcf16df13ee8113$export$2290ec7febe36dd6)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $a64418aef0267491$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $9e4fa4b20312155c$export$626336c2cd4b14de).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $5a3532f8b2a8e80b$export$3bb0b4ff1037b8dd)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $5a3532f8b2a8e80b$export$3bb0b4ff1037b8dd)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $a64418aef0267491$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $a64418aef0267491$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $a64418aef0267491$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $a64418aef0267491$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $a64418aef0267491$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $a64418aef0267491$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $a64418aef0267491$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $a64418aef0267491$export$42b76f1d0d16d5b(box.x, transforms, $a64418aef0267491$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $a64418aef0267491$export$42b76f1d0d16d5b(box.y, transforms, $a64418aef0267491$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}




function $89b41278514ea693$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $89b41278514ea693$export$a7ec7642fe550fb6(delta) {
    return $89b41278514ea693$var$isAxisDeltaZero(delta.x) && $89b41278514ea693$var$isAxisDeltaZero(delta.y);
}
function $89b41278514ea693$export$7a9a6f114ddd0fdb(a, b) {
    return a.min === b.min && a.max === b.max;
}
function $89b41278514ea693$export$8d5cf76bb7daff09(a, b) {
    return $89b41278514ea693$export$7a9a6f114ddd0fdb(a.x, b.x) && $89b41278514ea693$export$7a9a6f114ddd0fdb(a.y, b.y);
}
function $89b41278514ea693$export$22adf28bfca1c186(a, b) {
    return Math.round(a.min) === Math.round(b.min) && Math.round(a.max) === Math.round(b.max);
}
function $89b41278514ea693$export$ef641b782d85522(a, b) {
    return $89b41278514ea693$export$22adf28bfca1c186(a.x, b.x) && $89b41278514ea693$export$22adf28bfca1c186(a.y, b.y);
}
function $89b41278514ea693$export$c5706146bc63213(box) {
    return (0, $3cec24e0364f7039$export$c1c127004b72a37)(box.x) / (0, $3cec24e0364f7039$export$c1c127004b72a37)(box.y);
}
function $89b41278514ea693$export$444620505e28fe92(a, b) {
    return a.translate === b.translate && a.scale === b.scale && a.originPoint === b.originPoint;
}



class $55152167af4bafe5$export$39be5b2d82fc9dc7 {
    add(node) {
        (0, $ac9e1874010206ff$export$20e507e47fae79fd)(this.members, node);
        for(let i = this.members.length - 1; i >= 0; i--){
            const member = this.members[i];
            if (member === node || member === this.lead || member === this.prevLead) continue;
            const inst = member.instance;
            if ((!inst || inst.isConnected === false) && !member.snapshot) {
                (0, $ac9e1874010206ff$export$fe2d9b4e03920b4c)(this.members, member);
                member.unmount();
            }
        }
        node.scheduleRender();
    }
    remove(node) {
        (0, $ac9e1874010206ff$export$fe2d9b4e03920b4c)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        for(let i = this.members.indexOf(node) - 1; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false && member.instance?.isConnected !== false) {
                this.promote(member);
                return true;
            }
        }
        return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.updateSnapshot();
            node.scheduleRender();
            const { layoutDependency: prevDep } = prevLead.options;
            const { layoutDependency: nextDep } = node.options;
            if (prevDep === undefined || prevDep !== nextDep) {
                node.resumeFrom = prevLead;
                if (preserveFollowOpacity) prevLead.preserveOpacity = true;
                if (prevLead.snapshot) {
                    node.snapshot = prevLead.snapshot;
                    node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
                }
                if (node.root?.isUpdating) node.isLayoutDirty = true;
            }
            if (node.options.crossfade === false) prevLead.hide();
        }
    }
    exitAnimationComplete() {
        this.members.forEach((member)=>{
            member.options.onExitComplete?.();
            member.resumingFrom?.options.onExitComplete?.();
        });
    }
    scheduleRender() {
        this.members.forEach((member)=>member.instance && member.scheduleRender(false));
    }
    removeLeadSnapshot() {
        if (this.lead?.snapshot) this.lead.snapshot = undefined;
    }
    constructor(){
        this.members = [];
    }
}


function $b0ec721cfc535ed7$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    const zTranslate = latestTransform?.z || 0;
    if (xTranslate || yTranslate || zTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, ${zTranslate}px) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { transformPerspective: transformPerspective, rotate: rotate, pathRotation: pathRotation, rotateX: rotateX, rotateY: rotateY, skewX: skewX, skewY: skewY } = latestTransform;
        if (transformPerspective) transform = `perspective(${transformPerspective}px) ${transform}`;
        if (rotate) transform += `rotate(${rotate}deg) `;
        // Additive `rotate()` so user `rotate` isn't clobbered.
        if (pathRotation) transform += `rotate(${pathRotation}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
        if (skewX) transform += `skewX(${skewX}deg) `;
        if (skewY) transform += `skewY(${skewY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}




const $908e4256960f6fca$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;


class $0d8cc8913875ae3e$export$1465d17e3de78a96 {
    add(child) {
        (0, $ac9e1874010206ff$export$20e507e47fae79fd)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $ac9e1874010206ff$export$fe2d9b4e03920b4c)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $908e4256960f6fca$export$d689d9dec5ad338));
        this.isDirty = false;
        this.children.forEach(callback);
    }
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
}





const $520743bffd6c4832$var$metrics = {
    nodes: 0,
    calculatedTargetDeltas: 0,
    calculatedProjections: 0
};
const $520743bffd6c4832$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $520743bffd6c4832$var$animationTarget = 1000;
let $520743bffd6c4832$var$id = 0;
function $520743bffd6c4832$var$resetDistortingTransform(key, visualElement, values, sharedAnimationValues) {
    const { latestValues: latestValues } = visualElement;
    // Record the distorting transform and then temporarily set it to 0
    if (latestValues[key]) {
        values[key] = latestValues[key];
        visualElement.setStaticValue(key, 0);
        if (sharedAnimationValues) sharedAnimationValues[key] = 0;
    }
}
function $520743bffd6c4832$var$cancelTreeOptimisedTransformAnimations(projectionNode) {
    projectionNode.hasCheckedOptimisedAppear = true;
    if (projectionNode.root === projectionNode) return;
    const { visualElement: visualElement } = projectionNode.options;
    if (!visualElement) return;
    const appearId = (0, $64421ba86c14703e$export$5f8d21e84d1d84fc)(visualElement);
    if (window.MotionHasOptimisedAnimation(appearId, "transform")) {
        const { layout: layout, layoutId: layoutId } = projectionNode.options;
        window.MotionCancelOptimisedAnimation(appearId, "transform", (0, $99c45f49fc7b5e17$export$2cef06c20297c17d), !(layout || layoutId));
    }
    const { parent: parent } = projectionNode;
    if (parent && !parent.hasCheckedOptimisedAppear) $520743bffd6c4832$var$cancelTreeOptimisedTransformAnimations(parent);
}
function $520743bffd6c4832$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener, defaultParent: defaultParent, measureScroll: measureScroll, checkIsScrollRoot: checkIsScrollRoot, resetTransform: resetTransform }) {
    return class ProjectionNode {
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $c4eb4b324793743d$export$e7dff9482a5fd23c)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance) {
            if (this.instance) return;
            this.isSVG = (0, $a73c01e48b6f8ee0$export$17eda790a720ec57)(instance) && !(0, $ed8c3aa27b4dbaf4$export$66957ea77182581d)(instance);
            this.instance = instance;
            const { layoutId: layoutId, layout: layout, visualElement: visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (this.root.hasTreeAnimated && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                let innerWidth = 0;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                // Set initial innerWidth in a frame.read callback to batch the read
                (0, $99c45f49fc7b5e17$export$2cef06c20297c17d).read(()=>{
                    innerWidth = window.innerWidth;
                });
                attachResizeListener(instance, ()=>{
                    const newInnerWidth = window.innerWidth;
                    if (newInnerWidth === innerWidth) return;
                    innerWidth = newInnerWidth;
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $49c68038313e0aca$export$1391212d75b2ee65)(resizeUnblockUpdate, 250);
                    if ((0, $f42f1e16c437e190$export$97db156a3ed1593b).hasAnimatedSinceResize) {
                        (0, $f42f1e16c437e190$export$97db156a3ed1593b).hasAnimatedSinceResize = false;
                        this.nodes.forEach($520743bffd6c4832$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged, hasRelativeLayoutChanged: hasRelativeLayoutChanged, layout: newLayout })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || $520743bffd6c4832$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart, onLayoutAnimationComplete: onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const hasTargetChanged = !this.targetLayout || !(0, $89b41278514ea693$export$ef641b782d85522)(this.targetLayout, newLayout);
                /*
                     * Note: Disabled to fix relative animations always triggering new
                     * layout animations. If this causes further issues, we can try
                     * a different approach to detecting relative target changes.
                     */ // || hasRelativeLayoutChanged
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeLayoutChanged;
                if (this.options.layoutRoot || this.resumeFrom || hasOnlyRelativeTargetChanged || hasLayoutChanged && (hasTargetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    const animationOptions = {
                        ...(0, $e6a44c6e4fc3283d$export$7c1391340308742e)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                    /**
                         * Set animation origin after starting animation to avoid layout jump
                         * caused by stopping previous layout animation
                         */ this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged, animationOptions.path);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never committed to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $520743bffd6c4832$var$finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            this.eventHandlers.clear();
            (0, $99c45f49fc7b5e17$export$ec99c0ef4978dccb)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach($520743bffd6c4832$var$resetSkewAndRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement: visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            /**
             * If we're running optimised appear animations then these must be
             * cancelled before measuring the DOM. This is so we can measure
             * the true layout of the element rather than the WAAPI animation
             * which will be unaffected by the resetSkewAndRotate step.
             *
             * Note: This is a DOM write. Worst case scenario is this is sandwiched
             * between other snapshot reads which will cause unnecessary style recalculations.
             * This has to happen here though, as we don't yet know which nodes will need
             * snapshots in startUpdate(), but we only want to cancel optimised animations
             * if a layout animation measurement is actually going to be affected by them.
             */ if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear) $520743bffd6c4832$var$cancelTreeOptimisedTransformAnimations(this);
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                /**
                 * Percentage translates resolve against layoutBox dimensions,
                 * so ancestors with them must be re-measured after transform reset.
                 */ if (typeof node.latestValues.x === "string" || typeof node.latestValues.y === "string") node.isLayoutDirty = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId: layoutId, layout: layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                const wasBlockedByResize = this.updateBlockedByResize;
                this.unblockUpdate();
                this.updateBlockedByResize = false;
                this.clearAllSnapshots();
                /**
                 * When blocked by resize, still measure layouts so
                 * callbacks like onLayoutMeasure fire (e.g. Reorder).
                 * Skip notifyLayoutUpdate to prevent animations.
                 */ if (wasBlockedByResize) this.nodes.forEach($520743bffd6c4832$var$forceLayoutMeasure);
                this.nodes.forEach($520743bffd6c4832$var$clearMeasurements);
                return;
            }
            /**
             * If this is a repeat of didUpdate then ignore the animation.
             */ if (this.animationId <= this.animationCommitId) {
                this.nodes.forEach($520743bffd6c4832$var$clearIsLayoutDirty);
                return;
            }
            this.animationCommitId = this.animationId;
            if (!this.isUpdating) this.nodes.forEach($520743bffd6c4832$var$clearIsLayoutDirty);
            else {
                this.isUpdating = false;
                /**
                 * Ensure animation-blocked nodes (e.g. during drag)
                 * get measured even when memoized (willUpdate skipped).
                 */ this.nodes.forEach($520743bffd6c4832$var$ensureDraggedNodesSnapshotted);
                /**
                 * Write
                 */ this.nodes.forEach($520743bffd6c4832$var$resetTransformStyle);
                /**
                 * Read ==================
                 */ // Update layout measurements of updated children
                this.nodes.forEach($520743bffd6c4832$var$updateLayout);
                /**
                 * Write
                 */ // Notify listeners that the layout is updated
                this.nodes.forEach($520743bffd6c4832$var$notifyLayoutUpdate);
            }
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = (0, $08568323a95fcb6c$export$2da9be4cfdb689b1).now();
            (0, $99c45f49fc7b5e17$export$fff89137e9e818ce).delta = (0, $30bb3117a82170b4$export$7d15b64cf5a3a4c4)(0, 1000 / 60, now - (0, $99c45f49fc7b5e17$export$fff89137e9e818ce).timestamp);
            (0, $99c45f49fc7b5e17$export$fff89137e9e818ce).timestamp = now;
            (0, $99c45f49fc7b5e17$export$fff89137e9e818ce).isProcessing = true;
            (0, $99c45f49fc7b5e17$export$1811c3a7e3af92f0).update.process((0, $99c45f49fc7b5e17$export$fff89137e9e818ce));
            (0, $99c45f49fc7b5e17$export$1811c3a7e3af92f0).preRender.process((0, $99c45f49fc7b5e17$export$fff89137e9e818ce));
            (0, $99c45f49fc7b5e17$export$1811c3a7e3af92f0).render.process((0, $99c45f49fc7b5e17$export$fff89137e9e818ce));
            (0, $99c45f49fc7b5e17$export$fff89137e9e818ce).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                (0, $073347fc5f8d46b9$export$bb76eed83315504c).read(this.scheduleUpdate);
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach($520743bffd6c4832$var$clearSnapshot);
            this.sharedNodes.forEach($520743bffd6c4832$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            if (!this.projectionUpdateScheduled) {
                this.projectionUpdateScheduled = true;
                (0, $99c45f49fc7b5e17$export$2cef06c20297c17d).preRender(this.updateProjection, false, true);
            }
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $99c45f49fc7b5e17$export$2cef06c20297c17d).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
            if (this.snapshot && !(0, $3cec24e0364f7039$export$c1c127004b72a37)(this.snapshot.measuredBox.x) && !(0, $3cec24e0364f7039$export$c1c127004b72a37)(this.snapshot.measuredBox.y)) this.snapshot = undefined;
        }
        updateLayout() {
            if (!this.instance) return;
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutVersion++;
            if (!this.layoutCorrected) this.layoutCorrected = (0, $8719be7ef375b7e3$export$6459fc9e86be362e)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement: visualElement } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement && this.instance) {
                const isRoot = checkIsScrollRoot(this.instance);
                this.scroll = {
                    animationId: this.root.animationId,
                    phase: phase,
                    isRoot: isRoot,
                    offset: measureScroll(this.instance),
                    wasRoot: this.scroll ? this.scroll.isRoot : isRoot
                };
            }
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout;
            const hasProjection = this.projectionDelta && !(0, $89b41278514ea693$export$a7ec7642fe550fb6)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && this.instance && (hasProjection || (0, $b173916de606703a$export$a545127cf1fbb600)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $520743bffd6c4832$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return (0, $8719be7ef375b7e3$export$6459fc9e86be362e)();
            const box = visualElement.measureViewportBox();
            const wasInScrollRoot = this.scroll?.wasRoot || this.path.some($520743bffd6c4832$var$checkNodeWasScrollRoot);
            if (!wasInScrollRoot) {
                // Remove viewport scroll to give page-relative coordinates
                const { scroll: scroll } = this.root;
                if (scroll) {
                    (0, $5dcf16df13ee8113$export$a807a5ce5ebb3895)(box.x, scroll.offset.x);
                    (0, $5dcf16df13ee8113$export$a807a5ce5ebb3895)(box.y, scroll.offset.y);
                }
            }
            return box;
        }
        removeElementScroll(box) {
            const boxWithoutScroll = (0, $8719be7ef375b7e3$export$6459fc9e86be362e)();
            (0, $d9ea561cb1f2e9a5$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
            if (this.scroll?.wasRoot) return boxWithoutScroll;
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll, options: options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.wasRoot) (0, $d9ea561cb1f2e9a5$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
                    (0, $5dcf16df13ee8113$export$a807a5ce5ebb3895)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $5dcf16df13ee8113$export$a807a5ce5ebb3895)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false, output) {
            const withTransforms = output || (0, $8719be7ef375b7e3$export$6459fc9e86be362e)();
            (0, $d9ea561cb1f2e9a5$export$c53fd88f45d77e4b)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) {
                    (0, $5dcf16df13ee8113$export$a807a5ce5ebb3895)(withTransforms.x, -node.scroll.offset.x);
                    (0, $5dcf16df13ee8113$export$a807a5ce5ebb3895)(withTransforms.y, -node.scroll.offset.y);
                }
                if (!(0, $b173916de606703a$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $5dcf16df13ee8113$export$58b16271041fbfb)(withTransforms, node.latestValues, node.layout?.layoutBox);
            }
            if ((0, $b173916de606703a$export$a545127cf1fbb600)(this.latestValues)) (0, $5dcf16df13ee8113$export$58b16271041fbfb)(withTransforms, this.latestValues, this.layout?.layoutBox);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, $8719be7ef375b7e3$export$6459fc9e86be362e)();
            (0, $d9ea561cb1f2e9a5$export$c53fd88f45d77e4b)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!(0, $b173916de606703a$export$a545127cf1fbb600)(node.latestValues)) continue;
                let sourceBox;
                if (node.instance) {
                    (0, $b173916de606703a$export$bdf30dca883ea463)(node.latestValues) && node.updateSnapshot();
                    sourceBox = (0, $8719be7ef375b7e3$export$6459fc9e86be362e)();
                    (0, $d9ea561cb1f2e9a5$export$c53fd88f45d77e4b)(sourceBox, node.measurePageBox());
                }
                (0, $a64418aef0267491$export$73e1ad0a9694e25c)(boxWithoutTransform, node.latestValues, node.snapshot?.layoutBox, sourceBox);
            }
            if ((0, $b173916de606703a$export$a545127cf1fbb600)(this.latestValues)) (0, $a64418aef0267491$export$73e1ad0a9694e25c)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $99c45f49fc7b5e17$export$fff89137e9e818ce).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || this.parent?.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize);
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, $99c45f49fc7b5e17$export$fff89137e9e818ce).timestamp;
            const relativeParent = this.getClosestProjectingParent();
            if (relativeParent && this.linkedParentVersion !== relativeParent.layoutVersion && !relativeParent.options.layoutRoot) this.removeRelativeTarget();
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ if (!this.targetDelta && !this.relativeTarget) {
                if (this.options.layoutAnchor !== false && relativeParent && relativeParent.layout) this.createRelativeTarget(relativeParent, this.layout.layoutBox, relativeParent.layout.layoutBox);
                else this.removeRelativeTarget();
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $8719be7ef375b7e3$export$6459fc9e86be362e)();
                this.targetWithTransforms = (0, $8719be7ef375b7e3$export$6459fc9e86be362e)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, $3cec24e0364f7039$export$426154f9d100f99)(this.target, this.relativeTarget, this.relativeParent.target, this.options.layoutAnchor || undefined);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) this.applyTransform(this.layout.layoutBox, false, this.target);
                else (0, $d9ea561cb1f2e9a5$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
                (0, $5dcf16df13ee8113$export$d80074982803af5c)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $d9ea561cb1f2e9a5$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                if (this.options.layoutAnchor !== false && relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) this.createRelativeTarget(relativeParent, this.target, relativeParent.target);
                else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ if ((0, $a9d4288c548593bd$export$84ce9a476f53d110).value) $520743bffd6c4832$var$metrics.calculatedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $b173916de606703a$export$bdf30dca883ea463)(this.parent.latestValues) || (0, $b173916de606703a$export$bf80f5f8f4dc327f)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        createRelativeTarget(relativeParent, layout, parentLayout) {
            this.relativeParent = relativeParent;
            this.linkedParentVersion = relativeParent.layoutVersion;
            this.forceRelativeParentToResolveTarget();
            this.relativeTarget = (0, $8719be7ef375b7e3$export$6459fc9e86be362e)();
            this.relativeTargetOrigin = (0, $8719be7ef375b7e3$export$6459fc9e86be362e)();
            (0, $3cec24e0364f7039$export$2785bfcc929c5650)(this.relativeTargetOrigin, layout, parentLayout, this.options.layoutAnchor || undefined);
            (0, $d9ea561cb1f2e9a5$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
        }
        removeRelativeTarget() {
            this.relativeParent = this.relativeTarget = undefined;
        }
        calcProjection() {
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || this.parent?.isProjectionDirty) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $99c45f49fc7b5e17$export$fff89137e9e818ce).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $d9ea561cb1f2e9a5$export$c53fd88f45d77e4b)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $5dcf16df13ee8113$export$e2a980535c55eabb)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
                lead.target = lead.layout.layoutBox;
                lead.targetWithTransforms = (0, $8719be7ef375b7e3$export$6459fc9e86be362e)();
            }
            const { target: target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.prevProjectionDelta) {
                    this.createProjectionDeltas();
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta || !this.prevProjectionDelta) this.createProjectionDeltas();
            else {
                (0, $d9ea561cb1f2e9a5$export$8ead6a7d6b225ef)(this.prevProjectionDelta.x, this.projectionDelta.x);
                (0, $d9ea561cb1f2e9a5$export$8ead6a7d6b225ef)(this.prevProjectionDelta.y, this.projectionDelta.y);
            }
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $3cec24e0364f7039$export$c0d25e96fc67d310)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            if (this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY || !(0, $89b41278514ea693$export$444620505e28fe92)(this.projectionDelta.x, this.prevProjectionDelta.x) || !(0, $89b41278514ea693$export$444620505e28fe92)(this.projectionDelta.y, this.prevProjectionDelta.y)) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ if ((0, $a9d4288c548593bd$export$84ce9a476f53d110).value) $520743bffd6c4832$var$metrics.calculatedProjections++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            this.options.visualElement?.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        createProjectionDeltas() {
            this.prevProjectionDelta = (0, $8719be7ef375b7e3$export$3d227df54007d73a)();
            this.projectionDelta = (0, $8719be7ef375b7e3$export$3d227df54007d73a)();
            this.projectionDeltaWithTransform = (0, $8719be7ef375b7e3$export$3d227df54007d73a)();
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false, pathFn) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, $8719be7ef375b7e3$export$3d227df54007d73a)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $8719be7ef375b7e3$export$6459fc9e86be362e)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($520743bffd6c4832$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            // The path decides whether the layout shift is worth curving
            // (distance floor) and resolves the interpolator from the delta.
            const interpolate = pathFn?.interpolateProjection(delta);
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                const point = interpolate?.(progress);
                if (point) {
                    targetDelta.x.translate = point.x;
                    targetDelta.x.scale = (0, $5a3532f8b2a8e80b$export$3bb0b4ff1037b8dd)(delta.x.scale, 1, progress);
                    targetDelta.x.origin = delta.x.origin;
                    targetDelta.x.originPoint = delta.x.originPoint;
                    targetDelta.y.translate = point.y;
                    targetDelta.y.scale = (0, $5a3532f8b2a8e80b$export$3bb0b4ff1037b8dd)(delta.y.scale, 1, progress);
                    targetDelta.y.origin = delta.y.origin;
                    targetDelta.y.originPoint = delta.y.originPoint;
                } else {
                    $520743bffd6c4832$var$mixAxisDeltaLinear(targetDelta.x, delta.x, progress);
                    $520743bffd6c4832$var$mixAxisDeltaLinear(targetDelta.y, delta.y, progress);
                }
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, $3cec24e0364f7039$export$2785bfcc929c5650)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox, this.options.layoutAnchor || undefined);
                    $520743bffd6c4832$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $89b41278514ea693$export$8d5cf76bb7daff09)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, $8719be7ef375b7e3$export$6459fc9e86be362e)();
                    (0, $d9ea561cb1f2e9a5$export$c53fd88f45d77e4b)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $3c483c293c3d84c2$export$739e279c17d51c3d)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                if (point && point.rotate !== undefined) {
                    // Dedicated `pathRotation` channel, not `rotate`, so an
                    // animating `rotate` is composed with, never clobbered.
                    if (!this.animationValues) this.animationValues = mixedValues;
                    this.animationValues.pathRotation = point.rotate;
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation?.stop();
            this.resumingFrom?.currentAnimation?.stop();
            if (this.pendingAnimation) {
                (0, $99c45f49fc7b5e17$export$ec99c0ef4978dccb)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $99c45f49fc7b5e17$export$2cef06c20297c17d).update(()=>{
                (0, $f42f1e16c437e190$export$97db156a3ed1593b).hasAnimatedSinceResize = true;
                (0, $2ac10515ff3039be$export$d921fb2475e2900c).layout++;
                this.motionValue || (this.motionValue = (0, $273b0f90a77f315f$export$ce8bdc721e76545f)(0));
                this.motionValue.jump(0, false);
                this.currentAnimation = (0, $381798ab51269767$export$335a17c977067b99)(this.motionValue, [
                    0,
                    1000
                ], {
                    ...options,
                    velocity: 0,
                    isSync: true,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onStop: ()=>{
                        (0, $2ac10515ff3039be$export$d921fb2475e2900c).layout--;
                    },
                    onComplete: ()=>{
                        (0, $2ac10515ff3039be$export$d921fb2475e2900c).layout--;
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta($520743bffd6c4832$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms, target: target, layout: layout, latestValues: latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $520743bffd6c4832$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $8719be7ef375b7e3$export$6459fc9e86be362e)();
                const xLength = (0, $3cec24e0364f7039$export$c1c127004b72a37)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $3cec24e0364f7039$export$c1c127004b72a37)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $d9ea561cb1f2e9a5$export$c53fd88f45d77e4b)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $5dcf16df13ee8113$export$58b16271041fbfb)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $3cec24e0364f7039$export$c0d25e96fc67d310)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $55152167af4bafe5$export$39be5b2d82fc9dc7)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            const { layoutId: layoutId } = this.options;
            return layoutId ? this.getStack()?.lead || this : this;
        }
        getPrevLead() {
            const { layoutId: layoutId } = this.options;
            return layoutId ? this.getStack()?.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset, transition: transition, preserveFollowOpacity: preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetSkewAndRotation() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected skew or rotation values, we can early return without a forced render.
            let hasDistortingTransform = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues } = visualElement;
            if (latestValues.z || latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ || latestValues.skewX || latestValues.skewY) hasDistortingTransform = true;
            // If there's no distorting values, we don't need to do any more.
            if (!hasDistortingTransform) return;
            const resetValues = {};
            if (latestValues.z) $520743bffd6c4832$var$resetDistortingTransform("z", visualElement, resetValues, this.animationValues);
            // Check the skew and rotate value of all axes and reset to 0
            for(let i = 0; i < $520743bffd6c4832$var$transformAxes.length; i++){
                $520743bffd6c4832$var$resetDistortingTransform(`rotate${$520743bffd6c4832$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
                $520743bffd6c4832$var$resetDistortingTransform(`skew${$520743bffd6c4832$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
            }
            // Force a render of this element to apply the transform with all skews and rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues){
                visualElement.setStaticValue(key, resetValues[key]);
                if (this.animationValues) this.animationValues[key] = resetValues[key];
            }
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        applyProjectionStyles(targetStyle, styleProp) {
            if (!this.instance || this.isSVG) return;
            if (!this.isVisible) {
                targetStyle.visibility = "hidden";
                return;
            }
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                targetStyle.visibility = "";
                targetStyle.opacity = "";
                targetStyle.pointerEvents = (0, $eb85c9930d01bb56$export$fcc2206ecb6d74b)(styleProp?.pointerEvents) || "";
                targetStyle.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                if (this.options.layoutId) {
                    targetStyle.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    targetStyle.pointerEvents = (0, $eb85c9930d01bb56$export$fcc2206ecb6d74b)(styleProp?.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $b173916de606703a$export$a545127cf1fbb600)(this.latestValues)) {
                    targetStyle.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return;
            }
            targetStyle.visibility = "";
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            let transform = (0, $b0ec721cfc535ed7$export$d33653b270fe725c)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) transform = transformTemplate(valuesToRender, transform);
            targetStyle.transform = transform;
            const { x: x, y: y } = this.projectionDelta;
            targetStyle.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ targetStyle.opacity = lead === this ? valuesToRender.opacity ?? this.latestValues.opacity ?? 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ targetStyle.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $dbed2e9ad4f0fb29$export$91ddd985b97788d1){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct, applyTo: applyTo, isCSSVariable: isCSSVariable } = (0, $dbed2e9ad4f0fb29$export$91ddd985b97788d1)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)targetStyle[applyTo[i]] = corrected;
                } else // If this is a CSS variable, set it directly on the instance.
                // Replacing this function from creating styles to setting them
                // would be a good place to remove per frame object creation
                if (isCSSVariable) this.options.visualElement.renderState.vars[key] = corrected;
                else targetStyle[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) targetStyle.pointerEvents = lead === this ? (0, $eb85c9930d01bb56$export$fcc2206ecb6d74b)(styleProp?.pointerEvents) || "" : "none";
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>node.currentAnimation?.stop());
            this.root.nodes.forEach($520743bffd6c4832$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
        constructor(latestValues = {}, parent = defaultParent?.()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $520743bffd6c4832$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            this.animationCommitId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * Store whether this node has been checked for optimised appear animations. As
             * effects fire bottom-up, and we want to look up the tree for appear animations,
             * this makes sure we only check each path once, stopping at nodes that
             * have already been checked.
             */ this.hasCheckedOptimisedAppear = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            this.layoutVersion = 0;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.scheduleUpdate = ()=>this.update();
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ if ((0, $a9d4288c548593bd$export$84ce9a476f53d110).value) $520743bffd6c4832$var$metrics.nodes = $520743bffd6c4832$var$metrics.calculatedTargetDeltas = $520743bffd6c4832$var$metrics.calculatedProjections = 0;
                this.nodes.forEach($520743bffd6c4832$export$131f2f0cc5fe9609);
                this.nodes.forEach($520743bffd6c4832$var$resolveTargetDelta);
                this.nodes.forEach($520743bffd6c4832$var$calcProjection);
                this.nodes.forEach($520743bffd6c4832$export$c2664f37bc951031);
                if ((0, $a9d4288c548593bd$export$84ce9a476f53d110).addProjectionMetrics) (0, $a9d4288c548593bd$export$84ce9a476f53d110).addProjectionMetrics($520743bffd6c4832$var$metrics);
            };
            /**
             * Frame calculations
             */ this.resolvedRelativeTargetAt = 0.0;
            this.linkedParentVersion = 0;
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $0d8cc8913875ae3e$export$1465d17e3de78a96)();
        }
    };
}
function $520743bffd6c4832$var$updateLayout(node) {
    node.updateLayout();
}
function $520743bffd6c4832$var$notifyLayoutUpdate(node) {
    const snapshot = node.resumeFrom?.snapshot || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType: animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $677cd175d6f56db8$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $3cec24e0364f7039$export$c1c127004b72a37)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if (animationType === "x" || animationType === "y") {
            const snapAxis = animationType === "x" ? "y" : "x";
            (0, $d9ea561cb1f2e9a5$export$a0230ae482601ae8)(isShared ? snapshot.measuredBox[snapAxis] : snapshot.layoutBox[snapAxis], layout[snapAxis]);
        } else if ($520743bffd6c4832$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $677cd175d6f56db8$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $3cec24e0364f7039$export$c1c127004b72a37)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, $8719be7ef375b7e3$export$3d227df54007d73a)();
        (0, $3cec24e0364f7039$export$c0d25e96fc67d310)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $8719be7ef375b7e3$export$3d227df54007d73a)();
        if (isShared) (0, $3cec24e0364f7039$export$c0d25e96fc67d310)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $3cec24e0364f7039$export$c0d25e96fc67d310)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $89b41278514ea693$export$a7ec7642fe550fb6)(layoutDelta);
        let hasRelativeLayoutChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const anchor = node.options.layoutAnchor || undefined;
                    const relativeSnapshot = (0, $8719be7ef375b7e3$export$6459fc9e86be362e)();
                    (0, $3cec24e0364f7039$export$2785bfcc929c5650)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox, anchor);
                    const relativeLayout = (0, $8719be7ef375b7e3$export$6459fc9e86be362e)();
                    (0, $3cec24e0364f7039$export$2785bfcc929c5650)(relativeLayout, layout, parentLayout.layoutBox, anchor);
                    if (!(0, $89b41278514ea693$export$ef641b782d85522)(relativeSnapshot, relativeLayout)) hasRelativeLayoutChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeLayoutChanged: hasRelativeLayoutChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete: onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $520743bffd6c4832$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ if ((0, $a9d4288c548593bd$export$84ce9a476f53d110).value) $520743bffd6c4832$var$metrics.nodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $520743bffd6c4832$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $520743bffd6c4832$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $520743bffd6c4832$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $520743bffd6c4832$var$forceLayoutMeasure(node) {
    node.isLayoutDirty = true;
    node.updateLayout();
}
function $520743bffd6c4832$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
/**
 * When a node is animation-blocked (e.g. during drag) and its component
 * didn't re-render (memoized), willUpdate() is never called so there's
 * no snapshot. Use the previous layout as a snapshot and mark dirty so
 * resetTransform/updateLayout/notifyLayoutUpdate process it normally.
 */ function $520743bffd6c4832$var$ensureDraggedNodesSnapshotted(node) {
    if (node.isAnimationBlocked && node.layout && !node.isLayoutDirty) {
        node.snapshot = node.layout;
        node.isLayoutDirty = true;
    }
}
function $520743bffd6c4832$var$resetTransformStyle(node) {
    const { visualElement: visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $520743bffd6c4832$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $520743bffd6c4832$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $520743bffd6c4832$var$calcProjection(node) {
    node.calcProjection();
}
function $520743bffd6c4832$var$resetSkewAndRotation(node) {
    node.resetSkewAndRotation();
}
function $520743bffd6c4832$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $520743bffd6c4832$var$mixAxisDeltaLinear(output, delta, p) {
    output.translate = (0, $5a3532f8b2a8e80b$export$3bb0b4ff1037b8dd)(delta.translate, 0, p);
    output.scale = (0, $5a3532f8b2a8e80b$export$3bb0b4ff1037b8dd)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $520743bffd6c4832$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $5a3532f8b2a8e80b$export$3bb0b4ff1037b8dd)(from.min, to.min, p);
    output.max = (0, $5a3532f8b2a8e80b$export$3bb0b4ff1037b8dd)(from.max, to.max, p);
}
function $520743bffd6c4832$export$6ffd3e6ae339a132(output, from, to, p) {
    $520743bffd6c4832$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $520743bffd6c4832$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $520743bffd6c4832$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $520743bffd6c4832$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const $520743bffd6c4832$var$userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const $520743bffd6c4832$var$roundPoint = $520743bffd6c4832$var$userAgentContains("applewebkit/") && !$520743bffd6c4832$var$userAgentContains("chrome/") ? Math.round : (0, $df2228348c5a149c$export$8793edee2d425525);
function $520743bffd6c4832$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $520743bffd6c4832$var$roundPoint(axis.min);
    axis.max = $520743bffd6c4832$var$roundPoint(axis.max);
}
function $520743bffd6c4832$var$roundBox(box) {
    $520743bffd6c4832$var$roundAxis(box.x);
    $520743bffd6c4832$var$roundAxis(box.y);
}
function $520743bffd6c4832$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $3cec24e0364f7039$export$28d0384c4b79bde2)((0, $89b41278514ea693$export$c5706146bc63213)(snapshot), (0, $89b41278514ea693$export$c5706146bc63213)(layout), 0.2);
}
function $520743bffd6c4832$var$checkNodeWasScrollRoot(node) {
    return node !== node.root && node.scroll?.wasRoot;
}




const $0bf7dd4fc6942540$export$2d029a49a09b6177 = (0, $520743bffd6c4832$export$a84b61f69daa9da0)({
    attachResizeListener: (ref, notify)=>(0, $c6c2e3791712db82$export$b1d829ddf82884aa)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body?.scrollLeft || 0,
            y: document.documentElement.scrollTop || document.body?.scrollTop || 0
        }),
    checkIsScrollRoot: ()=>true
});


const $c8b1339116086ed4$export$b91509fcf893b648 = {
    current: undefined
};
const $c8b1339116086ed4$export$b61a9eb3dbde8858 = (0, $520743bffd6c4832$export$a84b61f69daa9da0)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$c8b1339116086ed4$export$b91509fcf893b648.current) {
            const documentNode = new (0, $0bf7dd4fc6942540$export$2d029a49a09b6177)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $c8b1339116086ed4$export$b91509fcf893b648.current = documentNode;
        }
        return $c8b1339116086ed4$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});


const $6eeb3366e6b865a4$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $a6a5796c309a9c3f$export$b4f8f1ee75ce5859)
    },
    drag: {
        Feature: (0, $cf651a164871d0d1$export$5d97dc2872682820),
        ProjectionNode: (0, $c8b1339116086ed4$export$b61a9eb3dbde8858),
        MeasureLayout: $63e7e4e4795e2f03$export$779f5fb01ad751cd
    }
};




function $b3d14661bd67aad7$export$edc0ace9d5e7e842(elementOrSelector, options) {
    const elements = (0, $0da12101cded0c58$export$90ceba2564a894f8)(elementOrSelector);
    const gestureAbortController = new AbortController();
    const eventOptions = {
        passive: true,
        ...options,
        signal: gestureAbortController.signal
    };
    const cancel = ()=>gestureAbortController.abort();
    return [
        elements,
        eventOptions,
        cancel
    ];
}


function $e393d48107575c50$var$isValidHover(event) {
    return !(event.pointerType === "touch" || (0, $8c06e427fb97e53d$export$1b3dd616664938e4)());
}
/**
 * Create a hover gesture. hover() is different to .addEventListener("pointerenter")
 * in that it has an easier syntax, filters out polyfilled touch events, interoperates
 * with drag gestures, and automatically removes the "pointerennd" event listener when the hover ends.
 *
 * @public
 */ function $e393d48107575c50$export$3f60957f5dbf3876(elementOrSelector, onHoverStart, options = {}) {
    const [elements, eventOptions, cancel] = (0, $b3d14661bd67aad7$export$edc0ace9d5e7e842)(elementOrSelector, options);
    elements.forEach((element)=>{
        let isPressed = false;
        let deferredHoverEnd = false;
        let hoverEndCallback;
        const removePointerLeave = ()=>{
            element.removeEventListener("pointerleave", onPointerLeave);
        };
        const endHover = (event)=>{
            if (hoverEndCallback) {
                hoverEndCallback(event);
                hoverEndCallback = undefined;
            }
            removePointerLeave();
        };
        const onPointerUp = (event)=>{
            isPressed = false;
            window.removeEventListener("pointerup", onPointerUp);
            window.removeEventListener("pointercancel", onPointerUp);
            if (deferredHoverEnd) {
                deferredHoverEnd = false;
                endHover(event);
            }
        };
        const onPointerDown = ()=>{
            isPressed = true;
            window.addEventListener("pointerup", onPointerUp, eventOptions);
            window.addEventListener("pointercancel", onPointerUp, eventOptions);
        };
        const onPointerLeave = (leaveEvent)=>{
            if (leaveEvent.pointerType === "touch") return;
            if (isPressed) {
                deferredHoverEnd = true;
                return;
            }
            endHover(leaveEvent);
        };
        const onPointerEnter = (enterEvent)=>{
            if (!$e393d48107575c50$var$isValidHover(enterEvent)) return;
            deferredHoverEnd = false;
            const onHoverEnd = onHoverStart(element, enterEvent);
            if (typeof onHoverEnd !== "function") return;
            hoverEndCallback = onHoverEnd;
            element.addEventListener("pointerleave", onPointerLeave, eventOptions);
        };
        element.addEventListener("pointerenter", onPointerEnter, eventOptions);
        element.addEventListener("pointerdown", onPointerDown, eventOptions);
    });
    return cancel;
}



function $e743da886ceb39b8$var$handleHoverEvent(node, event, lifecycle) {
    const { props: props } = node;
    if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", lifecycle === "Start");
    const eventName = "onHover" + lifecycle;
    const callback = props[eventName];
    if (callback) (0, $99c45f49fc7b5e17$export$2cef06c20297c17d).postRender(()=>callback(event, (0, $7bbf8abca28d5486$export$12f84bb882d06e1a)(event)));
}
class $e743da886ceb39b8$export$93a81ea037eac456 extends (0, $26080a271792ef8a$export$6e91cf7616333d5) {
    mount() {
        const { current: current } = this.node;
        if (!current) return;
        this.unmount = (0, $e393d48107575c50$export$3f60957f5dbf3876)(current, (_element, startEvent)=>{
            $e743da886ceb39b8$var$handleHoverEvent(this.node, startEvent, "Start");
            return (endEvent)=>$e743da886ceb39b8$var$handleHoverEvent(this.node, endEvent, "End");
        });
    }
    unmount() {}
}




class $e8576114e62da025$export$d4826db40d47595b extends (0, $26080a271792ef8a$export$6e91cf7616333d5) {
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $49331bd461989f84$export$a4627e546088548d)((0, $c6c2e3791712db82$export$b1d829ddf82884aa)(this.node.current, "focus", ()=>this.onFocus()), (0, $c6c2e3791712db82$export$b1d829ddf82884aa)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
}



/**
 * Checks if an element is an HTML element in a way
 * that works across iframes
 */ function $7d52f18fd507c138$export$1b3bfaa9684536aa(element) {
    return (0, $04cb160e67a0ea6d$export$a6cdc56e425d0d0a)(element) && "offsetHeight" in element && !("ownerSVGElement" in element);
}



/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $8f86f091f09a8565$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $8f86f091f09a8565$export$e841ada32ff745b(parent, child.parentElement);
};





const $31564acf67f34749$export$7987404a4e35b84b = new WeakSet();


/**
 * Filter out events that are not "Enter" keys.
 */ function $a6940be866f44f47$var$filterEvents(callback) {
    return (event)=>{
        if (event.key !== "Enter") return;
        callback(event);
    };
}
function $a6940be866f44f47$var$firePointerEvent(target, type) {
    target.dispatchEvent(new PointerEvent("pointer" + type, {
        isPrimary: true,
        bubbles: true
    }));
}
const $a6940be866f44f47$export$4b5790288fe12a79 = (focusEvent, eventOptions)=>{
    const element = focusEvent.currentTarget;
    if (!element) return;
    const handleKeydown = $a6940be866f44f47$var$filterEvents(()=>{
        if ((0, $31564acf67f34749$export$7987404a4e35b84b).has(element)) return;
        $a6940be866f44f47$var$firePointerEvent(element, "down");
        const handleKeyup = $a6940be866f44f47$var$filterEvents(()=>{
            $a6940be866f44f47$var$firePointerEvent(element, "up");
        });
        const handleBlur = ()=>$a6940be866f44f47$var$firePointerEvent(element, "cancel");
        element.addEventListener("keyup", handleKeyup, eventOptions);
        element.addEventListener("blur", handleBlur, eventOptions);
    });
    element.addEventListener("keydown", handleKeydown, eventOptions);
    /**
     * Add an event listener that fires on blur to remove the keydown events.
     */ element.addEventListener("blur", ()=>element.removeEventListener("keydown", handleKeydown), eventOptions);
};



/**
 * Filter out events that are not primary pointer events, or are triggering
 * while a Motion gesture is active.
 */ function $c2f28172f8c06887$var$isValidPressEvent(event) {
    return (0, $d1d5b7f809794a2a$export$a4cf9c8a4b063a6e)(event) && !(0, $8c06e427fb97e53d$export$1b3dd616664938e4)();
}
const $c2f28172f8c06887$var$claimedPointerDownEvents = new WeakSet();
/**
 * Create a press gesture.
 *
 * Press is different to `"pointerdown"`, `"pointerup"` in that it
 * automatically filters out secondary pointer events like right
 * click and multitouch.
 *
 * It also adds accessibility support for keyboards, where
 * an element with a press gesture will receive focus and
 *  trigger on Enter `"keydown"` and `"keyup"` events.
 *
 * This is different to a browser's `"click"` event, which does
 * respond to keyboards but only for the `"click"` itself, rather
 * than the press start and end/cancel. The element also needs
 * to be focusable for this to work, whereas a press gesture will
 * make an element focusable by default.
 *
 * @public
 */ function $c2f28172f8c06887$export$dbe9198142dace0c(targetOrSelector, onPressStart, options = {}) {
    const [targets, eventOptions, cancelEvents] = (0, $b3d14661bd67aad7$export$edc0ace9d5e7e842)(targetOrSelector, options);
    const startPress = (startEvent)=>{
        const target = startEvent.currentTarget;
        if (!$c2f28172f8c06887$var$isValidPressEvent(startEvent)) return;
        if ($c2f28172f8c06887$var$claimedPointerDownEvents.has(startEvent)) return;
        (0, $31564acf67f34749$export$7987404a4e35b84b).add(target);
        if (options.stopPropagation) $c2f28172f8c06887$var$claimedPointerDownEvents.add(startEvent);
        const onPressEnd = onPressStart(target, startEvent);
        const onPointerEnd = (endEvent, success)=>{
            window.removeEventListener("pointerup", onPointerUp);
            window.removeEventListener("pointercancel", onPointerCancel);
            if ((0, $31564acf67f34749$export$7987404a4e35b84b).has(target)) (0, $31564acf67f34749$export$7987404a4e35b84b).delete(target);
            if (!$c2f28172f8c06887$var$isValidPressEvent(endEvent)) return;
            if (typeof onPressEnd === "function") onPressEnd(endEvent, {
                success: success
            });
        };
        const onPointerUp = (upEvent)=>{
            onPointerEnd(upEvent, target === window || target === document || options.useGlobalTarget || (0, $8f86f091f09a8565$export$e841ada32ff745b)(target, upEvent.target));
        };
        const onPointerCancel = (cancelEvent)=>{
            onPointerEnd(cancelEvent, false);
        };
        window.addEventListener("pointerup", onPointerUp, eventOptions);
        window.addEventListener("pointercancel", onPointerCancel, eventOptions);
    };
    targets.forEach((target)=>{
        const pointerDownTarget = options.useGlobalTarget ? window : target;
        pointerDownTarget.addEventListener("pointerdown", startPress, eventOptions);
        if ((0, $7d52f18fd507c138$export$1b3bfaa9684536aa)(target)) {
            target.addEventListener("focus", (event)=>(0, $a6940be866f44f47$export$4b5790288fe12a79)(event, eventOptions));
            if (!(0, $7d4abd4ea4a9f329$export$5f6976e2f961e8b7)(target) && !target.hasAttribute("tabindex")) target.tabIndex = 0;
        }
    });
    return cancelEvents;
}



function $8993f95a19d3ff8f$var$handlePressEvent(node, event, lifecycle) {
    const { props: props } = node;
    if (node.current instanceof HTMLButtonElement && node.current.disabled) return;
    if (node.animationState && props.whileTap) node.animationState.setActive("whileTap", lifecycle === "Start");
    const eventName = "onTap" + (lifecycle === "End" ? "" : lifecycle);
    const callback = props[eventName];
    if (callback) (0, $99c45f49fc7b5e17$export$2cef06c20297c17d).postRender(()=>callback(event, (0, $7bbf8abca28d5486$export$12f84bb882d06e1a)(event)));
}
class $8993f95a19d3ff8f$export$f026abdbba7f0c9e extends (0, $26080a271792ef8a$export$6e91cf7616333d5) {
    mount() {
        const { current: current } = this.node;
        if (!current) return;
        const { globalTapTarget: globalTapTarget, propagate: propagate } = this.node.props;
        this.unmount = (0, $c2f28172f8c06887$export$dbe9198142dace0c)(current, (_element, startEvent)=>{
            $8993f95a19d3ff8f$var$handlePressEvent(this.node, startEvent, "Start");
            return (endEvent, { success: success })=>$8993f95a19d3ff8f$var$handlePressEvent(this.node, endEvent, success ? "End" : "Cancel");
        }, {
            useGlobalTarget: globalTapTarget,
            stopPropagation: propagate?.tap === false
        });
    }
    unmount() {}
}



/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $36da3579e737723d$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $36da3579e737723d$var$observers = new WeakMap();
const $36da3579e737723d$var$fireObserverCallback = (entry)=>{
    const callback = $36da3579e737723d$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $36da3579e737723d$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($36da3579e737723d$var$fireObserverCallback);
};
function $36da3579e737723d$var$initIntersectionObserver({ root: root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$36da3579e737723d$var$observers.has(lookupRoot)) $36da3579e737723d$var$observers.set(lookupRoot, {});
    const rootObservers = $36da3579e737723d$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($36da3579e737723d$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $36da3579e737723d$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $36da3579e737723d$var$initIntersectionObserver(options);
    $36da3579e737723d$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $36da3579e737723d$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}


const $303a93f8106b6a38$var$thresholdNames = {
    some: 0,
    all: 1
};
class $303a93f8106b6a38$export$150851c8cc2f0c72 extends (0, $26080a271792ef8a$export$6e91cf7616333d5) {
    startObserver() {
        this.stopObserver?.();
        const { viewport: viewport = {} } = this.node.getProps();
        const { root: root, margin: rootMargin, amount: amount = "some", once: once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $303a93f8106b6a38$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        this.stopObserver = (0, $36da3579e737723d$export$b2bcd62fb7925aa5)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props, prevProps: prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($303a93f8106b6a38$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {
        this.stopObserver?.();
        this.hasEnteredView = false;
        this.isInView = false;
    }
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
}
function $303a93f8106b6a38$var$hasViewportOptionChanged({ viewport: viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}


const $a02806c63d4e15d5$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $303a93f8106b6a38$export$150851c8cc2f0c72)
    },
    tap: {
        Feature: (0, $8993f95a19d3ff8f$export$f026abdbba7f0c9e)
    },
    focus: {
        Feature: (0, $e8576114e62da025$export$d4826db40d47595b)
    },
    hover: {
        Feature: (0, $e743da886ceb39b8$export$93a81ea037eac456)
    }
};




const $1366b9ab3a790f3c$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $c8b1339116086ed4$export$b61a9eb3dbde8858),
        MeasureLayout: $63e7e4e4795e2f03$export$779f5fb01ad751cd
    }
};


const $69f4a9875934b9dc$export$d596cd8841d25433 = {
    ...(0, $61435b153a491fc2$export$7f9953c70dacfd7f),
    ...(0, $a02806c63d4e15d5$export$e5b72898e5a201f1),
    ...(0, $6eeb3366e6b865a4$export$d7d5d435647ed5a0),
    ...(0, $1366b9ab3a790f3c$export$b3219800bda33a1f)
};


const $fda5cb254e24fbb5$export$e25e478948902b8b = /*@__PURE__*/ (0, $aca54ab863ad2bab$export$a28d6df673050e18)((0, $69f4a9875934b9dc$export$d596cd8841d25433), (0, $49c295e100cc1fa8$export$56ba0183203348f5));



var $lDJXT = parcelRequire("lDJXT");


var $lDJXT = parcelRequire("lDJXT");
const $c526f30047ea0462$var$shapePaths = {
    blob: [
        "M53.3,-56.6C68.8,-42.1,81.5,-21.1,78.6,-4.5C75.6,12.1,57,24.2,41.5,38C26,51.8,13,67.3,-1,68.6C-15,69.8,-30,56.8,-41.3,42.7C-52.6,28.6,-60.2,13.3,-61.8,-3.4C-63.3,-20.1,-58.9,-38.2,-47.3,-52.6C-35.7,-67.1,-17.9,-77.9,2,-80.3C21.9,-82.7,43.8,-76.8,53.3,-56.6Z",
        "M40.6,-64.2C50.5,-51.2,55.3,-38,61.2,-26C67.2,-14,74.3,-3.1,74.8,8.7C75.3,20.6,69.2,33.4,60.1,41.8C50.9,50.3,38.7,54.5,26.1,63.4C13.4,72.3,0.3,86,-16.3,89.5C-32.8,93,-52.9,86.3,-60.6,71.8C-68.2,57.2,-63.4,34.8,-58,16.6C-52.7,-1.7,-46.7,-15.7,-39.3,-29.6C-31.9,-43.5,-23.1,-57.3,-10.2,-66.4C2.7,-75.5,27.8,-79.8,40.6,-64.2Z",
        "M44.7,-61.6C55.7,-52,61.7,-38.4,64.4,-24.9C67.1,-11.4,66.5,2,62.3,14.5C58.2,27,50.6,38.6,40.8,49.2C31,59.8,19,69.3,5.3,71.5C-8.5,73.7,-17,68.7,-29.2,62.5C-41.3,56.2,-57.1,48.7,-65.3,36.2C-73.6,23.6,-74.3,6.1,-68.9,-8.1C-63.5,-22.3,-52,-33.3,-40.3,-43.7C-28.6,-54,-16.8,-63.6,-2.9,-61.3C11,-59,22,-44.9,44.7,-61.6Z",
        "M62.1,-47.5C75.2,-32.4,78.7,-8.5,75.7,13.8C72.7,36.1,63.3,56.7,47.3,65.8C31.3,74.9,8.8,72.5,-11.8,66.2C-32.5,60,-51.2,49.8,-61.6,34.5C-72,19.1,-74.1,-1.5,-66.9,-17.5C-59.7,-33.5,-43.3,-44.8,-27.7,-58.2C-12.2,-71.6,2.5,-87.2,20.1,-87.4C37.8,-87.6,58.3,-72.5,62.1,-47.5Z"
    ],
    heart: [
        "M60.83,17.18c8-8.35,13.62-15.57,26-17C110-2.46,131.27,21.26,119.57,44.61c-3.33,6.65-10.11,14.56-17.61,22.32-8.23,8.52-17.34,16.87-23.72,23.2l-17.4,17.26L46.46,93.55C29.16,76.89,1,55.92,0,29.94-.63,11.74,13.73.08,30.25.29c14.76.2,21,7.54,30.58,16.89Z"
    ],
    star: [
        "M63.09,1.11l16,39.1l42.14,3.13c0.98,0.07,1.72,0.92,1.65,1.9c-0.04,0.52-0.3,0.98-0.68,1.28L90,73.79l10.04,41.05 c0.23,0.95-0.36,1.92-1.31,2.15c-0.5,0.12-1,0.02-1.39-0.24l-35.9-22.21L25.5,116.77c-0.84,0.52-1.93,0.26-2.45-0.58 c-0.26-0.42-0.32-0.91-0.22-1.35l0,0l10.04-41.05L0.63,46.48c-0.75-0.63-0.84-1.76-0.21-2.51c0.32-0.38,0.77-0.59,1.23-0.63v0 l42.14-3.13l16-39.1c0.37-0.91,1.41-1.35,2.31-0.98C62.57,0.32,62.91,0.68,63.09,1.11L63.09,1.11L63.09,1.11z M64.1,39.66 l5.71,13.96l15.05,1.12c0.27,0.02,0.52,0.08,0.76,0.17l29.73-8.43l-37.62-2.8l0-0.01c-0.65-0.05-1.26-0.45-1.52-1.1L63.16,10.66 l0.3,28.08C63.74,39,63.96,39.31,64.1,39.66L64.1,39.66L64.1,39.66z M111.1,51.25l-23.95,6.79c-0.15,0.52-0.47,0.97-0.88,1.29 l-11.45,9.7l3.59,14.67c0.07,0.29,0.09,0.58,0.06,0.86l15.86,21.9L86.3,73.65c-0.2-0.66,0-1.4,0.56-1.87L111.1,51.25L111.1,51.25z M92.21,109.39l-16.3-22.51c-0.51,0-0.99-0.15-1.4-0.42L63.6,79.7v11.17c0,0.25-0.05,0.49-0.15,0.71L92.21,109.39L92.21,109.39z M60.18,91.13c-0.01-0.08-0.02-0.17-0.02-0.25V79.51l-11.28,6.98c-0.34,0.21-0.71,0.33-1.09,0.37L30.65,109.4L60.18,91.13 L60.18,91.13z M28.53,106.54l16.49-21.68c-0.08-0.38-0.08-0.78,0.01-1.15l0,0l3.59-14.67L37.1,59.27c-0.43-0.36-0.7-0.83-0.83-1.33 L8.71,48.66l27.31,23.12l0,0c0.5,0.42,0.74,1.1,0.58,1.78L28.53,106.54L28.53,106.54z M12,46.15l25.65,8.65 c0.08,0.03,0.16,0.06,0.23,0.1c0.22-0.08,0.46-0.13,0.7-0.15l0,0l15.06-1.12l5.71-13.96c0.16-0.39,0.4-0.71,0.69-0.97l-0.3-28.05 l-13.01,31.8c-0.21,0.68-0.82,1.19-1.58,1.25L12,46.15L12,46.15z M60.1,44.59l-4.7,11.48l-16.64,1.24l12.74,10.79l-3.97,16.21 l0.61-0.38l2.88-1.78l10.7-6.62l4.71,2.92l9.11,5.64l0.37,0.23l-3.97-16.21l12.74-10.79l-0.26-0.02v0l-16.38-1.22l-4.51-11.03v0 l-1.81-4.42L60.1,44.59L60.1,44.59z"
    ],
    bear: [
        "M101.1,19.08c-0.82,0.09-1.56-0.51-1.64-1.33c-0.09-0.82,0.51-1.56,1.33-1.64c0.8-0.09,1.6-0.06,2.4,0.07 c0.78,0.13,1.56,0.37,2.34,0.71c0.76,0.33,1.1,1.2,0.78,1.96c-0.33,0.76-1.2,1.1-1.96,0.78c-0.55-0.24-1.1-0.4-1.65-0.49 C102.16,19.04,101.63,19.03,101.1,19.08L101.1,19.08z M115.43,17.02c-1.16,0.44-1.55,1.27-1.31,3.62c0.24,2.36,0.36,4.57,2.91,5.48 c0.22,0.08,0.45,0.14,0.69,0.19c-1.2,0.84-2.7,1.21-4.31,1.6c-0.73,0.18-1.47,0.36-2.27,0.6c-0.06,0.01-0.12,0.03-0.18,0.06 L80.61,40.06c0.04-1.42,0-2.75-0.15-3.92c-0.13-1.02-0.31-1.98-0.55-2.89c-0.24-0.92-0.54-1.8-0.89-2.63 c-0.32-0.76-1.2-1.12-1.96-0.8c-0.76,0.32-1.12,1.2-0.8,1.96c0.29,0.7,0.54,1.44,0.75,2.22c0.21,0.8,0.37,1.64,0.48,2.51 c0.18,1.4,0.18,3.08,0.06,4.91c-0.33,0.4-0.44,0.96-0.24,1.47c0.03,0.08,0.06,0.15,0.1,0.22c-0.48,4.95-1.68,10.79-2.7,15.77 c-0.47,2.29-0.9,4.42-1.19,6.02l0,0c-0.01,0.07-0.02,0.15-0.02,0.23c-0.03,1.32,0.03,2.48,0.2,3.49c0.18,1.1,0.48,2.03,0.9,2.78 c0.88,1.55,2.13,1.94,3.4,2.34c0.83,0.26,1.68,0.53,2.06,1.46c0.06,0.15,0.08,0.31,0.05,0.47c-0.03,0.19-0.12,0.4-0.27,0.63 c-2.4,1.55-4.8,2.45-7.03,2.67c-2.19,0.22-4.23-0.21-5.95-1.33c-2.04-1.33-3.14-2.87-3.76-4.6c-0.65-1.84-0.8-3.98-0.91-6.34 l-0.1-2.09c0-0.04,0-0.08,0-0.12c-0.22-2.8-1.08-4.6-2.35-5.76c-0.84-0.77-1.82-1.22-2.88-1.48c0.18-0.74,0.33-1.45,0.43-2.16 c0.18-1.24,0.25-2.43,0.19-3.6c-0.09-1.7-0.43-3.31-1.04-4.85c-0.6-1.52-1.47-3-2.6-4.45c-0.51-0.65-1.45-0.77-2.1-0.26 c-0.65,0.51-0.77,1.45-0.26,2.1c0.94,1.21,1.67,2.43,2.17,3.71c0.37,0.94,0.62,1.91,0.75,2.9c-4.52,2.23-7.53,3.49-10.63,4.3 c-0.64,0.17-1.29,0.31-1.96,0.45c-0.21,0-0.41,0.04-0.61,0.12c-1.71,0.31-3.59,0.55-5.86,0.78c1.43-1.71,2.58-3.59,3.44-5.65 c1.79-4.31,2.29-9.37,1.4-15.24c-0.12-0.82-0.89-1.38-1.7-1.26c-0.82,0.12-1.38,0.89-1.26,1.7c0.81,5.32,0.38,9.85-1.2,13.65 c-1.2,2.88-3.06,5.36-5.56,7.47c-0.05,0.04-0.09,0.07-0.14,0.11c-0.72,0.6-1.49,1.17-2.31,1.71c-0.12,0.07-0.23,0.16-0.33,0.26 c-1.23,1.31-2.31,2.69-3.23,4.16c-0.9,1.45-1.64,2.98-2.2,4.62c-0.11,0.26-0.15,0.56-0.09,0.86c0.36,1.83,1.1,3.1,2.15,3.88 c1.03,0.77,2.29,1.03,3.72,0.88c1.26,0.22,2.07,0.88,2.38,1.64c0.12,0.29,0.16,0.6,0.12,0.91c-0.04,0.29-0.15,0.59-0.35,0.85 c-0.45,0.59-1.29,1.05-2.59,1.2h-3.18c-0.07,0-0.13,0-0.19,0.01H14.08L7.02,64.93c-0.14-1.3-0.04-2.35,0.26-3.21 c0.29-0.86,0.79-1.55,1.43-2.12l0,0c0.18-0.17,0.33-0.38,0.41-0.63c0.71-2.14,0.99-4.78,0.83-7.92c-0.15-3.02-0.71-6.54-1.66-10.53 c-0.03-0.18-0.1-0.36-0.21-0.53c-0.44-0.7-1.36-0.91-2.06-0.47c-1.23,0.77-2.04,1.06-2.4,0.84c-0.43-0.27-0.64-1.27-0.63-3.05 l0-0.01c0.18-4.42,1.2-8.16,2.91-11.32c1.71-3.15,4.12-5.75,7.09-7.89v0c0.04-0.03,0.08-0.06,0.12-0.09 c3.87-3.42,8.86-6,14.87-7.78c6.08-1.8,13.2-2.78,21.29-3.01c0.25,0.01,0.51-0.05,0.75-0.18c4.59-2.49,8.94-4.27,12.58-4 c3.39,0.25,6.28,2.44,8.34,7.82c0.29,0.77,1.16,1.16,1.93,0.87c0.77-0.29,1.16-1.16,0.87-1.93c-0.24-0.64-0.5-1.24-0.77-1.8 l15.8,1.51c0.76,0.11,1.5-0.38,1.67-1.15c0.43-1.9,1.56-3.26,2.89-3.95c0.69-0.36,1.43-0.54,2.14-0.52 c0.68,0.02,1.36,0.22,1.95,0.63c1.04,0.71,1.85,2.08,2.12,4.23h0c0.07,0.58,0.48,1.09,1.08,1.26c3.44,0.99,6.61,2.15,9.38,3.55 C112.04,14.55,113.86,15.71,115.43,17.02L115.43,17.02z M71.43,5.23c0.29-0.23,0.66-0.35,1.06-0.31L87.92,6.4 c0.81-2.16,2.31-3.76,4.04-4.66c1.13-0.59,2.37-0.89,3.6-0.86c1.25,0.03,2.49,0.4,3.56,1.14c1.52,1.04,2.73,2.8,3.24,5.35 c3.25,0.98,6.28,2.12,8.99,3.49c2.97,1.5,5.56,3.28,7.67,5.4c1.85,1.38,2.98,2.86,3.51,4.38c0.61,1.77,0.4,3.51-0.5,5.18 c-1.9,3.54-4.73,4.23-7.91,5c-0.7,0.17-1.43,0.35-2.12,0.55L80.4,43.33c-0.5,5.15-1.71,11.09-2.75,16.15 c-0.43,2.09-0.82,4.02-1.15,5.85c-0.02,1.08,0.04,2.02,0.16,2.82c0.12,0.74,0.3,1.34,0.55,1.77c0.3,0.52,0.99,0.74,1.69,0.96 c1.49,0.47,3.03,0.95,3.94,3.19c0.28,0.68,0.35,1.4,0.21,2.15c-0.12,0.66-0.41,1.32-0.88,1.98c-0.11,0.17-0.25,0.31-0.43,0.43 c-2.89,1.91-5.84,3.03-8.64,3.31c-2.87,0.29-5.56-0.3-7.87-1.8c-2.68-1.75-4.13-3.79-4.95-6.11c-0.78-2.21-0.95-4.59-1.08-7.19 l-0.1-2.08l0-0.05c-0.15-1.94-0.65-3.1-1.38-3.77c-0.7-0.64-1.7-0.89-2.84-0.97c-0.12-0.01-0.25-0.03-0.37-0.07 c-0.79-0.25-1.23-1.08-0.98-1.87c0.37-1.18,0.63-2.3,0.79-3.37c0.03-0.23,0.06-0.46,0.09-0.69c-3.99,1.92-6.86,3.08-9.9,3.86 c-0.67,0.17-1.34,0.33-2.03,0.47l-4.88,5.14c-0.28,0.34-0.5,0.59-0.7,0.83c-1.22,1.4-2.19,2.53-2.04,4.5 c0.03,0.34,0.1,0.66,0.21,0.95c0.02,0.06,0.05,0.12,0.08,0.18c2.88-0.22,5.13,0.91,6.4,2.5c0.7,0.87,1.11,1.88,1.2,2.9 c0.09,1.07-0.17,2.14-0.83,3.09c-1.17,1.66-3.59,2.85-7.53,2.64v0h-6.73c-0.6,0.05-1.24,0.06-1.94,0.01H13.18v0 c-0.53,0-1.05-0.29-1.32-0.79L4.25,66.1l0,0c-0.08-0.16-0.14-0.33-0.17-0.51c-0.26-1.92-0.1-3.5,0.35-4.83 c0.43-1.24,1.1-2.25,1.95-3.09c0.51-1.73,0.7-3.89,0.57-6.49c-0.12-2.39-0.51-5.13-1.18-8.2c-1.48,0.57-2.74,0.55-3.77-0.11 c-1.35-0.86-2.03-2.7-2.01-5.6c0-0.03,0-0.07,0-0.1c0.2-4.92,1.34-9.09,3.26-12.63c1.92-3.53,4.61-6.44,7.92-8.85 c4.21-3.7,9.55-6.46,15.95-8.36c6.25-1.85,13.53-2.87,21.78-3.12c4.92-2.64,9.67-4.5,13.9-4.19C66.15,0.28,69.09,1.81,71.43,5.23 L71.43,5.23z M31.93,59.63c-0.69,0.56-1.42,1.09-2.19,1.6c-1.05,1.13-1.97,2.31-2.75,3.57c-0.73,1.18-1.34,2.41-1.81,3.7 c0.21,0.84,0.52,1.39,0.92,1.68c0.41,0.3,0.99,0.39,1.71,0.3c0.15-0.02,0.3-0.03,0.45-0.01c2.53,0.35,4.21,1.8,4.91,3.51 c0.32,0.77,0.43,1.59,0.34,2.39c-0.07,0.58-0.25,1.16-0.54,1.7h1.43v0c0.03,0,0.06,0,0.09,0c2.79,0.16,4.36-0.47,4.99-1.37 c0.24-0.33,0.33-0.72,0.29-1.11c-0.04-0.44-0.23-0.89-0.55-1.28c-0.81-1-2.38-1.68-4.48-1.32c-0.55,0.13-1.15-0.05-1.52-0.52 c-0.4-0.5-0.72-1.05-0.94-1.62c-0.23-0.58-0.36-1.18-0.41-1.82c-0.25-3.2,1.09-4.75,2.77-6.68c0.24-0.27,0.49-0.56,0.67-0.78 c0.04-0.05,0.08-0.1,0.12-0.14l2.23-2.34C35.98,59.27,34.11,59.44,31.93,59.63L31.93,59.63z"
    ],
    music: [
        "M11.7,0h6.19V2.07c15.49,3.54,17.26,11,8.28,22.7.95-11.63-.22-14.12-8.28-14.66v29.4a3.62,3.62,0,0,1,0,.47c0,3.82-4,7.61-8.95,8.47S0,46.9,0,43.07c0-5.21,7.16-9.74,11.7-8.14V0ZM103,0h6.19V2.07c15.48,3.54,17.25,11,8.27,22.7,1-11.63-.22-14.12-8.27-14.66v29.4c0,.15,0,.31,0,.47,0,3.82-4,7.61-9,8.47s-9-1.55-9-5.38c0-5.21,7.16-9.74,11.7-8.14V0ZM70.51,68.64a11.26,11.26,0,0,1,4.5.08V37.13L41.58,46.72q0,18.66,0,37.3c0,5.82-6.42,10.06-11.57,11-6.39,1.1-11.58-2-11.58-7S23.65,78.18,30,77.08a13,13,0,0,1,6.49.42V32.34l43.54-9.91V73.31c.48,5.4-5,9.49-9.56,10.28-5.34.92-9.66-1.68-9.66-5.81s4.32-8.22,9.66-9.14Z"
    ],
    trophy: [
        "M89.43,45.54c3.38-1,6.39-2.61,8.84-4.65c4.02-3.35,6.5-7.9,6.5-12.87c0-2.78-0.77-5.42-2.15-7.78l0.01,0 c-0.62-1.06-1.36-2.07-2.21-3.01c-0.44,6.2-1.96,12.08-4.34,17.43C94.32,38.61,92.07,42.27,89.43,45.54L89.43,45.54L89.43,45.54z M56.4,91.21l2.83,7.93l8.42,0.24l-6.67,5.14l2.37,8.08l-6.95-4.76l-6.95,4.76l2.37-8.08l-6.67-5.14l8.42-0.24L56.4,91.21 L56.4,91.21z M20.63,80.94h71.55v41.94H20.63V80.94L20.63,80.94z M60.73,60.07v6.55h0.49v4.58l-12.42,0v-4.58l0.49,0v-6.59 c-7.57-1.17-14.49-4.59-20.14-9.59l-0.67,1.85c-7.79-0.13-14.84-2.82-19.95-7.08C3.26,40.83,0,34.75,0,28.01 c0-3.8,1.05-7.4,2.93-10.63l-0.01-0.01c1.9-3.27,4.66-6.13,8.03-8.37L14,6.97l-3.53,0V0h88.61v6.97h-2.82L99.31,9 c3.36,2.24,6.11,5.1,8.02,8.37h0.01c1.87,3.22,2.92,6.82,2.92,10.64c0,6.74-3.26,12.81-8.54,17.21 c-5.11,4.26-12.16,6.95-19.95,7.08l-0.67-1.86C75.39,55.5,68.39,58.94,60.73,60.07L60.73,60.07L60.73,60.07z M42.16,75.79h25.71 v4.58H42.16V75.79L42.16,75.79z M46.08,71.2h17.87v4.58H46.08V71.2L46.08,71.2z M11.99,40.89c2.45,2.05,5.47,3.65,8.85,4.66 c-2.64-3.27-4.89-6.93-6.66-10.9c-2.38-5.34-3.9-11.23-4.34-17.43c-0.83,0.92-1.57,1.94-2.2,3.01l-0.01,0 c-1.37,2.35-2.14,5-2.14,7.78C5.49,32.99,7.97,37.53,11.99,40.89L11.99,40.89z"
    ],
    ring: [
        "M10.94,31.01c-0.05-0.25-0.03-0.51,0.05-0.74l3.48-11.06c0.16-0.53,0.6-0.9,1.1-1l18.7-5.39c0.5-0.14,1.01-0.01,1.37,0.31 l0,0l8.52,7.54c0.15,0.11,0.27,0.26,0.37,0.42c0.23,0.39,0.26,0.86,0.1,1.28l-4.76,13.26c6.32-0.29,12.49,1,18.02,3.61 c2.1-2.01,4.44-3.8,6.99-5.31c2.73-1.61,5.72-2.92,8.93-3.84c10.19-2.94,20.61-1.47,29.2,3.28c8.6,4.75,15.39,12.79,18.33,22.99 c2.94,10.19,1.47,20.61-3.28,29.2c-4.75,8.6-12.79,15.39-22.99,18.33c-9.32,2.69-18.82,1.69-26.95-2.13 c-2.11,2.02-4.46,3.81-7.02,5.32c-2.72,1.61-5.7,2.9-8.9,3.83c-10.19,2.94-20.61,1.47-29.2-3.28c-8.6-4.75-15.39-12.79-18.33-22.99 c-2.94-10.19-1.47-20.61,3.28-29.2c3.4-6.16,8.48-11.39,14.84-14.94l-11.31-8.6C11.19,31.68,11,31.35,10.94,31.01L10.94,31.01z M6.69,31.24l-0.16,0.05C6.13,29.94,5.29,28.92,4,28.2c-1.29-0.71-2.61-0.88-3.95-0.49L0,27.55c1.34-0.39,2.37-1.23,3.09-2.52 c0.71-1.3,0.88-2.61,0.49-3.95l0.16-0.05c0.39,1.34,1.23,2.37,2.52,3.09c1.29,0.71,2.61,0.88,3.95,0.49l0.05,0.16 c-1.34,0.39-2.37,1.23-3.09,2.52C6.46,28.58,6.3,29.9,6.69,31.24L6.69,31.24L6.69,31.24z M17.03,12l-0.16,0.05 c-0.39-1.34-1.23-2.37-2.52-3.09c-1.29-0.71-2.61-0.88-3.95-0.49l-0.05-0.16c1.34-0.39,2.37-1.23,3.09-2.52 c0.71-1.3,0.88-2.61,0.49-3.95l0.16-0.05c0.39,1.34,1.23,2.37,2.52,3.09s2.61,0.88,3.95,0.49l0.05,0.16 c-1.34,0.39-2.37,1.23-3.09,2.52C16.8,9.34,16.64,10.66,17.03,12L17.03,12L17.03,12z M40.83,10.22l-0.16,0.05 c-0.39-1.34-1.23-2.37-2.52-3.09c-1.29-0.71-2.61-0.88-3.95-0.49l-0.05-0.16c1.34-0.39,2.37-1.23,3.09-2.52 c0.71-1.3,0.88-2.61,0.49-3.95L37.89,0c0.39,1.34,1.23,2.37,2.52,3.09c1.29,0.71,2.61,0.88,3.95,0.49l0.05,0.16 c-1.34,0.39-2.37,1.23-3.09,2.52C40.61,7.55,40.45,8.87,40.83,10.22L40.83,10.22L40.83,10.22z M60.66,40.68 c2.31,1.32,4.48,2.88,6.48,4.66c1.26-1,2.61-1.91,4.05-2.69c1.74-0.95,3.61-1.72,5.6-2.29c7.36-2.12,14.88-1.06,21.09,2.37 c6.21,3.43,11.12,9.24,13.24,16.6c2.12,7.36,1.06,14.88-2.37,21.09c-3.43,6.21-9.24,11.12-16.6,13.24 c-3.08,0.89-6.19,1.22-9.22,1.05c-3.14-0.17-6.2-0.89-9.05-2.07c-1.79-0.74-3.5-1.67-5.09-2.75c-1.59-1.09-3.06-2.34-4.41-3.74 c-1.52-1.59-2.86-3.37-3.97-5.32c-1.08-1.88-1.95-3.93-2.59-6.14c-0.93-3.24-1.25-6.5-1.03-9.67c0.22-3.05,0.94-6.01,2.11-8.77 c-1.59-1.55-3.38-2.87-5.31-3.94c-0.37-0.21-0.75-0.4-1.14-0.59c-1.77,3.7-2.9,7.71-3.31,11.86c-0.42,4.34-0.05,8.82,1.23,13.26 c2.71,9.41,8.99,16.83,16.94,21.22c7.95,4.39,17.58,5.75,26.99,3.04c9.41-2.71,16.83-8.99,21.22-16.94 c4.39-7.95,5.75-17.58,3.04-26.99c-2.71-9.41-8.99-16.83-16.94-21.22c-7.95-4.39-17.58-5.75-26.99-3.04 c-2.94,0.85-5.7,2.05-8.24,3.55C64.32,37.68,62.4,39.1,60.66,40.68L60.66,40.68z M69.27,47.38c4.2,4.36,7.43,9.78,9.22,16 c1.39,4.82,1.79,9.68,1.33,14.38c-0.44,4.43-1.64,8.71-3.51,12.67c2.16,0.75,4.44,1.21,6.78,1.34c2.72,0.15,5.5-0.14,8.26-0.94 c6.58-1.9,11.76-6.28,14.83-11.84c3.07-5.56,4.02-12.29,2.13-18.88c-1.9-6.58-6.28-11.76-11.84-14.84 c-5.56-3.07-12.29-4.02-18.88-2.13c-1.77,0.51-3.44,1.2-5,2.05C71.41,45.85,70.3,46.58,69.27,47.38L69.27,47.38z M73.6,89.3 c1.76-3.69,2.9-7.69,3.3-11.83c0.43-4.35,0.05-8.85-1.23-13.3c-2.71-9.41-8.99-16.83-16.94-21.22c-7.07-3.9-15.46-5.41-23.84-3.8 c-1.04,0.23-2.05,0.48-3.05,0.77c-1.34,0.39-2.67,0.84-3.96,1.34c-7.58,3.16-13.59,8.75-17.36,15.58 c-4.39,7.95-5.75,17.58-3.04,26.99c2.71,9.41,8.99,16.83,16.94,21.22c7.95,4.39,17.58,5.75,26.99,3.04 c2.93-0.85,5.68-2.05,8.22-3.54c2.08-1.23,4.01-2.65,5.76-4.23c-2.31-1.32-4.48-2.88-6.48-4.66c-1.27,1.02-2.63,1.93-4.07,2.71 c-1.72,0.93-3.58,1.7-5.57,2.27c-7.36,2.12-14.88,1.06-21.09-2.37c-6.21-3.43-11.12-9.24-13.24-16.6l0-0.01 c-2.12-7.36-1.06-14.87,2.37-21.08c3.43-6.21,9.24-11.12,16.6-13.24l0.01,0c7.36-2.12,14.87-1.06,21.08,2.37 c6.21,3.43,11.12,9.24,13.24,16.6l0,0c0.94,3.25,1.25,6.53,1.02,9.7c-0.22,3.03-0.94,5.98-2.11,8.73c1.02,0.99,2.12,1.89,3.29,2.69 C71.45,88.15,72.51,88.77,73.6,89.3L73.6,89.3z M56.78,93.63c-4.2-4.36-7.43-9.78-9.22-16c-1.38-4.8-1.79-9.65-1.34-14.34 c0.43-4.45,1.64-8.74,3.51-12.71c-4.64-1.62-9.81-1.88-14.9-0.45c-0.08,0.03-0.17,0.06-0.26,0.08c-6.52,1.92-11.66,6.28-14.71,11.8 c-3.05,5.52-4.01,12.2-2.16,18.74c0.03,0.08,0.06,0.17,0.08,0.26c1.92,6.52,6.28,11.66,11.8,14.71c5.56,3.07,12.29,4.02,18.88,2.13 c1.74-0.5,3.41-1.19,4.98-2.04C54.63,95.17,55.74,94.44,56.78,93.63L56.78,93.63z M61.09,58.68c-0.75,2.09-1.22,4.29-1.38,6.54 c-0.2,2.85,0.08,5.77,0.91,8.66c0.56,1.94,1.35,3.78,2.33,5.48c0.6,1.05,1.28,2.05,2.01,2.98c0.74-2.08,1.21-4.26,1.37-6.5 c0.21-2.81-0.06-5.7-0.87-8.56c-0.03-0.08-0.06-0.17-0.08-0.26C64.47,63.89,62.99,61.09,61.09,58.68L61.09,58.68z M27.02,38.48 c1.27-0.52,2.58-0.98,3.93-1.37c1.03-0.3,2.05-0.55,3.08-0.75c0.89-0.2,1.78-0.38,2.68-0.53l4.24-11.81l-25.38,7.32l10.11,7.68 C26.11,38.83,26.56,38.65,27.02,38.48L27.02,38.48z M14.59,28.58l25.72-7.42l-6-5.31l-17.27,4.98L14.59,28.58L14.59,28.58z"
    ]
};
function $c526f30047ea0462$export$2e2bcd8739ae039({ seed: seed, shape: shape = "blob" }) {
    const blobShapes = $c526f30047ea0462$var$shapePaths[shape];
    const selectedBlobs = (0, $lDJXT.useMemo)(()=>[
            {
                shape: blobShapes[Math.floor(Math.random() * blobShapes.length)],
                top: -Math.random() * 50,
                left: Math.random(),
                opacity: 20
            },
            {
                shape: blobShapes[Math.floor(Math.random() * blobShapes.length)],
                top: Math.random() * 50,
                left: 50 + Math.random() * 20,
                opacity: 30
            }
        ], // Recompute only when the seed (per-card) changes.
    [
        seed,
        shape
    ]);
    return /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("div", {
        children: selectedBlobs.map((blob, index)=>/*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("svg", {
                className: "rc-card__blob",
                viewBox: "0 0 300 200",
                xmlns: "http://www.w3.org/2000/svg",
                style: {
                    top: `${blob.top}%`,
                    left: `${blob.left}%`,
                    opacity: `${blob.opacity}%`
                },
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("path", {
                    fill: "var(--rc-blob-fill, #ffffff)",
                    d: blob.shape,
                    transform: "translate(100 100)"
                })
            }, index))
    });
}



function $f3535c1af022b71b$export$2e2bcd8739ae039({ title: title, category: category, description: description, from: from, to: to, shape: shape, variant: variant = "gradient" }) {
    const seed = (0, $lDJXT.useMemo)(()=>Math.random(), []);
    return /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)((0, $fda5cb254e24fbb5$export$e25e478948902b8b).div, {
        className: `rc-card rc-card--${variant}`,
        style: {
            "--rc-from": from,
            "--rc-to": to
        },
        whileTap: {
            scale: 0.95
        },
        whileHover: {
            scale: 1.05,
            boxShadow: "10px 8px 20px rgba(0, 0, 0, 0.35)"
        },
        transition: {
            type: "spring",
            stiffness: 200
        },
        children: [
            /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $c526f30047ea0462$export$2e2bcd8739ae039), {
                seed: seed,
                shape: shape
            }),
            /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("span", {
                className: "rc-card__tag",
                children: category
            }),
            /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("h2", {
                className: "rc-card__title",
                children: title
            }),
            /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("div", {
                className: "rc-card__progress",
                children: /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("div", {
                    className: "rc-card__progress-fill"
                })
            }),
            /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("p", {
                className: "rc-card__desc",
                children: description
            }),
            /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $fda5cb254e24fbb5$export$e25e478948902b8b).button, {
                type: "button",
                className: "rc-card__button",
                whileHover: {
                    scale: 1.2
                },
                "aria-hidden": "true",
                tabIndex: -1,
                children: /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $5c6707516b7f4999$export$c4e18b17bff7fe5b), {
                    size: 18
                })
            })
        ]
    });
}


/**
 * Return a new array shuffled with the Fisher–Yates algorithm.
 *
 * Replaces the legacy `array.sort(() => Math.random() - 0.5)` approach, which
 * produces a biased, non-uniform ordering (and, with a constant comparator,
 * no shuffle at all).
 */ function $44cc5c961e023a52$export$448332262467e042(input) {
    const result = input.slice();
    for(let i = result.length - 1; i > 0; i--){
        const j = Math.floor(Math.random() * (i + 1));
        [result[i], result[j]] = [
            result[j],
            result[i]
        ];
    }
    return result;
}


const $1a9670fa11f5e4b7$export$9842ff719f7b293 = [
    {
        from: "#4A90E2",
        to: "#5F9EE7"
    },
    {
        from: "#D35400",
        to: "#E67E22"
    },
    {
        from: "#8E44AD",
        to: "#9B59B6"
    },
    {
        from: "#27AE60",
        to: "#2ECC71"
    },
    {
        from: "#F39C12",
        to: "#F1C40F"
    },
    {
        from: "#E74C3C",
        to: "#EC7063"
    },
    {
        from: "#9B59B6",
        to: "#8E44AD"
    },
    {
        from: "#16A085",
        to: "#1ABC9C"
    },
    {
        from: "#00C9A7",
        to: "#02AABD"
    },
    {
        from: "#FF4E50",
        to: "#FC913A"
    },
    {
        from: "#6A0572",
        to: "#AB83A1"
    },
    {
        from: "#D946EF",
        to: "#F472B6"
    },
    {
        from: "#8E2DE2",
        to: "#4A00E0"
    },
    {
        from: "#FFD700",
        to: "#FFA500"
    }
];
function $1a9670fa11f5e4b7$export$a9ca186c6270e93b({ from: from, to: to }) {
    return `linear-gradient(135deg, ${from}, ${to})`;
}
function $1a9670fa11f5e4b7$export$c51b194721e17a8a(randomBackground) {
    return randomBackground ? (0, $44cc5c961e023a52$export$448332262467e042)($1a9670fa11f5e4b7$export$9842ff719f7b293) : $1a9670fa11f5e4b7$export$9842ff719f7b293.slice();
}
function $1a9670fa11f5e4b7$export$18cb9425622d4e06(randomBackground) {
    return $1a9670fa11f5e4b7$export$c51b194721e17a8a(randomBackground).map($1a9670fa11f5e4b7$export$a9ca186c6270e93b);
}
const $1a9670fa11f5e4b7$export$fc5727d09955ec17 = $1a9670fa11f5e4b7$export$9842ff719f7b293.map($1a9670fa11f5e4b7$export$a9ca186c6270e93b);


function $6dda834a2e43853f$export$2e2bcd8739ae039({ slides: slides, shape: shape, randomBackground: randomBackground = false, variant: variant = "gradient" }) {
    const sliderRef = (0, $lDJXT.useRef)(null);
    const scrollByHalf = (direction)=>{
        const el = sliderRef.current;
        if (el) el.scrollBy({
            left: direction * el.clientWidth / 2,
            behavior: "smooth"
        });
    };
    const palettes = (0, $1a9670fa11f5e4b7$export$c51b194721e17a8a)(randomBackground);
    return /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("div", {
        className: "rc-cardslider",
        children: [
            /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("div", {
                className: "rc-cardslider__overlay rc-cardslider__overlay--left"
            }),
            /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("div", {
                className: "rc-cardslider__overlay rc-cardslider__overlay--right"
            }),
            /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("button", {
                type: "button",
                className: "rc-cardslider__arrow rc-cardslider__arrow--left",
                "aria-label": "Scroll left",
                onClick: ()=>scrollByHalf(-1),
                children: /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $5c6707516b7f4999$export$29ab0a58e0457c56), {})
            }),
            /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("div", {
                ref: sliderRef,
                className: "rc-cardslider__track",
                children: slides.map((slide, index)=>{
                    const palette = palettes[index % palettes.length];
                    const card = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $f3535c1af022b71b$export$2e2bcd8739ae039), {
                        title: slide.title,
                        category: slide.category,
                        description: slide.description,
                        from: palette.from,
                        to: palette.to,
                        shape: shape,
                        variant: variant
                    });
                    return /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("div", {
                        className: "rc-cardslider__item",
                        children: slide.link ? /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("a", {
                            href: slide.link,
                            target: "_blank",
                            rel: "noreferrer",
                            children: card
                        }) : card
                    }, slide.title + index);
                })
            }),
            /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("button", {
                type: "button",
                className: "rc-cardslider__arrow rc-cardslider__arrow--right",
                "aria-label": "Scroll right",
                onClick: ()=>scrollByHalf(1),
                children: /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $5c6707516b7f4999$export$6172d85aadfc9b96), {})
            })
        ]
    });
}



var $lDJXT = parcelRequire("lDJXT");

var $lDJXT = parcelRequire("lDJXT");
const $927e5cfcbbbcef61$export$762b25d1c14c81e4 = /*#__PURE__*/ (0, $lDJXT.createContext)(null);
function $927e5cfcbbbcef61$export$32ac093bcfdd28dd() {
    const api = (0, $lDJXT.useContext)($927e5cfcbbbcef61$export$762b25d1c14c81e4);
    if (api === null) throw new Error("Carousel compound components must be rendered inside <Carousel>. Did you forget to wrap them, or import the part from a different package version?");
    return api;
}



var $lDJXT = parcelRequire("lDJXT");
/** Constrain `value` to the inclusive `[min, max]` range. */ function $c6035e37ca32b6d4$export$7d15b64cf5a3a4c4(value, min, max) {
    if (max < min) return min;
    return Math.min(Math.max(value, min), max);
}
function $c6035e37ca32b6d4$export$acb6ab09ed1b7b8b(index, count) {
    if (count <= 0) return 0;
    return (index % count + count) % count;
}


function $4bf34bfcd2255286$export$d91a617f6985961d(state, action) {
    // Furthest index that still keeps a full view on screen. With
    // slidesPerView > 1 this stops the last slide being scrolled past alone.
    const maxIndex = Math.max(0, state.slidesCount - state.slidesPerView);
    switch(action.type){
        case "NEXT":
            {
                const target = state.activeIndex + action.step;
                const next = action.loop ? (0, $c6035e37ca32b6d4$export$acb6ab09ed1b7b8b)(target, state.slidesCount) : (0, $c6035e37ca32b6d4$export$7d15b64cf5a3a4c4)(target, 0, maxIndex);
                return next === state.activeIndex ? state : {
                    ...state,
                    activeIndex: next
                };
            }
        case "PREV":
            {
                const target = state.activeIndex - action.step;
                const next = action.loop ? (0, $c6035e37ca32b6d4$export$acb6ab09ed1b7b8b)(target, state.slidesCount) : (0, $c6035e37ca32b6d4$export$7d15b64cf5a3a4c4)(target, 0, maxIndex);
                return next === state.activeIndex ? state : {
                    ...state,
                    activeIndex: next
                };
            }
        case "GO_TO":
            {
                const next = (0, $c6035e37ca32b6d4$export$7d15b64cf5a3a4c4)(action.index, 0, maxIndex);
                return next === state.activeIndex ? state : {
                    ...state,
                    activeIndex: next
                };
            }
        case "SET_COUNT":
            {
                if (action.slidesCount === state.slidesCount) return state;
                // Keep the active slide valid if the collection shrank.
                const activeIndex = (0, $c6035e37ca32b6d4$export$7d15b64cf5a3a4c4)(state.activeIndex, 0, Math.max(0, action.slidesCount - state.slidesPerView));
                return {
                    ...state,
                    slidesCount: action.slidesCount,
                    activeIndex: activeIndex
                };
            }
        case "SET_SLIDES_PER_VIEW":
            {
                if (action.slidesPerView === state.slidesPerView) return state;
                const activeIndex = (0, $c6035e37ca32b6d4$export$7d15b64cf5a3a4c4)(state.activeIndex, 0, Math.max(0, state.slidesCount - action.slidesPerView));
                return {
                    ...state,
                    slidesPerView: action.slidesPerView,
                    activeIndex: activeIndex
                };
            }
        case "SET_PLAYING":
            return action.isPlaying === state.isPlaying ? state : {
                ...state,
                isPlaying: action.isPlaying
            };
        default:
            return state;
    }
}



var $lDJXT = parcelRequire("lDJXT");
function $ac1d5a11a2af4411$export$233c1ebb88ea3744({ enabled: enabled, interval: interval, onTick: onTick, rootRef: rootRef }) {
    // Keep the latest callback without re-arming the interval every render.
    const onTickRef = (0, $lDJXT.useRef)(onTick);
    onTickRef.current = onTick;
    (0, $lDJXT.useEffect)(()=>{
        if (!enabled || typeof window === "undefined") return;
        const prefersReducedMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
        if (prefersReducedMotion) return;
        const root = rootRef.current;
        let paused = false;
        const pause = ()=>paused = true;
        const resume = ()=>paused = false;
        const timer = window.setInterval(()=>{
            if (!paused && !document.hidden) onTickRef.current();
        }, interval);
        root?.addEventListener("pointerenter", pause);
        root?.addEventListener("pointerleave", resume);
        root?.addEventListener("focusin", pause);
        root?.addEventListener("focusout", resume);
        return ()=>{
            window.clearInterval(timer);
            root?.removeEventListener("pointerenter", pause);
            root?.removeEventListener("pointerleave", resume);
            root?.removeEventListener("focusin", pause);
            root?.removeEventListener("focusout", resume);
        };
    }, [
        enabled,
        interval,
        rootRef
    ]);
}



var $lDJXT = parcelRequire("lDJXT");
function $fd32f7a95f3c5e8e$export$e818ed21e924bde4(base, breakpoints) {
    const [resolved, setResolved] = (0, $lDJXT.useState)(base);
    // Stable dependency for an object that's often passed inline.
    const bpKey = breakpoints ? JSON.stringify(breakpoints) : "";
    (0, $lDJXT.useEffect)(()=>{
        if (!breakpoints || typeof window === "undefined") return;
        const resolve = ()=>{
            const next = {
                ...base
            };
            for (const width of Object.keys(breakpoints).map(Number).sort((a, b)=>a - b))if (window.matchMedia(`(min-width: ${width}px)`).matches) {
                const over = breakpoints[width];
                if (over.slidesPerView != null) next.slidesPerView = over.slidesPerView;
                if (over.slidesToScroll != null) next.slidesToScroll = over.slidesToScroll;
            }
            return next;
        };
        const update = ()=>setResolved(resolve());
        update();
        window.addEventListener("resize", update);
        return ()=>window.removeEventListener("resize", update);
    // base is read via its primitive fields; bpKey captures breakpoints.
    }, [
        bpKey,
        base.slidesPerView,
        base.slidesToScroll
    ]);
    return breakpoints ? resolved : base;
}



var $lDJXT = parcelRequire("lDJXT");
function $4ab70b9ece306f63$export$8f71654801c2f7cd({ rootRef: rootRef, orientation: orientation, onPrev: onPrev, onNext: onNext, onFirst: onFirst, onLast: onLast }) {
    // Stash handlers in a ref so the listener is attached only once per element.
    const handlers = (0, $lDJXT.useRef)({
        onPrev: onPrev,
        onNext: onNext,
        onFirst: onFirst,
        onLast: onLast
    });
    handlers.current = {
        onPrev: onPrev,
        onNext: onNext,
        onFirst: onFirst,
        onLast: onLast
    };
    (0, $lDJXT.useEffect)(()=>{
        const root = rootRef.current;
        if (!root) return;
        const prevKey = orientation === "horizontal" ? "ArrowLeft" : "ArrowUp";
        const nextKey = orientation === "horizontal" ? "ArrowRight" : "ArrowDown";
        const onKeyDown = (event)=>{
            const { onPrev: onPrev, onNext: onNext, onFirst: onFirst, onLast: onLast } = handlers.current;
            switch(event.key){
                case prevKey:
                    event.preventDefault();
                    onPrev();
                    break;
                case nextKey:
                    event.preventDefault();
                    onNext();
                    break;
                case "Home":
                    event.preventDefault();
                    onFirst();
                    break;
                case "End":
                    event.preventDefault();
                    onLast();
                    break;
            }
        };
        root.addEventListener("keydown", onKeyDown);
        return ()=>root.removeEventListener("keydown", onKeyDown);
    }, [
        rootRef,
        orientation
    ]);
}



var $lDJXT = parcelRequire("lDJXT");
function $1705618c760f1674$export$b57f07e22c950716({ trackRef: trackRef, orientation: orientation, onPrev: onPrev, onNext: onNext, threshold: threshold = 50, onSwipeStart: onSwipeStart, onSwipeEnd: onSwipeEnd }) {
    const handlers = (0, $lDJXT.useRef)({
        onPrev: onPrev,
        onNext: onNext,
        onSwipeStart: onSwipeStart,
        onSwipeEnd: onSwipeEnd
    });
    handlers.current = {
        onPrev: onPrev,
        onNext: onNext,
        onSwipeStart: onSwipeStart,
        onSwipeEnd: onSwipeEnd
    };
    (0, $lDJXT.useEffect)(()=>{
        const track = trackRef.current;
        if (!track) return;
        const isHorizontal = orientation === "horizontal";
        let startPos = 0;
        let delta = 0;
        let dragging = false;
        let frame = 0;
        const axis = (event)=>isHorizontal ? event.clientX : event.clientY;
        const paint = ()=>{
            frame = 0;
            track.style.setProperty("--rc-drag", `${delta}px`);
        };
        const onPointerDown = (event)=>{
            // Ignore secondary buttons; only start on primary pointer.
            if (event.button !== 0) return;
            dragging = true;
            startPos = axis(event);
            delta = 0;
            track.setAttribute("data-dragging", "true");
            track.setPointerCapture(event.pointerId);
            handlers.current.onSwipeStart?.();
        };
        const onPointerMove = (event)=>{
            if (!dragging) return;
            delta = axis(event) - startPos;
            if (!frame) frame = window.requestAnimationFrame(paint);
        };
        const onPointerUp = (event)=>{
            if (!dragging) return;
            dragging = false;
            if (frame) window.cancelAnimationFrame(frame), frame = 0;
            track.removeAttribute("data-dragging");
            track.style.setProperty("--rc-drag", "0px");
            if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
            const committed = Math.abs(delta) > threshold;
            // Dragging the content toward the start reveals the next slide.
            handlers.current.onSwipeEnd?.({
                delta: delta,
                direction: committed ? delta < 0 ? "next" : "prev" : "none"
            });
            if (committed) delta < 0 ? handlers.current.onNext() : handlers.current.onPrev();
        };
        track.addEventListener("pointerdown", onPointerDown);
        track.addEventListener("pointermove", onPointerMove);
        track.addEventListener("pointerup", onPointerUp);
        track.addEventListener("pointercancel", onPointerUp);
        return ()=>{
            if (frame) window.cancelAnimationFrame(frame);
            track.removeEventListener("pointerdown", onPointerDown);
            track.removeEventListener("pointermove", onPointerMove);
            track.removeEventListener("pointerup", onPointerUp);
            track.removeEventListener("pointercancel", onPointerUp);
        };
    }, [
        trackRef,
        orientation,
        threshold
    ]);
}



function $37a3865aa7541cf0$export$2df8346413809f96(options) {
    const { slidesCount: slidesCount, initialIndex: initialIndex = 0, loop: loop = false, autoplay: autoplay = false, autoplayInterval: autoplayInterval = 4000, slidesToScroll: slidesToScroll = 1, slidesPerView: slidesPerView = 1, breakpoints: breakpoints, orientation: orientation = "horizontal", onIndexChange: onIndexChange, onSettle: onSettle, onSwipeStart: onSwipeStart, onSwipeEnd: onSwipeEnd } = options;
    // Resolve responsive slidesPerView / slidesToScroll for the current viewport.
    const effective = (0, $fd32f7a95f3c5e8e$export$e818ed21e924bde4)({
        slidesPerView: slidesPerView,
        slidesToScroll: slidesToScroll
    }, breakpoints);
    const trackRef = (0, $lDJXT.useRef)(null);
    const rootRef = (0, $lDJXT.useRef)(null);
    const [state, dispatch] = (0, $lDJXT.useReducer)((0, $4bf34bfcd2255286$export$d91a617f6985961d), undefined, ()=>({
            activeIndex: (0, $c6035e37ca32b6d4$export$7d15b64cf5a3a4c4)(initialIndex, 0, Math.max(0, slidesCount - slidesPerView)),
            slidesCount: slidesCount,
            slidesPerView: slidesPerView,
            isPlaying: autoplay
        }));
    // Keep the active index valid when the slide collection changes size.
    (0, $lDJXT.useEffect)(()=>{
        dispatch({
            type: "SET_COUNT",
            slidesCount: slidesCount
        });
    }, [
        slidesCount
    ]);
    // Sync the resolved slides-per-view (breakpoint changes) into the reducer.
    (0, $lDJXT.useEffect)(()=>{
        dispatch({
            type: "SET_SLIDES_PER_VIEW",
            slidesPerView: effective.slidesPerView
        });
    }, [
        effective.slidesPerView
    ]);
    // Notify consumers of index changes without re-arming on every render.
    const onIndexChangeRef = (0, $lDJXT.useRef)(onIndexChange);
    onIndexChangeRef.current = onIndexChange;
    (0, $lDJXT.useEffect)(()=>{
        onIndexChangeRef.current?.(state.activeIndex);
    }, [
        state.activeIndex
    ]);
    // Fire onSettle when the track's transform transition finishes.
    const onSettleRef = (0, $lDJXT.useRef)(onSettle);
    onSettleRef.current = onSettle;
    const indexRef = (0, $lDJXT.useRef)(state.activeIndex);
    indexRef.current = state.activeIndex;
    (0, $lDJXT.useEffect)(()=>{
        const track = trackRef.current;
        if (!track) return;
        const handle = (event)=>{
            if (event.target === track && event.propertyName === "transform") onSettleRef.current?.(indexRef.current);
        };
        track.addEventListener("transitionend", handle);
        return ()=>track.removeEventListener("transitionend", handle);
    }, []);
    const step = effective.slidesToScroll;
    const next = (0, $lDJXT.useCallback)(()=>dispatch({
            type: "NEXT",
            step: step,
            loop: loop
        }), [
        step,
        loop
    ]);
    const prev = (0, $lDJXT.useCallback)(()=>dispatch({
            type: "PREV",
            step: step,
            loop: loop
        }), [
        step,
        loop
    ]);
    const goTo = (0, $lDJXT.useCallback)((index)=>dispatch({
            type: "GO_TO",
            index: index
        }), []);
    const play = (0, $lDJXT.useCallback)(()=>dispatch({
            type: "SET_PLAYING",
            isPlaying: true
        }), []);
    const pause = (0, $lDJXT.useCallback)(()=>dispatch({
            type: "SET_PLAYING",
            isPlaying: false
        }), []);
    const first = (0, $lDJXT.useCallback)(()=>dispatch({
            type: "GO_TO",
            index: 0
        }), []);
    const last = (0, $lDJXT.useCallback)(()=>dispatch({
            type: "GO_TO",
            index: slidesCount - 1
        }), [
        slidesCount
    ]);
    (0, $4ab70b9ece306f63$export$8f71654801c2f7cd)({
        rootRef: rootRef,
        orientation: orientation,
        onPrev: prev,
        onNext: next,
        onFirst: first,
        onLast: last
    });
    (0, $1705618c760f1674$export$b57f07e22c950716)({
        trackRef: trackRef,
        orientation: orientation,
        onPrev: prev,
        onNext: next,
        onSwipeStart: onSwipeStart,
        onSwipeEnd: onSwipeEnd
    });
    (0, $ac1d5a11a2af4411$export$233c1ebb88ea3744)({
        enabled: state.isPlaying,
        interval: autoplayInterval,
        onTick: next,
        rootRef: rootRef
    });
    const maxIndex = Math.max(0, state.slidesCount - state.slidesPerView);
    const canPrev = loop || state.activeIndex > 0;
    const canNext = loop || state.activeIndex < maxIndex;
    return (0, $lDJXT.useMemo)(()=>({
            activeIndex: state.activeIndex,
            slidesCount: state.slidesCount,
            slidesPerView: state.slidesPerView,
            isPlaying: state.isPlaying,
            canPrev: canPrev,
            canNext: canNext,
            orientation: orientation,
            next: next,
            prev: prev,
            goTo: goTo,
            play: play,
            pause: pause,
            trackRef: trackRef,
            rootRef: rootRef
        }), [
        state,
        canPrev,
        canNext,
        orientation,
        next,
        prev,
        goTo,
        play,
        pause
    ]);
}


/** Join truthy class-name fragments into a single string. */ function $d8ae731eb2a5610a$export$a274e22fb40f762e(...parts) {
    return parts.filter(Boolean).join(" ");
}


const $9aa35e3494596531$export$144901db2ea8e967 = /*#__PURE__*/ (0, $lDJXT.forwardRef)(function Carousel({ slidesCount: slidesCount, initialIndex: initialIndex, loop: loop, autoplay: autoplay, autoplayInterval: autoplayInterval, slidesToScroll: slidesToScroll, slidesPerView: slidesPerView, breakpoints: breakpoints, orientation: orientation = "horizontal", onIndexChange: onIndexChange, onSettle: onSettle, onSwipeStart: onSwipeStart, onSwipeEnd: onSwipeEnd, label: label = "Carousel", className: className, style: style, children: children, ...rest }, ref) {
    const api = (0, $37a3865aa7541cf0$export$2df8346413809f96)({
        slidesCount: slidesCount,
        initialIndex: initialIndex,
        loop: loop,
        autoplay: autoplay,
        autoplayInterval: autoplayInterval,
        slidesToScroll: slidesToScroll,
        slidesPerView: slidesPerView,
        breakpoints: breakpoints,
        orientation: orientation,
        onIndexChange: onIndexChange,
        onSettle: onSettle,
        onSwipeStart: onSwipeStart,
        onSwipeEnd: onSwipeEnd
    });
    (0, $lDJXT.useImperativeHandle)(ref, ()=>({
            activeIndex: api.activeIndex,
            canPrev: api.canPrev,
            canNext: api.canNext,
            next: api.next,
            prev: api.prev,
            goTo: api.goTo,
            play: api.play,
            pause: api.pause
        }), [
        api
    ]);
    // Size each slide to fit `slidesPerView` per view. The explicit value wins
    // over any themed --rc-slide-size; other consumer style props are preserved.
    const sizedStyle = api.slidesPerView > 1 ? {
        ...style,
        "--rc-slide-size": `calc((100% - ${api.slidesPerView - 1} * var(--rc-slide-gap)) / ${api.slidesPerView})`
    } : style;
    return /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $927e5cfcbbbcef61$export$762b25d1c14c81e4).Provider, {
        value: api,
        children: /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("div", {
            ref: api.rootRef,
            className: (0, $d8ae731eb2a5610a$export$a274e22fb40f762e)("rc-root", className),
            role: "region",
            "aria-roledescription": "carousel",
            "aria-label": label,
            "data-orientation": orientation,
            tabIndex: 0,
            style: sizedStyle,
            ...rest,
            children: children
        })
    });
});





function $ea918e59d89de47f$export$13921ac0cc260818({ children: children, className: className, style: style, ...rest }) {
    const { activeIndex: activeIndex, isPlaying: isPlaying, orientation: orientation, trackRef: trackRef } = (0, $927e5cfcbbbcef61$export$32ac093bcfdd28dd)();
    return /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("div", {
        className: "rc-viewport",
        "data-orientation": orientation,
        // Pause announcements while autoplaying; announce on manual navigation.
        "aria-live": isPlaying ? "off" : "polite",
        children: /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("div", {
            ref: trackRef,
            className: (0, $d8ae731eb2a5610a$export$a274e22fb40f762e)("rc-track", className),
            "data-orientation": orientation,
            style: {
                "--rc-active-index": activeIndex,
                ...style
            },
            ...rest,
            children: children
        })
    });
}





function $e623440f940b046c$export$d8dc01b5c85a37b9({ index: index, children: children, className: className, ...rest }) {
    const { activeIndex: activeIndex, slidesCount: slidesCount } = (0, $927e5cfcbbbcef61$export$32ac093bcfdd28dd)();
    const isActive = index === activeIndex;
    return /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("div", {
        className: (0, $d8ae731eb2a5610a$export$a274e22fb40f762e)("rc-slide", isActive && "rc-slide--active", className),
        role: "group",
        "aria-roledescription": "slide",
        "aria-label": `${index + 1} of ${slidesCount}`,
        "aria-hidden": !isActive || undefined,
        "data-active": isActive || undefined,
        ...rest,
        children: children
    });
}





const $f43c4d105b41199e$var$DEFAULT_LABELS = {
    prev: "Previous slide",
    next: "Next slide",
    first: "First slide",
    last: "Last slide"
};
/** Inline chevron icon so the core ships with zero icon dependencies. */ function $f43c4d105b41199e$var$Icon({ dir: dir }) {
    // first/last render a doubled chevron to read as "jump to end".
    const lines = {
        prev: [
            "15 18 9 12 15 6"
        ],
        next: [
            "9 18 15 12 9 6"
        ],
        first: [
            "18 18 12 12 18 6",
            "11 18 5 12 11 6"
        ],
        last: [
            "13 18 19 12 13 6",
            "6 18 12 12 6 6"
        ]
    };
    return /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("svg", {
        className: "rc-button__icon",
        viewBox: "0 0 24 24",
        width: "1em",
        height: "1em",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": "true",
        focusable: "false",
        children: lines[dir].map((points)=>/*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("polyline", {
                points: points
            }, points))
    });
}
function $f43c4d105b41199e$export$353f5b6fc5456de1({ dir: dir, className: className, children: children, disabled: disabled, "aria-label": ariaLabel, ...rest }) {
    const { prev: prev, next: next, goTo: goTo, slidesCount: slidesCount, canPrev: canPrev, canNext: canNext } = (0, $927e5cfcbbbcef61$export$32ac093bcfdd28dd)();
    const actions = {
        prev: prev,
        next: next,
        first: ()=>goTo(0),
        last: ()=>goTo(slidesCount - 1)
    };
    // prev/first are blocked at the start; next/last at the end.
    const enabled = dir === "prev" || dir === "first" ? canPrev : canNext;
    return /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("button", {
        type: "button",
        className: (0, $d8ae731eb2a5610a$export$a274e22fb40f762e)("rc-button", `rc-button--${dir}`, className),
        "aria-label": ariaLabel ?? $f43c4d105b41199e$var$DEFAULT_LABELS[dir],
        onClick: actions[dir],
        disabled: disabled ?? !enabled,
        ...rest,
        children: children ?? /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)($f43c4d105b41199e$var$Icon, {
            dir: dir
        })
    });
}





function $2d1bc58beaf1064f$export$8da50d3722682be0({ className: className, dotLabel: dotLabel, ...rest }) {
    const { slidesCount: slidesCount, activeIndex: activeIndex, goTo: goTo } = (0, $927e5cfcbbbcef61$export$32ac093bcfdd28dd)();
    return /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("div", {
        className: (0, $d8ae731eb2a5610a$export$a274e22fb40f762e)("rc-dots", className),
        role: "tablist",
        ...rest,
        children: Array.from({
            length: slidesCount
        }, (_, index)=>{
            const isActive = index === activeIndex;
            return /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("button", {
                type: "button",
                role: "tab",
                "aria-selected": isActive,
                "aria-current": isActive || undefined,
                "aria-label": dotLabel ? dotLabel(index) : `Go to slide ${index + 1}`,
                className: (0, $d8ae731eb2a5610a$export$a274e22fb40f762e)("rc-dot", isActive && "rc-dot--active"),
                onClick: ()=>goTo(index)
            }, index);
        })
    });
}





/** Inline play (triangle) / pause (bars) icon — no icon dependency. */ function $ae1b1d6b06f61e85$var$Icon({ playing: playing }) {
    return /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("svg", {
        className: "rc-button__icon",
        viewBox: "0 0 24 24",
        width: "1em",
        height: "1em",
        fill: "currentColor",
        "aria-hidden": "true",
        focusable: "false",
        children: playing ? /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)((0, $217385444e3d1677$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("rect", {
                    x: "6",
                    y: "5",
                    width: "4",
                    height: "14",
                    rx: "1"
                }),
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("rect", {
                    x: "14",
                    y: "5",
                    width: "4",
                    height: "14",
                    rx: "1"
                })
            ]
        }) : /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("polygon", {
            points: "7 4 20 12 7 20 7 4"
        })
    });
}
function $ae1b1d6b06f61e85$export$c73916fe05296ede({ className: className, children: children, "aria-label": ariaLabel, ...rest }) {
    const { isPlaying: isPlaying, play: play, pause: pause } = (0, $927e5cfcbbbcef61$export$32ac093bcfdd28dd)();
    return /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("button", {
        type: "button",
        className: (0, $d8ae731eb2a5610a$export$a274e22fb40f762e)("rc-button", "rc-button--playpause", className),
        "aria-label": ariaLabel ?? (isPlaying ? "Pause" : "Play"),
        "aria-pressed": isPlaying,
        onClick: isPlaying ? pause : play,
        ...rest,
        children: children ?? /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)($ae1b1d6b06f61e85$var$Icon, {
            playing: isPlaying
        })
    });
}


const $0bc8e4e0cf3665cd$export$144901db2ea8e967 = Object.assign((0, $9aa35e3494596531$export$144901db2ea8e967), {
    Track: $ea918e59d89de47f$export$13921ac0cc260818,
    Slide: $e623440f940b046c$export$d8dc01b5c85a37b9,
    Button: $f43c4d105b41199e$export$353f5b6fc5456de1,
    Dots: $2d1bc58beaf1064f$export$8da50d3722682be0,
    PlayPause: $ae1b1d6b06f61e85$export$c73916fe05296ede
});



var $lDJXT = parcelRequire("lDJXT");





function $6a573cd607e7205c$export$2e2bcd8739ae039({ slides: slides, loop: loop = true, autoplay: autoplay = false, autoplayInterval: autoplayInterval, height: height = 460, vertical: vertical = false, shadow: shadow = true, showArrows: showArrows = true, showDots: showDots = true, className: className, label: label = "Cube carousel" }) {
    const api = (0, $37a3865aa7541cf0$export$2df8346413809f96)({
        slidesCount: slides.length,
        loop: loop,
        autoplay: autoplay,
        autoplayInterval: autoplayInterval,
        orientation: vertical ? "vertical" : "horizontal"
    });
    const count = slides.length;
    // translateZ depth = half the rotation-axis extent: width for a horizontal
    // (rotateY) cube, height for a vertical (rotateX) one. Width is responsive,
    // so measure the viewport and feed it to CSS as --rc-cube-depth.
    const [depth, setDepth] = (0, $lDJXT.useState)(0);
    (0, $lDJXT.useEffect)(()=>{
        const el = api.trackRef.current;
        if (!el) return;
        const measure = ()=>setDepth((vertical ? el.clientHeight : el.clientWidth) / 2);
        measure();
        if (typeof ResizeObserver === "undefined") return;
        const observer = new ResizeObserver(measure);
        observer.observe(el);
        return ()=>observer.disconnect();
    }, [
        api.trackRef,
        vertical
    ]);
    // Signed distance from the active face, taking the shorter way around a loop
    // so the wrap-around neighbour is treated as adjacent.
    const offsetOf = (i)=>{
        let off = i - api.activeIndex;
        if (loop && count > 1) {
            if (off > count / 2) off -= count;
            else if (off < -count / 2) off += count;
        }
        return off;
    };
    return /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $927e5cfcbbbcef61$export$762b25d1c14c81e4).Provider, {
        value: api,
        children: /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("div", {
            ref: api.rootRef,
            className: (0, $d8ae731eb2a5610a$export$a274e22fb40f762e)("rc-cube", className),
            role: "region",
            "aria-roledescription": "carousel",
            "aria-label": label,
            tabIndex: 0,
            "data-orientation": vertical ? "vertical" : "horizontal",
            "data-shadow": shadow || undefined,
            style: {
                "--rc-image-height": `${height}px`,
                "--rc-cube-depth": `${depth}px`
            },
            children: [
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("div", {
                    ref: api.trackRef,
                    className: "rc-cube__viewport",
                    children: /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("div", {
                        className: "rc-cube__cage",
                        children: slides.map((slide, i)=>{
                            const off = offsetOf(i);
                            const active = off === 0;
                            return /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("div", {
                                className: "rc-cube__face",
                                "data-active": active || undefined,
                                "aria-hidden": !active || undefined,
                                role: "group",
                                "aria-roledescription": "slide",
                                "aria-label": `${i + 1} of ${count}`,
                                style: {
                                    "--off": off,
                                    // Only the active face and its two neighbours form the cube.
                                    visibility: Math.abs(off) <= 1 ? undefined : "hidden",
                                    backgroundImage: `url(${slide.src})`
                                },
                                children: slide.caption != null && /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("div", {
                                    className: "rc-cube__caption",
                                    children: slide.caption
                                })
                            }, i);
                        })
                    })
                }),
                shadow && /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("div", {
                    className: "rc-cube__shadow",
                    "aria-hidden": "true"
                }),
                showArrows && /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $f43c4d105b41199e$export$353f5b6fc5456de1), {
                    dir: "prev"
                }),
                showArrows && /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $f43c4d105b41199e$export$353f5b6fc5456de1), {
                    dir: "next"
                }),
                showDots && /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $2d1bc58beaf1064f$export$8da50d3722682be0), {})
            ]
        })
    });
}




function $5102dbc734e93edb$export$2e2bcd8739ae039({ slides: slides, loop: loop = true, autoplay: autoplay = false, autoplayInterval: autoplayInterval, height: height = 460, showArrows: showArrows = true, showDots: showDots = true, className: className, label: label = "Image carousel" }) {
    return /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)((0, $0bc8e4e0cf3665cd$export$144901db2ea8e967), {
        slidesCount: slides.length,
        loop: loop,
        autoplay: autoplay,
        autoplayInterval: autoplayInterval,
        label: label,
        className: (0, $d8ae731eb2a5610a$export$a274e22fb40f762e)("rc-image", className),
        style: {
            "--rc-image-height": typeof height === "number" ? `${height}px` : height
        },
        children: [
            showArrows && /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $0bc8e4e0cf3665cd$export$144901db2ea8e967).Button, {
                dir: "prev"
            }),
            /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $0bc8e4e0cf3665cd$export$144901db2ea8e967).Track, {
                children: slides.map((slide, i)=>{
                    const inner = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("div", {
                        className: "rc-image__slide",
                        style: {
                            backgroundImage: `url(${slide.src})`
                        },
                        role: "img",
                        "aria-label": slide.alt,
                        children: slide.caption != null && /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("div", {
                            className: "rc-image__caption",
                            children: slide.caption
                        })
                    });
                    return /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $0bc8e4e0cf3665cd$export$144901db2ea8e967).Slide, {
                        index: i,
                        children: slide.href ? /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("a", {
                            className: "rc-image__link",
                            href: slide.href,
                            target: "_blank",
                            rel: "noreferrer",
                            children: inner
                        }) : inner
                    }, i);
                })
            }),
            showArrows && /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $0bc8e4e0cf3665cd$export$144901db2ea8e967).Button, {
                dir: "next"
            }),
            showDots && /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $0bc8e4e0cf3665cd$export$144901db2ea8e967).Dots, {})
        ]
    });
}







function $e9e3409503f8005f$export$2e2bcd8739ae039({ slides: slides, loop: loop = true, autoplay: autoplay = false, autoplayInterval: autoplayInterval, height: height = 460, slices: slices = 6, showArrows: showArrows = true, showDots: showDots = true, className: className, label: label = "Slicer carousel" }) {
    const api = (0, $37a3865aa7541cf0$export$2df8346413809f96)({
        slidesCount: slides.length,
        loop: loop,
        autoplay: autoplay,
        autoplayInterval: autoplayInterval
    });
    const strips = Array.from({
        length: slices
    }, (_, k)=>k);
    return /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $927e5cfcbbbcef61$export$762b25d1c14c81e4).Provider, {
        value: api,
        children: /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("div", {
            ref: api.rootRef,
            className: (0, $d8ae731eb2a5610a$export$a274e22fb40f762e)("rc-slicer", className),
            role: "region",
            "aria-roledescription": "carousel",
            "aria-label": label,
            tabIndex: 0,
            style: {
                "--rc-image-height": `${height}px`,
                "--rc-slices": slices
            },
            children: [
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("div", {
                    ref: api.trackRef,
                    className: "rc-slicer__viewport",
                    children: slides.map((slide, i)=>{
                        const active = i === api.activeIndex;
                        return /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("div", {
                            className: "rc-slicer__slide",
                            "data-active": active || undefined,
                            "aria-hidden": !active || undefined,
                            role: "group",
                            "aria-roledescription": "slide",
                            "aria-label": `${i + 1} of ${slides.length}`,
                            children: [
                                strips.map((k)=>/*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("span", {
                                        className: "rc-slicer__strip",
                                        style: {
                                            "--k": k,
                                            backgroundImage: `url(${slide.src})`
                                        }
                                    }, k)),
                                slide.caption != null && /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("div", {
                                    className: "rc-slicer__caption",
                                    children: slide.caption
                                })
                            ]
                        }, i);
                    })
                }),
                showArrows && /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $f43c4d105b41199e$export$353f5b6fc5456de1), {
                    dir: "prev"
                }),
                showArrows && /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $f43c4d105b41199e$export$353f5b6fc5456de1), {
                    dir: "next"
                }),
                showDots && /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $2d1bc58beaf1064f$export$8da50d3722682be0), {})
            ]
        })
    });
}






const $ac10b426a722a818$export$d7def349cabdd169 = [
    {
        title: "Aurora",
        sub: "Northern lights over the fjords",
        bg: "linear-gradient(135deg,#667eea,#764ba2)"
    },
    {
        title: "Desert",
        sub: "Endless dunes at golden hour",
        bg: "linear-gradient(135deg,#f093fb,#f5576c)"
    },
    {
        title: "Ocean",
        sub: "Deep blue, calm and vast",
        bg: "linear-gradient(135deg,#4facfe,#00f2fe)"
    },
    {
        title: "Forest",
        sub: "Mist between ancient pines",
        bg: "linear-gradient(135deg,#0ba360,#3cba92)"
    }
];
const $ac10b426a722a818$export$8128819a2322681a = [
    {
        title: "01",
        sub: "Panel one",
        bg: "linear-gradient(135deg,#6a0572,#ab83a1)"
    },
    {
        title: "02",
        sub: "Panel two",
        bg: "linear-gradient(135deg,#16a085,#1abc9c)"
    },
    {
        title: "03",
        sub: "Panel three",
        bg: "linear-gradient(135deg,#d35400,#e67e22)"
    },
    {
        title: "04",
        sub: "Panel four",
        bg: "linear-gradient(135deg,#8e2de2,#4a00e0)"
    },
    {
        title: "05",
        sub: "Panel five",
        bg: "linear-gradient(135deg,#4facfe,#00f2fe)"
    },
    {
        title: "06",
        sub: "Panel six",
        bg: "linear-gradient(135deg,#0ba360,#3cba92)"
    }
];
const $ac10b426a722a818$export$edb2fd0131bb05f1 = [
    {
        title: "Shooting Star",
        category: "Astronomy",
        description: "Catch the next meteor shower in style."
    },
    {
        title: "Star Chef",
        category: "Food",
        description: "A recipe that's out of this world."
    },
    {
        title: "Rising Star",
        category: "Entertainment",
        description: "The actor taking Hollywood by storm."
    },
    {
        title: "All-Star",
        category: "Sports",
        description: "Highlights from the season's best."
    },
    {
        title: "Lone Star",
        category: "Travel",
        description: "A road trip across the open plains."
    }
];
var $31118f2f7a47861b$exports = {};
$31118f2f7a47861b$exports = $parcel$resolve("7WUtL");


var $0e853098f23d7378$exports = {};
$0e853098f23d7378$exports = $parcel$resolve("af8aa");


var $dfc150eda16d57f3$exports = {};
$dfc150eda16d57f3$exports = $parcel$resolve("4yruO");


var $e3fb034d8ec22bc2$exports = {};
$e3fb034d8ec22bc2$exports = $parcel$resolve("5WWjA");


var $9b029986825f4452$exports = {};
$9b029986825f4452$exports = $parcel$resolve("1B4W6");


const $ac10b426a722a818$export$65358af74274c821 = [
    {
        src: new URL($31118f2f7a47861b$exports).href,
        alt: "Abstract waves",
        caption: "Slide 1"
    },
    {
        src: new URL($0e853098f23d7378$exports).href,
        alt: "Abstract waves",
        caption: "Slide 2"
    },
    {
        src: new URL($dfc150eda16d57f3$exports).href,
        alt: "Abstract waves",
        caption: "Slide 3"
    },
    {
        src: new URL($e3fb034d8ec22bc2$exports).href,
        alt: "Abstract waves",
        caption: "Slide 4"
    },
    {
        src: new URL($9b029986825f4452$exports).href,
        alt: "Abstract waves",
        caption: "Slide 5"
    }
];

var $7156ec0f8e77e53e$exports = {};
$7156ec0f8e77e53e$exports = $parcel$resolve("7tkWV");


var $ff8d2c4ce80f6bae$exports = {};
$ff8d2c4ce80f6bae$exports = $parcel$resolve("ijwLV");


var $1e1ade234e438c97$exports = {};
$1e1ade234e438c97$exports = $parcel$resolve("h6jk3");


var $903352df2fb08489$exports = {};
$903352df2fb08489$exports = $parcel$resolve("e3MDb");


const $ac10b426a722a818$export$428f3fc27bf16bca = [
    {
        src: new URL($9b029986825f4452$exports).href,
        alt: "Abstract waves",
        caption: "Slide 1"
    },
    {
        src: new URL($7156ec0f8e77e53e$exports).href,
        alt: "Abstract waves",
        caption: "Slide 2"
    },
    {
        src: new URL($ff8d2c4ce80f6bae$exports).href,
        alt: "Abstract waves",
        caption: "Slide 3"
    },
    {
        src: new URL($1e1ade234e438c97$exports).href,
        alt: "Abstract waves",
        caption: "Slide 4"
    },
    {
        src: new URL($903352df2fb08489$exports).href,
        alt: "Abstract waves",
        caption: "Slide 5"
    }
];
const $ac10b426a722a818$export$965585c66c69359 = [
    {
        variant: "gradient",
        title: "Gradient",
        desc: "The original \u2014 a full diagonal gradient with white type and floating blobs.",
        shape: "star"
    },
    {
        variant: "glass",
        title: "Glass",
        desc: "Frosted translucency layered over the gradient, with a blurred category tag.",
        shape: "ring"
    },
    {
        variant: "solid",
        title: "Solid",
        desc: "A flat, confident single-colour fill from the palette's first stop.",
        shape: "music"
    },
    {
        variant: "outline",
        title: "Outline",
        desc: "Light card, coloured border and title \u2014 quiet but unmistakably on-brand.",
        shape: "heart"
    },
    {
        variant: "dark",
        title: "Dark",
        desc: "Deep navy with a neon accent pulled from the palette and an ambient glow.",
        shape: "trophy"
    },
    {
        variant: "minimal",
        title: "Minimal",
        desc: "Clean white card; the gradient survives only as a thin progress accent.",
        shape: "blob"
    }
];
const $ac10b426a722a818$export$80e4b313e5e6b30d = [
    {
        group: "Getting started",
        items: [
            [
                "overview",
                "Overview"
            ],
            [
                "install",
                "Installation"
            ],
            [
                "quickstart",
                "Quick start"
            ]
        ]
    },
    {
        group: "Presets",
        items: [
            [
                "designs",
                "Card designs"
            ],
            [
                "image",
                "Image slider"
            ],
            [
                "slicer",
                "Slicer slider"
            ],
            [
                "cube",
                "Cube slider"
            ],
            [
                "cardslider",
                "CardSlider"
            ]
        ]
    },
    {
        group: "Carousel",
        items: [
            [
                "api",
                "Props"
            ],
            [
                "controls",
                "Controls"
            ],
            [
                "patterns",
                "Patterns"
            ],
            [
                "responsive",
                "Responsive"
            ],
            [
                "vertical",
                "Vertical"
            ],
            [
                "customslides",
                "Custom slides"
            ],
            [
                "control",
                "Programmatic control"
            ]
        ]
    },
    {
        group: "More",
        items: [
            [
                "theming",
                "Theming"
            ],
            [
                "a11y",
                "Accessibility"
            ]
        ]
    }
];
const $ac10b426a722a818$export$be3381fd8bf5f5cf = $ac10b426a722a818$export$80e4b313e5e6b30d.flatMap((g)=>g.items.map(([id])=>id));
const $ac10b426a722a818$export$c6ebd78480de3ea8 = Object.fromEntries($ac10b426a722a818$export$80e4b313e5e6b30d.flatMap((g)=>g.items));
const $ac10b426a722a818$export$36451a99d350b8e5 = [
    [
        "slidesCount",
        "number",
        "Required. How many slides the carousel manages."
    ],
    [
        "initialIndex",
        "number = 0",
        "Slide shown first (clamped into range)."
    ],
    [
        "loop",
        "boolean = false",
        "Wrap past the first / last slide."
    ],
    [
        "autoplay",
        "boolean = false",
        "Auto-advance on a timer."
    ],
    [
        "autoplayInterval",
        "number = 4000",
        "Autoplay delay in milliseconds."
    ],
    [
        "slidesToScroll",
        "number = 1",
        "Slides advanced per prev / next."
    ],
    [
        "slidesPerView",
        "number = 1",
        "How many slides are visible at once (sets --rc-slide-size)."
    ],
    [
        "breakpoints",
        "Record<number, \u2026>",
        "Per-min-width overrides for slidesPerView / slidesToScroll."
    ],
    [
        "orientation",
        '"horizontal" | "vertical"',
        "Layout axis. Default horizontal."
    ],
    [
        "onIndexChange",
        "(i: number) => void",
        "Fires whenever the active slide changes."
    ],
    [
        "onSettle",
        "(i: number) => void",
        "Fires after a slide transition settles."
    ],
    [
        "onSwipeEnd",
        "(info) => void",
        "Fires when a pointer swipe ends ({ delta, direction })."
    ],
    [
        "label",
        'string = "Carousel"',
        "Accessible name for the region."
    ]
];
const $ac10b426a722a818$export$fd62969fb0b7081c = [
    [
        "--rc-slide-size",
        "Slide width \u2014 100% for one-per-view, 350px / 33% for cards."
    ],
    [
        "--rc-slide-gap",
        "Space between slides."
    ],
    [
        "--rc-viewport-height",
        "Viewport height for vertical carousels. Default 360px."
    ],
    [
        "--rc-duration",
        "Transition duration of the track."
    ],
    [
        "--rc-accent",
        "Focus ring / dot accent colour."
    ],
    [
        "--rc-button-bg",
        "Prev / next button background."
    ],
    [
        "--rc-dot-active-color",
        "Active pagination dot colour."
    ]
];


const $fe95941a4f3677d1$export$50376e21b48b88d2 = `npm install react-carousel-latest`;
const $fe95941a4f3677d1$export$ceef928770ff08e1 = `import { Carousel } from "react-carousel-latest";
import "react-carousel-latest/styles.css";`;
const $fe95941a4f3677d1$export$b4cf2e8093f7b4a5 = `import { Carousel } from "react-carousel-latest";
import "react-carousel-latest/styles.css";

const items = [
  { id: 1, content: "Slide one" },
  { id: 2, content: "Slide two" },
  { id: 3, content: "Slide three" },
];

export function Gallery() {
  return (
    <Carousel slidesCount={items.length} loop autoplay>
      <Carousel.Button dir="prev" />
      <Carousel.Track>
        {items.map((item, i) => (
          <Carousel.Slide key={item.id} index={i}>
            {item.content}
          </Carousel.Slide>
        ))}
      </Carousel.Track>
      <Carousel.Button dir="next" />
      <Carousel.Dots />
    </Carousel>
  );
}`;
const $fe95941a4f3677d1$export$fd2c775c3031e165 = `<div className="rc-controls">
  <Carousel.Button dir="first" />
  <Carousel.PlayPause />
  <Carousel.Button dir="last" />
</div>`;
const $fe95941a4f3677d1$export$179093e6b14ea070 = `import { Carousel } from "react-carousel-latest";
import { Card } from "react-carousel-latest/presets";
import "react-carousel-latest/bundle.css";

const cards = [
  { title: "Shooting Star", category: "Astronomy", description: "Catch the next meteor shower in style.", from: "#6A0572", to: "#AB83A1" },
  { title: "Star Chef", category: "Food", description: "A recipe that's out of this world.", from: "#16A085", to: "#1ABC9C" },
  { title: "Rising Star", category: "Entertainment", description: "The actor taking Hollywood by storm.", from: "#D35400", to: "#E67E22" },
  { title: "All-Star", category: "Sports", description: "Highlights from the season's best.", from: "#8E2DE2", to: "#4A00E0" },
];

export function CardCarousel() {
  return (
    <Carousel
      slidesCount={cards.length}
      style={{ "--rc-slide-size": "350px", "--rc-slide-gap": "1.25rem" } as React.CSSProperties}
    >
      <Carousel.Button dir="prev" />
      <Carousel.Track>
        {cards.map((card, i) => (
          <Carousel.Slide key={card.title} index={i}>
            <Card {...card} shape="star" variant="gradient" />
          </Carousel.Slide>
        ))}
      </Carousel.Track>
      <Carousel.Button dir="next" />
      <Carousel.Dots />
    </Carousel>
  );
}`;
const $fe95941a4f3677d1$export$60ac69347d22a628 = `import { Carousel } from "react-carousel-latest";
import "react-carousel-latest/styles.css";

const scenes = [
  { title: "Aurora", sub: "Northern lights over the fjords", bg: "linear-gradient(135deg,#667eea,#764ba2)" },
  { title: "Desert", sub: "Endless dunes at golden hour", bg: "linear-gradient(135deg,#f093fb,#f5576c)" },
  { title: "Ocean", sub: "Deep blue, calm and vast", bg: "linear-gradient(135deg,#4facfe,#00f2fe)" },
  { title: "Forest", sub: "Mist between ancient pines", bg: "linear-gradient(135deg,#0ba360,#3cba92)" },
];

export function HeroCarousel() {
  return (
    <Carousel slidesCount={scenes.length} loop autoplay autoplayInterval={3800} label="Scenery">
      <Carousel.Button dir="prev" />
      <Carousel.Track>
        {scenes.map((s, i) => (
          <Carousel.Slide key={s.title} index={i}>
            <div style={{ height: 340, display: "flex", flexDirection: "column", justifyContent: "flex-end", padding: "2rem", color: "#fff", background: s.bg }}>
              <h3 style={{ fontSize: "2.4rem", margin: 0 }}>{s.title}</h3>
              <p style={{ margin: 0, opacity: 0.92 }}>{s.sub}</p>
            </div>
          </Carousel.Slide>
        ))}
      </Carousel.Track>
      <Carousel.Button dir="next" />
      <div className="rc-controls">
        <Carousel.Button dir="first" />
        <Carousel.PlayPause />
        <Carousel.Button dir="last" />
      </div>
      <Carousel.Dots />
    </Carousel>
  );
}`;
function $fe95941a4f3677d1$export$797297d9251acc8a(d, p) {
    return `import { Card, CardSlider } from "react-carousel-latest/presets";
import "react-carousel-latest/presets.css";

const slides = [
  { title: "${d.title}", category: "Preview", description: "Built from --rc-from / --rc-to." },
];

// 1 \u{2014} the single card shown above
export function CardExample() {
  return (
    <Card
      title="${d.title}"
      category="Preview"
      description="Built from --rc-from / --rc-to."
      from="${p.from}"
      to="${p.to}"
      shape="${d.shape}"
      variant="${d.variant}"
    />
  );
}

// 2 \u{2014} or a whole slider in the "${d.variant}" design
export function SliderExample() {
  return <CardSlider shape="${d.shape}" variant="${d.variant}" slides={slides} />;
}`;
}
function $fe95941a4f3677d1$export$edf69de4cdae67b(variant) {
    return `import CardSlider from "react-carousel-latest";
import "react-carousel-latest/presets.css";

const slides = [
  { title: "Shooting Star", category: "Astronomy", description: "Catch the next meteor shower in style." },
  { title: "Star Chef", category: "Food", description: "A recipe that's out of this world." },
  { title: "Rising Star", category: "Entertainment", description: "The actor taking Hollywood by storm." },
];

export function Example() {
  return <CardSlider shape="star" variant="${variant}" randomBackground slides={slides} />;
}`;
}
const $fe95941a4f3677d1$export$493b2bffffa87635 = `import { ImageSlider } from "react-carousel-latest/presets";
import "react-carousel-latest/bundle.css";

const slides = [
  { src: "/photos/01.jpg", alt: "Abstract waves", caption: "Slide 1" },
  { src: "/photos/02.jpg", alt: "Abstract waves", caption: "Slide 2" },
  { src: "/photos/03.jpg", alt: "Abstract waves", caption: "Slide 3" },
];

export function Hero() {
  return <ImageSlider slides={slides} loop autoplay height={460} />;
}`;
const $fe95941a4f3677d1$export$64b82858c30fdaf4 = `import { SlicerSlider } from "react-carousel-latest/presets";
import "react-carousel-latest/bundle.css";

const slides = [
  { src: "/photos/01.jpg", caption: "Slide 1" },
  { src: "/photos/02.jpg", caption: "Slide 2" },
  { src: "/photos/03.jpg", caption: "Slide 3" },
];

export function Hero() {
  // slices = number of horizontal strips in the wipe transition
  return <SlicerSlider slides={slides} loop autoplay slices={6} height={440} />;
}`;
const $fe95941a4f3677d1$export$485323a64e20f0b8 = `import CardSlider from "react-carousel-latest";
import "react-carousel-latest/presets.css";

const slides = [
  { title: "Shooting Star", category: "Astronomy", description: "Catch the next meteor shower.", link: "https://example.com" },
  { title: "Star Chef", category: "Food", description: "A recipe that's out of this world." },
];

export function Example() {
  return <CardSlider shape="star" variant="glass" randomBackground slides={slides} />;
}`;
const $fe95941a4f3677d1$export$3697123274b327dd = `.rc-root {
  --rc-slide-size: 350px;
  --rc-slide-gap: 1.25rem;
  --rc-accent: #ff6a3d;
}`;
const $fe95941a4f3677d1$export$3863e1a9685c4c68 = `import { Carousel } from "react-carousel-latest";
import "react-carousel-latest/styles.css";

// 1 slide on phones, 2 on tablets, 3 on desktop \u{2014} the largest match wins.
export function Gallery() {
  return (
    <Carousel
      slidesCount={panels.length}
      slidesPerView={1}
      breakpoints={{ 640: { slidesPerView: 2 }, 1024: { slidesPerView: 3 } }}
    >
      <Carousel.Button dir="prev" />
      <Carousel.Track>
        {panels.map((p, i) => (
          <Carousel.Slide key={i} index={i}>{p}</Carousel.Slide>
        ))}
      </Carousel.Track>
      <Carousel.Button dir="next" />
      <Carousel.Dots />
    </Carousel>
  );
}`;
const $fe95941a4f3677d1$export$643c90265fee513d = `import { Carousel } from "react-carousel-latest";
import "react-carousel-latest/styles.css";

export function VerticalGallery() {
  return (
    <Carousel
      slidesCount={panels.length}
      orientation="vertical"
      // vertical needs a bounded height
      style={{ "--rc-viewport-height": "320px" } as React.CSSProperties}
    >
      <Carousel.Button dir="prev" />
      <Carousel.Track>
        {panels.map((p, i) => (
          <Carousel.Slide key={i} index={i}>{p}</Carousel.Slide>
        ))}
      </Carousel.Track>
      <Carousel.Button dir="next" />
      <Carousel.Dots />
    </Carousel>
  );
}`;
const $fe95941a4f3677d1$export$81248509a08aa4e = `import { CubeSlider } from "react-carousel-latest/presets";
import "react-carousel-latest/bundle.css";

const slides = [
  { src: "/photos/01.jpg", caption: "Slide 1" },
  { src: "/photos/02.jpg", caption: "Slide 2" },
  { src: "/photos/03.jpg", caption: "Slide 3" },
];

export function Hero() {
  // vertical spins on the X axis instead; shadow is on by default
  return <CubeSlider slides={slides} loop height={460} />;
}`;
const $fe95941a4f3677d1$export$996358f888e0daf4 = `import { useRef, useState } from "react";
import { Carousel } from "react-carousel-latest";
import type { CarouselHandle, DragInfo } from "react-carousel-latest";
import "react-carousel-latest/styles.css";

export function Controlled() {
  const ref = useRef<CarouselHandle>(null);
  const [status, setStatus] = useState("ready");

  return (
    <>
      <div className="toolbar">
        <button onClick={() => ref.current?.prev()}>Prev</button>
        <button onClick={() => ref.current?.goTo(0)}>First</button>
        <button onClick={() => ref.current?.next()}>Next</button>
      </div>

      <Carousel
        ref={ref}
        slidesCount={panels.length}
        onSettle={(i) => setStatus(\`settled on \${i + 1}\`)}
        onSwipeEnd={(d: DragInfo) => setStatus(\`swiped \${d.direction}\`)}
      >
        <Carousel.Track>
          {panels.map((p, i) => (
            <Carousel.Slide key={i} index={i}>{p}</Carousel.Slide>
          ))}
        </Carousel.Track>
      </Carousel>

      <p>{status}</p>
    </>
  );
}`;





var $lDJXT = parcelRequire("lDJXT");



function $8ebec350a57326b1$export$6c415d1fdae3dfdb(t0) {
    const $ = (0, $2cf3419409a8d23a$exports.c)(19);
    const { code: code, lang: t1 } = t0;
    const lang = t1 === undefined ? "tsx" : t1;
    const { copied: copied, copy: copy } = (0, $cac52ab6427d584a$export$d59a452d6b3a29e2)();
    let t2;
    let t3;
    let t4;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("span", {
            className: "code__dot"
        });
        t3 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("span", {
            className: "code__dot"
        });
        t4 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("span", {
            className: "code__dot"
        });
        $[0] = t2;
        $[1] = t3;
        $[2] = t4;
    } else {
        t2 = $[0];
        t3 = $[1];
        t4 = $[2];
    }
    let t5;
    if ($[3] !== lang) {
        t5 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("span", {
            className: "code__lang",
            children: lang
        });
        $[3] = lang;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== code || $[6] !== copy) {
        t6 = ()=>copy(code);
        $[5] = code;
        $[6] = copy;
        $[7] = t6;
    } else t6 = $[7];
    const t7 = copied ? "copied \u2713" : "copy";
    let t8;
    if ($[8] !== t6 || $[9] !== t7) {
        t8 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("button", {
            className: "code__copy",
            onClick: t6,
            children: t7
        });
        $[8] = t6;
        $[9] = t7;
        $[10] = t8;
    } else t8 = $[10];
    let t9;
    if ($[11] !== t5 || $[12] !== t8) {
        t9 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("div", {
            className: "code__bar",
            children: [
                t2,
                t3,
                t4,
                t5,
                t8
            ]
        });
        $[11] = t5;
        $[12] = t8;
        $[13] = t9;
    } else t9 = $[13];
    let t10;
    if ($[14] !== code) {
        t10 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("pre", {
            children: /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("code", {
                children: code
            })
        });
        $[14] = code;
        $[15] = t10;
    } else t10 = $[15];
    let t11;
    if ($[16] !== t10 || $[17] !== t9) {
        t11 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("div", {
            className: "code",
            children: [
                t9,
                t10
            ]
        });
        $[16] = t10;
        $[17] = t9;
        $[18] = t11;
    } else t11 = $[18];
    return t11;
}


function $2dc0036198356c0d$export$425ce3ef4cdbf755(t0) {
    const $ = (0, $2cf3419409a8d23a$exports.c)(14);
    const { code: code, lang: lang, className: className, style: style, children: children } = t0;
    const [open, setOpen] = (0, $lDJXT.useState)(false);
    const t1 = `demo${className ? ` ${className}` : ""}`;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>setOpen($2dc0036198356c0d$var$_temp);
        $[0] = t2;
    } else t2 = $[0];
    const t3 = open ? "Hide code" : "Get code";
    let t4;
    if ($[1] !== open || $[2] !== t3) {
        t4 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("button", {
            className: "demo__toggle",
            "aria-expanded": open,
            onClick: t2,
            children: t3
        });
        $[1] = open;
        $[2] = t3;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== code || $[5] !== lang || $[6] !== open) {
        t5 = open && /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $8ebec350a57326b1$export$6c415d1fdae3dfdb), {
            code: code,
            lang: lang
        });
        $[4] = code;
        $[5] = lang;
        $[6] = open;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== children || $[9] !== style || $[10] !== t1 || $[11] !== t4 || $[12] !== t5) {
        t6 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("div", {
            className: t1,
            style: style,
            children: [
                t4,
                children,
                t5
            ]
        });
        $[8] = children;
        $[9] = style;
        $[10] = t1;
        $[11] = t4;
        $[12] = t5;
        $[13] = t6;
    } else t6 = $[13];
    return t6;
}
function $2dc0036198356c0d$var$_temp(o) {
    return !o;
}


const $2d3dbfbb9e9eca07$var$CHIPS = [
    "Compound components",
    "useCarousel hook",
    "Touch & swipe",
    "Keyboard nav",
    "Autoplay",
    "Dual ESM / CJS",
    "No Tailwind required"
];
const $2d3dbfbb9e9eca07$var$INSTALL_CMD = "npm install react-carousel-latest";
function $2d3dbfbb9e9eca07$export$887967f05dc521ae() {
    const $ = (0, $2cf3419409a8d23a$exports.c)(16);
    const install = (0, $cac52ab6427d584a$export$d59a452d6b3a29e2)();
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("div", {
            className: "hero__mesh"
        });
        t1 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("p", {
            className: "eyebrow",
            children: "React \xb7 headless \xb7 accessible"
        });
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    let t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("h1", {
            children: [
                "Carousels, ",
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("em", {
                    children: "composed."
                })
            ]
        });
        t3 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("p", {
            className: "hero__lede",
            children: "A headless, tree-shakeable React carousel with a compound-component API. Keyboard, swipe, autoplay and ARIA built in \u2014 bring your own markup, or the batteries-included card preset."
        });
        $[2] = t2;
        $[3] = t3;
    } else {
        t2 = $[2];
        t3 = $[3];
    }
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("a", {
            className: "btn btn--primary",
            href: "#quickstart",
            children: "Get started \u2192"
        });
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("span", {
            children: [
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("span", {
                    className: "cmd__prompt",
                    children: "$"
                }),
                " ",
                $2d3dbfbb9e9eca07$var$INSTALL_CMD
            ]
        });
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== install) {
        t6 = ()=>install.copy($2d3dbfbb9e9eca07$var$INSTALL_CMD);
        $[6] = install;
        $[7] = t6;
    } else t6 = $[7];
    const t7 = install.copied ? "copied \u2713" : "copy";
    let t8;
    if ($[8] !== t6 || $[9] !== t7) {
        t8 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("div", {
            className: "hero__cta",
            children: [
                t4,
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("div", {
                    className: "cmd",
                    children: [
                        t5,
                        /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("button", {
                            onClick: t6,
                            children: t7
                        })
                    ]
                })
            ]
        });
        $[8] = t6;
        $[9] = t7;
        $[10] = t8;
    } else t8 = $[10];
    let t9;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = {
            marginTop: "2.5rem"
        };
        $[11] = t9;
    } else t9 = $[11];
    let t10;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $2dc0036198356c0d$export$425ce3ef4cdbf755), {
            style: t9,
            code: (0, $fe95941a4f3677d1$export$64b82858c30fdaf4),
            children: /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $e9e3409503f8005f$export$2e2bcd8739ae039), {
                slides: (0, $ac10b426a722a818$export$65358af74274c821),
                loop: true,
                autoplay: true,
                autoplayInterval: 4500,
                slices: 6,
                height: 440
            })
        });
        $[12] = t10;
    } else t10 = $[12];
    let t11;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("div", {
            className: "chips",
            children: $2d3dbfbb9e9eca07$var$CHIPS.map($2d3dbfbb9e9eca07$var$_temp)
        });
        $[13] = t11;
    } else t11 = $[13];
    let t12;
    if ($[14] !== t8) {
        t12 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("section", {
            id: "overview",
            className: "hero section",
            children: [
                t0,
                t1,
                t2,
                t3,
                t8,
                t10,
                t11
            ]
        });
        $[14] = t8;
        $[15] = t12;
    } else t12 = $[15];
    return t12;
}
function $2d3dbfbb9e9eca07$var$_temp(c) {
    return /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("span", {
        className: "chip",
        children: c
    }, c);
}





function $77f377cf3819795e$export$1ba59dacbcbf90fe(t0) {
    const $ = (0, $2cf3419409a8d23a$exports.c)(4);
    const { active: active } = t0;
    let t1;
    if ($[0] !== active) {
        t1 = (0, $ac10b426a722a818$export$80e4b313e5e6b30d).map((group)=>/*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("div", {
                className: "sidebar__group",
                children: [
                    /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("p", {
                        className: "sidebar__title",
                        children: group.group
                    }),
                    group.items.map((t2)=>{
                        const [id, label] = t2;
                        return /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("a", {
                            href: `#${id}`,
                            className: `sidebar__link${active === id ? " is-active" : ""}`,
                            children: label
                        }, id);
                    })
                ]
            }, group.group));
        $[0] = active;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("aside", {
            className: "sidebar",
            children: t1
        });
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
}






function $0e26b9c1cff7652a$export$fd5aa6db13c36b91(t0) {
    const $ = (0, $2cf3419409a8d23a$exports.c)(2);
    const { theme: theme } = t0;
    let t1;
    if ($[0] !== theme) {
        t1 = theme === "dark" ? /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("svg", {
            width: "17",
            height: "17",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            children: [
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "4"
                }),
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("path", {
                    d: "M12 2v2M12 20v2M4 12H2M22 12h-2M5 5l1.5 1.5M17.5 17.5L19 19M19 5l-1.5 1.5M6.5 17.5L5 19"
                })
            ]
        }) : /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("svg", {
            width: "17",
            height: "17",
            viewBox: "0 0 24 24",
            fill: "currentColor",
            children: /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("path", {
                d: "M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"
            })
        });
        $[0] = theme;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
}
function $0e26b9c1cff7652a$export$1e450c42b77127b1() {
    const $ = (0, $2cf3419409a8d23a$exports.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("svg", {
            width: "17",
            height: "17",
            viewBox: "0 0 24 24",
            fill: "currentColor",
            "aria-hidden": "true",
            children: /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("path", {
                d: "M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12"
            })
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
}
function $0e26b9c1cff7652a$export$a2209d94a3378a73() {
    const $ = (0, $2cf3419409a8d23a$exports.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("svg", {
            width: "18",
            height: "18",
            viewBox: "0 0 24 24",
            fill: "currentColor",
            "aria-hidden": "true",
            children: /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("path", {
                d: "M0 7.334v8h6.666v1.332H12v-1.332h12v-8H0zm6.666 6.664H5.334v-4H3.999v4H1.335V8.667h5.331v5.331zm4 0v1.336H8.001V8.667h5.334v5.332H10.666zm12.001 0h-1.333v-4h-1.333v4h-1.334v-4h-1.333v4h-2.667V8.667h8v5.331zM10.665 10H12v2.667h-1.335V10z"
            })
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
}
function $0e26b9c1cff7652a$export$cff2f7c4d3a0671f() {
    const $ = (0, $2cf3419409a8d23a$exports.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("svg", {
            width: "17",
            height: "17",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "2",
            "aria-hidden": "true",
            children: [
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "9.5"
                }),
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "2.2",
                    fill: "currentColor",
                    stroke: "none"
                })
            ]
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
}


const $f1f18ab43a2adff2$var$REPO_URL = "https://github.com/droidbg/react-carousel";
const $f1f18ab43a2adff2$var$NPM_URL = "https://www.npmjs.com/package/react-carousel-latest";
const $f1f18ab43a2adff2$var$NEW_ISSUE_URL = "https://github.com/droidbg/react-carousel/issues/new";
function $f1f18ab43a2adff2$export$1ca1e38143dcc152(t0) {
    const $ = (0, $2cf3419409a8d23a$exports.c)(12);
    const { theme: theme, onToggleTheme: onToggleTheme } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("span", {
            className: "brand__mark"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    let t3;
    let t4;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("a", {
            className: "brand",
            href: "#overview",
            children: [
                t1,
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("span", {
                    className: "brand__name",
                    children: [
                        "react\u200A",
                        /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("em", {
                            children: "carousel"
                        })
                    ]
                })
            ]
        });
        t3 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("span", {
            className: "pill",
            children: "v2.0"
        });
        t4 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("span", {
            className: "topbar__spacer"
        });
        $[1] = t2;
        $[2] = t3;
        $[3] = t4;
    } else {
        t2 = $[1];
        t3 = $[2];
        t4 = $[3];
    }
    let t5;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("a", {
            className: "topbar__icon",
            href: $f1f18ab43a2adff2$var$REPO_URL,
            target: "_blank",
            rel: "noreferrer",
            "aria-label": "GitHub repository",
            title: "GitHub",
            children: /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $0e26b9c1cff7652a$export$1e450c42b77127b1), {})
        });
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("a", {
            className: "topbar__icon",
            href: $f1f18ab43a2adff2$var$NPM_URL,
            target: "_blank",
            rel: "noreferrer",
            "aria-label": "npm package",
            title: "View on npm",
            children: /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $0e26b9c1cff7652a$export$a2209d94a3378a73), {})
        });
        $[5] = t6;
    } else t6 = $[5];
    let t7;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("a", {
            className: "topbar__icon",
            href: $f1f18ab43a2adff2$var$NEW_ISSUE_URL,
            target: "_blank",
            rel: "noreferrer",
            "aria-label": "Open an issue",
            title: "Open an issue",
            children: /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $0e26b9c1cff7652a$export$cff2f7c4d3a0671f), {})
        });
        $[6] = t7;
    } else t7 = $[6];
    let t8;
    if ($[7] !== theme) {
        t8 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $0e26b9c1cff7652a$export$fd5aa6db13c36b91), {
            theme: theme
        });
        $[7] = theme;
        $[8] = t8;
    } else t8 = $[8];
    let t9;
    if ($[9] !== onToggleTheme || $[10] !== t8) {
        t9 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("header", {
            className: "topbar",
            children: [
                t2,
                t3,
                t4,
                t5,
                t6,
                t7,
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("button", {
                    className: "topbar__icon",
                    onClick: onToggleTheme,
                    "aria-label": "Toggle colour theme",
                    title: "Toggle theme",
                    children: t8
                })
            ]
        });
        $[9] = onToggleTheme;
        $[10] = t8;
        $[11] = t9;
    } else t9 = $[11];
    return t9;
}









function $e20ceab6cca46499$export$6e2c8f0811a474ce(t0) {
    const $ = (0, $2cf3419409a8d23a$exports.c)(9);
    const { id: id, num: num, title: title, children: children } = t0;
    let t1;
    if ($[0] !== num) {
        t1 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("div", {
            className: "section__num",
            children: num
        });
        $[0] = num;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== title) {
        t2 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("h2", {
            children: title
        });
        $[2] = title;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== children || $[5] !== id || $[6] !== t1 || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("section", {
            id: id,
            className: "section",
            children: [
                t1,
                t2,
                children
            ]
        });
        $[4] = children;
        $[5] = id;
        $[6] = t1;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
}



function $766d18f819b0bd94$export$8564277db535bd71() {
    const $ = (0, $2cf3419409a8d23a$exports.c)(5);
    let t0;
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("p", {
            className: "lead",
            children: "Install the package and import the base stylesheet once at your app root."
        });
        t1 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $8ebec350a57326b1$export$6c415d1fdae3dfdb), {
            lang: "bash",
            code: (0, $fe95941a4f3677d1$export$50376e21b48b88d2)
        });
        t2 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $8ebec350a57326b1$export$6c415d1fdae3dfdb), {
            code: (0, $fe95941a4f3677d1$export$ceef928770ff08e1)
        });
        $[0] = t0;
        $[1] = t1;
        $[2] = t2;
    } else {
        t0 = $[0];
        t1 = $[1];
        t2 = $[2];
    }
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("code", {
            children: "presets.css"
        });
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)((0, $e20ceab6cca46499$export$6e2c8f0811a474ce), {
            id: "install",
            num: "01 / Getting started",
            title: "Installation",
            children: [
                t0,
                t1,
                t2,
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("p", {
                    children: [
                        "Using a preset? Add ",
                        t3,
                        " too \u2014 or pull both in with a single ",
                        /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("code", {
                            children: "react-carousel-latest/bundle.css"
                        }),
                        " import."
                    ]
                })
            ]
        });
        $[4] = t4;
    } else t4 = $[4];
    return t4;
}







function $3eaaf17abeb77fd9$export$b14428087440894d() {
    const $ = (0, $2cf3419409a8d23a$exports.c)(2);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("code", {
            children: "slidesCount"
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)((0, $e20ceab6cca46499$export$6e2c8f0811a474ce), {
            id: "quickstart",
            num: "02 / Getting started",
            title: "Quick start",
            children: [
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("p", {
                    children: [
                        "Compose the parts. You provide ",
                        t0,
                        " and render whatever you like inside each ",
                        /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("code", {
                            children: "Carousel.Slide"
                        }),
                        "."
                    ]
                }),
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $8ebec350a57326b1$export$6c415d1fdae3dfdb), {
                    code: (0, $fe95941a4f3677d1$export$b4cf2e8093f7b4a5)
                })
            ]
        });
        $[1] = t1;
    } else t1 = $[1];
    return t1;
}






function $6bdfc24b0a771180$export$ab4150be7c673f50() {
    const $ = (0, $2cf3419409a8d23a$exports.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("code", {
            children: "<Carousel>"
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("p", {
            children: [
                "Pass these to the ",
                t0,
                " root. Every value is also available from the headless ",
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("code", {
                    children: "useCarousel"
                }),
                " hook."
            ]
        });
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)((0, $e20ceab6cca46499$export$6e2c8f0811a474ce), {
            id: "api",
            num: "08 / Carousel",
            title: "Props",
            children: [
                t1,
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("div", {
                    className: "table-wrap",
                    children: /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("table", {
                        children: [
                            /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("th", {
                                            children: "Prop"
                                        }),
                                        /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("th", {
                                            children: "Type"
                                        }),
                                        /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("th", {
                                            children: "Description"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("tbody", {
                                children: (0, $ac10b426a722a818$export$36451a99d350b8e5).map($6bdfc24b0a771180$var$_temp)
                            })
                        ]
                    })
                })
            ]
        });
        $[2] = t2;
    } else t2 = $[2];
    return t2;
}
function $6bdfc24b0a771180$var$_temp(t0) {
    const [prop, type, description] = t0;
    return /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("tr", {
        children: [
            /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("td", {
                children: prop
            }),
            /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("td", {
                children: /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("code", {
                    children: type
                })
            }),
            /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("td", {
                children: description
            })
        ]
    }, prop);
}







function $dfe13d5338013424$export$c7c44baae9d9f25f() {
    const $ = (0, $2cf3419409a8d23a$exports.c)(6);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("p", {
            children: [
                "Drop-in controls read state from context \u2014 no wiring required. Group secondary controls in a ",
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("code", {
                    children: ".rc-controls"
                }),
                " row."
            ]
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("thead", {
            children: /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("tr", {
                children: [
                    /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("th", {
                        children: "Part"
                    }),
                    /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("th", {
                        children: "Purpose"
                    })
                ]
            })
        });
        t2 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("tr", {
            children: [
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("td", {
                    children: "<Carousel.Button dir=\"prev | next\" />"
                }),
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("td", {
                    children: "Step one slide (overlays the track edges)."
                })
            ]
        });
        t3 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("tr", {
            children: [
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("td", {
                    children: "<Carousel.Button dir=\"first | last\" />"
                }),
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("td", {
                    children: "Jump to the start or end."
                })
            ]
        });
        t4 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("td", {
            children: "<Carousel.PlayPause />"
        });
        $[1] = t1;
        $[2] = t2;
        $[3] = t3;
        $[4] = t4;
    } else {
        t1 = $[1];
        t2 = $[2];
        t3 = $[3];
        t4 = $[4];
    }
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)((0, $e20ceab6cca46499$export$6e2c8f0811a474ce), {
            id: "controls",
            num: "09 / Carousel",
            title: "Controls",
            children: [
                t0,
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("div", {
                    className: "table-wrap",
                    children: /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("table", {
                        children: [
                            t1,
                            /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("tbody", {
                                children: [
                                    t2,
                                    t3,
                                    /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("tr", {
                                        children: [
                                            t4,
                                            /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("td", {
                                                children: [
                                                    "Toggle autoplay (reflects ",
                                                    /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("code", {
                                                        children: "aria-pressed"
                                                    }),
                                                    ")."
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("td", {
                                                children: "<Carousel.Dots />"
                                            }),
                                            /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("td", {
                                                children: "Clickable pagination, one per slide."
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $8ebec350a57326b1$export$6c415d1fdae3dfdb), {
                    code: (0, $fe95941a4f3677d1$export$fd2c775c3031e165)
                })
            ]
        });
        $[5] = t5;
    } else t5 = $[5];
    return t5;
}








function $159fdff6dda762e6$export$7ed115685df827af() {
    return /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)((0, $e20ceab6cca46499$export$6e2c8f0811a474ce), {
        id: "patterns",
        num: "10 / Carousel",
        title: "Patterns",
        children: [
            /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("p", {
                children: [
                    "One slide or many \u2014 the same component. Set ",
                    /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("code", {
                        children: "--rc-slide-size"
                    }),
                    " to a fixed width and several cards share the view, with neighbours peeking. Prev / next still page one card at a time. Hit ",
                    /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("strong", {
                        children: "Get code"
                    }),
                    " on the demo for the full snippet."
                ]
            }),
            /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $2dc0036198356c0d$export$425ce3ef4cdbf755), {
                code: (0, $fe95941a4f3677d1$export$179093e6b14ea070),
                children: /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)((0, $0bc8e4e0cf3665cd$export$144901db2ea8e967), {
                    slidesCount: (0, $ac10b426a722a818$export$edb2fd0131bb05f1).length,
                    label: "Featured cards",
                    style: {
                        ["--rc-slide-size"]: "350px",
                        ["--rc-slide-gap"]: "1.25rem"
                    },
                    children: [
                        /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $0bc8e4e0cf3665cd$export$144901db2ea8e967).Button, {
                            dir: "prev"
                        }),
                        /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $0bc8e4e0cf3665cd$export$144901db2ea8e967).Track, {
                            children: (0, $ac10b426a722a818$export$edb2fd0131bb05f1).map((c, i)=>{
                                const p = (0, $1a9670fa11f5e4b7$export$9842ff719f7b293)[i * 3 % (0, $1a9670fa11f5e4b7$export$9842ff719f7b293).length];
                                return /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $0bc8e4e0cf3665cd$export$144901db2ea8e967).Slide, {
                                    index: i,
                                    children: /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $f3535c1af022b71b$export$2e2bcd8739ae039), {
                                        title: c.title,
                                        category: c.category,
                                        description: c.description,
                                        from: p.from,
                                        to: p.to,
                                        shape: "star",
                                        variant: "gradient"
                                    })
                                }, c.title);
                            })
                        }),
                        /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $0bc8e4e0cf3665cd$export$144901db2ea8e967).Button, {
                            dir: "next"
                        }),
                        /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $0bc8e4e0cf3665cd$export$144901db2ea8e967).Dots, {})
                    ]
                })
            })
        ]
    });
}





var $lDJXT = parcelRequire("lDJXT");






var $lDJXT = parcelRequire("lDJXT");



function $ead8366e825a4047$export$f248f718e8b6c905(t0) {
    const $ = (0, $2cf3419409a8d23a$exports.c)(30);
    const { design: design, palette: palette } = t0;
    const [open, setOpen] = (0, $lDJXT.useState)(false);
    let t1;
    if ($[0] !== design.shape || $[1] !== design.title || $[2] !== design.variant || $[3] !== palette.from || $[4] !== palette.to) {
        t1 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("div", {
            className: "variant__preview",
            children: /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $f3535c1af022b71b$export$2e2bcd8739ae039), {
                title: design.title,
                category: "Preview",
                description: "Built from --rc-from / --rc-to.",
                from: palette.from,
                to: palette.to,
                shape: design.shape,
                variant: design.variant
            })
        });
        $[0] = design.shape;
        $[1] = design.title;
        $[2] = design.variant;
        $[3] = palette.from;
        $[4] = palette.to;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] !== design.variant) {
        t2 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("span", {
            className: "variant__name",
            children: [
                'variant="',
                design.variant,
                '"'
            ]
        });
        $[6] = design.variant;
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            margin: "0.15rem 0 0.4rem"
        };
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== design.title) {
        t4 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("h3", {
            className: "variant__title",
            style: t3,
            children: design.title
        });
        $[9] = design.title;
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== design.desc) {
        t5 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("p", {
            className: "variant__desc",
            children: design.desc
        });
        $[11] = design.desc;
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>setOpen($ead8366e825a4047$var$_temp);
        $[13] = t6;
    } else t6 = $[13];
    const t7 = open ? "Hide code" : "Get code";
    let t8;
    if ($[14] !== open || $[15] !== t7) {
        t8 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("button", {
            className: "variant__code",
            "aria-expanded": open,
            onClick: t6,
            children: t7
        });
        $[14] = open;
        $[15] = t7;
        $[16] = t8;
    } else t8 = $[16];
    let t9;
    if ($[17] !== design || $[18] !== open || $[19] !== palette) {
        t9 = open && /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $8ebec350a57326b1$export$6c415d1fdae3dfdb), {
            code: (0, $fe95941a4f3677d1$export$797297d9251acc8a)(design, palette)
        });
        $[17] = design;
        $[18] = open;
        $[19] = palette;
        $[20] = t9;
    } else t9 = $[20];
    let t10;
    if ($[21] !== t2 || $[22] !== t4 || $[23] !== t5 || $[24] !== t8 || $[25] !== t9) {
        t10 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("div", {
            className: "variant__body",
            children: [
                t2,
                t4,
                t5,
                t8,
                t9
            ]
        });
        $[21] = t2;
        $[22] = t4;
        $[23] = t5;
        $[24] = t8;
        $[25] = t9;
        $[26] = t10;
    } else t10 = $[26];
    let t11;
    if ($[27] !== t1 || $[28] !== t10) {
        t11 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("div", {
            className: "variant",
            children: [
                t1,
                t10
            ]
        });
        $[27] = t1;
        $[28] = t10;
        $[29] = t11;
    } else t11 = $[29];
    return t11;
}
function $ead8366e825a4047$var$_temp(o) {
    return !o;
}




function $d9167f8fcf0d20df$export$1974f7d0dcd7cd15() {
    const $ = (0, $2cf3419409a8d23a$exports.c)(24);
    const [variant, setVariant] = (0, $lDJXT.useState)("gradient");
    const [isPending, startTransition] = (0, $lDJXT.useTransition)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("code", {
            children: "--rc-from"
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("code", {
            children: "--rc-to"
        });
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("p", {
            className: "lead",
            children: [
                "The card preset ships six designs. Each is built from the card's two palette colours (",
                t0,
                " / ",
                t1,
                "), so they stay fully themeable. Every card has its own ",
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("strong", {
                    children: "Get code"
                }),
                "."
            ]
        });
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("div", {
            className: "gallery",
            children: (0, $ac10b426a722a818$export$965585c66c69359).map($d9167f8fcf0d20df$var$_temp)
        });
        t4 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("h3", {
            children: "Try them live"
        });
        $[3] = t3;
        $[4] = t4;
    } else {
        t3 = $[3];
        t4 = $[4];
    }
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("code", {
            children: "variant"
        });
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("p", {
            children: [
                "Switch the ",
                t5,
                " prop on a single ",
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("code", {
                    children: "<CardSlider>"
                }),
                " \u2014 the snippet updates with it:"
            ]
        });
        $[6] = t6;
    } else t6 = $[6];
    let t7;
    if ($[7] !== variant) {
        t7 = (0, $ac10b426a722a818$export$965585c66c69359).map((d_0)=>/*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("button", {
                "aria-pressed": variant === d_0.variant,
                onClick: ()=>startTransition(()=>setVariant(d_0.variant)),
                children: d_0.variant
            }, d_0.variant));
        $[7] = variant;
        $[8] = t7;
    } else t7 = $[8];
    let t8;
    if ($[9] !== t7) {
        t8 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("div", {
            className: "switcher",
            children: t7
        });
        $[9] = t7;
        $[10] = t8;
    } else t8 = $[10];
    let t9;
    if ($[11] !== variant) {
        t9 = (0, $fe95941a4f3677d1$export$edf69de4cdae67b)(variant);
        $[11] = variant;
        $[12] = t9;
    } else t9 = $[12];
    const t10 = isPending ? 0.65 : 1;
    let t11;
    if ($[13] !== t10) {
        t11 = {
            opacity: t10,
            transition: "opacity 0.2s ease"
        };
        $[13] = t10;
        $[14] = t11;
    } else t11 = $[14];
    let t12;
    if ($[15] !== variant) {
        t12 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $6dda834a2e43853f$export$2e2bcd8739ae039), {
            shape: "star",
            randomBackground: true,
            variant: variant,
            slides: (0, $ac10b426a722a818$export$edb2fd0131bb05f1)
        });
        $[15] = variant;
        $[16] = t12;
    } else t12 = $[16];
    let t13;
    if ($[17] !== t11 || $[18] !== t12 || $[19] !== t9) {
        t13 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $2dc0036198356c0d$export$425ce3ef4cdbf755), {
            code: t9,
            style: t11,
            children: t12
        });
        $[17] = t11;
        $[18] = t12;
        $[19] = t9;
        $[20] = t13;
    } else t13 = $[20];
    let t14;
    if ($[21] !== t13 || $[22] !== t8) {
        t14 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)((0, $e20ceab6cca46499$export$6e2c8f0811a474ce), {
            id: "designs",
            num: "03 / Presets",
            title: "Card designs",
            children: [
                t2,
                t3,
                t4,
                t6,
                t8,
                t13
            ]
        });
        $[21] = t13;
        $[22] = t8;
        $[23] = t14;
    } else t14 = $[23];
    return t14;
}
function $d9167f8fcf0d20df$var$_temp(d, i) {
    return /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $ead8366e825a4047$export$f248f718e8b6c905), {
        design: d,
        palette: (0, $1a9670fa11f5e4b7$export$9842ff719f7b293)[i * 2 % (0, $1a9670fa11f5e4b7$export$9842ff719f7b293).length]
    }, d.variant);
}









function $cbbf15ad4177303b$export$487ee7542ff81536() {
    const $ = (0, $2cf3419409a8d23a$exports.c)(2);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("p", {
            className: "lead",
            children: [
                "Full-bleed images with a centered caption, thin overlaid arrows, and overlaid dots. Built on the headless ",
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("code", {
                    children: "Carousel"
                }),
                ", so keyboard, swipe, and autoplay come for free."
            ]
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)((0, $e20ceab6cca46499$export$6e2c8f0811a474ce), {
            id: "image",
            num: "04 / Presets",
            title: "Image slider",
            children: [
                t0,
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $2dc0036198356c0d$export$425ce3ef4cdbf755), {
                    code: (0, $fe95941a4f3677d1$export$493b2bffffa87635),
                    children: /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $5102dbc734e93edb$export$2e2bcd8739ae039), {
                        slides: (0, $ac10b426a722a818$export$65358af74274c821),
                        loop: true,
                        autoplay: true,
                        autoplayInterval: 4000,
                        height: 460
                    })
                })
            ]
        });
        $[1] = t1;
    } else t1 = $[1];
    return t1;
}









function $9fa3ed7b99215744$export$ab40f25e43841e88() {
    const $ = (0, $2cf3419409a8d23a$exports.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("strong", {
            children: "horizontal-slice"
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("p", {
            className: "lead",
            children: [
                "The same effect that greets you up top \u2014 transitions with a staggered ",
                t0,
                " wipe. Tune it with the ",
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("code", {
                    children: "slices"
                }),
                " prop."
            ]
        });
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)((0, $e20ceab6cca46499$export$6e2c8f0811a474ce), {
            id: "slicer",
            num: "05 / Presets",
            title: "Slicer slider",
            children: [
                t1,
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $2dc0036198356c0d$export$425ce3ef4cdbf755), {
                    code: (0, $fe95941a4f3677d1$export$64b82858c30fdaf4),
                    children: /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $e9e3409503f8005f$export$2e2bcd8739ae039), {
                        slides: (0, $ac10b426a722a818$export$65358af74274c821),
                        loop: true,
                        slices: 6,
                        height: 460
                    })
                })
            ]
        });
        $[2] = t2;
    } else t2 = $[2];
    return t2;
}









function $58792ee500d4c80b$export$dd53be77193aba26() {
    const $ = (0, $2cf3419409a8d23a$exports.c)(2);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("p", {
            children: [
                "The card preset is also the package's default export \u2014 a native-scroll row of decorated cards. Add the presets stylesheet; the ",
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("code", {
                    children: "variant"
                }),
                " prop selects the design."
            ]
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)((0, $e20ceab6cca46499$export$6e2c8f0811a474ce), {
            id: "cardslider",
            num: "07 / Presets",
            title: "CardSlider",
            children: [
                t0,
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $2dc0036198356c0d$export$425ce3ef4cdbf755), {
                    code: (0, $fe95941a4f3677d1$export$485323a64e20f0b8),
                    children: /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $6dda834a2e43853f$export$2e2bcd8739ae039), {
                        shape: "star",
                        variant: "glass",
                        randomBackground: true,
                        slides: (0, $ac10b426a722a818$export$edb2fd0131bb05f1)
                    })
                })
            ]
        });
        $[1] = t1;
    } else t1 = $[1];
    return t1;
}









function $24adffde02e6e318$export$6332622ae377cb3() {
    const $ = (0, $2cf3419409a8d23a$exports.c)(6);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("p", {
            children: [
                "A slide can hold any markup. Here are plain gradient panels driven by the headless ",
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("code", {
                    children: "Carousel"
                }),
                " with the full control set \u2014 Start / Prev / Play-Pause / Next / End plus dots."
            ]
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            borderRadius: 14,
            overflow: "hidden"
        };
        t2 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $0bc8e4e0cf3665cd$export$144901db2ea8e967).Button, {
            dir: "prev"
        });
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    let t3;
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $0bc8e4e0cf3665cd$export$144901db2ea8e967).Track, {
            children: (0, $ac10b426a722a818$export$d7def349cabdd169).map($24adffde02e6e318$var$_temp)
        });
        t4 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $0bc8e4e0cf3665cd$export$144901db2ea8e967).Button, {
            dir: "next"
        });
        $[3] = t3;
        $[4] = t4;
    } else {
        t3 = $[3];
        t4 = $[4];
    }
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)((0, $e20ceab6cca46499$export$6e2c8f0811a474ce), {
            id: "customslides",
            num: "13 / Carousel",
            title: "Custom slides",
            children: [
                t0,
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $2dc0036198356c0d$export$425ce3ef4cdbf755), {
                    code: (0, $fe95941a4f3677d1$export$60ac69347d22a628),
                    children: /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)((0, $0bc8e4e0cf3665cd$export$144901db2ea8e967), {
                        slidesCount: (0, $ac10b426a722a818$export$d7def349cabdd169).length,
                        loop: true,
                        autoplay: true,
                        autoplayInterval: 3800,
                        label: "Scenery",
                        style: t1,
                        children: [
                            t2,
                            t3,
                            t4,
                            /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("div", {
                                className: "rc-controls",
                                children: [
                                    /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $0bc8e4e0cf3665cd$export$144901db2ea8e967).Button, {
                                        dir: "first"
                                    }),
                                    /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $0bc8e4e0cf3665cd$export$144901db2ea8e967).PlayPause, {}),
                                    /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $0bc8e4e0cf3665cd$export$144901db2ea8e967).Button, {
                                        dir: "last"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $0bc8e4e0cf3665cd$export$144901db2ea8e967).Dots, {})
                        ]
                    })
                })
            ]
        });
        $[5] = t5;
    } else t5 = $[5];
    return t5;
}
function $24adffde02e6e318$var$_temp(s, i) {
    return /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $0bc8e4e0cf3665cd$export$144901db2ea8e967).Slide, {
        index: i,
        children: /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("div", {
            style: {
                height: 340,
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-end",
                padding: "2rem",
                color: "#fff",
                background: s.bg
            },
            children: [
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("span", {
                    style: {
                        fontFamily: "Fraunces, serif",
                        fontSize: "2.4rem",
                        fontWeight: 500
                    },
                    children: s.title
                }),
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("span", {
                    style: {
                        opacity: 0.92
                    },
                    children: s.sub
                })
            ]
        })
    }, s.title);
}








function $c9ed6e04dd40c4f7$export$d28117db278fe749() {
    const $ = (0, $2cf3419409a8d23a$exports.c)(6);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("p", {
            children: [
                "Override CSS custom properties on ",
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("code", {
                    children: ".rc-root"
                }),
                " (or any ancestor). No utility framework, no build step."
            ]
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    let t2;
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("div", {
            className: "table-wrap",
            children: /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("table", {
                children: [
                    /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("th", {
                                    children: "Variable"
                                }),
                                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("th", {
                                    children: "Controls"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("tbody", {
                        children: (0, $ac10b426a722a818$export$fd62969fb0b7081c).map($c9ed6e04dd40c4f7$var$_temp)
                    })
                ]
            })
        });
        t2 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $8ebec350a57326b1$export$6c415d1fdae3dfdb), {
            lang: "css",
            code: (0, $fe95941a4f3677d1$export$3697123274b327dd)
        });
        t3 = {
            marginTop: "1rem"
        };
        $[1] = t1;
        $[2] = t2;
        $[3] = t3;
    } else {
        t1 = $[1];
        t2 = $[2];
        t3 = $[3];
    }
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("code", {
            children: "--rc-button-bg"
        });
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)((0, $e20ceab6cca46499$export$6e2c8f0811a474ce), {
            id: "theming",
            num: "15 / More",
            title: "Theming",
            children: [
                t0,
                t1,
                t2,
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("p", {
                    style: t3,
                    children: [
                        "This very page retints the carousel chrome for dark mode by overriding ",
                        t4,
                        " and ",
                        /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("code", {
                            children: "--rc-dot-active-color"
                        }),
                        " \u2014 try the toggle, top right."
                    ]
                })
            ]
        });
        $[5] = t5;
    } else t5 = $[5];
    return t5;
}
function $c9ed6e04dd40c4f7$var$_temp(t0) {
    const [v, d] = t0;
    return /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("tr", {
        children: [
            /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("td", {
                children: v
            }),
            /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("td", {
                children: d
            })
        ]
    }, v);
}





function $e98a61e82d4b2f49$export$ea0f6181e3388ffd() {
    const $ = (0, $2cf3419409a8d23a$exports.c)(7);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("p", {
            children: "Sensible semantics ship by default:"
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("code", {
            children: 'role="region"'
        });
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("li", {
            children: [
                "Region with ",
                t1,
                " and ",
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("code", {
                    children: 'aria-roledescription="carousel"'
                }),
                "."
            ]
        });
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    let t4;
    let t5;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("li", {
            children: [
                "Each slide is a labelled ",
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("code", {
                    children: "group"
                }),
                " announcing \u201CN of total\u201D."
            ]
        });
        t4 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("code", {
                    children: "aria-live"
                }),
                " politely announces manual navigation, and goes quiet during autoplay."
            ]
        });
        t5 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("li", {
            children: "Arrow keys, Home / End; prev / next disable at the bounds when not looping."
        });
        $[3] = t3;
        $[4] = t4;
        $[5] = t5;
    } else {
        t3 = $[3];
        t4 = $[4];
        t5 = $[5];
    }
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)((0, $e20ceab6cca46499$export$6e2c8f0811a474ce), {
            id: "a11y",
            num: "16 / More",
            title: "Accessibility",
            children: [
                t0,
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("ul", {
                    className: "checklist",
                    children: [
                        t2,
                        t3,
                        t4,
                        t5,
                        /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("li", {
                            children: [
                                "Autoplay pauses on hover & focus and respects ",
                                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("code", {
                                    children: "prefers-reduced-motion"
                                }),
                                "."
                            ]
                        })
                    ]
                })
            ]
        });
        $[6] = t6;
    } else t6 = $[6];
    return t6;
}









function $0c1ba4ed5fe7bb0d$export$2ddb90ad54e5f587(t0) {
    const $ = (0, $2cf3419409a8d23a$exports.c)(6);
    const { bg: bg, label: label, height: t1 } = t0;
    const height = t1 === undefined ? 160 : t1;
    let t2;
    if ($[0] !== bg || $[1] !== height) {
        t2 = {
            height: height,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
            fontFamily: "Fraunces, serif",
            fontSize: "2rem",
            fontWeight: 500,
            borderRadius: 12,
            background: bg
        };
        $[0] = bg;
        $[1] = height;
        $[2] = t2;
    } else t2 = $[2];
    const style = t2;
    let t3;
    if ($[3] !== label || $[4] !== style) {
        t3 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("div", {
            style: style,
            children: label
        });
        $[3] = label;
        $[4] = style;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
}




function $cc92c28a1400f9b3$export$49b67f1c7ac91d9b() {
    const $ = (0, $2cf3419409a8d23a$exports.c)(6);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("code", {
            children: "slidesPerView"
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("code", {
            children: "breakpoints"
        });
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("p", {
            className: "lead",
            children: [
                "Show several slides at once with ",
                t0,
                ", and vary it per screen with ",
                t1,
                ". ",
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("strong", {
                    children: "Resize the window"
                }),
                " \u2014 this demo shows 1 slide on phones, 2 on tablets, and 3 on desktop. Prev / next still page one at a time and stop at the last full view."
            ]
        });
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            640: {
                slidesPerView: 2
            },
            1024: {
                slidesPerView: 3
            }
        };
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $0bc8e4e0cf3665cd$export$144901db2ea8e967).Button, {
            dir: "prev"
        });
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)((0, $e20ceab6cca46499$export$6e2c8f0811a474ce), {
            id: "responsive",
            num: "11 / Carousel",
            title: "Responsive (slidesPerView)",
            children: [
                t2,
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $2dc0036198356c0d$export$425ce3ef4cdbf755), {
                    code: (0, $fe95941a4f3677d1$export$3863e1a9685c4c68),
                    children: /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)((0, $0bc8e4e0cf3665cd$export$144901db2ea8e967), {
                        slidesCount: (0, $ac10b426a722a818$export$8128819a2322681a).length,
                        slidesPerView: 1,
                        breakpoints: t3,
                        label: "Responsive gallery",
                        children: [
                            t4,
                            /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $0bc8e4e0cf3665cd$export$144901db2ea8e967).Track, {
                                children: (0, $ac10b426a722a818$export$8128819a2322681a).map($cc92c28a1400f9b3$var$_temp)
                            }),
                            /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $0bc8e4e0cf3665cd$export$144901db2ea8e967).Button, {
                                dir: "next"
                            }),
                            /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $0bc8e4e0cf3665cd$export$144901db2ea8e967).Dots, {})
                        ]
                    })
                })
            ]
        });
        $[5] = t5;
    } else t5 = $[5];
    return t5;
}
function $cc92c28a1400f9b3$var$_temp(p, i) {
    return /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $0bc8e4e0cf3665cd$export$144901db2ea8e967).Slide, {
        index: i,
        children: /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $0c1ba4ed5fe7bb0d$export$2ddb90ad54e5f587), {
            bg: p.bg,
            label: p.title
        })
    }, i);
}










function $4e753cc7dc0819c4$export$fbd5e94d16e21e4d() {
    const $ = (0, $2cf3419409a8d23a$exports.c)(5);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("code", {
            children: 'orientation="vertical"'
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("p", {
            className: "lead",
            children: [
                "Set ",
                t0,
                " and give the viewport a height with",
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("code", {
                    children: "--rc-viewport-height"
                }),
                ". Keyboard (\u2191/\u2193) and swipe follow the axis automatically."
            ]
        });
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            "--rc-viewport-height": "320px"
        };
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $0bc8e4e0cf3665cd$export$144901db2ea8e967).Button, {
            dir: "prev"
        });
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)((0, $e20ceab6cca46499$export$6e2c8f0811a474ce), {
            id: "vertical",
            num: "12 / Carousel",
            title: "Vertical",
            children: [
                t1,
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $2dc0036198356c0d$export$425ce3ef4cdbf755), {
                    code: (0, $fe95941a4f3677d1$export$643c90265fee513d),
                    children: /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)((0, $0bc8e4e0cf3665cd$export$144901db2ea8e967), {
                        slidesCount: (0, $ac10b426a722a818$export$8128819a2322681a).length,
                        orientation: "vertical",
                        label: "Vertical gallery",
                        style: t2,
                        children: [
                            t3,
                            /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $0bc8e4e0cf3665cd$export$144901db2ea8e967).Track, {
                                children: (0, $ac10b426a722a818$export$8128819a2322681a).map($4e753cc7dc0819c4$var$_temp)
                            }),
                            /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $0bc8e4e0cf3665cd$export$144901db2ea8e967).Button, {
                                dir: "next"
                            }),
                            /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $0bc8e4e0cf3665cd$export$144901db2ea8e967).Dots, {})
                        ]
                    })
                })
            ]
        });
        $[4] = t4;
    } else t4 = $[4];
    return t4;
}
function $4e753cc7dc0819c4$var$_temp(p, i) {
    return /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $0bc8e4e0cf3665cd$export$144901db2ea8e967).Slide, {
        index: i,
        children: /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $0c1ba4ed5fe7bb0d$export$2ddb90ad54e5f587), {
            bg: p.bg,
            label: p.title,
            height: "100%"
        })
    }, i);
}





var $lDJXT = parcelRequire("lDJXT");






function $f330b2fb3c70c683$export$7a7fa4424cb20976() {
    const $ = (0, $2cf3419409a8d23a$exports.c)(11);
    const ref = (0, $lDJXT.useRef)(null);
    const [status, setStatus] = (0, $lDJXT.useState)("ready");
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("code", {
            children: "ref"
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("code", {
            children: "CarouselHandle"
        });
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("code", {
            children: "onSettle"
        });
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("p", {
            className: "lead",
            children: [
                "Drive the carousel from outside with a ",
                t0,
                " (the imperative",
                t1,
                "), and react to lifecycle callbacks like",
                t2,
                " and ",
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("code", {
                    children: "onSwipeEnd"
                }),
                "."
            ]
        });
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("div", {
            className: "switcher",
            style: {
                marginBottom: "1rem"
            },
            children: [
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("button", {
                    onClick: ()=>ref.current?.prev(),
                    children: "Prev"
                }),
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("button", {
                    onClick: ()=>ref.current?.goTo(0),
                    children: "First"
                }),
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("button", {
                    onClick: ()=>ref.current?.next(),
                    children: "Next"
                })
            ]
        });
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    let t6;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (i)=>setStatus(`settled on ${i + 1}`);
        t6 = (d)=>setStatus(`swiped ${d.direction}`);
        $[5] = t5;
        $[6] = t6;
    } else {
        t5 = $[5];
        t6 = $[6];
    }
    let t7;
    let t8;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)((0, $0bc8e4e0cf3665cd$export$144901db2ea8e967), {
            ref: ref,
            slidesCount: (0, $ac10b426a722a818$export$8128819a2322681a).length,
            label: "Controlled gallery",
            onSettle: t5,
            onSwipeEnd: t6,
            children: [
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $0bc8e4e0cf3665cd$export$144901db2ea8e967).Track, {
                    children: (0, $ac10b426a722a818$export$8128819a2322681a).map($f330b2fb3c70c683$var$_temp)
                }),
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $0bc8e4e0cf3665cd$export$144901db2ea8e967).Dots, {})
            ]
        });
        t8 = {
            marginTop: "0.75rem",
            fontFamily: "var(--font-mono)"
        };
        $[7] = t7;
        $[8] = t8;
    } else {
        t7 = $[7];
        t8 = $[8];
    }
    let t9;
    if ($[9] !== status) {
        t9 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)((0, $e20ceab6cca46499$export$6e2c8f0811a474ce), {
            id: "control",
            num: "14 / Carousel",
            title: "Programmatic control",
            children: [
                t3,
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)((0, $2dc0036198356c0d$export$425ce3ef4cdbf755), {
                    code: (0, $fe95941a4f3677d1$export$996358f888e0daf4),
                    children: [
                        t4,
                        t7,
                        /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("p", {
                            style: t8,
                            children: [
                                "status: ",
                                status
                            ]
                        })
                    ]
                })
            ]
        });
        $[9] = status;
        $[10] = t9;
    } else t9 = $[10];
    return t9;
}
function $f330b2fb3c70c683$var$_temp(p, i_0) {
    return /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $0bc8e4e0cf3665cd$export$144901db2ea8e967).Slide, {
        index: i_0,
        children: /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $0c1ba4ed5fe7bb0d$export$2ddb90ad54e5f587), {
            bg: p.bg,
            label: p.title
        })
    }, i_0);
}





var $lDJXT = parcelRequire("lDJXT");





function $e641541db110981c$export$a4540e2a2effdfa3() {
    const $ = (0, $2cf3419409a8d23a$exports.c)(17);
    const [vertical, setVertical] = (0, $lDJXT.useState)(false);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("p", {
            className: "lead",
            children: "Slides are the faces of a 3D cube \u2014 navigating rotates it 90\xb0 to the next face, with subtle face shadows for depth. Spins on either axis and works with any number of slides."
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            marginBottom: "1rem"
        };
        $[1] = t1;
    } else t1 = $[1];
    const t2 = !vertical;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>setVertical(false);
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== t2) {
        t4 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("button", {
            "aria-pressed": t2,
            onClick: t3,
            children: "Horizontal"
        });
        $[3] = t2;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = ()=>setVertical(true);
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== vertical) {
        t6 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("button", {
            "aria-pressed": vertical,
            onClick: t5,
            children: "Vertical"
        });
        $[6] = vertical;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== t4 || $[9] !== t6) {
        t7 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("div", {
            className: "switcher",
            style: t1,
            children: [
                t4,
                t6
            ]
        });
        $[8] = t4;
        $[9] = t6;
        $[10] = t7;
    } else t7 = $[10];
    const t8 = vertical ? "v" : "h";
    let t9;
    if ($[11] !== t8 || $[12] !== vertical) {
        t9 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $2dc0036198356c0d$export$425ce3ef4cdbf755), {
            code: (0, $fe95941a4f3677d1$export$81248509a08aa4e),
            children: /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $6a573cd607e7205c$export$2e2bcd8739ae039), {
                slides: (0, $ac10b426a722a818$export$428f3fc27bf16bca),
                loop: true,
                vertical: vertical,
                height: 460
            }, t8)
        });
        $[11] = t8;
        $[12] = vertical;
        $[13] = t9;
    } else t9 = $[13];
    let t10;
    if ($[14] !== t7 || $[15] !== t9) {
        t10 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)((0, $e20ceab6cca46499$export$6e2c8f0811a474ce), {
            id: "cube",
            num: "06 / Presets",
            title: "Cube slider",
            children: [
                t0,
                t7,
                t9
            ]
        });
        $[14] = t7;
        $[15] = t9;
        $[16] = t10;
    } else t10 = $[16];
    return t10;
}


const $211c5a9af33ec991$export$5a1dbaa3e4449344 = [
    // Getting started
    (0, $766d18f819b0bd94$export$8564277db535bd71),
    (0, $3eaaf17abeb77fd9$export$b14428087440894d),
    // Presets
    (0, $d9167f8fcf0d20df$export$1974f7d0dcd7cd15),
    (0, $cbbf15ad4177303b$export$487ee7542ff81536),
    (0, $9fa3ed7b99215744$export$ab40f25e43841e88),
    (0, $e641541db110981c$export$a4540e2a2effdfa3),
    (0, $58792ee500d4c80b$export$dd53be77193aba26),
    // Carousel (core)
    (0, $6bdfc24b0a771180$export$ab4150be7c673f50),
    (0, $dfe13d5338013424$export$c7c44baae9d9f25f),
    (0, $159fdff6dda762e6$export$7ed115685df827af),
    (0, $cc92c28a1400f9b3$export$49b67f1c7ac91d9b),
    (0, $4e753cc7dc0819c4$export$fbd5e94d16e21e4d),
    (0, $24adffde02e6e318$export$6332622ae377cb3),
    (0, $f330b2fb3c70c683$export$7a7fa4424cb20976),
    // More
    (0, $c9ed6e04dd40c4f7$export$d28117db278fe749),
    (0, $e98a61e82d4b2f49$export$ea0f6181e3388ffd)
];



const $e244c161b41380d9$var$SITE_TITLE = "react-carousel-latest \xb7 docs";
const $e244c161b41380d9$var$SITE_DESCRIPTION = "A headless, accessible, tree-shakeable React carousel with a compound-component API.";
function $e244c161b41380d9$export$2e2bcd8739ae039() {
    const $ = (0, $2cf3419409a8d23a$exports.c)(20);
    const [theme, setTheme] = (0, $ec797a31f053fa32$export$93d4e7f90805808f)();
    const active = (0, $0ee366ceeb6b9dab$export$ea86cd170f22eba6)((0, $ac10b426a722a818$export$be3381fd8bf5f5cf));
    const title = active && active !== "overview" ? `${(0, $ac10b426a722a818$export$c6ebd78480de3ea8)[active]} \xb7 react-carousel-latest` : $e244c161b41380d9$var$SITE_TITLE;
    let t0;
    if ($[0] !== title) {
        t0 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("title", {
            children: title
        });
        $[0] = title;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("meta", {
            name: "description",
            content: $e244c161b41380d9$var$SITE_DESCRIPTION
        });
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== setTheme) {
        t2 = ()=>setTheme($e244c161b41380d9$var$_temp);
        $[3] = setTheme;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t2 || $[6] !== theme) {
        t3 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $f1f18ab43a2adff2$export$1ca1e38143dcc152), {
            theme: theme,
            onToggleTheme: t2
        });
        $[5] = t2;
        $[6] = theme;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== active) {
        t4 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $77f377cf3819795e$export$1ba59dacbcbf90fe), {
            active: active
        });
        $[8] = active;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    let t6;
    let t7;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $2d3dbfbb9e9eca07$export$887967f05dc521ae), {});
        t6 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("hr", {
            className: "rule"
        });
        t7 = (0, $211c5a9af33ec991$export$5a1dbaa3e4449344).map($e244c161b41380d9$var$_temp2);
        $[10] = t5;
        $[11] = t6;
        $[12] = t7;
    } else {
        t5 = $[10];
        t6 = $[11];
        t7 = $[12];
    }
    let t8;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("main", {
            className: "content",
            children: [
                t5,
                t6,
                t7,
                /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("footer", {
                    className: "footer",
                    children: [
                        /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("span", {
                            children: "react-carousel-latest \xb7 Apache-2.0"
                        }),
                        /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)("span", {
                            children: "Built with Fraunces & Hanken Grotesk"
                        })
                    ]
                })
            ]
        });
        $[13] = t8;
    } else t8 = $[13];
    let t9;
    if ($[14] !== t4) {
        t9 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)("div", {
            className: "layout",
            children: [
                t4,
                t8
            ]
        });
        $[14] = t4;
        $[15] = t9;
    } else t9 = $[15];
    let t10;
    if ($[16] !== t0 || $[17] !== t3 || $[18] !== t9) {
        t10 = /*#__PURE__*/ (0, $217385444e3d1677$exports.jsxs)((0, $217385444e3d1677$exports.Fragment), {
            children: [
                t0,
                t1,
                t3,
                t9
            ]
        });
        $[16] = t0;
        $[17] = t3;
        $[18] = t9;
        $[19] = t10;
    } else t10 = $[19];
    return t10;
}
function $e244c161b41380d9$var$_temp2(SectionComponent) {
    return /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)(SectionComponent, {}, SectionComponent.name);
}
function $e244c161b41380d9$var$_temp(t) {
    return t === "dark" ? "light" : "dark";
}


const $99c155e5d7cba7aa$var$container = document.getElementById("root");
if (!$99c155e5d7cba7aa$var$container) throw new Error('Root element "#root" not found in index.html');
(0, $6d3b784170d7cd9b$exports.createRoot)($99c155e5d7cba7aa$var$container).render(/*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $lDJXT.StrictMode), {
    children: /*#__PURE__*/ (0, $217385444e3d1677$exports.jsx)((0, $e244c161b41380d9$export$2e2bcd8739ae039), {})
}));


//# sourceMappingURL=example.9ef03b50.js.map
